/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PreviewRouteImport } from './routes/preview'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as FormsIndexRouteImport } from './routes/forms/index'
import { Route as SchedulesRequestRouteImport } from './routes/schedules/request'
import { Route as PreviewConsentRouteImport } from './routes/preview/consent'
import { Route as PreferencesUserIdRouteImport } from './routes/preferences/$userId'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding/welcome'
import { Route as OnboardingPhoneRouteImport } from './routes/onboarding/phone'
import { Route as OnboardingNotificationsRouteImport } from './routes/onboarding/notifications'
import { Route as OnboardingNameRouteImport } from './routes/onboarding/name'
import { Route as OnboardingEmailRouteImport } from './routes/onboarding/email'
import { Route as OnboardingDateOfBirthRouteImport } from './routes/onboarding/date-of-birth'
import { Route as OnboardingCompleteRouteImport } from './routes/onboarding/complete'
import { Route as OnboardingClinicianNumberRouteImport } from './routes/onboarding/clinician-number'
import { Route as FormsRequestRouteImport } from './routes/forms/request'
import { Route as FeedbackPatientRouteImport } from './routes/feedback/patient'
import { Route as CliniciansClinicianIdRouteImport } from './routes/clinicians/$clinicianId'
import { Route as AuthVerifyPaymentRouteImport } from './routes/_auth/verify-payment'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthVerifyRouteImport } from './routes/_auth/verify'
import { Route as AuthVerificationCompleteRouteImport } from './routes/_auth/verification-complete'
import { Route as AuthTryDemoRouteImport } from './routes/_auth/try-demo'
import { Route as AuthTestRouteImport } from './routes/_auth/test'
import { Route as AuthSetPasswordRouteImport } from './routes/_auth/set-password'
import { Route as AuthNewDiaryInviteRouteImport } from './routes/_auth/new-diary-invite'
import { Route as AuthMagicRouteImport } from './routes/_auth/magic'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthEmailConfirmedRouteImport } from './routes/_auth/email-confirmed'
import { Route as AuthDeleteAccountRouteImport } from './routes/_auth/delete-account'
import { Route as AuthConfirmAccountRouteImport } from './routes/_auth/confirm-account'
import { Route as AuthChangePasswordRouteImport } from './routes/_auth/change-password'
import { Route as AuthAuthenticationCompleteRouteImport } from './routes/_auth/authentication-complete'
import { Route as AuthAuthErrorRouteImport } from './routes/_auth/auth-error'
import { Route as AuthActivateAccountRouteImport } from './routes/_auth/activate-account'
import { Route as AuthPublicRouteImport } from './routes/_auth/_public'
import { Route as AppWorklistRouteImport } from './routes/_app/worklist'
import { Route as AppTemplatesRouteImport } from './routes/_app/templates'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as AppStudiesRouteImport } from './routes/_app/studies'
import { Route as AppStatisticsRouteImport } from './routes/_app/statistics'
import { Route as AppSalesRouteImport } from './routes/_app/sales'
import { Route as AppRoleRouteImport } from './routes/_app/role'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppPatientsRouteImport } from './routes/_app/patients'
import { Route as AppInviteRouteImport } from './routes/_app/invite'
import { Route as AppDeveloperRouteImport } from './routes/_app/developer'
import { Route as AppDesignRouteImport } from './routes/_app/design'
import { Route as AppCustomersRouteImport } from './routes/_app/customers'
import { Route as AppCompleteProfileRouteImport } from './routes/_app/complete-profile'
import { Route as AppBusinessRouteImport } from './routes/_app/business'
import { Route as AppBuilderRouteImport } from './routes/_app/builder'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppUsersRouteRouteImport } from './routes/_app/users/route'
import { Route as ScreenScreenerIdIndexRouteImport } from './routes/screen/$screenerId/index'
import { Route as FormsFormIdIndexRouteImport } from './routes/forms/$formId/index'
import { Route as AuthNewUserIndexRouteImport } from './routes/_auth/new-user/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/_auth/forgot-password.index'
import { Route as AuthConfirmAccountIndexRouteImport } from './routes/_auth/confirm-account.index'
import { Route as AuthPublicIndexRouteImport } from './routes/_auth/_public/index'
import { Route as AppWorklistIndexRouteImport } from './routes/_app/worklist/index'
import { Route as AppValidateIndexRouteImport } from './routes/_app/validate/index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppTemplatesIndexRouteImport } from './routes/_app/templates/index'
import { Route as AppTeamIndexRouteImport } from './routes/_app/team/index'
import { Route as AppStudiesIndexRouteImport } from './routes/_app/studies/index'
import { Route as AppSchedulesIndexRouteImport } from './routes/_app/schedules/index'
import { Route as AppSalesIndexRouteImport } from './routes/_app/sales/index'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppNewIndexRouteImport } from './routes/_app/new/index'
import { Route as AppLeadGenIndexRouteImport } from './routes/_app/lead-gen/index'
import { Route as AppInviteIndexRouteImport } from './routes/_app/invite/index'
import { Route as AppDiariesIndexRouteImport } from './routes/_app/diaries/index'
import { Route as AppDeveloperIndexRouteImport } from './routes/_app/developer/index'
import { Route as AppDesignIndexRouteImport } from './routes/_app/design/index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppBusinessIndexRouteImport } from './routes/_app/business/index'
import { Route as AppBuilderIndexRouteImport } from './routes/_app/builder/index'
import { Route as AppAnalyticsIndexRouteImport } from './routes/_app/analytics/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as TrackerTrackerIdSuccessRouteImport } from './routes/tracker/$trackerId/success'
import { Route as TrackerTrackerIdResultsRouteImport } from './routes/tracker/$trackerId/results'
import { Route as ScreenScreenerIdResultRouteImport } from './routes/screen/$screenerId/result'
import { Route as PreviewInviteQrCodeRouteImport } from './routes/preview/invite/qr-code'
import { Route as PreviewConsentConsentIdRouteImport } from './routes/preview/consent/$consentId'
import { Route as OnboardingClinicianProfessionalRouteImport } from './routes/onboarding/clinician/professional'
import { Route as OnboardingClinicianOrganisationRouteImport } from './routes/onboarding/clinician/organisation'
import { Route as OnboardingClinicianNameRouteImport } from './routes/onboarding/clinician/name'
import { Route as HelpExplainerExplainerTypeRouteImport } from './routes/help/explainer/$explainerType'
import { Route as AuthMfaEnrollRouteImport } from './routes/_auth/mfa.enroll'
import { Route as AuthMfaChallengeRouteImport } from './routes/_auth/mfa.challenge'
import { Route as AuthForgotPasswordVerifyRouteImport } from './routes/_auth/forgot-password.verify'
import { Route as AuthConfirmAccountVerifyRouteImport } from './routes/_auth/confirm-account.verify'
import { Route as AuthPublicLoginRouteImport } from './routes/_auth/_public/login'
import { Route as AuthPublicAuthenticateRouteImport } from './routes/_auth/_public/authenticate'
import { Route as AppWorklistCompleteRouteImport } from './routes/_app/worklist/complete'
import { Route as AppValidateValidationIdRouteImport } from './routes/_app/validate/$validationId'
import { Route as AppUsersSecretariesRouteImport } from './routes/_app/users/secretaries'
import { Route as AppUsersPreferencesRouteImport } from './routes/_app/users/preferences'
import { Route as AppUsersPatientsRouteImport } from './routes/_app/users/patients'
import { Route as AppUsersOrganisationsRouteImport } from './routes/_app/users/organisations'
import { Route as AppUsersManagersRouteImport } from './routes/_app/users/managers'
import { Route as AppUsersCliniciansRouteImport } from './routes/_app/users/clinicians'
import { Route as AppUsersBillingRouteImport } from './routes/_app/users/billing'
import { Route as AppUsersAdminsRouteImport } from './routes/_app/users/admins'
import { Route as AppTemplatesQuickstartPageRouteImport } from './routes/_app/templates/quickstart-page'
import { Route as AppTemplatesPublicRouteImport } from './routes/_app/templates/public'
import { Route as AppTemplatesCompleteRouteImport } from './routes/_app/templates/complete'
import { Route as AppTemplatesTemplateIdRouteImport } from './routes/_app/templates/$templateId'
import { Route as AppTeamInviteRouteImport } from './routes/_app/team.invite'
import { Route as AppStudiesStudyIdRouteImport } from './routes/_app/studies/$studyId'
import { Route as AppSchedulesScheduleIdRouteImport } from './routes/_app/schedules/$scheduleId'
import { Route as AppProfilePhoneRouteImport } from './routes/_app/profile/phone'
import { Route as AppProfileOrganisationRouteImport } from './routes/_app/profile/organisation'
import { Route as AppProfileNotificationsRouteImport } from './routes/_app/profile/notifications'
import { Route as AppProfileNhsNumberRouteImport } from './routes/_app/profile/nhs-number'
import { Route as AppProfileNameRouteImport } from './routes/_app/profile/name'
import { Route as AppProfileMfaRouteImport } from './routes/_app/profile/mfa'
import { Route as AppProfileEmailRouteImport } from './routes/_app/profile/email'
import { Route as AppProfileDeleteAccountRouteImport } from './routes/_app/profile/delete-account'
import { Route as AppProfileDateOfBirthRouteImport } from './routes/_app/profile/date-of-birth'
import { Route as AppProfileClinicianNumberRouteImport } from './routes/_app/profile/clinician-number'
import { Route as AppProfileChangePasswordRouteImport } from './routes/_app/profile/change-password'
import { Route as AppProfileBillingRouteImport } from './routes/_app/profile/billing'
import { Route as AppProfileAddImagingCenterRouteImport } from './routes/_app/profile/add-imaging-center'
import { Route as AppPatientsDiaryIdRouteImport } from './routes/_app/patients/$diaryId'
import { Route as AppNewSplatRouteImport } from './routes/_app/new/$'
import { Route as AppLeadGenSplatRouteImport } from './routes/_app/lead-gen/$'
import { Route as AppInviteQrCodeRouteImport } from './routes/_app/invite/qr-code'
import { Route as AppHelpPatientRouteImport } from './routes/_app/help/patient'
import { Route as AppHelpClinicianRouteImport } from './routes/_app/help/clinician'
import { Route as AppHeadacheWatchDashboardRouteImport } from './routes/_app/headache-watch/dashboard'
import { Route as AppFootWatchDiaryIdRouteImport } from './routes/_app/foot-watch/$diaryId'
import { Route as AppFisherWatchDashboardRouteImport } from './routes/_app/fisher-watch/dashboard'
import { Route as AppDiariesDiaryIdRouteImport } from './routes/_app/diaries/$diaryId'
import { Route as AppDeveloperSmsDeliverabilityRouteImport } from './routes/_app/developer/sms-deliverability'
import { Route as AppDeveloperReminderSendVolumeRouteImport } from './routes/_app/developer/reminder-send-volume'
import { Route as AppDeveloperMessagingScheduleRouteImport } from './routes/_app/developer/messaging-schedule'
import { Route as AppDeveloperHealthCheckRouteImport } from './routes/_app/developer/health-check'
import { Route as AppCustomersSuccessRouteImport } from './routes/_app/customers/success'
import { Route as AppCustomersCliniciansRouteImport } from './routes/_app/customers/clinicians'
import { Route as AppCustomersChurnRouteImport } from './routes/_app/customers/churn'
import { Route as AppCustomersAnonymousRouteImport } from './routes/_app/customers/anonymous'
import { Route as AppCustomersAmbassadorsRouteImport } from './routes/_app/customers/ambassadors'
import { Route as AppClinicianDiariesRouteImport } from './routes/_app/clinician/diaries'
import { Route as AppBusinessChurnRouteImport } from './routes/_app/business/churn'
import { Route as AppBusinessAmbassadorsRouteImport } from './routes/_app/business/ambassadors'
import { Route as AppAnalyticsArthrosamidRouteImport } from './routes/_app/analytics/arthrosamid'
import { Route as AppAnalyticsAnikaRouteImport } from './routes/_app/analytics/anika'
import { Route as AppAnalyticsDiaryLabelRouteImport } from './routes/_app/analytics/$diaryLabel'
import { Route as AppAdminViewDiaryAsPatientRouteImport } from './routes/_app/admin/view-diary-as-patient'
import { Route as AppAdminUserOrganisationsRouteImport } from './routes/_app/admin/user-organisations'
import { Route as AppAdminUserBillingRouteImport } from './routes/_app/admin/user-billing'
import { Route as AppAdminTrackersRouteImport } from './routes/_app/admin/trackers'
import { Route as AppAdminTemplatesRouteImport } from './routes/_app/admin/templates'
import { Route as AppAdminStudiesRouteImport } from './routes/_app/admin/studies'
import { Route as AppAdminSmsDeliverabilityRouteImport } from './routes/_app/admin/sms-deliverability'
import { Route as AppAdminReminderSendVolumeRouteImport } from './routes/_app/admin/reminder-send-volume'
import { Route as AppAdminNotificationPreferencesRouteImport } from './routes/_app/admin/notification-preferences'
import { Route as AppAdminLabelsRouteImport } from './routes/_app/admin/labels'
import { Route as AppAdminLabelAccessRouteImport } from './routes/_app/admin/label-access'
import { Route as AppAdminImpersonateUserRouteImport } from './routes/_app/admin/impersonate-user'
import { Route as AppAdminHealthCheckRouteImport } from './routes/_app/admin/health-check'
import { Route as AppAdminEventsRouteImport } from './routes/_app/admin/events'
import { Route as AppAdminEntryValuesRouteImport } from './routes/_app/admin/entry-values'
import { Route as AppAdminEntriesRouteImport } from './routes/_app/admin/entries'
import { Route as AppAdminAmbassadorsRouteImport } from './routes/_app/admin/ambassadors'
import { Route as AppUsersNotificationsRouteRouteImport } from './routes/_app/users/notifications/route'
import { Route as AppUsersCreateUserRouteRouteImport } from './routes/_app/users/create-user/route'
import { Route as AppSalesLeadsRouteRouteImport } from './routes/_app/sales/leads/route'
import { Route as AppDeveloperSftpRouteRouteImport } from './routes/_app/developer/sftp/route'
import { Route as AppBusinessLeadsRouteRouteImport } from './routes/_app/business/leads/route'
import { Route as AppAdminSftpRouteRouteImport } from './routes/_app/admin/sftp/route'
import { Route as AppAdminOrganisationRouteRouteImport } from './routes/_app/admin/organisation/route'
import { Route as AppAdminAuditRouteRouteImport } from './routes/_app/admin/audit/route'
import { Route as AppAdminAccessRouteRouteImport } from './routes/_app/admin/access/route'
import { Route as AuthNewUserPatientIndexRouteImport } from './routes/_auth/new-user/patient/index'
import { Route as AuthNewUserClinicianIndexRouteImport } from './routes/_auth/new-user/clinician/index'
import { Route as AuthPublicSignupIndexRouteImport } from './routes/_auth/_public/signup.index'
import { Route as AuthPublicLoginIndexRouteImport } from './routes/_auth/_public/login.index'
import { Route as AppValidateValidationIdIndexRouteImport } from './routes/_app/validate/$validationId/index'
import { Route as AppUsersNotificationsIndexRouteImport } from './routes/_app/users/notifications/index'
import { Route as AppUsersCreateUserIndexRouteImport } from './routes/_app/users/create-user/index'
import { Route as AppTeamInviteIndexRouteImport } from './routes/_app/team.invite.index'
import { Route as AppStudiesStudyIdIndexRouteImport } from './routes/_app/studies/$studyId/index'
import { Route as AppSalesLeadsIndexRouteImport } from './routes/_app/sales/leads/index'
import { Route as AppPatientsDiaryIdIndexRouteImport } from './routes/_app/patients/$diaryId/index'
import { Route as AppOrganisationOrganisationIdIndexRouteImport } from './routes/_app/organisation/$organisationId/index'
import { Route as AppDiariesDiaryIdIndexRouteImport } from './routes/_app/diaries/$diaryId/index'
import { Route as AppDeveloperSftpIndexRouteImport } from './routes/_app/developer/sftp/index'
import { Route as AppDesignIconsIndexRouteImport } from './routes/_app/design/icons/index'
import { Route as AppDesignFormsIndexRouteImport } from './routes/_app/design/forms/index'
import { Route as AppBusinessLeadsIndexRouteImport } from './routes/_app/business/leads/index'
import { Route as AppBuilderTemplatesIndexRouteImport } from './routes/_app/builder/templates/index'
import { Route as AppBuilderSurgeriesIndexRouteImport } from './routes/_app/builder/surgeries/index'
import { Route as AppBuilderSchedulesIndexRouteImport } from './routes/_app/builder/schedules/index'
import { Route as AppBuilderOptionsIndexRouteImport } from './routes/_app/builder/options/index'
import { Route as AppBuilderMessagesIndexRouteImport } from './routes/_app/builder/messages/index'
import { Route as AppBuilderLabelsIndexRouteImport } from './routes/_app/builder/labels/index'
import { Route as AppBuilderInjectionLocationsIndexRouteImport } from './routes/_app/builder/injection-locations/index'
import { Route as AppBuilderInjectionContentsIndexRouteImport } from './routes/_app/builder/injection-contents/index'
import { Route as AppBuilderFormsIndexRouteImport } from './routes/_app/builder/forms/index'
import { Route as AppBuilderDictionariesIndexRouteImport } from './routes/_app/builder/dictionaries/index'
import { Route as AppBuilderConsentsIndexRouteImport } from './routes/_app/builder/consents/index'
import { Route as AppAdminUserActivationIndexRouteImport } from './routes/_app/admin/user-activation/index'
import { Route as AppAdminSftpIndexRouteImport } from './routes/_app/admin/sftp/index'
import { Route as AppAdminOrganisationIndexRouteImport } from './routes/_app/admin/organisation/index'
import { Route as AppAdminDiariesIndexRouteImport } from './routes/_app/admin/diaries/index'
import { Route as AppAdminCliniciansIndexRouteImport } from './routes/_app/admin/clinicians/index'
import { Route as AppAdminBusinessIndexRouteImport } from './routes/_app/admin/business/index'
import { Route as AppAdminAuditIndexRouteImport } from './routes/_app/admin/audit/index'
import { Route as AppAdminAccessIndexRouteImport } from './routes/_app/admin/access/index'
import { Route as AuthPublicSignupVerifyPhoneRouteImport } from './routes/_auth/_public/signup.verify-phone'
import { Route as AuthPublicSignupTrialRouteImport } from './routes/_auth/_public/signup.trial'
import { Route as AuthPublicSignupPlanRouteImport } from './routes/_auth/_public/signup.$plan'
import { Route as AuthPublicLoginVerifyRouteImport } from './routes/_auth/_public/login.verify'
import { Route as AppUsersSecretariesUserIdRouteImport } from './routes/_app/users/secretaries/$userId'
import { Route as AppUsersPatientsUserIdRouteImport } from './routes/_app/users/patients/$userId'
import { Route as AppUsersNotificationsSmsRouteImport } from './routes/_app/users/notifications/sms'
import { Route as AppUsersManagersUserIdRouteImport } from './routes/_app/users/managers/$userId'
import { Route as AppUsersCreateUserTemplatesRouteImport } from './routes/_app/users/create-user/templates'
import { Route as AppUsersCreateUserOrganisationsRouteImport } from './routes/_app/users/create-user/organisations'
import { Route as AppUsersCreateUserImpersonateRouteImport } from './routes/_app/users/create-user/impersonate'
import { Route as AppUsersCreateUserDetailsRouteImport } from './routes/_app/users/create-user/details'
import { Route as AppUsersCreateUserBillingRouteImport } from './routes/_app/users/create-user/billing'
import { Route as AppUsersCreateUserAccessRouteImport } from './routes/_app/users/create-user/access'
import { Route as AppUsersCliniciansUserIdRouteImport } from './routes/_app/users/clinicians/$userId'
import { Route as AppUsersAdminsUserIdRouteImport } from './routes/_app/users/admins/$userId'
import { Route as AppTemplatesDiaryTemplateIdRouteImport } from './routes/_app/templates/diary/$templateId'
import { Route as AppTemplatesDiaryNewDiaryTemplateIdRouteImport } from './routes/_app/templates/diary/$newDiaryTemplateId'
import { Route as AppTemplatesTemplateIdTrackersRouteImport } from './routes/_app/templates/$templateId/trackers'
import { Route as AppTemplatesTemplateIdScreenerRouteImport } from './routes/_app/templates/$templateId/screener'
import { Route as AppTemplatesTemplateIdPublishRouteImport } from './routes/_app/templates/$templateId/publish'
import { Route as AppTemplatesTemplateIdOrganisationRouteImport } from './routes/_app/templates/$templateId/organisation'
import { Route as AppTemplatesTemplateIdNameRouteImport } from './routes/_app/templates/$templateId/name'
import { Route as AppTemplatesTemplateIdLabelsRouteImport } from './routes/_app/templates/$templateId/labels'
import { Route as AppTemplatesTemplateIdHospitalNumberRouteImport } from './routes/_app/templates/$templateId/hospital-number'
import { Route as AppTemplatesTemplateIdDateRouteImport } from './routes/_app/templates/$templateId/date'
import { Route as AppTemplatesTemplateIdConsentRouteImport } from './routes/_app/templates/$templateId/consent'
import { Route as AppTeamInviteQrRouteImport } from './routes/_app/team.invite.qr'
import { Route as AppTeamInviteEmailRouteImport } from './routes/_app/team.invite.email'
import { Route as AppStudiesStudyIdEditRouteImport } from './routes/_app/studies/$studyId/edit'
import { Route as AppSalesLeadsNewRouteImport } from './routes/_app/sales/leads/new'
import { Route as AppProfileMedicalDiabetesRouteImport } from './routes/_app/profile/medical/diabetes'
import { Route as AppPatientsBulkReviewedRouteImport } from './routes/_app/patients/bulk/reviewed'
import { Route as AppPatientsBulkOrganisationRouteImport } from './routes/_app/patients/bulk/organisation'
import { Route as AppPatientsBulkMessageRouteImport } from './routes/_app/patients/bulk/message'
import { Route as AppPatientsBulkLabelsRouteImport } from './routes/_app/patients/bulk/labels'
import { Route as AppPatientsBulkEventsRouteImport } from './routes/_app/patients/bulk/events'
import { Route as AppPatientsBulkContactRouteImport } from './routes/_app/patients/bulk/contact'
import { Route as AppPatientsDiaryIdEditRouteImport } from './routes/_app/patients/$diaryId/edit'
import { Route as AppOrganisationOrganisationIdQrCodeRouteImport } from './routes/_app/organisation/$organisationId/qr-code'
import { Route as AppInviteDiaryReviewRouteImport } from './routes/_app/invite/diary/review'
import { Route as AppInviteDiaryQrRouteImport } from './routes/_app/invite/diary/qr'
import { Route as AppInviteDiaryPatientRouteImport } from './routes/_app/invite/diary/patient'
import { Route as AppInviteDiaryOrganisationRouteImport } from './routes/_app/invite/diary/organisation'
import { Route as AppInviteDiaryCompleteRouteImport } from './routes/_app/invite/diary/complete'
import { Route as AppFootWatchNewDiaryShareRouteImport } from './routes/_app/foot-watch/new-diary/share'
import { Route as AppFootWatchDiaryIdEditRouteImport } from './routes/_app/foot-watch/$diaryId/edit'
import { Route as AppFootWatchDiaryIdViewRouteImport } from './routes/_app/foot-watch/$diaryId/_view'
import { Route as AppDiariesDiaryIdSetupRouteImport } from './routes/_app/diaries/$diaryId/setup'
import { Route as AppDiariesDiaryIdProgressRouteImport } from './routes/_app/diaries/$diaryId/progress'
import { Route as AppDiariesDiaryIdHomeRouteImport } from './routes/_app/diaries/$diaryId/home'
import { Route as AppDiariesDiaryIdFormsRouteImport } from './routes/_app/diaries/$diaryId/forms'
import { Route as AppDeveloperUiInputsRouteImport } from './routes/_app/developer/ui/inputs'
import { Route as AppDeveloperUiInputSwitchRouteImport } from './routes/_app/developer/ui/input-switch'
import { Route as AppDeveloperUiEntryValuesRouteImport } from './routes/_app/developer/ui/entry-values'
import { Route as AppDeveloperUiDictionariesRouteImport } from './routes/_app/developer/ui/dictionaries'
import { Route as AppDeveloperUiButtonsRouteImport } from './routes/_app/developer/ui/buttons'
import { Route as AppDeveloperUiAuthRouteImport } from './routes/_app/developer/ui/auth'
import { Route as AppDeveloperUiAnimationsRouteImport } from './routes/_app/developer/ui/animations'
import { Route as AppDeveloperSftpUploadRouteImport } from './routes/_app/developer/sftp/upload'
import { Route as AppDeveloperSftpPreviewRouteImport } from './routes/_app/developer/sftp/preview'
import { Route as AppDeveloperSftpOrganisationsRouteImport } from './routes/_app/developer/sftp/organisations'
import { Route as AppDeveloperSftpExplorerRouteImport } from './routes/_app/developer/sftp/explorer'
import { Route as AppDeveloperSftpDiariesRouteImport } from './routes/_app/developer/sftp/diaries'
import { Route as AppDeveloperSftpDashboardRouteImport } from './routes/_app/developer/sftp/dashboard'
import { Route as AppDeveloperDemosOtivioFrictionlessOnboardingRouteImport } from './routes/_app/developer/demos/otivio-frictionless-onboarding'
import { Route as AppDeveloperDemosManagerStudyClinicianInvitePlanRouteImport } from './routes/_app/developer/demos/manager-study-clinician-invite-plan'
import { Route as AppDeveloperDemosGeneralisedAnalyticsRouteImport } from './routes/_app/developer/demos/generalised-analytics'
import { Route as AppDesignIconsStatesRouteImport } from './routes/_app/design/icons/states'
import { Route as AppDesignIconsFacesRouteImport } from './routes/_app/design/icons/faces'
import { Route as AppDesignIconsAnimationsRouteImport } from './routes/_app/design/icons/animations'
import { Route as AppDesignFormsPagesRouteImport } from './routes/_app/design/forms/pages'
import { Route as AppDesignFormsInputsRouteImport } from './routes/_app/design/forms/inputs'
import { Route as AppDesignFormsEntryValuesRouteImport } from './routes/_app/design/forms/entry-values'
import { Route as AppDesignFormsBlocksRouteImport } from './routes/_app/design/forms/blocks'
import { Route as AppDesignFeaturesReminderSequencesRouteImport } from './routes/_app/design/features/reminder-sequences'
import { Route as AppDesignFeaturesOtivioFrictionlessOnboardingRouteImport } from './routes/_app/design/features/otivio-frictionless-onboarding'
import { Route as AppDesignFeaturesMessagingScheduleRouteImport } from './routes/_app/design/features/messaging-schedule'
import { Route as AppDesignFeaturesManagerStudyClinicianInvitePlanRouteImport } from './routes/_app/design/features/manager-study-clinician-invite-plan'
import { Route as AppDesignFeaturesGeneralisedAnalyticsRouteImport } from './routes/_app/design/features/generalised-analytics'
import { Route as AppDesignComponentsSelectDialogsRouteImport } from './routes/_app/design/components/select-dialogs'
import { Route as AppDesignComponentsSearchFieldsRouteImport } from './routes/_app/design/components/search-fields'
import { Route as AppDesignComponentsInputsRouteImport } from './routes/_app/design/components/inputs'
import { Route as AppDesignComponentsDictionariesRouteImport } from './routes/_app/design/components/dictionaries'
import { Route as AppDesignComponentsButtonsRouteImport } from './routes/_app/design/components/buttons'
import { Route as AppDesignComponentsAuthRouteImport } from './routes/_app/design/components/auth'
import { Route as AppDesignComponentsAnimationsRouteImport } from './routes/_app/design/components/animations'
import { Route as AppBusinessLeadsNewRouteImport } from './routes/_app/business/leads/new'
import { Route as AppBuilderSchedulesNewRouteImport } from './routes/_app/builder/schedules/new'
import { Route as AppBuilderSchedulesScheduleIdRouteImport } from './routes/_app/builder/schedules/$scheduleId'
import { Route as AppBuilderFormsNewRouteImport } from './routes/_app/builder/forms/new'
import { Route as AppBuilderDictionariesDictionaryIdRouteImport } from './routes/_app/builder/dictionaries/$dictionaryId'
import { Route as AppBuilderConsentsConsentBodyIdRouteImport } from './routes/_app/builder/consents/$consentBodyId'
import { Route as AppAdminUserUserIdRouteImport } from './routes/_app/admin/user/$userId'
import { Route as AppAdminSftpUploadRouteImport } from './routes/_app/admin/sftp/upload'
import { Route as AppAdminSftpPreviewRouteImport } from './routes/_app/admin/sftp/preview'
import { Route as AppAdminSftpOrganisationsRouteImport } from './routes/_app/admin/sftp/organisations'
import { Route as AppAdminSftpExplorerRouteImport } from './routes/_app/admin/sftp/explorer'
import { Route as AppAdminSftpDiariesRouteImport } from './routes/_app/admin/sftp/diaries'
import { Route as AppAdminSftpDashboardRouteImport } from './routes/_app/admin/sftp/dashboard'
import { Route as AppAdminOrganisationStatisticsRouteImport } from './routes/_app/admin/organisation/statistics'
import { Route as AppAdminOrganisationLogosRouteImport } from './routes/_app/admin/organisation/logos'
import { Route as AppAdminOrganisationAddRouteImport } from './routes/_app/admin/organisation/add'
import { Route as AppAdminDiariesTypesRouteImport } from './routes/_app/admin/diaries/types'
import { Route as AppAdminCliniciansStatisticsRouteImport } from './routes/_app/admin/clinicians/statistics'
import { Route as AppAdminCliniciansPhotosRouteImport } from './routes/_app/admin/clinicians/photos'
import { Route as AppAdminCliniciansLeaderboardRouteImport } from './routes/_app/admin/clinicians/leaderboard'
import { Route as AppAdminBusinessChurnRouteImport } from './routes/_app/admin/business/churn'
import { Route as AppAdminBusinessAmbassadorsRouteImport } from './routes/_app/admin/business/ambassadors'
import { Route as AppAdminAuditSnapshotRouteImport } from './routes/_app/admin/audit/snapshot'
import { Route as AppAdminAuditLockDiariesRouteImport } from './routes/_app/admin/audit/lock-diaries'
import { Route as AppAdminAuditChangeTimelineRouteImport } from './routes/_app/admin/audit/change-timeline'
import { Route as AppAdminAccessUsersRouteImport } from './routes/_app/admin/access/users'
import { Route as AppAdminAccessTabsRouteImport } from './routes/_app/admin/access/tabs'
import { Route as AppAdminAccessStudiesRouteImport } from './routes/_app/admin/access/studies'
import { Route as AppAdminAccessSchedulesRouteImport } from './routes/_app/admin/access/schedules'
import { Route as AppAdminAccessRolesRouteImport } from './routes/_app/admin/access/roles'
import { Route as AppAdminAccessLabelsRouteImport } from './routes/_app/admin/access/labels'
import { Route as AppAdminAccessFormsRouteImport } from './routes/_app/admin/access/forms'
import { Route as AppAdminAccessAttributeRouteImport } from './routes/_app/admin/access/$attribute'
import { Route as AppAdminBusinessLeadsRouteRouteImport } from './routes/_app/admin/business/leads/route'
import { Route as TrackerTrackerIdFormFormIdIndexRouteImport } from './routes/tracker/$trackerId/form/$formId/index'
import { Route as FormsFormIdPagePageIndexIndexRouteImport } from './routes/forms/$formId/page/$pageIndex/index'
import { Route as AppTemplatesTemplateIdEventsIndexRouteImport } from './routes/_app/templates/$templateId/events/index'
import { Route as AppStudiesStudyIdInviteIndexRouteImport } from './routes/_app/studies/$studyId/invite/index'
import { Route as AppSalesLeadsTouchesIndexRouteImport } from './routes/_app/sales/leads/touches/index'
import { Route as AppSalesLeadsTemplatesIndexRouteImport } from './routes/_app/sales/leads/templates/index'
import { Route as AppSalesLeadsCompaniesIndexRouteImport } from './routes/_app/sales/leads/companies/index'
import { Route as AppSalesLeadsArtifactsIndexRouteImport } from './routes/_app/sales/leads/artifacts/index'
import { Route as AppSalesLeadsLeadIdIndexRouteImport } from './routes/_app/sales/leads/$leadId/index'
import { Route as AppPatientsBulkEventsIndexRouteImport } from './routes/_app/patients/bulk/events.index'
import { Route as AppDiariesDiaryIdHomeIndexRouteImport } from './routes/_app/diaries/$diaryId/home/index'
import { Route as AppDesignFormsPagesIndexRouteImport } from './routes/_app/design/forms/pages/index'
import { Route as AppDesignFeaturesWorklistIndexRouteImport } from './routes/_app/design/features/worklist/index'
import { Route as AppBusinessLeadsTouchesIndexRouteImport } from './routes/_app/business/leads/touches/index'
import { Route as AppBusinessLeadsTemplatesIndexRouteImport } from './routes/_app/business/leads/templates/index'
import { Route as AppBusinessLeadsCompaniesIndexRouteImport } from './routes/_app/business/leads/companies/index'
import { Route as AppBusinessLeadsArtifactsIndexRouteImport } from './routes/_app/business/leads/artifacts/index'
import { Route as AppBusinessLeadsLeadIdIndexRouteImport } from './routes/_app/business/leads/$leadId/index'
import { Route as AppBuilderFormsFormIdIndexRouteImport } from './routes/_app/builder/forms/$formId/index'
import { Route as AppAdminEntryEntryIdIndexRouteImport } from './routes/_app/admin/entry/$entryId/index'
import { Route as AppAdminDiariesDiaryIdIndexRouteImport } from './routes/_app/admin/diaries/$diaryId/index'
import { Route as AppAdminBusinessLeadsIndexRouteImport } from './routes/_app/admin/business/leads/index'
import { Route as ScreenScreenerIdEntryIdPagePageIndexRouteImport } from './routes/screen/$screenerId/$entryId/page/$pageIndex'
import { Route as AppWorklistConsentDiaryIdConsentIdRouteImport } from './routes/_app/worklist/consent/$diaryId/$consentId'
import { Route as AppValidateChangeTrailEntityTypeEntityIdRouteImport } from './routes/_app/validate/change-trail/$entityType.$entityId'
import { Route as AppStudiesStudyIdInviteQrRouteImport } from './routes/_app/studies/$studyId/invite/qr'
import { Route as AppSalesLeadsTouchesTouchIdRouteImport } from './routes/_app/sales/leads/touches/$touchId'
import { Route as AppSalesLeadsTemplatesNewRouteImport } from './routes/_app/sales/leads/templates/new'
import { Route as AppSalesLeadsTemplatesTemplateIdRouteImport } from './routes/_app/sales/leads/templates/$templateId'
import { Route as AppSalesLeadsCompaniesNewRouteImport } from './routes/_app/sales/leads/companies/new'
import { Route as AppSalesLeadsCompaniesCompanyIdRouteImport } from './routes/_app/sales/leads/companies/$companyId'
import { Route as AppSalesLeadsArtifactsNewRouteImport } from './routes/_app/sales/leads/artifacts/new'
import { Route as AppSalesLeadsArtifactsArtifactIdRouteImport } from './routes/_app/sales/leads/artifacts/$artifactId'
import { Route as AppPatientsBulkEventsEventTypeRouteImport } from './routes/_app/patients/bulk/events.$eventType'
import { Route as AppPatientsDiaryIdUpdateTemplatesRouteImport } from './routes/_app/patients/$diaryId/update/templates'
import { Route as AppPatientsDiaryIdUpdateTemplateExistingTrackersRouteImport } from './routes/_app/patients/$diaryId/update/template-existing-trackers'
import { Route as AppPatientsDiaryIdUpdateReviewRouteImport } from './routes/_app/patients/$diaryId/update/review'
import { Route as AppPatientsDiaryIdUpdateFromTemplateRouteImport } from './routes/_app/patients/$diaryId/update/from-template'
import { Route as AppPatientsDiaryIdUpdateExistingTrackersRouteImport } from './routes/_app/patients/$diaryId/update/existing-trackers'
import { Route as AppPatientsDiaryIdUpdateConsentRouteImport } from './routes/_app/patients/$diaryId/update/consent'
import { Route as AppPatientsDiaryIdUpdateAddRouteImport } from './routes/_app/patients/$diaryId/update/add'
import { Route as AppPatientsDiaryIdConsentConsentIdRouteImport } from './routes/_app/patients/$diaryId/consent/$consentId'
import { Route as AppPatientsDiaryIdActionActionIdRouteImport } from './routes/_app/patients/$diaryId/action.$actionId'
import { Route as AppFootWatchDiaryIdNewUploadRouteImport } from './routes/_app/foot-watch/$diaryId/new/upload'
import { Route as AppFootWatchDiaryIdNewStartRouteImport } from './routes/_app/foot-watch/$diaryId/new/start'
import { Route as AppFootWatchDiaryIdNewSelectPatientRouteImport } from './routes/_app/foot-watch/$diaryId/new/select-patient'
import { Route as AppFootWatchDiaryIdNewNewPatientRouteImport } from './routes/_app/foot-watch/$diaryId/new/new-patient'
import { Route as AppFootWatchDiaryIdNewInstructionsRouteImport } from './routes/_app/foot-watch/$diaryId/new/instructions'
import { Route as AppFootWatchDiaryIdNewCameraRouteImport } from './routes/_app/foot-watch/$diaryId/new/camera'
import { Route as AppFootWatchDiaryIdNewAddPhotosRouteImport } from './routes/_app/foot-watch/$diaryId/new/add-photos'
import { Route as AppFootWatchDiaryIdEditNameRouteImport } from './routes/_app/foot-watch/$diaryId/edit/name'
import { Route as AppFootWatchDiaryIdEditDiaryRouteImport } from './routes/_app/foot-watch/$diaryId/edit/diary'
import { Route as AppFootWatchDiaryIdViewProgressRouteImport } from './routes/_app/foot-watch/$diaryId/_view/progress'
import { Route as AppFootWatchDiaryIdViewNewRouteImport } from './routes/_app/foot-watch/$diaryId/_view/new'
import { Route as AppFootWatchDiaryIdViewHistoryRouteImport } from './routes/_app/foot-watch/$diaryId/_view/history'
import { Route as AppDiariesDiaryIdSetupSideRouteImport } from './routes/_app/diaries/$diaryId/setup/side'
import { Route as AppDiariesDiaryIdSetupReferenceDateRouteImport } from './routes/_app/diaries/$diaryId/setup/reference-date'
import { Route as AppDiariesDiaryIdSetupHospitalNumberRouteImport } from './routes/_app/diaries/$diaryId/setup/hospital-number'
import { Route as AppDiariesDiaryIdSetupCompleteRouteImport } from './routes/_app/diaries/$diaryId/setup/complete'
import { Route as AppDiariesDiaryIdHomeToDoRouteImport } from './routes/_app/diaries/$diaryId/home/to-do'
import { Route as AppDiariesDiaryIdHomeResultsRouteImport } from './routes/_app/diaries/$diaryId/home/results'
import { Route as AppDiariesDiaryIdHomeProgressRouteImport } from './routes/_app/diaries/$diaryId/home/progress'
import { Route as AppDiariesDiaryIdHomeFormsRouteImport } from './routes/_app/diaries/$diaryId/home/forms'
import { Route as AppDiariesDiaryIdHomeEditRouteImport } from './routes/_app/diaries/$diaryId/home/edit'
import { Route as AppDesignFormsPagesScreenRouteImport } from './routes/_app/design/forms/pages/$screen'
import { Route as AppDesignFeaturesWorklistAutomationsRouteImport } from './routes/_app/design/features/worklist/automations'
import { Route as AppBusinessLeadsTouchesTouchIdRouteImport } from './routes/_app/business/leads/touches/$touchId'
import { Route as AppBusinessLeadsTemplatesNewRouteImport } from './routes/_app/business/leads/templates/new'
import { Route as AppBusinessLeadsTemplatesTemplateIdRouteImport } from './routes/_app/business/leads/templates/$templateId'
import { Route as AppBusinessLeadsCompaniesNewRouteImport } from './routes/_app/business/leads/companies/new'
import { Route as AppBusinessLeadsCompaniesCompanyIdRouteImport } from './routes/_app/business/leads/companies/$companyId'
import { Route as AppBusinessLeadsArtifactsNewRouteImport } from './routes/_app/business/leads/artifacts/new'
import { Route as AppBusinessLeadsArtifactsArtifactIdRouteImport } from './routes/_app/business/leads/artifacts/$artifactId'
import { Route as AppBuilderSchedulesFormsFormIdRouteImport } from './routes/_app/builder/schedules/forms/formId'
import { Route as AppBuilderFormsFormIdMetadataRouteImport } from './routes/_app/builder/forms/$formId/metadata'
import { Route as AppBuilderFormsFormIdTabRouteImport } from './routes/_app/builder/forms/$formId/$tab'
import { Route as AppAdminFormFormIdResultsRouteImport } from './routes/_app/admin/form/$formId/results'
import { Route as AppAdminBusinessLeadsNewRouteImport } from './routes/_app/admin/business/leads/new'
import { Route as PreviewPatientPatientIdDiaryDiaryIdIndexRouteImport } from './routes/preview/patient/$patientId/diary/$diaryId/index'
import { Route as AppValidateValidationIdFormsFormIdIndexRouteImport } from './routes/_app/validate/$validationId/forms/$formId/index'
import { Route as AppTemplatesTemplateIdEventsSurgeryIndexRouteImport } from './routes/_app/templates/$templateId/events/surgery/index'
import { Route as AppTemplatesTemplateIdEventsShockwaveIndexRouteImport } from './routes/_app/templates/$templateId/events/shockwave/index'
import { Route as AppTemplatesTemplateIdEventsProductIndexRouteImport } from './routes/_app/templates/$templateId/events/product/index'
import { Route as AppTemplatesTemplateIdEventsInjectionIndexRouteImport } from './routes/_app/templates/$templateId/events/injection/index'
import { Route as AppTemplatesTemplateIdEventsEducationIndexRouteImport } from './routes/_app/templates/$templateId/events/education/index'
import { Route as AppPatientsDiaryIdConsentConsentIdIndexRouteImport } from './routes/_app/patients/$diaryId/consent/$consentId/index'
import { Route as AppFootWatchNewDiaryPatientIdDiaryIdIndexRouteImport } from './routes/_app/foot-watch/new-diary/$patientId/$diaryId/index'
import { Route as AppFootWatchDiaryIdNewUploadIndexRouteImport } from './routes/_app/foot-watch/$diaryId/new/upload/index'
import { Route as AppAdminBusinessLeadsTouchesIndexRouteImport } from './routes/_app/admin/business/leads/touches/index'
import { Route as AppAdminBusinessLeadsTemplatesIndexRouteImport } from './routes/_app/admin/business/leads/templates/index'
import { Route as AppAdminBusinessLeadsCompaniesIndexRouteImport } from './routes/_app/admin/business/leads/companies/index'
import { Route as AppAdminBusinessLeadsArtifactsIndexRouteImport } from './routes/_app/admin/business/leads/artifacts/index'
import { Route as AppAdminBusinessLeadsLeadIdIndexRouteImport } from './routes/_app/admin/business/leads/$leadId/index'
import { Route as AppValidateValidationIdFormsFormIdResultsRouteImport } from './routes/_app/validate/$validationId/forms/$formId/results'
import { Route as AppTemplatesDiaryFormInterventionInjectionRouteImport } from './routes/_app/templates/diary/_form/intervention/injection'
import { Route as AppTemplatesTemplateIdEventsSurgeryDetailsRouteImport } from './routes/_app/templates/$templateId/events/surgery/details'
import { Route as AppTemplatesTemplateIdEventsShockwaveDetailsRouteImport } from './routes/_app/templates/$templateId/events/shockwave/details'
import { Route as AppTemplatesTemplateIdEventsInjectionDetailsRouteImport } from './routes/_app/templates/$templateId/events/injection/details'
import { Route as AppPatientsDiaryIdConsentConsentIdCompleteRouteImport } from './routes/_app/patients/$diaryId/consent/$consentId/complete'
import { Route as AppFootWatchDiaryIdNewUploadUploadingRouteImport } from './routes/_app/foot-watch/$diaryId/new/upload/uploading'
import { Route as AppFootWatchDiaryIdNewUploadMessageRouteImport } from './routes/_app/foot-watch/$diaryId/new/upload/message'
import { Route as AppFootWatchDiaryIdNewUploadCompleteRouteImport } from './routes/_app/foot-watch/$diaryId/new/upload/complete'
import { Route as AppDiariesDiaryIdSetupConsentConsentIdRouteImport } from './routes/_app/diaries/$diaryId/setup/consent/$consentId'
import { Route as AppAdminBusinessLeadsTouchesTouchIdRouteImport } from './routes/_app/admin/business/leads/touches/$touchId'
import { Route as AppAdminBusinessLeadsTemplatesNewRouteImport } from './routes/_app/admin/business/leads/templates/new'
import { Route as AppAdminBusinessLeadsTemplatesTemplateIdRouteImport } from './routes/_app/admin/business/leads/templates/$templateId'
import { Route as AppAdminBusinessLeadsCompaniesNewRouteImport } from './routes/_app/admin/business/leads/companies/new'
import { Route as AppAdminBusinessLeadsCompaniesCompanyIdRouteImport } from './routes/_app/admin/business/leads/companies/$companyId'
import { Route as AppAdminBusinessLeadsArtifactsNewRouteImport } from './routes/_app/admin/business/leads/artifacts/new'
import { Route as AppAdminBusinessLeadsArtifactsArtifactIdRouteImport } from './routes/_app/admin/business/leads/artifacts/$artifactId'
import { Route as PreviewRadiologyReportPatientPatientIdEventEventIdIndexRouteImport } from './routes/preview/radiology-report/patient/$patientId/event/$eventId/index'
import { Route as AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRouteImport } from './routes/_app/templates/diary/$diaryId/trackers/$trackerId/index'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdIndexRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/index'
import { Route as AppDiariesDiaryIdSetupConsentConsentIdIndexRouteImport } from './routes/_app/diaries/$diaryId/setup/consent/$consentId/index'
import { Route as AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRouteImport } from './routes/_app/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind'
import { Route as AppValidateValidationIdFormsFormIdPagePageIndexRouteImport } from './routes/_app/validate/$validationId/forms/$formId/page/$pageIndex'
import { Route as AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRouteImport } from './routes/_app/templates/diary/$diaryId/trackers/$trackerId/details'
import { Route as AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRouteImport } from './routes/_app/templates/diary/$diaryId/trackers/$trackerId/date'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdDetailsRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/details'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdCompleteRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/complete'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/questionnaire'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/message'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/intervention'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdDateRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/date'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdContactRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/contact'
import { Route as AppFootWatchDiaryIdNewInstructionsAngleSideRouteImport } from './routes/_app/foot-watch/$diaryId/new/instructions/$angle.$side'
import { Route as AppDiariesDiaryIdSetupConsentConsentIdCompleteRouteImport } from './routes/_app/diaries/$diaryId/setup/consent/$consentId/complete'
import { Route as TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRouteImport } from './routes/tracker/$trackerId/form/$formId/entry/$entryId/page/index'
import { Route as PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRouteImport } from './routes/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/index'
import { Route as AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRouteImport } from './routes/_app/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection'
import { Route as AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRouteImport } from './routes/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education'
import { Route as AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteImport } from './routes/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete'
import { Route as AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteImport } from './routes/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId'
import { Route as TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRouteImport } from './routes/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/index'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/surgery.$surgeryId/index'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/shockwave.$shockwaveId/index'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/product.$productId/index'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/injection.$injectionId/index'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/education.$educationId/index'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/surgery.$surgeryId/details'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/shockwave.$shockwaveId/details'
import { Route as AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRouteImport } from './routes/_app/templates/diary/$diaryId/events/$eventId/injection.$injectionId/details'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete'
import { Route as FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteImport } from './routes/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/route'
import { Route as FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRouteImport } from './routes/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/index'
import { Route as AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport } from './routes/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/index'
import { Route as AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport } from './routes/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/index'
import { Route as FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRouteImport } from './routes/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
import { Route as FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRouteImport } from './routes/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews'
import { Route as FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRouteImport } from './routes/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/index'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/index'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRouteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle.$side'

const PreviewRoute = PreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsIndexRoute = FormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulesRequestRoute = SchedulesRequestRouteImport.update({
  id: '/schedules/request',
  path: '/schedules/request',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewConsentRoute = PreviewConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => PreviewRoute,
} as any)
const PreferencesUserIdRoute = PreferencesUserIdRouteImport.update({
  id: '/preferences/$userId',
  path: '/preferences/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingPhoneRoute = OnboardingPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingNotificationsRoute = OnboardingNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingNameRoute = OnboardingNameRouteImport.update({
  id: '/name',
  path: '/name',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingEmailRoute = OnboardingEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingDateOfBirthRoute = OnboardingDateOfBirthRouteImport.update({
  id: '/date-of-birth',
  path: '/date-of-birth',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCompleteRoute = OnboardingCompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingClinicianNumberRoute =
  OnboardingClinicianNumberRouteImport.update({
    id: '/clinician-number',
    path: '/clinician-number',
    getParentRoute: () => OnboardingRoute,
  } as any)
const FormsRequestRoute = FormsRequestRouteImport.update({
  id: '/forms/request',
  path: '/forms/request',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackPatientRoute = FeedbackPatientRouteImport.update({
  id: '/feedback/patient',
  path: '/feedback/patient',
  getParentRoute: () => rootRouteImport,
} as any)
const CliniciansClinicianIdRoute = CliniciansClinicianIdRouteImport.update({
  id: '/clinicians/$clinicianId',
  path: '/clinicians/$clinicianId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyPaymentRoute = AuthVerifyPaymentRouteImport.update({
  id: '/verify-payment',
  path: '/verify-payment',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerificationCompleteRoute =
  AuthVerificationCompleteRouteImport.update({
    id: '/verification-complete',
    path: '/verification-complete',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthTryDemoRoute = AuthTryDemoRouteImport.update({
  id: '/try-demo',
  path: '/try-demo',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTestRoute = AuthTestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNewDiaryInviteRoute = AuthNewDiaryInviteRouteImport.update({
  id: '/new-diary-invite',
  path: '/new-diary-invite',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMagicRoute = AuthMagicRouteImport.update({
  id: '/magic',
  path: '/magic',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEmailConfirmedRoute = AuthEmailConfirmedRouteImport.update({
  id: '/email-confirmed',
  path: '/email-confirmed',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDeleteAccountRoute = AuthDeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConfirmAccountRoute = AuthConfirmAccountRouteImport.update({
  id: '/confirm-account',
  path: '/confirm-account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthenticationCompleteRoute =
  AuthAuthenticationCompleteRouteImport.update({
    id: '/authentication-complete',
    path: '/authentication-complete',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAuthErrorRoute = AuthAuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => AuthRoute,
} as any)
const AuthActivateAccountRoute = AuthActivateAccountRouteImport.update({
  id: '/activate-account',
  path: '/activate-account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublicRoute = AuthPublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => AuthRoute,
} as any)
const AppWorklistRoute = AppWorklistRouteImport.update({
  id: '/worklist',
  path: '/worklist',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppStudiesRoute = AppStudiesRouteImport.update({
  id: '/studies',
  path: '/studies',
  getParentRoute: () => AppRoute,
} as any)
const AppStatisticsRoute = AppStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRoute = AppSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppRoute,
} as any)
const AppRoleRoute = AppRoleRouteImport.update({
  id: '/role',
  path: '/role',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppPatientsRoute = AppPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => AppRoute,
} as any)
const AppInviteRoute = AppInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AppRoute,
} as any)
const AppDeveloperRoute = AppDeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => AppRoute,
} as any)
const AppDesignRoute = AppDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppCompleteProfileRoute = AppCompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessRoute = AppBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => AppRoute,
} as any)
const AppBuilderRoute = AppBuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRouteRoute = AppUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const ScreenScreenerIdIndexRoute = ScreenScreenerIdIndexRouteImport.update({
  id: '/screen/$screenerId/',
  path: '/screen/$screenerId/',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsFormIdIndexRoute = FormsFormIdIndexRouteImport.update({
  id: '/forms/$formId/',
  path: '/forms/$formId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthNewUserIndexRoute = AuthNewUserIndexRouteImport.update({
  id: '/new-user/',
  path: '/new-user/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthForgotPasswordRoute,
} as any)
const AuthConfirmAccountIndexRoute = AuthConfirmAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthConfirmAccountRoute,
} as any)
const AuthPublicIndexRoute = AuthPublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPublicRoute,
} as any)
const AppWorklistIndexRoute = AppWorklistIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorklistRoute,
} as any)
const AppValidateIndexRoute = AppValidateIndexRouteImport.update({
  id: '/validate/',
  path: '/validate/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppTemplatesIndexRoute = AppTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTemplatesRoute,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTeamRoute,
} as any)
const AppStudiesIndexRoute = AppStudiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStudiesRoute,
} as any)
const AppSchedulesIndexRoute = AppSchedulesIndexRouteImport.update({
  id: '/schedules/',
  path: '/schedules/',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesIndexRoute = AppSalesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppNewIndexRoute = AppNewIndexRouteImport.update({
  id: '/new/',
  path: '/new/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadGenIndexRoute = AppLeadGenIndexRouteImport.update({
  id: '/lead-gen/',
  path: '/lead-gen/',
  getParentRoute: () => AppRoute,
} as any)
const AppInviteIndexRoute = AppInviteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInviteRoute,
} as any)
const AppDiariesIndexRoute = AppDiariesIndexRouteImport.update({
  id: '/diaries/',
  path: '/diaries/',
  getParentRoute: () => AppRoute,
} as any)
const AppDeveloperIndexRoute = AppDeveloperIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDeveloperRoute,
} as any)
const AppDesignIndexRoute = AppDesignIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomersRoute,
} as any)
const AppBusinessIndexRoute = AppBusinessIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBusinessRoute,
} as any)
const AppBuilderIndexRoute = AppBuilderIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppAnalyticsIndexRoute = AppAnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAnalyticsRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const TrackerTrackerIdSuccessRoute = TrackerTrackerIdSuccessRouteImport.update({
  id: '/tracker/$trackerId/success',
  path: '/tracker/$trackerId/success',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackerTrackerIdResultsRoute = TrackerTrackerIdResultsRouteImport.update({
  id: '/tracker/$trackerId/results',
  path: '/tracker/$trackerId/results',
  getParentRoute: () => rootRouteImport,
} as any)
const ScreenScreenerIdResultRoute = ScreenScreenerIdResultRouteImport.update({
  id: '/screen/$screenerId/result',
  path: '/screen/$screenerId/result',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewInviteQrCodeRoute = PreviewInviteQrCodeRouteImport.update({
  id: '/invite/qr-code',
  path: '/invite/qr-code',
  getParentRoute: () => PreviewRoute,
} as any)
const PreviewConsentConsentIdRoute = PreviewConsentConsentIdRouteImport.update({
  id: '/$consentId',
  path: '/$consentId',
  getParentRoute: () => PreviewConsentRoute,
} as any)
const OnboardingClinicianProfessionalRoute =
  OnboardingClinicianProfessionalRouteImport.update({
    id: '/clinician/professional',
    path: '/clinician/professional',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingClinicianOrganisationRoute =
  OnboardingClinicianOrganisationRouteImport.update({
    id: '/clinician/organisation',
    path: '/clinician/organisation',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingClinicianNameRoute = OnboardingClinicianNameRouteImport.update({
  id: '/clinician/name',
  path: '/clinician/name',
  getParentRoute: () => OnboardingRoute,
} as any)
const HelpExplainerExplainerTypeRoute =
  HelpExplainerExplainerTypeRouteImport.update({
    id: '/help/explainer/$explainerType',
    path: '/help/explainer/$explainerType',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthMfaEnrollRoute = AuthMfaEnrollRouteImport.update({
  id: '/mfa/enroll',
  path: '/mfa/enroll',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMfaChallengeRoute = AuthMfaChallengeRouteImport.update({
  id: '/mfa/challenge',
  path: '/mfa/challenge',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordVerifyRoute =
  AuthForgotPasswordVerifyRouteImport.update({
    id: '/verify',
    path: '/verify',
    getParentRoute: () => AuthForgotPasswordRoute,
  } as any)
const AuthConfirmAccountVerifyRoute =
  AuthConfirmAccountVerifyRouteImport.update({
    id: '/verify',
    path: '/verify',
    getParentRoute: () => AuthConfirmAccountRoute,
  } as any)
const AuthPublicLoginRoute = AuthPublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthPublicRoute,
} as any)
const AuthPublicAuthenticateRoute = AuthPublicAuthenticateRouteImport.update({
  id: '/authenticate',
  path: '/authenticate',
  getParentRoute: () => AuthPublicRoute,
} as any)
const AppWorklistCompleteRoute = AppWorklistCompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => AppWorklistRoute,
} as any)
const AppValidateValidationIdRoute = AppValidateValidationIdRouteImport.update({
  id: '/validate/$validationId',
  path: '/validate/$validationId',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersSecretariesRoute = AppUsersSecretariesRouteImport.update({
  id: '/secretaries',
  path: '/secretaries',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersPreferencesRoute = AppUsersPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersPatientsRoute = AppUsersPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersOrganisationsRoute = AppUsersOrganisationsRouteImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersManagersRoute = AppUsersManagersRouteImport.update({
  id: '/managers',
  path: '/managers',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersCliniciansRoute = AppUsersCliniciansRouteImport.update({
  id: '/clinicians',
  path: '/clinicians',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersBillingRoute = AppUsersBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersAdminsRoute = AppUsersAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppTemplatesQuickstartPageRoute =
  AppTemplatesQuickstartPageRouteImport.update({
    id: '/quickstart-page',
    path: '/quickstart-page',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesPublicRoute = AppTemplatesPublicRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => AppTemplatesRoute,
} as any)
const AppTemplatesCompleteRoute = AppTemplatesCompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => AppTemplatesRoute,
} as any)
const AppTemplatesTemplateIdRoute = AppTemplatesTemplateIdRouteImport.update({
  id: '/$templateId',
  path: '/$templateId',
  getParentRoute: () => AppTemplatesRoute,
} as any)
const AppTeamInviteRoute = AppTeamInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AppTeamRoute,
} as any)
const AppStudiesStudyIdRoute = AppStudiesStudyIdRouteImport.update({
  id: '/$studyId',
  path: '/$studyId',
  getParentRoute: () => AppStudiesRoute,
} as any)
const AppSchedulesScheduleIdRoute = AppSchedulesScheduleIdRouteImport.update({
  id: '/schedules/$scheduleId',
  path: '/schedules/$scheduleId',
  getParentRoute: () => AppRoute,
} as any)
const AppProfilePhoneRoute = AppProfilePhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileOrganisationRoute = AppProfileOrganisationRouteImport.update({
  id: '/organisation',
  path: '/organisation',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileNotificationsRoute = AppProfileNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileNhsNumberRoute = AppProfileNhsNumberRouteImport.update({
  id: '/nhs-number',
  path: '/nhs-number',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileNameRoute = AppProfileNameRouteImport.update({
  id: '/name',
  path: '/name',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileMfaRoute = AppProfileMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileEmailRoute = AppProfileEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileDeleteAccountRoute = AppProfileDeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileDateOfBirthRoute = AppProfileDateOfBirthRouteImport.update({
  id: '/date-of-birth',
  path: '/date-of-birth',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileClinicianNumberRoute =
  AppProfileClinicianNumberRouteImport.update({
    id: '/clinician-number',
    path: '/clinician-number',
    getParentRoute: () => AppProfileRoute,
  } as any)
const AppProfileChangePasswordRoute =
  AppProfileChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => AppProfileRoute,
  } as any)
const AppProfileBillingRoute = AppProfileBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppProfileRoute,
} as any)
const AppProfileAddImagingCenterRoute =
  AppProfileAddImagingCenterRouteImport.update({
    id: '/add-imaging-center',
    path: '/add-imaging-center',
    getParentRoute: () => AppProfileRoute,
  } as any)
const AppPatientsDiaryIdRoute = AppPatientsDiaryIdRouteImport.update({
  id: '/$diaryId',
  path: '/$diaryId',
  getParentRoute: () => AppPatientsRoute,
} as any)
const AppNewSplatRoute = AppNewSplatRouteImport.update({
  id: '/new/$',
  path: '/new/$',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadGenSplatRoute = AppLeadGenSplatRouteImport.update({
  id: '/lead-gen/$',
  path: '/lead-gen/$',
  getParentRoute: () => AppRoute,
} as any)
const AppInviteQrCodeRoute = AppInviteQrCodeRouteImport.update({
  id: '/qr-code',
  path: '/qr-code',
  getParentRoute: () => AppInviteRoute,
} as any)
const AppHelpPatientRoute = AppHelpPatientRouteImport.update({
  id: '/help/patient',
  path: '/help/patient',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpClinicianRoute = AppHelpClinicianRouteImport.update({
  id: '/help/clinician',
  path: '/help/clinician',
  getParentRoute: () => AppRoute,
} as any)
const AppHeadacheWatchDashboardRoute =
  AppHeadacheWatchDashboardRouteImport.update({
    id: '/headache-watch/dashboard',
    path: '/headache-watch/dashboard',
    getParentRoute: () => AppRoute,
  } as any)
const AppFootWatchDiaryIdRoute = AppFootWatchDiaryIdRouteImport.update({
  id: '/foot-watch/$diaryId',
  path: '/foot-watch/$diaryId',
  getParentRoute: () => AppRoute,
} as any)
const AppFisherWatchDashboardRoute = AppFisherWatchDashboardRouteImport.update({
  id: '/fisher-watch/dashboard',
  path: '/fisher-watch/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDiariesDiaryIdRoute = AppDiariesDiaryIdRouteImport.update({
  id: '/diaries/$diaryId',
  path: '/diaries/$diaryId',
  getParentRoute: () => AppRoute,
} as any)
const AppDeveloperSmsDeliverabilityRoute =
  AppDeveloperSmsDeliverabilityRouteImport.update({
    id: '/sms-deliverability',
    path: '/sms-deliverability',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperReminderSendVolumeRoute =
  AppDeveloperReminderSendVolumeRouteImport.update({
    id: '/reminder-send-volume',
    path: '/reminder-send-volume',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperMessagingScheduleRoute =
  AppDeveloperMessagingScheduleRouteImport.update({
    id: '/messaging-schedule',
    path: '/messaging-schedule',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperHealthCheckRoute = AppDeveloperHealthCheckRouteImport.update({
  id: '/health-check',
  path: '/health-check',
  getParentRoute: () => AppDeveloperRoute,
} as any)
const AppCustomersSuccessRoute = AppCustomersSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AppCustomersRoute,
} as any)
const AppCustomersCliniciansRoute = AppCustomersCliniciansRouteImport.update({
  id: '/clinicians',
  path: '/clinicians',
  getParentRoute: () => AppCustomersRoute,
} as any)
const AppCustomersChurnRoute = AppCustomersChurnRouteImport.update({
  id: '/churn',
  path: '/churn',
  getParentRoute: () => AppCustomersRoute,
} as any)
const AppCustomersAnonymousRoute = AppCustomersAnonymousRouteImport.update({
  id: '/anonymous',
  path: '/anonymous',
  getParentRoute: () => AppCustomersRoute,
} as any)
const AppCustomersAmbassadorsRoute = AppCustomersAmbassadorsRouteImport.update({
  id: '/ambassadors',
  path: '/ambassadors',
  getParentRoute: () => AppCustomersRoute,
} as any)
const AppClinicianDiariesRoute = AppClinicianDiariesRouteImport.update({
  id: '/clinician/diaries',
  path: '/clinician/diaries',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessChurnRoute = AppBusinessChurnRouteImport.update({
  id: '/churn',
  path: '/churn',
  getParentRoute: () => AppBusinessRoute,
} as any)
const AppBusinessAmbassadorsRoute = AppBusinessAmbassadorsRouteImport.update({
  id: '/ambassadors',
  path: '/ambassadors',
  getParentRoute: () => AppBusinessRoute,
} as any)
const AppAnalyticsArthrosamidRoute = AppAnalyticsArthrosamidRouteImport.update({
  id: '/arthrosamid',
  path: '/arthrosamid',
  getParentRoute: () => AppAnalyticsRoute,
} as any)
const AppAnalyticsAnikaRoute = AppAnalyticsAnikaRouteImport.update({
  id: '/anika',
  path: '/anika',
  getParentRoute: () => AppAnalyticsRoute,
} as any)
const AppAnalyticsDiaryLabelRoute = AppAnalyticsDiaryLabelRouteImport.update({
  id: '/$diaryLabel',
  path: '/$diaryLabel',
  getParentRoute: () => AppAnalyticsRoute,
} as any)
const AppAdminViewDiaryAsPatientRoute =
  AppAdminViewDiaryAsPatientRouteImport.update({
    id: '/view-diary-as-patient',
    path: '/view-diary-as-patient',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminUserOrganisationsRoute =
  AppAdminUserOrganisationsRouteImport.update({
    id: '/user-organisations',
    path: '/user-organisations',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminUserBillingRoute = AppAdminUserBillingRouteImport.update({
  id: '/user-billing',
  path: '/user-billing',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTrackersRoute = AppAdminTrackersRouteImport.update({
  id: '/trackers',
  path: '/trackers',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTemplatesRoute = AppAdminTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminStudiesRoute = AppAdminStudiesRouteImport.update({
  id: '/studies',
  path: '/studies',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSmsDeliverabilityRoute =
  AppAdminSmsDeliverabilityRouteImport.update({
    id: '/sms-deliverability',
    path: '/sms-deliverability',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminReminderSendVolumeRoute =
  AppAdminReminderSendVolumeRouteImport.update({
    id: '/reminder-send-volume',
    path: '/reminder-send-volume',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminNotificationPreferencesRoute =
  AppAdminNotificationPreferencesRouteImport.update({
    id: '/notification-preferences',
    path: '/notification-preferences',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminLabelsRoute = AppAdminLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminLabelAccessRoute = AppAdminLabelAccessRouteImport.update({
  id: '/label-access',
  path: '/label-access',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminImpersonateUserRoute = AppAdminImpersonateUserRouteImport.update({
  id: '/impersonate-user',
  path: '/impersonate-user',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminHealthCheckRoute = AppAdminHealthCheckRouteImport.update({
  id: '/health-check',
  path: '/health-check',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminEventsRoute = AppAdminEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminEntryValuesRoute = AppAdminEntryValuesRouteImport.update({
  id: '/entry-values',
  path: '/entry-values',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminEntriesRoute = AppAdminEntriesRouteImport.update({
  id: '/entries',
  path: '/entries',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAmbassadorsRoute = AppAdminAmbassadorsRouteImport.update({
  id: '/ambassadors',
  path: '/ambassadors',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppUsersNotificationsRouteRoute =
  AppUsersNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppUsersRouteRoute,
  } as any)
const AppUsersCreateUserRouteRoute = AppUsersCreateUserRouteRouteImport.update({
  id: '/create-user',
  path: '/create-user',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppSalesLeadsRouteRoute = AppSalesLeadsRouteRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppDeveloperSftpRouteRoute = AppDeveloperSftpRouteRouteImport.update({
  id: '/sftp',
  path: '/sftp',
  getParentRoute: () => AppDeveloperRoute,
} as any)
const AppBusinessLeadsRouteRoute = AppBusinessLeadsRouteRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppBusinessRoute,
} as any)
const AppAdminSftpRouteRoute = AppAdminSftpRouteRouteImport.update({
  id: '/sftp',
  path: '/sftp',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOrganisationRouteRoute =
  AppAdminOrganisationRouteRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminAuditRouteRoute = AppAdminAuditRouteRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAccessRouteRoute = AppAdminAccessRouteRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AppAdminRoute,
} as any)
const AuthNewUserPatientIndexRoute = AuthNewUserPatientIndexRouteImport.update({
  id: '/new-user/patient/',
  path: '/new-user/patient/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNewUserClinicianIndexRoute =
  AuthNewUserClinicianIndexRouteImport.update({
    id: '/new-user/clinician/',
    path: '/new-user/clinician/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPublicSignupIndexRoute = AuthPublicSignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => AuthPublicRoute,
} as any)
const AuthPublicLoginIndexRoute = AuthPublicLoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPublicLoginRoute,
} as any)
const AppValidateValidationIdIndexRoute =
  AppValidateValidationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppValidateValidationIdRoute,
  } as any)
const AppUsersNotificationsIndexRoute =
  AppUsersNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUsersNotificationsRouteRoute,
  } as any)
const AppUsersCreateUserIndexRoute = AppUsersCreateUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUsersCreateUserRouteRoute,
} as any)
const AppTeamInviteIndexRoute = AppTeamInviteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTeamInviteRoute,
} as any)
const AppStudiesStudyIdIndexRoute = AppStudiesStudyIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStudiesStudyIdRoute,
} as any)
const AppSalesLeadsIndexRoute = AppSalesLeadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalesLeadsRouteRoute,
} as any)
const AppPatientsDiaryIdIndexRoute = AppPatientsDiaryIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPatientsDiaryIdRoute,
} as any)
const AppOrganisationOrganisationIdIndexRoute =
  AppOrganisationOrganisationIdIndexRouteImport.update({
    id: '/organisation/$organisationId/',
    path: '/organisation/$organisationId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDiariesDiaryIdIndexRoute = AppDiariesDiaryIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDiariesDiaryIdRoute,
} as any)
const AppDeveloperSftpIndexRoute = AppDeveloperSftpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDeveloperSftpRouteRoute,
} as any)
const AppDesignIconsIndexRoute = AppDesignIconsIndexRouteImport.update({
  id: '/icons/',
  path: '/icons/',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppDesignFormsIndexRoute = AppDesignFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppBusinessLeadsIndexRoute = AppBusinessLeadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBusinessLeadsRouteRoute,
} as any)
const AppBuilderTemplatesIndexRoute =
  AppBuilderTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderSurgeriesIndexRoute =
  AppBuilderSurgeriesIndexRouteImport.update({
    id: '/surgeries/',
    path: '/surgeries/',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderSchedulesIndexRoute =
  AppBuilderSchedulesIndexRouteImport.update({
    id: '/schedules/',
    path: '/schedules/',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderOptionsIndexRoute = AppBuilderOptionsIndexRouteImport.update({
  id: '/options/',
  path: '/options/',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppBuilderMessagesIndexRoute = AppBuilderMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppBuilderLabelsIndexRoute = AppBuilderLabelsIndexRouteImport.update({
  id: '/labels/',
  path: '/labels/',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppBuilderInjectionLocationsIndexRoute =
  AppBuilderInjectionLocationsIndexRouteImport.update({
    id: '/injection-locations/',
    path: '/injection-locations/',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderInjectionContentsIndexRoute =
  AppBuilderInjectionContentsIndexRouteImport.update({
    id: '/injection-contents/',
    path: '/injection-contents/',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderFormsIndexRoute = AppBuilderFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppBuilderDictionariesIndexRoute =
  AppBuilderDictionariesIndexRouteImport.update({
    id: '/dictionaries/',
    path: '/dictionaries/',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderConsentsIndexRoute = AppBuilderConsentsIndexRouteImport.update({
  id: '/consents/',
  path: '/consents/',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppAdminUserActivationIndexRoute =
  AppAdminUserActivationIndexRouteImport.update({
    id: '/user-activation/',
    path: '/user-activation/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminSftpIndexRoute = AppAdminSftpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSftpRouteRoute,
} as any)
const AppAdminOrganisationIndexRoute =
  AppAdminOrganisationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminOrganisationRouteRoute,
  } as any)
const AppAdminDiariesIndexRoute = AppAdminDiariesIndexRouteImport.update({
  id: '/diaries/',
  path: '/diaries/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCliniciansIndexRoute = AppAdminCliniciansIndexRouteImport.update({
  id: '/clinicians/',
  path: '/clinicians/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminBusinessIndexRoute = AppAdminBusinessIndexRouteImport.update({
  id: '/business/',
  path: '/business/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditIndexRoute = AppAdminAuditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminAuditRouteRoute,
} as any)
const AppAdminAccessIndexRoute = AppAdminAccessIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AuthPublicSignupVerifyPhoneRoute =
  AuthPublicSignupVerifyPhoneRouteImport.update({
    id: '/signup/verify-phone',
    path: '/signup/verify-phone',
    getParentRoute: () => AuthPublicRoute,
  } as any)
const AuthPublicSignupTrialRoute = AuthPublicSignupTrialRouteImport.update({
  id: '/signup/trial',
  path: '/signup/trial',
  getParentRoute: () => AuthPublicRoute,
} as any)
const AuthPublicSignupPlanRoute = AuthPublicSignupPlanRouteImport.update({
  id: '/signup/$plan',
  path: '/signup/$plan',
  getParentRoute: () => AuthPublicRoute,
} as any)
const AuthPublicLoginVerifyRoute = AuthPublicLoginVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthPublicLoginRoute,
} as any)
const AppUsersSecretariesUserIdRoute =
  AppUsersSecretariesUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AppUsersSecretariesRoute,
  } as any)
const AppUsersPatientsUserIdRoute = AppUsersPatientsUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppUsersPatientsRoute,
} as any)
const AppUsersNotificationsSmsRoute =
  AppUsersNotificationsSmsRouteImport.update({
    id: '/sms',
    path: '/sms',
    getParentRoute: () => AppUsersNotificationsRouteRoute,
  } as any)
const AppUsersManagersUserIdRoute = AppUsersManagersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppUsersManagersRoute,
} as any)
const AppUsersCreateUserTemplatesRoute =
  AppUsersCreateUserTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AppUsersCreateUserRouteRoute,
  } as any)
const AppUsersCreateUserOrganisationsRoute =
  AppUsersCreateUserOrganisationsRouteImport.update({
    id: '/organisations',
    path: '/organisations',
    getParentRoute: () => AppUsersCreateUserRouteRoute,
  } as any)
const AppUsersCreateUserImpersonateRoute =
  AppUsersCreateUserImpersonateRouteImport.update({
    id: '/impersonate',
    path: '/impersonate',
    getParentRoute: () => AppUsersCreateUserRouteRoute,
  } as any)
const AppUsersCreateUserDetailsRoute =
  AppUsersCreateUserDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AppUsersCreateUserRouteRoute,
  } as any)
const AppUsersCreateUserBillingRoute =
  AppUsersCreateUserBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppUsersCreateUserRouteRoute,
  } as any)
const AppUsersCreateUserAccessRoute =
  AppUsersCreateUserAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AppUsersCreateUserRouteRoute,
  } as any)
const AppUsersCliniciansUserIdRoute =
  AppUsersCliniciansUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AppUsersCliniciansRoute,
  } as any)
const AppUsersAdminsUserIdRoute = AppUsersAdminsUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppUsersAdminsRoute,
} as any)
const AppTemplatesDiaryTemplateIdRoute =
  AppTemplatesDiaryTemplateIdRouteImport.update({
    id: '/diary/$templateId',
    path: '/diary/$templateId',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesDiaryNewDiaryTemplateIdRoute =
  AppTemplatesDiaryNewDiaryTemplateIdRouteImport.update({
    id: '/diary/$newDiaryTemplateId',
    path: '/diary/$newDiaryTemplateId',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesTemplateIdTrackersRoute =
  AppTemplatesTemplateIdTrackersRouteImport.update({
    id: '/trackers',
    path: '/trackers',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdScreenerRoute =
  AppTemplatesTemplateIdScreenerRouteImport.update({
    id: '/screener',
    path: '/screener',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdPublishRoute =
  AppTemplatesTemplateIdPublishRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdOrganisationRoute =
  AppTemplatesTemplateIdOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdNameRoute =
  AppTemplatesTemplateIdNameRouteImport.update({
    id: '/name',
    path: '/name',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdLabelsRoute =
  AppTemplatesTemplateIdLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdHospitalNumberRoute =
  AppTemplatesTemplateIdHospitalNumberRouteImport.update({
    id: '/hospital-number',
    path: '/hospital-number',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdDateRoute =
  AppTemplatesTemplateIdDateRouteImport.update({
    id: '/date',
    path: '/date',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdConsentRoute =
  AppTemplatesTemplateIdConsentRouteImport.update({
    id: '/consent',
    path: '/consent',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTeamInviteQrRoute = AppTeamInviteQrRouteImport.update({
  id: '/qr',
  path: '/qr',
  getParentRoute: () => AppTeamInviteRoute,
} as any)
const AppTeamInviteEmailRoute = AppTeamInviteEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppTeamInviteRoute,
} as any)
const AppStudiesStudyIdEditRoute = AppStudiesStudyIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AppStudiesStudyIdRoute,
} as any)
const AppSalesLeadsNewRoute = AppSalesLeadsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppSalesLeadsRouteRoute,
} as any)
const AppProfileMedicalDiabetesRoute =
  AppProfileMedicalDiabetesRouteImport.update({
    id: '/medical/diabetes',
    path: '/medical/diabetes',
    getParentRoute: () => AppProfileRoute,
  } as any)
const AppPatientsBulkReviewedRoute = AppPatientsBulkReviewedRouteImport.update({
  id: '/bulk/reviewed',
  path: '/bulk/reviewed',
  getParentRoute: () => AppPatientsRoute,
} as any)
const AppPatientsBulkOrganisationRoute =
  AppPatientsBulkOrganisationRouteImport.update({
    id: '/bulk/organisation',
    path: '/bulk/organisation',
    getParentRoute: () => AppPatientsRoute,
  } as any)
const AppPatientsBulkMessageRoute = AppPatientsBulkMessageRouteImport.update({
  id: '/bulk/message',
  path: '/bulk/message',
  getParentRoute: () => AppPatientsRoute,
} as any)
const AppPatientsBulkLabelsRoute = AppPatientsBulkLabelsRouteImport.update({
  id: '/bulk/labels',
  path: '/bulk/labels',
  getParentRoute: () => AppPatientsRoute,
} as any)
const AppPatientsBulkEventsRoute = AppPatientsBulkEventsRouteImport.update({
  id: '/bulk/events',
  path: '/bulk/events',
  getParentRoute: () => AppPatientsRoute,
} as any)
const AppPatientsBulkContactRoute = AppPatientsBulkContactRouteImport.update({
  id: '/bulk/contact',
  path: '/bulk/contact',
  getParentRoute: () => AppPatientsRoute,
} as any)
const AppPatientsDiaryIdEditRoute = AppPatientsDiaryIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AppPatientsDiaryIdRoute,
} as any)
const AppOrganisationOrganisationIdQrCodeRoute =
  AppOrganisationOrganisationIdQrCodeRouteImport.update({
    id: '/organisation/$organisationId/qr-code',
    path: '/organisation/$organisationId/qr-code',
    getParentRoute: () => AppRoute,
  } as any)
const AppInviteDiaryReviewRoute = AppInviteDiaryReviewRouteImport.update({
  id: '/diary/review',
  path: '/diary/review',
  getParentRoute: () => AppInviteRoute,
} as any)
const AppInviteDiaryQrRoute = AppInviteDiaryQrRouteImport.update({
  id: '/diary/qr',
  path: '/diary/qr',
  getParentRoute: () => AppInviteRoute,
} as any)
const AppInviteDiaryPatientRoute = AppInviteDiaryPatientRouteImport.update({
  id: '/diary/patient',
  path: '/diary/patient',
  getParentRoute: () => AppInviteRoute,
} as any)
const AppInviteDiaryOrganisationRoute =
  AppInviteDiaryOrganisationRouteImport.update({
    id: '/diary/organisation',
    path: '/diary/organisation',
    getParentRoute: () => AppInviteRoute,
  } as any)
const AppInviteDiaryCompleteRoute = AppInviteDiaryCompleteRouteImport.update({
  id: '/diary/complete',
  path: '/diary/complete',
  getParentRoute: () => AppInviteRoute,
} as any)
const AppFootWatchNewDiaryShareRoute =
  AppFootWatchNewDiaryShareRouteImport.update({
    id: '/foot-watch/new-diary/share',
    path: '/foot-watch/new-diary/share',
    getParentRoute: () => AppRoute,
  } as any)
const AppFootWatchDiaryIdEditRoute = AppFootWatchDiaryIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AppFootWatchDiaryIdRoute,
} as any)
const AppFootWatchDiaryIdViewRoute = AppFootWatchDiaryIdViewRouteImport.update({
  id: '/_view',
  getParentRoute: () => AppFootWatchDiaryIdRoute,
} as any)
const AppDiariesDiaryIdSetupRoute = AppDiariesDiaryIdSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppDiariesDiaryIdRoute,
} as any)
const AppDiariesDiaryIdProgressRoute =
  AppDiariesDiaryIdProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)
const AppDiariesDiaryIdHomeRoute = AppDiariesDiaryIdHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppDiariesDiaryIdRoute,
} as any)
const AppDiariesDiaryIdFormsRoute = AppDiariesDiaryIdFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AppDiariesDiaryIdRoute,
} as any)
const AppDeveloperUiInputsRoute = AppDeveloperUiInputsRouteImport.update({
  id: '/ui/inputs',
  path: '/ui/inputs',
  getParentRoute: () => AppDeveloperRoute,
} as any)
const AppDeveloperUiInputSwitchRoute =
  AppDeveloperUiInputSwitchRouteImport.update({
    id: '/ui/input-switch',
    path: '/ui/input-switch',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperUiEntryValuesRoute =
  AppDeveloperUiEntryValuesRouteImport.update({
    id: '/ui/entry-values',
    path: '/ui/entry-values',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperUiDictionariesRoute =
  AppDeveloperUiDictionariesRouteImport.update({
    id: '/ui/dictionaries',
    path: '/ui/dictionaries',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperUiButtonsRoute = AppDeveloperUiButtonsRouteImport.update({
  id: '/ui/buttons',
  path: '/ui/buttons',
  getParentRoute: () => AppDeveloperRoute,
} as any)
const AppDeveloperUiAuthRoute = AppDeveloperUiAuthRouteImport.update({
  id: '/ui/auth',
  path: '/ui/auth',
  getParentRoute: () => AppDeveloperRoute,
} as any)
const AppDeveloperUiAnimationsRoute =
  AppDeveloperUiAnimationsRouteImport.update({
    id: '/ui/animations',
    path: '/ui/animations',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperSftpUploadRoute = AppDeveloperSftpUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => AppDeveloperSftpRouteRoute,
} as any)
const AppDeveloperSftpPreviewRoute = AppDeveloperSftpPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => AppDeveloperSftpRouteRoute,
} as any)
const AppDeveloperSftpOrganisationsRoute =
  AppDeveloperSftpOrganisationsRouteImport.update({
    id: '/organisations',
    path: '/organisations',
    getParentRoute: () => AppDeveloperSftpRouteRoute,
  } as any)
const AppDeveloperSftpExplorerRoute =
  AppDeveloperSftpExplorerRouteImport.update({
    id: '/explorer',
    path: '/explorer',
    getParentRoute: () => AppDeveloperSftpRouteRoute,
  } as any)
const AppDeveloperSftpDiariesRoute = AppDeveloperSftpDiariesRouteImport.update({
  id: '/diaries',
  path: '/diaries',
  getParentRoute: () => AppDeveloperSftpRouteRoute,
} as any)
const AppDeveloperSftpDashboardRoute =
  AppDeveloperSftpDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppDeveloperSftpRouteRoute,
  } as any)
const AppDeveloperDemosOtivioFrictionlessOnboardingRoute =
  AppDeveloperDemosOtivioFrictionlessOnboardingRouteImport.update({
    id: '/demos/otivio-frictionless-onboarding',
    path: '/demos/otivio-frictionless-onboarding',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperDemosManagerStudyClinicianInvitePlanRoute =
  AppDeveloperDemosManagerStudyClinicianInvitePlanRouteImport.update({
    id: '/demos/manager-study-clinician-invite-plan',
    path: '/demos/manager-study-clinician-invite-plan',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDeveloperDemosGeneralisedAnalyticsRoute =
  AppDeveloperDemosGeneralisedAnalyticsRouteImport.update({
    id: '/demos/generalised-analytics',
    path: '/demos/generalised-analytics',
    getParentRoute: () => AppDeveloperRoute,
  } as any)
const AppDesignIconsStatesRoute = AppDesignIconsStatesRouteImport.update({
  id: '/icons/states',
  path: '/icons/states',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppDesignIconsFacesRoute = AppDesignIconsFacesRouteImport.update({
  id: '/icons/faces',
  path: '/icons/faces',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppDesignIconsAnimationsRoute =
  AppDesignIconsAnimationsRouteImport.update({
    id: '/icons/animations',
    path: '/icons/animations',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignFormsPagesRoute = AppDesignFormsPagesRouteImport.update({
  id: '/forms/pages',
  path: '/forms/pages',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppDesignFormsInputsRoute = AppDesignFormsInputsRouteImport.update({
  id: '/forms/inputs',
  path: '/forms/inputs',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppDesignFormsEntryValuesRoute =
  AppDesignFormsEntryValuesRouteImport.update({
    id: '/forms/entry-values',
    path: '/forms/entry-values',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignFormsBlocksRoute = AppDesignFormsBlocksRouteImport.update({
  id: '/forms/blocks',
  path: '/forms/blocks',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppDesignFeaturesReminderSequencesRoute =
  AppDesignFeaturesReminderSequencesRouteImport.update({
    id: '/features/reminder-sequences',
    path: '/features/reminder-sequences',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignFeaturesOtivioFrictionlessOnboardingRoute =
  AppDesignFeaturesOtivioFrictionlessOnboardingRouteImport.update({
    id: '/features/otivio-frictionless-onboarding',
    path: '/features/otivio-frictionless-onboarding',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignFeaturesMessagingScheduleRoute =
  AppDesignFeaturesMessagingScheduleRouteImport.update({
    id: '/features/messaging-schedule',
    path: '/features/messaging-schedule',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignFeaturesManagerStudyClinicianInvitePlanRoute =
  AppDesignFeaturesManagerStudyClinicianInvitePlanRouteImport.update({
    id: '/features/manager-study-clinician-invite-plan',
    path: '/features/manager-study-clinician-invite-plan',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignFeaturesGeneralisedAnalyticsRoute =
  AppDesignFeaturesGeneralisedAnalyticsRouteImport.update({
    id: '/features/generalised-analytics',
    path: '/features/generalised-analytics',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignComponentsSelectDialogsRoute =
  AppDesignComponentsSelectDialogsRouteImport.update({
    id: '/components/select-dialogs',
    path: '/components/select-dialogs',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignComponentsSearchFieldsRoute =
  AppDesignComponentsSearchFieldsRouteImport.update({
    id: '/components/search-fields',
    path: '/components/search-fields',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignComponentsInputsRoute =
  AppDesignComponentsInputsRouteImport.update({
    id: '/components/inputs',
    path: '/components/inputs',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignComponentsDictionariesRoute =
  AppDesignComponentsDictionariesRouteImport.update({
    id: '/components/dictionaries',
    path: '/components/dictionaries',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignComponentsButtonsRoute =
  AppDesignComponentsButtonsRouteImport.update({
    id: '/components/buttons',
    path: '/components/buttons',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppDesignComponentsAuthRoute = AppDesignComponentsAuthRouteImport.update({
  id: '/components/auth',
  path: '/components/auth',
  getParentRoute: () => AppDesignRoute,
} as any)
const AppDesignComponentsAnimationsRoute =
  AppDesignComponentsAnimationsRouteImport.update({
    id: '/components/animations',
    path: '/components/animations',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppBusinessLeadsNewRoute = AppBusinessLeadsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppBusinessLeadsRouteRoute,
} as any)
const AppBuilderSchedulesNewRoute = AppBuilderSchedulesNewRouteImport.update({
  id: '/schedules/new',
  path: '/schedules/new',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppBuilderSchedulesScheduleIdRoute =
  AppBuilderSchedulesScheduleIdRouteImport.update({
    id: '/schedules/$scheduleId',
    path: '/schedules/$scheduleId',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderFormsNewRoute = AppBuilderFormsNewRouteImport.update({
  id: '/forms/new',
  path: '/forms/new',
  getParentRoute: () => AppBuilderRoute,
} as any)
const AppBuilderDictionariesDictionaryIdRoute =
  AppBuilderDictionariesDictionaryIdRouteImport.update({
    id: '/dictionaries/$dictionaryId',
    path: '/dictionaries/$dictionaryId',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderConsentsConsentBodyIdRoute =
  AppBuilderConsentsConsentBodyIdRouteImport.update({
    id: '/consents/$consentBodyId',
    path: '/consents/$consentBodyId',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppAdminUserUserIdRoute = AppAdminUserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSftpUploadRoute = AppAdminSftpUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => AppAdminSftpRouteRoute,
} as any)
const AppAdminSftpPreviewRoute = AppAdminSftpPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => AppAdminSftpRouteRoute,
} as any)
const AppAdminSftpOrganisationsRoute =
  AppAdminSftpOrganisationsRouteImport.update({
    id: '/organisations',
    path: '/organisations',
    getParentRoute: () => AppAdminSftpRouteRoute,
  } as any)
const AppAdminSftpExplorerRoute = AppAdminSftpExplorerRouteImport.update({
  id: '/explorer',
  path: '/explorer',
  getParentRoute: () => AppAdminSftpRouteRoute,
} as any)
const AppAdminSftpDiariesRoute = AppAdminSftpDiariesRouteImport.update({
  id: '/diaries',
  path: '/diaries',
  getParentRoute: () => AppAdminSftpRouteRoute,
} as any)
const AppAdminSftpDashboardRoute = AppAdminSftpDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppAdminSftpRouteRoute,
} as any)
const AppAdminOrganisationStatisticsRoute =
  AppAdminOrganisationStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => AppAdminOrganisationRouteRoute,
  } as any)
const AppAdminOrganisationLogosRoute =
  AppAdminOrganisationLogosRouteImport.update({
    id: '/logos',
    path: '/logos',
    getParentRoute: () => AppAdminOrganisationRouteRoute,
  } as any)
const AppAdminOrganisationAddRoute = AppAdminOrganisationAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AppAdminOrganisationRouteRoute,
} as any)
const AppAdminDiariesTypesRoute = AppAdminDiariesTypesRouteImport.update({
  id: '/diaries/types',
  path: '/diaries/types',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCliniciansStatisticsRoute =
  AppAdminCliniciansStatisticsRouteImport.update({
    id: '/clinicians/statistics',
    path: '/clinicians/statistics',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminCliniciansPhotosRoute =
  AppAdminCliniciansPhotosRouteImport.update({
    id: '/clinicians/photos',
    path: '/clinicians/photos',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminCliniciansLeaderboardRoute =
  AppAdminCliniciansLeaderboardRouteImport.update({
    id: '/clinicians/leaderboard',
    path: '/clinicians/leaderboard',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminBusinessChurnRoute = AppAdminBusinessChurnRouteImport.update({
  id: '/business/churn',
  path: '/business/churn',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminBusinessAmbassadorsRoute =
  AppAdminBusinessAmbassadorsRouteImport.update({
    id: '/business/ambassadors',
    path: '/business/ambassadors',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminAuditSnapshotRoute = AppAdminAuditSnapshotRouteImport.update({
  id: '/snapshot',
  path: '/snapshot',
  getParentRoute: () => AppAdminAuditRouteRoute,
} as any)
const AppAdminAuditLockDiariesRoute =
  AppAdminAuditLockDiariesRouteImport.update({
    id: '/lock-diaries',
    path: '/lock-diaries',
    getParentRoute: () => AppAdminAuditRouteRoute,
  } as any)
const AppAdminAuditChangeTimelineRoute =
  AppAdminAuditChangeTimelineRouteImport.update({
    id: '/change-timeline',
    path: '/change-timeline',
    getParentRoute: () => AppAdminAuditRouteRoute,
  } as any)
const AppAdminAccessUsersRoute = AppAdminAccessUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminAccessTabsRoute = AppAdminAccessTabsRouteImport.update({
  id: '/tabs',
  path: '/tabs',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminAccessStudiesRoute = AppAdminAccessStudiesRouteImport.update({
  id: '/studies',
  path: '/studies',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminAccessSchedulesRoute = AppAdminAccessSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminAccessRolesRoute = AppAdminAccessRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminAccessLabelsRoute = AppAdminAccessLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminAccessFormsRoute = AppAdminAccessFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminAccessAttributeRoute = AppAdminAccessAttributeRouteImport.update({
  id: '/$attribute',
  path: '/$attribute',
  getParentRoute: () => AppAdminAccessRouteRoute,
} as any)
const AppAdminBusinessLeadsRouteRoute =
  AppAdminBusinessLeadsRouteRouteImport.update({
    id: '/business/leads',
    path: '/business/leads',
    getParentRoute: () => AppAdminRoute,
  } as any)
const TrackerTrackerIdFormFormIdIndexRoute =
  TrackerTrackerIdFormFormIdIndexRouteImport.update({
    id: '/tracker/$trackerId/form/$formId/',
    path: '/tracker/$trackerId/form/$formId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormsFormIdPagePageIndexIndexRoute =
  FormsFormIdPagePageIndexIndexRouteImport.update({
    id: '/forms/$formId/page/$pageIndex/',
    path: '/forms/$formId/page/$pageIndex/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppTemplatesTemplateIdEventsIndexRoute =
  AppTemplatesTemplateIdEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppStudiesStudyIdInviteIndexRoute =
  AppStudiesStudyIdInviteIndexRouteImport.update({
    id: '/invite/',
    path: '/invite/',
    getParentRoute: () => AppStudiesStudyIdRoute,
  } as any)
const AppSalesLeadsTouchesIndexRoute =
  AppSalesLeadsTouchesIndexRouteImport.update({
    id: '/touches/',
    path: '/touches/',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsTemplatesIndexRoute =
  AppSalesLeadsTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsCompaniesIndexRoute =
  AppSalesLeadsCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsArtifactsIndexRoute =
  AppSalesLeadsArtifactsIndexRouteImport.update({
    id: '/artifacts/',
    path: '/artifacts/',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsLeadIdIndexRoute =
  AppSalesLeadsLeadIdIndexRouteImport.update({
    id: '/$leadId/',
    path: '/$leadId/',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppPatientsBulkEventsIndexRoute =
  AppPatientsBulkEventsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPatientsBulkEventsRoute,
  } as any)
const AppDiariesDiaryIdHomeIndexRoute =
  AppDiariesDiaryIdHomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)
const AppDesignFormsPagesIndexRoute =
  AppDesignFormsPagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDesignFormsPagesRoute,
  } as any)
const AppDesignFeaturesWorklistIndexRoute =
  AppDesignFeaturesWorklistIndexRouteImport.update({
    id: '/features/worklist/',
    path: '/features/worklist/',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppBusinessLeadsTouchesIndexRoute =
  AppBusinessLeadsTouchesIndexRouteImport.update({
    id: '/touches/',
    path: '/touches/',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsTemplatesIndexRoute =
  AppBusinessLeadsTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsCompaniesIndexRoute =
  AppBusinessLeadsCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsArtifactsIndexRoute =
  AppBusinessLeadsArtifactsIndexRouteImport.update({
    id: '/artifacts/',
    path: '/artifacts/',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsLeadIdIndexRoute =
  AppBusinessLeadsLeadIdIndexRouteImport.update({
    id: '/$leadId/',
    path: '/$leadId/',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBuilderFormsFormIdIndexRoute =
  AppBuilderFormsFormIdIndexRouteImport.update({
    id: '/forms/$formId/',
    path: '/forms/$formId/',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppAdminEntryEntryIdIndexRoute =
  AppAdminEntryEntryIdIndexRouteImport.update({
    id: '/entry/$entryId/',
    path: '/entry/$entryId/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminDiariesDiaryIdIndexRoute =
  AppAdminDiariesDiaryIdIndexRouteImport.update({
    id: '/diaries/$diaryId/',
    path: '/diaries/$diaryId/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminBusinessLeadsIndexRoute =
  AppAdminBusinessLeadsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const ScreenScreenerIdEntryIdPagePageIndexRoute =
  ScreenScreenerIdEntryIdPagePageIndexRouteImport.update({
    id: '/screen/$screenerId/$entryId/page/$pageIndex',
    path: '/screen/$screenerId/$entryId/page/$pageIndex',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppWorklistConsentDiaryIdConsentIdRoute =
  AppWorklistConsentDiaryIdConsentIdRouteImport.update({
    id: '/consent/$diaryId/$consentId',
    path: '/consent/$diaryId/$consentId',
    getParentRoute: () => AppWorklistRoute,
  } as any)
const AppValidateChangeTrailEntityTypeEntityIdRoute =
  AppValidateChangeTrailEntityTypeEntityIdRouteImport.update({
    id: '/validate/change-trail/$entityType/$entityId',
    path: '/validate/change-trail/$entityType/$entityId',
    getParentRoute: () => AppRoute,
  } as any)
const AppStudiesStudyIdInviteQrRoute =
  AppStudiesStudyIdInviteQrRouteImport.update({
    id: '/invite/qr',
    path: '/invite/qr',
    getParentRoute: () => AppStudiesStudyIdRoute,
  } as any)
const AppSalesLeadsTouchesTouchIdRoute =
  AppSalesLeadsTouchesTouchIdRouteImport.update({
    id: '/touches/$touchId',
    path: '/touches/$touchId',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsTemplatesNewRoute =
  AppSalesLeadsTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsTemplatesTemplateIdRoute =
  AppSalesLeadsTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsCompaniesNewRoute =
  AppSalesLeadsCompaniesNewRouteImport.update({
    id: '/companies/new',
    path: '/companies/new',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsCompaniesCompanyIdRoute =
  AppSalesLeadsCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsArtifactsNewRoute =
  AppSalesLeadsArtifactsNewRouteImport.update({
    id: '/artifacts/new',
    path: '/artifacts/new',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesLeadsArtifactsArtifactIdRoute =
  AppSalesLeadsArtifactsArtifactIdRouteImport.update({
    id: '/artifacts/$artifactId',
    path: '/artifacts/$artifactId',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppPatientsBulkEventsEventTypeRoute =
  AppPatientsBulkEventsEventTypeRouteImport.update({
    id: '/$eventType',
    path: '/$eventType',
    getParentRoute: () => AppPatientsBulkEventsRoute,
  } as any)
const AppPatientsDiaryIdUpdateTemplatesRoute =
  AppPatientsDiaryIdUpdateTemplatesRouteImport.update({
    id: '/update/templates',
    path: '/update/templates',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute =
  AppPatientsDiaryIdUpdateTemplateExistingTrackersRouteImport.update({
    id: '/update/template-existing-trackers',
    path: '/update/template-existing-trackers',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateReviewRoute =
  AppPatientsDiaryIdUpdateReviewRouteImport.update({
    id: '/update/review',
    path: '/update/review',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateFromTemplateRoute =
  AppPatientsDiaryIdUpdateFromTemplateRouteImport.update({
    id: '/update/from-template',
    path: '/update/from-template',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateExistingTrackersRoute =
  AppPatientsDiaryIdUpdateExistingTrackersRouteImport.update({
    id: '/update/existing-trackers',
    path: '/update/existing-trackers',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateConsentRoute =
  AppPatientsDiaryIdUpdateConsentRouteImport.update({
    id: '/update/consent',
    path: '/update/consent',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateAddRoute =
  AppPatientsDiaryIdUpdateAddRouteImport.update({
    id: '/update/add',
    path: '/update/add',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdConsentConsentIdRoute =
  AppPatientsDiaryIdConsentConsentIdRouteImport.update({
    id: '/consent/$consentId',
    path: '/consent/$consentId',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdActionActionIdRoute =
  AppPatientsDiaryIdActionActionIdRouteImport.update({
    id: '/action/$actionId',
    path: '/action/$actionId',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewUploadRoute =
  AppFootWatchDiaryIdNewUploadRouteImport.update({
    id: '/new/upload',
    path: '/new/upload',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewStartRoute =
  AppFootWatchDiaryIdNewStartRouteImport.update({
    id: '/new/start',
    path: '/new/start',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewSelectPatientRoute =
  AppFootWatchDiaryIdNewSelectPatientRouteImport.update({
    id: '/new/select-patient',
    path: '/new/select-patient',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewNewPatientRoute =
  AppFootWatchDiaryIdNewNewPatientRouteImport.update({
    id: '/new/new-patient',
    path: '/new/new-patient',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewInstructionsRoute =
  AppFootWatchDiaryIdNewInstructionsRouteImport.update({
    id: '/new/instructions',
    path: '/new/instructions',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewCameraRoute =
  AppFootWatchDiaryIdNewCameraRouteImport.update({
    id: '/new/camera',
    path: '/new/camera',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewAddPhotosRoute =
  AppFootWatchDiaryIdNewAddPhotosRouteImport.update({
    id: '/new/add-photos',
    path: '/new/add-photos',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdEditNameRoute =
  AppFootWatchDiaryIdEditNameRouteImport.update({
    id: '/name',
    path: '/name',
    getParentRoute: () => AppFootWatchDiaryIdEditRoute,
  } as any)
const AppFootWatchDiaryIdEditDiaryRoute =
  AppFootWatchDiaryIdEditDiaryRouteImport.update({
    id: '/diary',
    path: '/diary',
    getParentRoute: () => AppFootWatchDiaryIdEditRoute,
  } as any)
const AppFootWatchDiaryIdViewProgressRoute =
  AppFootWatchDiaryIdViewProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => AppFootWatchDiaryIdViewRoute,
  } as any)
const AppFootWatchDiaryIdViewNewRoute =
  AppFootWatchDiaryIdViewNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppFootWatchDiaryIdViewRoute,
  } as any)
const AppFootWatchDiaryIdViewHistoryRoute =
  AppFootWatchDiaryIdViewHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AppFootWatchDiaryIdViewRoute,
  } as any)
const AppDiariesDiaryIdSetupSideRoute =
  AppDiariesDiaryIdSetupSideRouteImport.update({
    id: '/side',
    path: '/side',
    getParentRoute: () => AppDiariesDiaryIdSetupRoute,
  } as any)
const AppDiariesDiaryIdSetupReferenceDateRoute =
  AppDiariesDiaryIdSetupReferenceDateRouteImport.update({
    id: '/reference-date',
    path: '/reference-date',
    getParentRoute: () => AppDiariesDiaryIdSetupRoute,
  } as any)
const AppDiariesDiaryIdSetupHospitalNumberRoute =
  AppDiariesDiaryIdSetupHospitalNumberRouteImport.update({
    id: '/hospital-number',
    path: '/hospital-number',
    getParentRoute: () => AppDiariesDiaryIdSetupRoute,
  } as any)
const AppDiariesDiaryIdSetupCompleteRoute =
  AppDiariesDiaryIdSetupCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => AppDiariesDiaryIdSetupRoute,
  } as any)
const AppDiariesDiaryIdHomeToDoRoute =
  AppDiariesDiaryIdHomeToDoRouteImport.update({
    id: '/to-do',
    path: '/to-do',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)
const AppDiariesDiaryIdHomeResultsRoute =
  AppDiariesDiaryIdHomeResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)
const AppDiariesDiaryIdHomeProgressRoute =
  AppDiariesDiaryIdHomeProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)
const AppDiariesDiaryIdHomeFormsRoute =
  AppDiariesDiaryIdHomeFormsRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)
const AppDiariesDiaryIdHomeEditRoute =
  AppDiariesDiaryIdHomeEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)
const AppDesignFormsPagesScreenRoute =
  AppDesignFormsPagesScreenRouteImport.update({
    id: '/$screen',
    path: '/$screen',
    getParentRoute: () => AppDesignFormsPagesRoute,
  } as any)
const AppDesignFeaturesWorklistAutomationsRoute =
  AppDesignFeaturesWorklistAutomationsRouteImport.update({
    id: '/features/worklist/automations',
    path: '/features/worklist/automations',
    getParentRoute: () => AppDesignRoute,
  } as any)
const AppBusinessLeadsTouchesTouchIdRoute =
  AppBusinessLeadsTouchesTouchIdRouteImport.update({
    id: '/touches/$touchId',
    path: '/touches/$touchId',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsTemplatesNewRoute =
  AppBusinessLeadsTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsTemplatesTemplateIdRoute =
  AppBusinessLeadsTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsCompaniesNewRoute =
  AppBusinessLeadsCompaniesNewRouteImport.update({
    id: '/companies/new',
    path: '/companies/new',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsCompaniesCompanyIdRoute =
  AppBusinessLeadsCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsArtifactsNewRoute =
  AppBusinessLeadsArtifactsNewRouteImport.update({
    id: '/artifacts/new',
    path: '/artifacts/new',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBusinessLeadsArtifactsArtifactIdRoute =
  AppBusinessLeadsArtifactsArtifactIdRouteImport.update({
    id: '/artifacts/$artifactId',
    path: '/artifacts/$artifactId',
    getParentRoute: () => AppBusinessLeadsRouteRoute,
  } as any)
const AppBuilderSchedulesFormsFormIdRoute =
  AppBuilderSchedulesFormsFormIdRouteImport.update({
    id: '/schedules/forms/formId',
    path: '/schedules/forms/formId',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderFormsFormIdMetadataRoute =
  AppBuilderFormsFormIdMetadataRouteImport.update({
    id: '/forms/$formId/metadata',
    path: '/forms/$formId/metadata',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppBuilderFormsFormIdTabRoute =
  AppBuilderFormsFormIdTabRouteImport.update({
    id: '/forms/$formId/$tab',
    path: '/forms/$formId/$tab',
    getParentRoute: () => AppBuilderRoute,
  } as any)
const AppAdminFormFormIdResultsRoute =
  AppAdminFormFormIdResultsRouteImport.update({
    id: '/form/$formId/results',
    path: '/form/$formId/results',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminBusinessLeadsNewRoute =
  AppAdminBusinessLeadsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const PreviewPatientPatientIdDiaryDiaryIdIndexRoute =
  PreviewPatientPatientIdDiaryDiaryIdIndexRouteImport.update({
    id: '/patient/$patientId/diary/$diaryId/',
    path: '/patient/$patientId/diary/$diaryId/',
    getParentRoute: () => PreviewRoute,
  } as any)
const AppValidateValidationIdFormsFormIdIndexRoute =
  AppValidateValidationIdFormsFormIdIndexRouteImport.update({
    id: '/forms/$formId/',
    path: '/forms/$formId/',
    getParentRoute: () => AppValidateValidationIdRoute,
  } as any)
const AppTemplatesTemplateIdEventsSurgeryIndexRoute =
  AppTemplatesTemplateIdEventsSurgeryIndexRouteImport.update({
    id: '/events/surgery/',
    path: '/events/surgery/',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdEventsShockwaveIndexRoute =
  AppTemplatesTemplateIdEventsShockwaveIndexRouteImport.update({
    id: '/events/shockwave/',
    path: '/events/shockwave/',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdEventsProductIndexRoute =
  AppTemplatesTemplateIdEventsProductIndexRouteImport.update({
    id: '/events/product/',
    path: '/events/product/',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdEventsInjectionIndexRoute =
  AppTemplatesTemplateIdEventsInjectionIndexRouteImport.update({
    id: '/events/injection/',
    path: '/events/injection/',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdEventsEducationIndexRoute =
  AppTemplatesTemplateIdEventsEducationIndexRouteImport.update({
    id: '/events/education/',
    path: '/events/education/',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppPatientsDiaryIdConsentConsentIdIndexRoute =
  AppPatientsDiaryIdConsentConsentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPatientsDiaryIdConsentConsentIdRoute,
  } as any)
const AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute =
  AppFootWatchNewDiaryPatientIdDiaryIdIndexRouteImport.update({
    id: '/foot-watch/new-diary/$patientId/$diaryId/',
    path: '/foot-watch/new-diary/$patientId/$diaryId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppFootWatchDiaryIdNewUploadIndexRoute =
  AppFootWatchDiaryIdNewUploadIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)
const AppAdminBusinessLeadsTouchesIndexRoute =
  AppAdminBusinessLeadsTouchesIndexRouteImport.update({
    id: '/touches/',
    path: '/touches/',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsTemplatesIndexRoute =
  AppAdminBusinessLeadsTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsCompaniesIndexRoute =
  AppAdminBusinessLeadsCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsArtifactsIndexRoute =
  AppAdminBusinessLeadsArtifactsIndexRouteImport.update({
    id: '/artifacts/',
    path: '/artifacts/',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsLeadIdIndexRoute =
  AppAdminBusinessLeadsLeadIdIndexRouteImport.update({
    id: '/$leadId/',
    path: '/$leadId/',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppValidateValidationIdFormsFormIdResultsRoute =
  AppValidateValidationIdFormsFormIdResultsRouteImport.update({
    id: '/forms/$formId/results',
    path: '/forms/$formId/results',
    getParentRoute: () => AppValidateValidationIdRoute,
  } as any)
const AppTemplatesDiaryFormInterventionInjectionRoute =
  AppTemplatesDiaryFormInterventionInjectionRouteImport.update({
    id: '/diary/_form/intervention/injection',
    path: '/diary/intervention/injection',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesTemplateIdEventsSurgeryDetailsRoute =
  AppTemplatesTemplateIdEventsSurgeryDetailsRouteImport.update({
    id: '/events/surgery/details',
    path: '/events/surgery/details',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdEventsShockwaveDetailsRoute =
  AppTemplatesTemplateIdEventsShockwaveDetailsRouteImport.update({
    id: '/events/shockwave/details',
    path: '/events/shockwave/details',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppTemplatesTemplateIdEventsInjectionDetailsRoute =
  AppTemplatesTemplateIdEventsInjectionDetailsRouteImport.update({
    id: '/events/injection/details',
    path: '/events/injection/details',
    getParentRoute: () => AppTemplatesTemplateIdRoute,
  } as any)
const AppPatientsDiaryIdConsentConsentIdCompleteRoute =
  AppPatientsDiaryIdConsentConsentIdCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => AppPatientsDiaryIdConsentConsentIdRoute,
  } as any)
const AppFootWatchDiaryIdNewUploadUploadingRoute =
  AppFootWatchDiaryIdNewUploadUploadingRouteImport.update({
    id: '/uploading',
    path: '/uploading',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)
const AppFootWatchDiaryIdNewUploadMessageRoute =
  AppFootWatchDiaryIdNewUploadMessageRouteImport.update({
    id: '/message',
    path: '/message',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)
const AppFootWatchDiaryIdNewUploadCompleteRoute =
  AppFootWatchDiaryIdNewUploadCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)
const AppDiariesDiaryIdSetupConsentConsentIdRoute =
  AppDiariesDiaryIdSetupConsentConsentIdRouteImport.update({
    id: '/consent/$consentId',
    path: '/consent/$consentId',
    getParentRoute: () => AppDiariesDiaryIdSetupRoute,
  } as any)
const AppAdminBusinessLeadsTouchesTouchIdRoute =
  AppAdminBusinessLeadsTouchesTouchIdRouteImport.update({
    id: '/touches/$touchId',
    path: '/touches/$touchId',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsTemplatesNewRoute =
  AppAdminBusinessLeadsTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsTemplatesTemplateIdRoute =
  AppAdminBusinessLeadsTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsCompaniesNewRoute =
  AppAdminBusinessLeadsCompaniesNewRouteImport.update({
    id: '/companies/new',
    path: '/companies/new',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsCompaniesCompanyIdRoute =
  AppAdminBusinessLeadsCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsArtifactsNewRoute =
  AppAdminBusinessLeadsArtifactsNewRouteImport.update({
    id: '/artifacts/new',
    path: '/artifacts/new',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const AppAdminBusinessLeadsArtifactsArtifactIdRoute =
  AppAdminBusinessLeadsArtifactsArtifactIdRouteImport.update({
    id: '/artifacts/$artifactId',
    path: '/artifacts/$artifactId',
    getParentRoute: () => AppAdminBusinessLeadsRouteRoute,
  } as any)
const PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute =
  PreviewRadiologyReportPatientPatientIdEventEventIdIndexRouteImport.update({
    id: '/radiology-report/patient/$patientId/event/$eventId/',
    path: '/radiology-report/patient/$patientId/event/$eventId/',
    getParentRoute: () => PreviewRoute,
  } as any)
const AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute =
  AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRouteImport.update({
    id: '/diary/$diaryId/trackers/$trackerId/',
    path: '/diary/$diaryId/trackers/$trackerId/',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdIndexRouteImport.update({
    id: '/diary/$diaryId/events/$eventId/',
    path: '/diary/$diaryId/events/$eventId/',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppDiariesDiaryIdSetupConsentConsentIdIndexRoute =
  AppDiariesDiaryIdSetupConsentConsentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDiariesDiaryIdSetupConsentConsentIdRoute,
  } as any)
const AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute =
  AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRouteImport.update({
    id: '/details/$diaryId/$eventId/$trackerId/$procedureKind',
    path: '/details/$diaryId/$eventId/$trackerId/$procedureKind',
    getParentRoute: () => AppWorklistRoute,
  } as any)
const AppValidateValidationIdFormsFormIdPagePageIndexRoute =
  AppValidateValidationIdFormsFormIdPagePageIndexRouteImport.update({
    id: '/forms/$formId/page/$pageIndex',
    path: '/forms/$formId/page/$pageIndex',
    getParentRoute: () => AppValidateValidationIdRoute,
  } as any)
const AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute =
  AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRouteImport.update({
    id: '/diary/$diaryId/trackers/$trackerId/details',
    path: '/diary/$diaryId/trackers/$trackerId/details',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute =
  AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRouteImport.update({
    id: '/diary/$diaryId/trackers/$trackerId/date',
    path: '/diary/$diaryId/trackers/$trackerId/date',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdDetailsRouteImport.update({
    id: '/diary/$diaryId/events/$eventId/details',
    path: '/diary/$diaryId/events/$eventId/details',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdCompleteRouteImport.update({
    id: '/diary/$diaryId/events/$eventId/complete',
    path: '/diary/$diaryId/events/$eventId/complete',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRouteImport.update({
    id: '/update/$eventId/$trackerId/questionnaire',
    path: '/update/$eventId/$trackerId/questionnaire',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRouteImport.update({
    id: '/update/$eventId/$trackerId/message',
    path: '/update/$eventId/$trackerId/message',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRouteImport.update({
    id: '/update/$eventId/$trackerId/intervention',
    path: '/update/$eventId/$trackerId/intervention',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdDateRouteImport.update({
    id: '/update/$eventId/$trackerId/date',
    path: '/update/$eventId/$trackerId/date',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdContactRouteImport.update({
    id: '/update/$eventId/$trackerId/contact',
    path: '/update/$eventId/$trackerId/contact',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppFootWatchDiaryIdNewInstructionsAngleSideRoute =
  AppFootWatchDiaryIdNewInstructionsAngleSideRouteImport.update({
    id: '/$angle/$side',
    path: '/$angle/$side',
    getParentRoute: () => AppFootWatchDiaryIdNewInstructionsRoute,
  } as any)
const AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute =
  AppDiariesDiaryIdSetupConsentConsentIdCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => AppDiariesDiaryIdSetupConsentConsentIdRoute,
  } as any)
const TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute =
  TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRouteImport.update({
    id: '/tracker/$trackerId/form/$formId/entry/$entryId/page/',
    path: '/tracker/$trackerId/form/$formId/entry/$entryId/page/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute =
  PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRouteImport.update({
    id: '/patient/$patientId/diary/$diaryId/tracker/$trackerId/',
    path: '/patient/$patientId/diary/$diaryId/tracker/$trackerId/',
    getParentRoute: () => PreviewRoute,
  } as any)
const AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute =
  AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRouteImport.update({
    id: '/form/$diaryId/$trackerId/$entryId/page/$pageIndex',
    path: '/form/$diaryId/$trackerId/$entryId/page/$pageIndex',
    getParentRoute: () => AppWorklistRoute,
  } as any)
const AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRouteImport.update(
    {
      id: '/update/$eventId/$trackerId/intervention-details/surgery',
      path: '/update/$eventId/$trackerId/intervention-details/surgery',
      getParentRoute: () => AppPatientsDiaryIdRoute,
    } as any,
  )
const AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRouteImport.update(
    {
      id: '/update/$eventId/$trackerId/intervention-details/shockwave',
      path: '/update/$eventId/$trackerId/intervention-details/shockwave',
      getParentRoute: () => AppPatientsDiaryIdRoute,
    } as any,
  )
const AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRouteImport.update(
    {
      id: '/update/$eventId/$trackerId/intervention-details/product',
      path: '/update/$eventId/$trackerId/intervention-details/product',
      getParentRoute: () => AppPatientsDiaryIdRoute,
    } as any,
  )
const AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRouteImport.update(
    {
      id: '/update/$eventId/$trackerId/intervention-details/injection',
      path: '/update/$eventId/$trackerId/intervention-details/injection',
      getParentRoute: () => AppPatientsDiaryIdRoute,
    } as any,
  )
const AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute =
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRouteImport.update(
    {
      id: '/update/$eventId/$trackerId/intervention-details/education',
      path: '/update/$eventId/$trackerId/intervention-details/education',
      getParentRoute: () => AppPatientsDiaryIdRoute,
    } as any,
  )
const AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute =
  AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteImport.update({
    id: '/tracker/$trackerId/entry/$entryId/complete',
    path: '/tracker/$trackerId/entry/$entryId/complete',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)
const AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute =
  AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteImport.update({
    id: '/tracker/$trackerId/entry/$entryId/complete',
    path: '/tracker/$trackerId/entry/$entryId/complete',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteImport.update({
    id: '/new/tracker/$trackerId/entry/$entryId',
    path: '/new/tracker/$trackerId/entry/$entryId',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)
const TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute =
  TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRouteImport.update({
    id: '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/',
    path: '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRouteImport.update({
    id: '/diary/$diaryId/events/$eventId/surgery/$surgeryId/',
    path: '/diary/$diaryId/events/$eventId/surgery/$surgeryId/',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRouteImport.update(
    {
      id: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/',
      path: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/',
      getParentRoute: () => AppTemplatesRoute,
    } as any,
  )
const AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRouteImport.update({
    id: '/diary/$diaryId/events/$eventId/product/$productId/',
    path: '/diary/$diaryId/events/$eventId/product/$productId/',
    getParentRoute: () => AppTemplatesRoute,
  } as any)
const AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRouteImport.update(
    {
      id: '/diary/$diaryId/events/$eventId/injection/$injectionId/',
      path: '/diary/$diaryId/events/$eventId/injection/$injectionId/',
      getParentRoute: () => AppTemplatesRoute,
    } as any,
  )
const AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRouteImport.update(
    {
      id: '/diary/$diaryId/events/$eventId/education/$educationId/',
      path: '/diary/$diaryId/events/$eventId/education/$educationId/',
      getParentRoute: () => AppTemplatesRoute,
    } as any,
  )
const AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRouteImport.update(
    {
      id: '/diary/$diaryId/events/$eventId/surgery/$surgeryId/details',
      path: '/diary/$diaryId/events/$eventId/surgery/$surgeryId/details',
      getParentRoute: () => AppTemplatesRoute,
    } as any,
  )
const AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRouteImport.update(
    {
      id: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details',
      path: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details',
      getParentRoute: () => AppTemplatesRoute,
    } as any,
  )
const AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute =
  AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRouteImport.update(
    {
      id: '/diary/$diaryId/events/$eventId/injection/$injectionId/details',
      path: '/diary/$diaryId/events/$eventId/injection/$injectionId/details',
      getParentRoute: () => AppTemplatesRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteImport.update({
    id: '/page',
    path: '/page',
    getParentRoute: () => AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute,
  } as any)
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute,
  } as any)
const FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute =
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteImport.update(
    {
      id: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete',
      path: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute =
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute,
    } as any,
  )
const AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute =
  AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport.update(
    {
      id: '/tracker/$trackerId/entry/$entryId/page/$pageIndex/',
      path: '/tracker/$trackerId/entry/$entryId/page/$pageIndex/',
      getParentRoute: () => AppPatientsDiaryIdRoute,
    } as any,
  )
const AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute =
  AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport.update(
    {
      id: '/tracker/$trackerId/entry/$entryId/page/$pageIndex/',
      path: '/tracker/$trackerId/entry/$entryId/page/$pageIndex/',
      getParentRoute: () => AppDiariesDiaryIdRoute,
    } as any,
  )
const FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute =
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRouteImport.update(
    {
      id: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex',
      path: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute =
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRouteImport.update(
    {
      id: '/reviews',
      path: '/reviews',
      getParentRoute: () =>
        FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute,
    } as any,
  )
const FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute =
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRouteImport.update(
    {
      id: '/results',
      path: '/results',
      getParentRoute: () =>
        FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport.update(
    {
      id: '/$pageIndex/',
      path: '/$pageIndex/',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteImport.update(
    {
      id: '/$pageIndex/foot-photos/upload',
      path: '/$pageIndex/foot-photos/upload',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRouteImport.update(
    {
      id: '/$pageIndex/foot-photos/start',
      path: '/$pageIndex/foot-photos/start',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRouteImport.update(
    {
      id: '/$pageIndex/foot-photos/select-patient',
      path: '/$pageIndex/foot-photos/select-patient',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRouteImport.update(
    {
      id: '/$pageIndex/foot-photos/new-patient',
      path: '/$pageIndex/foot-photos/new-patient',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteImport.update(
    {
      id: '/$pageIndex/foot-photos/instructions',
      path: '/$pageIndex/foot-photos/instructions',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRouteImport.update(
    {
      id: '/$pageIndex/foot-photos/camera',
      path: '/$pageIndex/foot-photos/camera',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRouteImport.update(
    {
      id: '/$pageIndex/foot-photos/add-photos',
      path: '/$pageIndex/foot-photos/add-photos',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRouteImport.update(
    {
      id: '/uploading',
      path: '/uploading',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRouteImport.update(
    {
      id: '/message',
      path: '/message',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRouteImport.update(
    {
      id: '/complete',
      path: '/complete',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )
const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRouteImport.update(
    {
      id: '/$angle/$side',
      path: '/$angle/$side',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthPublicIndexRoute
  '/error': typeof ErrorRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/preview': typeof PreviewRouteWithChildren
  '/users': typeof AppUsersRouteRouteWithChildren
  '/admin': typeof AppAdminRouteWithChildren
  '/analytics': typeof AppAnalyticsRouteWithChildren
  '/builder': typeof AppBuilderRouteWithChildren
  '/business': typeof AppBusinessRouteWithChildren
  '/complete-profile': typeof AppCompleteProfileRoute
  '/customers': typeof AppCustomersRouteWithChildren
  '/design': typeof AppDesignRouteWithChildren
  '/developer': typeof AppDeveloperRouteWithChildren
  '/invite': typeof AppInviteRouteWithChildren
  '/patients': typeof AppPatientsRouteWithChildren
  '/profile': typeof AppProfileRouteWithChildren
  '/role': typeof AppRoleRoute
  '/sales': typeof AppSalesRouteWithChildren
  '/statistics': typeof AppStatisticsRoute
  '/studies': typeof AppStudiesRouteWithChildren
  '/team': typeof AppTeamRouteWithChildren
  '/templates': typeof AppTemplatesRouteWithChildren
  '/worklist': typeof AppWorklistRouteWithChildren
  '/activate-account': typeof AuthActivateAccountRoute
  '/auth-error': typeof AuthAuthErrorRoute
  '/authentication-complete': typeof AuthAuthenticationCompleteRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/confirm-account': typeof AuthConfirmAccountRouteWithChildren
  '/delete-account': typeof AuthDeleteAccountRoute
  '/email-confirmed': typeof AuthEmailConfirmedRoute
  '/forgot-password': typeof AuthForgotPasswordRouteWithChildren
  '/magic': typeof AuthMagicRoute
  '/new-diary-invite': typeof AuthNewDiaryInviteRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/test': typeof AuthTestRoute
  '/try-demo': typeof AuthTryDemoRoute
  '/verification-complete': typeof AuthVerificationCompleteRoute
  '/verify': typeof AuthVerifyRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/verify-payment': typeof AuthVerifyPaymentRoute
  '/clinicians/$clinicianId': typeof CliniciansClinicianIdRoute
  '/feedback/patient': typeof FeedbackPatientRoute
  '/forms/request': typeof FormsRequestRoute
  '/onboarding/clinician-number': typeof OnboardingClinicianNumberRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/date-of-birth': typeof OnboardingDateOfBirthRoute
  '/onboarding/email': typeof OnboardingEmailRoute
  '/onboarding/name': typeof OnboardingNameRoute
  '/onboarding/notifications': typeof OnboardingNotificationsRoute
  '/onboarding/phone': typeof OnboardingPhoneRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/preferences/$userId': typeof PreferencesUserIdRoute
  '/preview/consent': typeof PreviewConsentRouteWithChildren
  '/schedules/request': typeof SchedulesRequestRoute
  '/forms/': typeof FormsIndexRoute
  '/admin/access': typeof AppAdminAccessRouteRouteWithChildren
  '/admin/audit': typeof AppAdminAuditRouteRouteWithChildren
  '/admin/organisation': typeof AppAdminOrganisationRouteRouteWithChildren
  '/admin/sftp': typeof AppAdminSftpRouteRouteWithChildren
  '/business/leads': typeof AppBusinessLeadsRouteRouteWithChildren
  '/developer/sftp': typeof AppDeveloperSftpRouteRouteWithChildren
  '/sales/leads': typeof AppSalesLeadsRouteRouteWithChildren
  '/users/create-user': typeof AppUsersCreateUserRouteRouteWithChildren
  '/users/notifications': typeof AppUsersNotificationsRouteRouteWithChildren
  '/admin/ambassadors': typeof AppAdminAmbassadorsRoute
  '/admin/entries': typeof AppAdminEntriesRoute
  '/admin/entry-values': typeof AppAdminEntryValuesRoute
  '/admin/events': typeof AppAdminEventsRoute
  '/admin/health-check': typeof AppAdminHealthCheckRoute
  '/admin/impersonate-user': typeof AppAdminImpersonateUserRoute
  '/admin/label-access': typeof AppAdminLabelAccessRoute
  '/admin/labels': typeof AppAdminLabelsRoute
  '/admin/notification-preferences': typeof AppAdminNotificationPreferencesRoute
  '/admin/reminder-send-volume': typeof AppAdminReminderSendVolumeRoute
  '/admin/sms-deliverability': typeof AppAdminSmsDeliverabilityRoute
  '/admin/studies': typeof AppAdminStudiesRoute
  '/admin/templates': typeof AppAdminTemplatesRoute
  '/admin/trackers': typeof AppAdminTrackersRoute
  '/admin/user-billing': typeof AppAdminUserBillingRoute
  '/admin/user-organisations': typeof AppAdminUserOrganisationsRoute
  '/admin/view-diary-as-patient': typeof AppAdminViewDiaryAsPatientRoute
  '/analytics/$diaryLabel': typeof AppAnalyticsDiaryLabelRoute
  '/analytics/anika': typeof AppAnalyticsAnikaRoute
  '/analytics/arthrosamid': typeof AppAnalyticsArthrosamidRoute
  '/business/ambassadors': typeof AppBusinessAmbassadorsRoute
  '/business/churn': typeof AppBusinessChurnRoute
  '/clinician/diaries': typeof AppClinicianDiariesRoute
  '/customers/ambassadors': typeof AppCustomersAmbassadorsRoute
  '/customers/anonymous': typeof AppCustomersAnonymousRoute
  '/customers/churn': typeof AppCustomersChurnRoute
  '/customers/clinicians': typeof AppCustomersCliniciansRoute
  '/customers/success': typeof AppCustomersSuccessRoute
  '/developer/health-check': typeof AppDeveloperHealthCheckRoute
  '/developer/messaging-schedule': typeof AppDeveloperMessagingScheduleRoute
  '/developer/reminder-send-volume': typeof AppDeveloperReminderSendVolumeRoute
  '/developer/sms-deliverability': typeof AppDeveloperSmsDeliverabilityRoute
  '/diaries/$diaryId': typeof AppDiariesDiaryIdRouteWithChildren
  '/fisher-watch/dashboard': typeof AppFisherWatchDashboardRoute
  '/foot-watch/$diaryId': typeof AppFootWatchDiaryIdRouteWithChildren
  '/headache-watch/dashboard': typeof AppHeadacheWatchDashboardRoute
  '/help/clinician': typeof AppHelpClinicianRoute
  '/help/patient': typeof AppHelpPatientRoute
  '/invite/qr-code': typeof AppInviteQrCodeRoute
  '/lead-gen/$': typeof AppLeadGenSplatRoute
  '/new/$': typeof AppNewSplatRoute
  '/patients/$diaryId': typeof AppPatientsDiaryIdRouteWithChildren
  '/profile/add-imaging-center': typeof AppProfileAddImagingCenterRoute
  '/profile/billing': typeof AppProfileBillingRoute
  '/profile/change-password': typeof AppProfileChangePasswordRoute
  '/profile/clinician-number': typeof AppProfileClinicianNumberRoute
  '/profile/date-of-birth': typeof AppProfileDateOfBirthRoute
  '/profile/delete-account': typeof AppProfileDeleteAccountRoute
  '/profile/email': typeof AppProfileEmailRoute
  '/profile/mfa': typeof AppProfileMfaRoute
  '/profile/name': typeof AppProfileNameRoute
  '/profile/nhs-number': typeof AppProfileNhsNumberRoute
  '/profile/notifications': typeof AppProfileNotificationsRoute
  '/profile/organisation': typeof AppProfileOrganisationRoute
  '/profile/phone': typeof AppProfilePhoneRoute
  '/schedules/$scheduleId': typeof AppSchedulesScheduleIdRoute
  '/studies/$studyId': typeof AppStudiesStudyIdRouteWithChildren
  '/team/invite': typeof AppTeamInviteRouteWithChildren
  '/templates/$templateId': typeof AppTemplatesTemplateIdRouteWithChildren
  '/templates/complete': typeof AppTemplatesCompleteRoute
  '/templates/public': typeof AppTemplatesPublicRoute
  '/templates/quickstart-page': typeof AppTemplatesQuickstartPageRoute
  '/users/admins': typeof AppUsersAdminsRouteWithChildren
  '/users/billing': typeof AppUsersBillingRoute
  '/users/clinicians': typeof AppUsersCliniciansRouteWithChildren
  '/users/managers': typeof AppUsersManagersRouteWithChildren
  '/users/organisations': typeof AppUsersOrganisationsRoute
  '/users/patients': typeof AppUsersPatientsRouteWithChildren
  '/users/preferences': typeof AppUsersPreferencesRoute
  '/users/secretaries': typeof AppUsersSecretariesRouteWithChildren
  '/validate/$validationId': typeof AppValidateValidationIdRouteWithChildren
  '/worklist/complete': typeof AppWorklistCompleteRoute
  '/authenticate': typeof AuthPublicAuthenticateRoute
  '/login': typeof AuthPublicLoginRouteWithChildren
  '/confirm-account/verify': typeof AuthConfirmAccountVerifyRoute
  '/forgot-password/verify': typeof AuthForgotPasswordVerifyRoute
  '/mfa/challenge': typeof AuthMfaChallengeRoute
  '/mfa/enroll': typeof AuthMfaEnrollRoute
  '/help/explainer/$explainerType': typeof HelpExplainerExplainerTypeRoute
  '/onboarding/clinician/name': typeof OnboardingClinicianNameRoute
  '/onboarding/clinician/organisation': typeof OnboardingClinicianOrganisationRoute
  '/onboarding/clinician/professional': typeof OnboardingClinicianProfessionalRoute
  '/preview/consent/$consentId': typeof PreviewConsentConsentIdRoute
  '/preview/invite/qr-code': typeof PreviewInviteQrCodeRoute
  '/screen/$screenerId/result': typeof ScreenScreenerIdResultRoute
  '/tracker/$trackerId/results': typeof TrackerTrackerIdResultsRoute
  '/tracker/$trackerId/success': typeof TrackerTrackerIdSuccessRoute
  '/admin/': typeof AppAdminIndexRoute
  '/analytics/': typeof AppAnalyticsIndexRoute
  '/builder/': typeof AppBuilderIndexRoute
  '/business/': typeof AppBusinessIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/design/': typeof AppDesignIndexRoute
  '/developer/': typeof AppDeveloperIndexRoute
  '/diaries/': typeof AppDiariesIndexRoute
  '/invite/': typeof AppInviteIndexRoute
  '/lead-gen/': typeof AppLeadGenIndexRoute
  '/new/': typeof AppNewIndexRoute
  '/profile/': typeof AppProfileIndexRoute
  '/sales/': typeof AppSalesIndexRoute
  '/schedules/': typeof AppSchedulesIndexRoute
  '/studies/': typeof AppStudiesIndexRoute
  '/team/': typeof AppTeamIndexRoute
  '/templates/': typeof AppTemplatesIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/validate/': typeof AppValidateIndexRoute
  '/worklist/': typeof AppWorklistIndexRoute
  '/confirm-account/': typeof AuthConfirmAccountIndexRoute
  '/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/new-user/': typeof AuthNewUserIndexRoute
  '/forms/$formId/': typeof FormsFormIdIndexRoute
  '/screen/$screenerId/': typeof ScreenScreenerIdIndexRoute
  '/admin/business/leads': typeof AppAdminBusinessLeadsRouteRouteWithChildren
  '/admin/access/$attribute': typeof AppAdminAccessAttributeRoute
  '/admin/access/forms': typeof AppAdminAccessFormsRoute
  '/admin/access/labels': typeof AppAdminAccessLabelsRoute
  '/admin/access/roles': typeof AppAdminAccessRolesRoute
  '/admin/access/schedules': typeof AppAdminAccessSchedulesRoute
  '/admin/access/studies': typeof AppAdminAccessStudiesRoute
  '/admin/access/tabs': typeof AppAdminAccessTabsRoute
  '/admin/access/users': typeof AppAdminAccessUsersRoute
  '/admin/audit/change-timeline': typeof AppAdminAuditChangeTimelineRoute
  '/admin/audit/lock-diaries': typeof AppAdminAuditLockDiariesRoute
  '/admin/audit/snapshot': typeof AppAdminAuditSnapshotRoute
  '/admin/business/ambassadors': typeof AppAdminBusinessAmbassadorsRoute
  '/admin/business/churn': typeof AppAdminBusinessChurnRoute
  '/admin/clinicians/leaderboard': typeof AppAdminCliniciansLeaderboardRoute
  '/admin/clinicians/photos': typeof AppAdminCliniciansPhotosRoute
  '/admin/clinicians/statistics': typeof AppAdminCliniciansStatisticsRoute
  '/admin/diaries/types': typeof AppAdminDiariesTypesRoute
  '/admin/organisation/add': typeof AppAdminOrganisationAddRoute
  '/admin/organisation/logos': typeof AppAdminOrganisationLogosRoute
  '/admin/organisation/statistics': typeof AppAdminOrganisationStatisticsRoute
  '/admin/sftp/dashboard': typeof AppAdminSftpDashboardRoute
  '/admin/sftp/diaries': typeof AppAdminSftpDiariesRoute
  '/admin/sftp/explorer': typeof AppAdminSftpExplorerRoute
  '/admin/sftp/organisations': typeof AppAdminSftpOrganisationsRoute
  '/admin/sftp/preview': typeof AppAdminSftpPreviewRoute
  '/admin/sftp/upload': typeof AppAdminSftpUploadRoute
  '/admin/user/$userId': typeof AppAdminUserUserIdRoute
  '/builder/consents/$consentBodyId': typeof AppBuilderConsentsConsentBodyIdRoute
  '/builder/dictionaries/$dictionaryId': typeof AppBuilderDictionariesDictionaryIdRoute
  '/builder/forms/new': typeof AppBuilderFormsNewRoute
  '/builder/schedules/$scheduleId': typeof AppBuilderSchedulesScheduleIdRoute
  '/builder/schedules/new': typeof AppBuilderSchedulesNewRoute
  '/business/leads/new': typeof AppBusinessLeadsNewRoute
  '/design/components/animations': typeof AppDesignComponentsAnimationsRoute
  '/design/components/auth': typeof AppDesignComponentsAuthRoute
  '/design/components/buttons': typeof AppDesignComponentsButtonsRoute
  '/design/components/dictionaries': typeof AppDesignComponentsDictionariesRoute
  '/design/components/inputs': typeof AppDesignComponentsInputsRoute
  '/design/components/search-fields': typeof AppDesignComponentsSearchFieldsRoute
  '/design/components/select-dialogs': typeof AppDesignComponentsSelectDialogsRoute
  '/design/features/generalised-analytics': typeof AppDesignFeaturesGeneralisedAnalyticsRoute
  '/design/features/manager-study-clinician-invite-plan': typeof AppDesignFeaturesManagerStudyClinicianInvitePlanRoute
  '/design/features/messaging-schedule': typeof AppDesignFeaturesMessagingScheduleRoute
  '/design/features/otivio-frictionless-onboarding': typeof AppDesignFeaturesOtivioFrictionlessOnboardingRoute
  '/design/features/reminder-sequences': typeof AppDesignFeaturesReminderSequencesRoute
  '/design/forms/blocks': typeof AppDesignFormsBlocksRoute
  '/design/forms/entry-values': typeof AppDesignFormsEntryValuesRoute
  '/design/forms/inputs': typeof AppDesignFormsInputsRoute
  '/design/forms/pages': typeof AppDesignFormsPagesRouteWithChildren
  '/design/icons/animations': typeof AppDesignIconsAnimationsRoute
  '/design/icons/faces': typeof AppDesignIconsFacesRoute
  '/design/icons/states': typeof AppDesignIconsStatesRoute
  '/developer/demos/generalised-analytics': typeof AppDeveloperDemosGeneralisedAnalyticsRoute
  '/developer/demos/manager-study-clinician-invite-plan': typeof AppDeveloperDemosManagerStudyClinicianInvitePlanRoute
  '/developer/demos/otivio-frictionless-onboarding': typeof AppDeveloperDemosOtivioFrictionlessOnboardingRoute
  '/developer/sftp/dashboard': typeof AppDeveloperSftpDashboardRoute
  '/developer/sftp/diaries': typeof AppDeveloperSftpDiariesRoute
  '/developer/sftp/explorer': typeof AppDeveloperSftpExplorerRoute
  '/developer/sftp/organisations': typeof AppDeveloperSftpOrganisationsRoute
  '/developer/sftp/preview': typeof AppDeveloperSftpPreviewRoute
  '/developer/sftp/upload': typeof AppDeveloperSftpUploadRoute
  '/developer/ui/animations': typeof AppDeveloperUiAnimationsRoute
  '/developer/ui/auth': typeof AppDeveloperUiAuthRoute
  '/developer/ui/buttons': typeof AppDeveloperUiButtonsRoute
  '/developer/ui/dictionaries': typeof AppDeveloperUiDictionariesRoute
  '/developer/ui/entry-values': typeof AppDeveloperUiEntryValuesRoute
  '/developer/ui/input-switch': typeof AppDeveloperUiInputSwitchRoute
  '/developer/ui/inputs': typeof AppDeveloperUiInputsRoute
  '/diaries/$diaryId/forms': typeof AppDiariesDiaryIdFormsRoute
  '/diaries/$diaryId/home': typeof AppDiariesDiaryIdHomeRouteWithChildren
  '/diaries/$diaryId/progress': typeof AppDiariesDiaryIdProgressRoute
  '/diaries/$diaryId/setup': typeof AppDiariesDiaryIdSetupRouteWithChildren
  '/foot-watch/$diaryId/edit': typeof AppFootWatchDiaryIdEditRouteWithChildren
  '/foot-watch/new-diary/share': typeof AppFootWatchNewDiaryShareRoute
  '/invite/diary/complete': typeof AppInviteDiaryCompleteRoute
  '/invite/diary/organisation': typeof AppInviteDiaryOrganisationRoute
  '/invite/diary/patient': typeof AppInviteDiaryPatientRoute
  '/invite/diary/qr': typeof AppInviteDiaryQrRoute
  '/invite/diary/review': typeof AppInviteDiaryReviewRoute
  '/organisation/$organisationId/qr-code': typeof AppOrganisationOrganisationIdQrCodeRoute
  '/patients/$diaryId/edit': typeof AppPatientsDiaryIdEditRoute
  '/patients/bulk/contact': typeof AppPatientsBulkContactRoute
  '/patients/bulk/events': typeof AppPatientsBulkEventsRouteWithChildren
  '/patients/bulk/labels': typeof AppPatientsBulkLabelsRoute
  '/patients/bulk/message': typeof AppPatientsBulkMessageRoute
  '/patients/bulk/organisation': typeof AppPatientsBulkOrganisationRoute
  '/patients/bulk/reviewed': typeof AppPatientsBulkReviewedRoute
  '/profile/medical/diabetes': typeof AppProfileMedicalDiabetesRoute
  '/sales/leads/new': typeof AppSalesLeadsNewRoute
  '/studies/$studyId/edit': typeof AppStudiesStudyIdEditRoute
  '/team/invite/email': typeof AppTeamInviteEmailRoute
  '/team/invite/qr': typeof AppTeamInviteQrRoute
  '/templates/$templateId/consent': typeof AppTemplatesTemplateIdConsentRoute
  '/templates/$templateId/date': typeof AppTemplatesTemplateIdDateRoute
  '/templates/$templateId/hospital-number': typeof AppTemplatesTemplateIdHospitalNumberRoute
  '/templates/$templateId/labels': typeof AppTemplatesTemplateIdLabelsRoute
  '/templates/$templateId/name': typeof AppTemplatesTemplateIdNameRoute
  '/templates/$templateId/organisation': typeof AppTemplatesTemplateIdOrganisationRoute
  '/templates/$templateId/publish': typeof AppTemplatesTemplateIdPublishRoute
  '/templates/$templateId/screener': typeof AppTemplatesTemplateIdScreenerRoute
  '/templates/$templateId/trackers': typeof AppTemplatesTemplateIdTrackersRoute
  '/templates/diary/$newDiaryTemplateId': typeof AppTemplatesDiaryNewDiaryTemplateIdRoute
  '/templates/diary/$templateId': typeof AppTemplatesDiaryTemplateIdRoute
  '/users/admins/$userId': typeof AppUsersAdminsUserIdRoute
  '/users/clinicians/$userId': typeof AppUsersCliniciansUserIdRoute
  '/users/create-user/access': typeof AppUsersCreateUserAccessRoute
  '/users/create-user/billing': typeof AppUsersCreateUserBillingRoute
  '/users/create-user/details': typeof AppUsersCreateUserDetailsRoute
  '/users/create-user/impersonate': typeof AppUsersCreateUserImpersonateRoute
  '/users/create-user/organisations': typeof AppUsersCreateUserOrganisationsRoute
  '/users/create-user/templates': typeof AppUsersCreateUserTemplatesRoute
  '/users/managers/$userId': typeof AppUsersManagersUserIdRoute
  '/users/notifications/sms': typeof AppUsersNotificationsSmsRoute
  '/users/patients/$userId': typeof AppUsersPatientsUserIdRoute
  '/users/secretaries/$userId': typeof AppUsersSecretariesUserIdRoute
  '/login/verify': typeof AuthPublicLoginVerifyRoute
  '/signup/$plan': typeof AuthPublicSignupPlanRoute
  '/signup/trial': typeof AuthPublicSignupTrialRoute
  '/signup/verify-phone': typeof AuthPublicSignupVerifyPhoneRoute
  '/admin/access/': typeof AppAdminAccessIndexRoute
  '/admin/audit/': typeof AppAdminAuditIndexRoute
  '/admin/business/': typeof AppAdminBusinessIndexRoute
  '/admin/clinicians/': typeof AppAdminCliniciansIndexRoute
  '/admin/diaries/': typeof AppAdminDiariesIndexRoute
  '/admin/organisation/': typeof AppAdminOrganisationIndexRoute
  '/admin/sftp/': typeof AppAdminSftpIndexRoute
  '/admin/user-activation/': typeof AppAdminUserActivationIndexRoute
  '/builder/consents/': typeof AppBuilderConsentsIndexRoute
  '/builder/dictionaries/': typeof AppBuilderDictionariesIndexRoute
  '/builder/forms/': typeof AppBuilderFormsIndexRoute
  '/builder/injection-contents/': typeof AppBuilderInjectionContentsIndexRoute
  '/builder/injection-locations/': typeof AppBuilderInjectionLocationsIndexRoute
  '/builder/labels/': typeof AppBuilderLabelsIndexRoute
  '/builder/messages/': typeof AppBuilderMessagesIndexRoute
  '/builder/options/': typeof AppBuilderOptionsIndexRoute
  '/builder/schedules/': typeof AppBuilderSchedulesIndexRoute
  '/builder/surgeries/': typeof AppBuilderSurgeriesIndexRoute
  '/builder/templates/': typeof AppBuilderTemplatesIndexRoute
  '/business/leads/': typeof AppBusinessLeadsIndexRoute
  '/design/forms/': typeof AppDesignFormsIndexRoute
  '/design/icons/': typeof AppDesignIconsIndexRoute
  '/developer/sftp/': typeof AppDeveloperSftpIndexRoute
  '/diaries/$diaryId/': typeof AppDiariesDiaryIdIndexRoute
  '/organisation/$organisationId/': typeof AppOrganisationOrganisationIdIndexRoute
  '/patients/$diaryId/': typeof AppPatientsDiaryIdIndexRoute
  '/sales/leads/': typeof AppSalesLeadsIndexRoute
  '/studies/$studyId/': typeof AppStudiesStudyIdIndexRoute
  '/team/invite/': typeof AppTeamInviteIndexRoute
  '/users/create-user/': typeof AppUsersCreateUserIndexRoute
  '/users/notifications/': typeof AppUsersNotificationsIndexRoute
  '/validate/$validationId/': typeof AppValidateValidationIdIndexRoute
  '/login/': typeof AuthPublicLoginIndexRoute
  '/signup/': typeof AuthPublicSignupIndexRoute
  '/new-user/clinician/': typeof AuthNewUserClinicianIndexRoute
  '/new-user/patient/': typeof AuthNewUserPatientIndexRoute
  '/admin/business/leads/new': typeof AppAdminBusinessLeadsNewRoute
  '/admin/form/$formId/results': typeof AppAdminFormFormIdResultsRoute
  '/builder/forms/$formId/$tab': typeof AppBuilderFormsFormIdTabRoute
  '/builder/forms/$formId/metadata': typeof AppBuilderFormsFormIdMetadataRoute
  '/builder/schedules/forms/formId': typeof AppBuilderSchedulesFormsFormIdRoute
  '/business/leads/artifacts/$artifactId': typeof AppBusinessLeadsArtifactsArtifactIdRoute
  '/business/leads/artifacts/new': typeof AppBusinessLeadsArtifactsNewRoute
  '/business/leads/companies/$companyId': typeof AppBusinessLeadsCompaniesCompanyIdRoute
  '/business/leads/companies/new': typeof AppBusinessLeadsCompaniesNewRoute
  '/business/leads/templates/$templateId': typeof AppBusinessLeadsTemplatesTemplateIdRoute
  '/business/leads/templates/new': typeof AppBusinessLeadsTemplatesNewRoute
  '/business/leads/touches/$touchId': typeof AppBusinessLeadsTouchesTouchIdRoute
  '/design/features/worklist/automations': typeof AppDesignFeaturesWorklistAutomationsRoute
  '/design/forms/pages/$screen': typeof AppDesignFormsPagesScreenRoute
  '/diaries/$diaryId/home/edit': typeof AppDiariesDiaryIdHomeEditRoute
  '/diaries/$diaryId/home/forms': typeof AppDiariesDiaryIdHomeFormsRoute
  '/diaries/$diaryId/home/progress': typeof AppDiariesDiaryIdHomeProgressRoute
  '/diaries/$diaryId/home/results': typeof AppDiariesDiaryIdHomeResultsRoute
  '/diaries/$diaryId/home/to-do': typeof AppDiariesDiaryIdHomeToDoRoute
  '/diaries/$diaryId/setup/complete': typeof AppDiariesDiaryIdSetupCompleteRoute
  '/diaries/$diaryId/setup/hospital-number': typeof AppDiariesDiaryIdSetupHospitalNumberRoute
  '/diaries/$diaryId/setup/reference-date': typeof AppDiariesDiaryIdSetupReferenceDateRoute
  '/diaries/$diaryId/setup/side': typeof AppDiariesDiaryIdSetupSideRoute
  '/foot-watch/$diaryId/history': typeof AppFootWatchDiaryIdViewHistoryRoute
  '/foot-watch/$diaryId/new': typeof AppFootWatchDiaryIdViewNewRoute
  '/foot-watch/$diaryId/progress': typeof AppFootWatchDiaryIdViewProgressRoute
  '/foot-watch/$diaryId/edit/diary': typeof AppFootWatchDiaryIdEditDiaryRoute
  '/foot-watch/$diaryId/edit/name': typeof AppFootWatchDiaryIdEditNameRoute
  '/foot-watch/$diaryId/new/add-photos': typeof AppFootWatchDiaryIdNewAddPhotosRoute
  '/foot-watch/$diaryId/new/camera': typeof AppFootWatchDiaryIdNewCameraRoute
  '/foot-watch/$diaryId/new/instructions': typeof AppFootWatchDiaryIdNewInstructionsRouteWithChildren
  '/foot-watch/$diaryId/new/new-patient': typeof AppFootWatchDiaryIdNewNewPatientRoute
  '/foot-watch/$diaryId/new/select-patient': typeof AppFootWatchDiaryIdNewSelectPatientRoute
  '/foot-watch/$diaryId/new/start': typeof AppFootWatchDiaryIdNewStartRoute
  '/foot-watch/$diaryId/new/upload': typeof AppFootWatchDiaryIdNewUploadRouteWithChildren
  '/patients/$diaryId/action/$actionId': typeof AppPatientsDiaryIdActionActionIdRoute
  '/patients/$diaryId/consent/$consentId': typeof AppPatientsDiaryIdConsentConsentIdRouteWithChildren
  '/patients/$diaryId/update/add': typeof AppPatientsDiaryIdUpdateAddRoute
  '/patients/$diaryId/update/consent': typeof AppPatientsDiaryIdUpdateConsentRoute
  '/patients/$diaryId/update/existing-trackers': typeof AppPatientsDiaryIdUpdateExistingTrackersRoute
  '/patients/$diaryId/update/from-template': typeof AppPatientsDiaryIdUpdateFromTemplateRoute
  '/patients/$diaryId/update/review': typeof AppPatientsDiaryIdUpdateReviewRoute
  '/patients/$diaryId/update/template-existing-trackers': typeof AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute
  '/patients/$diaryId/update/templates': typeof AppPatientsDiaryIdUpdateTemplatesRoute
  '/patients/bulk/events/$eventType': typeof AppPatientsBulkEventsEventTypeRoute
  '/sales/leads/artifacts/$artifactId': typeof AppSalesLeadsArtifactsArtifactIdRoute
  '/sales/leads/artifacts/new': typeof AppSalesLeadsArtifactsNewRoute
  '/sales/leads/companies/$companyId': typeof AppSalesLeadsCompaniesCompanyIdRoute
  '/sales/leads/companies/new': typeof AppSalesLeadsCompaniesNewRoute
  '/sales/leads/templates/$templateId': typeof AppSalesLeadsTemplatesTemplateIdRoute
  '/sales/leads/templates/new': typeof AppSalesLeadsTemplatesNewRoute
  '/sales/leads/touches/$touchId': typeof AppSalesLeadsTouchesTouchIdRoute
  '/studies/$studyId/invite/qr': typeof AppStudiesStudyIdInviteQrRoute
  '/validate/change-trail/$entityType/$entityId': typeof AppValidateChangeTrailEntityTypeEntityIdRoute
  '/worklist/consent/$diaryId/$consentId': typeof AppWorklistConsentDiaryIdConsentIdRoute
  '/screen/$screenerId/$entryId/page/$pageIndex': typeof ScreenScreenerIdEntryIdPagePageIndexRoute
  '/admin/business/leads/': typeof AppAdminBusinessLeadsIndexRoute
  '/admin/diaries/$diaryId/': typeof AppAdminDiariesDiaryIdIndexRoute
  '/admin/entry/$entryId/': typeof AppAdminEntryEntryIdIndexRoute
  '/builder/forms/$formId/': typeof AppBuilderFormsFormIdIndexRoute
  '/business/leads/$leadId/': typeof AppBusinessLeadsLeadIdIndexRoute
  '/business/leads/artifacts/': typeof AppBusinessLeadsArtifactsIndexRoute
  '/business/leads/companies/': typeof AppBusinessLeadsCompaniesIndexRoute
  '/business/leads/templates/': typeof AppBusinessLeadsTemplatesIndexRoute
  '/business/leads/touches/': typeof AppBusinessLeadsTouchesIndexRoute
  '/design/features/worklist/': typeof AppDesignFeaturesWorklistIndexRoute
  '/design/forms/pages/': typeof AppDesignFormsPagesIndexRoute
  '/diaries/$diaryId/home/': typeof AppDiariesDiaryIdHomeIndexRoute
  '/patients/bulk/events/': typeof AppPatientsBulkEventsIndexRoute
  '/sales/leads/$leadId/': typeof AppSalesLeadsLeadIdIndexRoute
  '/sales/leads/artifacts/': typeof AppSalesLeadsArtifactsIndexRoute
  '/sales/leads/companies/': typeof AppSalesLeadsCompaniesIndexRoute
  '/sales/leads/templates/': typeof AppSalesLeadsTemplatesIndexRoute
  '/sales/leads/touches/': typeof AppSalesLeadsTouchesIndexRoute
  '/studies/$studyId/invite/': typeof AppStudiesStudyIdInviteIndexRoute
  '/templates/$templateId/events/': typeof AppTemplatesTemplateIdEventsIndexRoute
  '/forms/$formId/page/$pageIndex/': typeof FormsFormIdPagePageIndexIndexRoute
  '/tracker/$trackerId/form/$formId/': typeof TrackerTrackerIdFormFormIdIndexRoute
  '/admin/business/leads/artifacts/$artifactId': typeof AppAdminBusinessLeadsArtifactsArtifactIdRoute
  '/admin/business/leads/artifacts/new': typeof AppAdminBusinessLeadsArtifactsNewRoute
  '/admin/business/leads/companies/$companyId': typeof AppAdminBusinessLeadsCompaniesCompanyIdRoute
  '/admin/business/leads/companies/new': typeof AppAdminBusinessLeadsCompaniesNewRoute
  '/admin/business/leads/templates/$templateId': typeof AppAdminBusinessLeadsTemplatesTemplateIdRoute
  '/admin/business/leads/templates/new': typeof AppAdminBusinessLeadsTemplatesNewRoute
  '/admin/business/leads/touches/$touchId': typeof AppAdminBusinessLeadsTouchesTouchIdRoute
  '/diaries/$diaryId/setup/consent/$consentId': typeof AppDiariesDiaryIdSetupConsentConsentIdRouteWithChildren
  '/foot-watch/$diaryId/new/upload/complete': typeof AppFootWatchDiaryIdNewUploadCompleteRoute
  '/foot-watch/$diaryId/new/upload/message': typeof AppFootWatchDiaryIdNewUploadMessageRoute
  '/foot-watch/$diaryId/new/upload/uploading': typeof AppFootWatchDiaryIdNewUploadUploadingRoute
  '/patients/$diaryId/consent/$consentId/complete': typeof AppPatientsDiaryIdConsentConsentIdCompleteRoute
  '/templates/$templateId/events/injection/details': typeof AppTemplatesTemplateIdEventsInjectionDetailsRoute
  '/templates/$templateId/events/shockwave/details': typeof AppTemplatesTemplateIdEventsShockwaveDetailsRoute
  '/templates/$templateId/events/surgery/details': typeof AppTemplatesTemplateIdEventsSurgeryDetailsRoute
  '/templates/diary/intervention/injection': typeof AppTemplatesDiaryFormInterventionInjectionRoute
  '/validate/$validationId/forms/$formId/results': typeof AppValidateValidationIdFormsFormIdResultsRoute
  '/admin/business/leads/$leadId/': typeof AppAdminBusinessLeadsLeadIdIndexRoute
  '/admin/business/leads/artifacts/': typeof AppAdminBusinessLeadsArtifactsIndexRoute
  '/admin/business/leads/companies/': typeof AppAdminBusinessLeadsCompaniesIndexRoute
  '/admin/business/leads/templates/': typeof AppAdminBusinessLeadsTemplatesIndexRoute
  '/admin/business/leads/touches/': typeof AppAdminBusinessLeadsTouchesIndexRoute
  '/foot-watch/$diaryId/new/upload/': typeof AppFootWatchDiaryIdNewUploadIndexRoute
  '/foot-watch/new-diary/$patientId/$diaryId/': typeof AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute
  '/patients/$diaryId/consent/$consentId/': typeof AppPatientsDiaryIdConsentConsentIdIndexRoute
  '/templates/$templateId/events/education/': typeof AppTemplatesTemplateIdEventsEducationIndexRoute
  '/templates/$templateId/events/injection/': typeof AppTemplatesTemplateIdEventsInjectionIndexRoute
  '/templates/$templateId/events/product/': typeof AppTemplatesTemplateIdEventsProductIndexRoute
  '/templates/$templateId/events/shockwave/': typeof AppTemplatesTemplateIdEventsShockwaveIndexRoute
  '/templates/$templateId/events/surgery/': typeof AppTemplatesTemplateIdEventsSurgeryIndexRoute
  '/validate/$validationId/forms/$formId/': typeof AppValidateValidationIdFormsFormIdIndexRoute
  '/preview/patient/$patientId/diary/$diaryId/': typeof PreviewPatientPatientIdDiaryDiaryIdIndexRoute
  '/diaries/$diaryId/setup/consent/$consentId/complete': typeof AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute
  '/foot-watch/$diaryId/new/instructions/$angle/$side': typeof AppFootWatchDiaryIdNewInstructionsAngleSideRoute
  '/patients/$diaryId/update/$eventId/$trackerId/contact': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute
  '/patients/$diaryId/update/$eventId/$trackerId/date': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute
  '/patients/$diaryId/update/$eventId/$trackerId/message': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute
  '/patients/$diaryId/update/$eventId/$trackerId/questionnaire': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute
  '/templates/diary/$diaryId/events/$eventId/complete': typeof AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute
  '/templates/diary/$diaryId/events/$eventId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute
  '/templates/diary/$diaryId/trackers/$trackerId/date': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute
  '/templates/diary/$diaryId/trackers/$trackerId/details': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute
  '/validate/$validationId/forms/$formId/page/$pageIndex': typeof AppValidateValidationIdFormsFormIdPagePageIndexRoute
  '/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind': typeof AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute
  '/diaries/$diaryId/setup/consent/$consentId/': typeof AppDiariesDiaryIdSetupConsentConsentIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute
  '/templates/diary/$diaryId/trackers/$trackerId/': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute
  '/preview/radiology-report/patient/$patientId/event/$eventId/': typeof PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteWithChildren
  '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  '/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute
  '/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex': typeof AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute
  '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/': typeof PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute
  '/tracker/$trackerId/form/$formId/entry/$entryId/page/': typeof TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteWithChildren
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteWithChildren
  '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute
  '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute
  '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute
  '/templates/diary/$diaryId/events/$eventId/education/$educationId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/product/$productId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute
  '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/': typeof TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute
  '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/': typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/': typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteWithChildren
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteWithChildren
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthPublicIndexRoute
  '/error': typeof ErrorRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/preview': typeof PreviewRouteWithChildren
  '/complete-profile': typeof AppCompleteProfileRoute
  '/patients': typeof AppPatientsRouteWithChildren
  '/role': typeof AppRoleRoute
  '/statistics': typeof AppStatisticsRoute
  '/activate-account': typeof AuthActivateAccountRoute
  '/auth-error': typeof AuthAuthErrorRoute
  '/authentication-complete': typeof AuthAuthenticationCompleteRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/delete-account': typeof AuthDeleteAccountRoute
  '/email-confirmed': typeof AuthEmailConfirmedRoute
  '/magic': typeof AuthMagicRoute
  '/new-diary-invite': typeof AuthNewDiaryInviteRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/test': typeof AuthTestRoute
  '/try-demo': typeof AuthTryDemoRoute
  '/verification-complete': typeof AuthVerificationCompleteRoute
  '/verify': typeof AuthVerifyRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/verify-payment': typeof AuthVerifyPaymentRoute
  '/clinicians/$clinicianId': typeof CliniciansClinicianIdRoute
  '/feedback/patient': typeof FeedbackPatientRoute
  '/forms/request': typeof FormsRequestRoute
  '/onboarding/clinician-number': typeof OnboardingClinicianNumberRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/date-of-birth': typeof OnboardingDateOfBirthRoute
  '/onboarding/email': typeof OnboardingEmailRoute
  '/onboarding/name': typeof OnboardingNameRoute
  '/onboarding/notifications': typeof OnboardingNotificationsRoute
  '/onboarding/phone': typeof OnboardingPhoneRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/preferences/$userId': typeof PreferencesUserIdRoute
  '/preview/consent': typeof PreviewConsentRouteWithChildren
  '/schedules/request': typeof SchedulesRequestRoute
  '/forms': typeof FormsIndexRoute
  '/admin/ambassadors': typeof AppAdminAmbassadorsRoute
  '/admin/entries': typeof AppAdminEntriesRoute
  '/admin/entry-values': typeof AppAdminEntryValuesRoute
  '/admin/events': typeof AppAdminEventsRoute
  '/admin/health-check': typeof AppAdminHealthCheckRoute
  '/admin/impersonate-user': typeof AppAdminImpersonateUserRoute
  '/admin/label-access': typeof AppAdminLabelAccessRoute
  '/admin/labels': typeof AppAdminLabelsRoute
  '/admin/notification-preferences': typeof AppAdminNotificationPreferencesRoute
  '/admin/reminder-send-volume': typeof AppAdminReminderSendVolumeRoute
  '/admin/sms-deliverability': typeof AppAdminSmsDeliverabilityRoute
  '/admin/studies': typeof AppAdminStudiesRoute
  '/admin/templates': typeof AppAdminTemplatesRoute
  '/admin/trackers': typeof AppAdminTrackersRoute
  '/admin/user-billing': typeof AppAdminUserBillingRoute
  '/admin/user-organisations': typeof AppAdminUserOrganisationsRoute
  '/admin/view-diary-as-patient': typeof AppAdminViewDiaryAsPatientRoute
  '/analytics/$diaryLabel': typeof AppAnalyticsDiaryLabelRoute
  '/analytics/anika': typeof AppAnalyticsAnikaRoute
  '/analytics/arthrosamid': typeof AppAnalyticsArthrosamidRoute
  '/business/ambassadors': typeof AppBusinessAmbassadorsRoute
  '/business/churn': typeof AppBusinessChurnRoute
  '/clinician/diaries': typeof AppClinicianDiariesRoute
  '/customers/ambassadors': typeof AppCustomersAmbassadorsRoute
  '/customers/anonymous': typeof AppCustomersAnonymousRoute
  '/customers/churn': typeof AppCustomersChurnRoute
  '/customers/clinicians': typeof AppCustomersCliniciansRoute
  '/customers/success': typeof AppCustomersSuccessRoute
  '/developer/health-check': typeof AppDeveloperHealthCheckRoute
  '/developer/messaging-schedule': typeof AppDeveloperMessagingScheduleRoute
  '/developer/reminder-send-volume': typeof AppDeveloperReminderSendVolumeRoute
  '/developer/sms-deliverability': typeof AppDeveloperSmsDeliverabilityRoute
  '/fisher-watch/dashboard': typeof AppFisherWatchDashboardRoute
  '/foot-watch/$diaryId': typeof AppFootWatchDiaryIdRouteWithChildren
  '/headache-watch/dashboard': typeof AppHeadacheWatchDashboardRoute
  '/help/clinician': typeof AppHelpClinicianRoute
  '/help/patient': typeof AppHelpPatientRoute
  '/invite/qr-code': typeof AppInviteQrCodeRoute
  '/lead-gen/$': typeof AppLeadGenSplatRoute
  '/new/$': typeof AppNewSplatRoute
  '/profile/add-imaging-center': typeof AppProfileAddImagingCenterRoute
  '/profile/billing': typeof AppProfileBillingRoute
  '/profile/change-password': typeof AppProfileChangePasswordRoute
  '/profile/clinician-number': typeof AppProfileClinicianNumberRoute
  '/profile/date-of-birth': typeof AppProfileDateOfBirthRoute
  '/profile/delete-account': typeof AppProfileDeleteAccountRoute
  '/profile/email': typeof AppProfileEmailRoute
  '/profile/mfa': typeof AppProfileMfaRoute
  '/profile/name': typeof AppProfileNameRoute
  '/profile/nhs-number': typeof AppProfileNhsNumberRoute
  '/profile/notifications': typeof AppProfileNotificationsRoute
  '/profile/organisation': typeof AppProfileOrganisationRoute
  '/profile/phone': typeof AppProfilePhoneRoute
  '/schedules/$scheduleId': typeof AppSchedulesScheduleIdRoute
  '/templates/$templateId': typeof AppTemplatesTemplateIdRouteWithChildren
  '/templates/complete': typeof AppTemplatesCompleteRoute
  '/templates/public': typeof AppTemplatesPublicRoute
  '/templates/quickstart-page': typeof AppTemplatesQuickstartPageRoute
  '/users/admins': typeof AppUsersAdminsRouteWithChildren
  '/users/billing': typeof AppUsersBillingRoute
  '/users/clinicians': typeof AppUsersCliniciansRouteWithChildren
  '/users/managers': typeof AppUsersManagersRouteWithChildren
  '/users/organisations': typeof AppUsersOrganisationsRoute
  '/users/patients': typeof AppUsersPatientsRouteWithChildren
  '/users/preferences': typeof AppUsersPreferencesRoute
  '/users/secretaries': typeof AppUsersSecretariesRouteWithChildren
  '/worklist/complete': typeof AppWorklistCompleteRoute
  '/authenticate': typeof AuthPublicAuthenticateRoute
  '/confirm-account/verify': typeof AuthConfirmAccountVerifyRoute
  '/forgot-password/verify': typeof AuthForgotPasswordVerifyRoute
  '/mfa/challenge': typeof AuthMfaChallengeRoute
  '/mfa/enroll': typeof AuthMfaEnrollRoute
  '/help/explainer/$explainerType': typeof HelpExplainerExplainerTypeRoute
  '/onboarding/clinician/name': typeof OnboardingClinicianNameRoute
  '/onboarding/clinician/organisation': typeof OnboardingClinicianOrganisationRoute
  '/onboarding/clinician/professional': typeof OnboardingClinicianProfessionalRoute
  '/preview/consent/$consentId': typeof PreviewConsentConsentIdRoute
  '/preview/invite/qr-code': typeof PreviewInviteQrCodeRoute
  '/screen/$screenerId/result': typeof ScreenScreenerIdResultRoute
  '/tracker/$trackerId/results': typeof TrackerTrackerIdResultsRoute
  '/tracker/$trackerId/success': typeof TrackerTrackerIdSuccessRoute
  '/admin': typeof AppAdminIndexRoute
  '/analytics': typeof AppAnalyticsIndexRoute
  '/builder': typeof AppBuilderIndexRoute
  '/business': typeof AppBusinessIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/design': typeof AppDesignIndexRoute
  '/developer': typeof AppDeveloperIndexRoute
  '/diaries': typeof AppDiariesIndexRoute
  '/invite': typeof AppInviteIndexRoute
  '/lead-gen': typeof AppLeadGenIndexRoute
  '/new': typeof AppNewIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/sales': typeof AppSalesIndexRoute
  '/schedules': typeof AppSchedulesIndexRoute
  '/studies': typeof AppStudiesIndexRoute
  '/team': typeof AppTeamIndexRoute
  '/templates': typeof AppTemplatesIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/validate': typeof AppValidateIndexRoute
  '/worklist': typeof AppWorklistIndexRoute
  '/confirm-account': typeof AuthConfirmAccountIndexRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/new-user': typeof AuthNewUserIndexRoute
  '/forms/$formId': typeof FormsFormIdIndexRoute
  '/screen/$screenerId': typeof ScreenScreenerIdIndexRoute
  '/admin/access/$attribute': typeof AppAdminAccessAttributeRoute
  '/admin/access/forms': typeof AppAdminAccessFormsRoute
  '/admin/access/labels': typeof AppAdminAccessLabelsRoute
  '/admin/access/roles': typeof AppAdminAccessRolesRoute
  '/admin/access/schedules': typeof AppAdminAccessSchedulesRoute
  '/admin/access/studies': typeof AppAdminAccessStudiesRoute
  '/admin/access/tabs': typeof AppAdminAccessTabsRoute
  '/admin/access/users': typeof AppAdminAccessUsersRoute
  '/admin/audit/change-timeline': typeof AppAdminAuditChangeTimelineRoute
  '/admin/audit/lock-diaries': typeof AppAdminAuditLockDiariesRoute
  '/admin/audit/snapshot': typeof AppAdminAuditSnapshotRoute
  '/admin/business/ambassadors': typeof AppAdminBusinessAmbassadorsRoute
  '/admin/business/churn': typeof AppAdminBusinessChurnRoute
  '/admin/clinicians/leaderboard': typeof AppAdminCliniciansLeaderboardRoute
  '/admin/clinicians/photos': typeof AppAdminCliniciansPhotosRoute
  '/admin/clinicians/statistics': typeof AppAdminCliniciansStatisticsRoute
  '/admin/diaries/types': typeof AppAdminDiariesTypesRoute
  '/admin/organisation/add': typeof AppAdminOrganisationAddRoute
  '/admin/organisation/logos': typeof AppAdminOrganisationLogosRoute
  '/admin/organisation/statistics': typeof AppAdminOrganisationStatisticsRoute
  '/admin/sftp/dashboard': typeof AppAdminSftpDashboardRoute
  '/admin/sftp/diaries': typeof AppAdminSftpDiariesRoute
  '/admin/sftp/explorer': typeof AppAdminSftpExplorerRoute
  '/admin/sftp/organisations': typeof AppAdminSftpOrganisationsRoute
  '/admin/sftp/preview': typeof AppAdminSftpPreviewRoute
  '/admin/sftp/upload': typeof AppAdminSftpUploadRoute
  '/admin/user/$userId': typeof AppAdminUserUserIdRoute
  '/builder/consents/$consentBodyId': typeof AppBuilderConsentsConsentBodyIdRoute
  '/builder/dictionaries/$dictionaryId': typeof AppBuilderDictionariesDictionaryIdRoute
  '/builder/forms/new': typeof AppBuilderFormsNewRoute
  '/builder/schedules/$scheduleId': typeof AppBuilderSchedulesScheduleIdRoute
  '/builder/schedules/new': typeof AppBuilderSchedulesNewRoute
  '/business/leads/new': typeof AppBusinessLeadsNewRoute
  '/design/components/animations': typeof AppDesignComponentsAnimationsRoute
  '/design/components/auth': typeof AppDesignComponentsAuthRoute
  '/design/components/buttons': typeof AppDesignComponentsButtonsRoute
  '/design/components/dictionaries': typeof AppDesignComponentsDictionariesRoute
  '/design/components/inputs': typeof AppDesignComponentsInputsRoute
  '/design/components/search-fields': typeof AppDesignComponentsSearchFieldsRoute
  '/design/components/select-dialogs': typeof AppDesignComponentsSelectDialogsRoute
  '/design/features/generalised-analytics': typeof AppDesignFeaturesGeneralisedAnalyticsRoute
  '/design/features/manager-study-clinician-invite-plan': typeof AppDesignFeaturesManagerStudyClinicianInvitePlanRoute
  '/design/features/messaging-schedule': typeof AppDesignFeaturesMessagingScheduleRoute
  '/design/features/otivio-frictionless-onboarding': typeof AppDesignFeaturesOtivioFrictionlessOnboardingRoute
  '/design/features/reminder-sequences': typeof AppDesignFeaturesReminderSequencesRoute
  '/design/forms/blocks': typeof AppDesignFormsBlocksRoute
  '/design/forms/entry-values': typeof AppDesignFormsEntryValuesRoute
  '/design/forms/inputs': typeof AppDesignFormsInputsRoute
  '/design/icons/animations': typeof AppDesignIconsAnimationsRoute
  '/design/icons/faces': typeof AppDesignIconsFacesRoute
  '/design/icons/states': typeof AppDesignIconsStatesRoute
  '/developer/demos/generalised-analytics': typeof AppDeveloperDemosGeneralisedAnalyticsRoute
  '/developer/demos/manager-study-clinician-invite-plan': typeof AppDeveloperDemosManagerStudyClinicianInvitePlanRoute
  '/developer/demos/otivio-frictionless-onboarding': typeof AppDeveloperDemosOtivioFrictionlessOnboardingRoute
  '/developer/sftp/dashboard': typeof AppDeveloperSftpDashboardRoute
  '/developer/sftp/diaries': typeof AppDeveloperSftpDiariesRoute
  '/developer/sftp/explorer': typeof AppDeveloperSftpExplorerRoute
  '/developer/sftp/organisations': typeof AppDeveloperSftpOrganisationsRoute
  '/developer/sftp/preview': typeof AppDeveloperSftpPreviewRoute
  '/developer/sftp/upload': typeof AppDeveloperSftpUploadRoute
  '/developer/ui/animations': typeof AppDeveloperUiAnimationsRoute
  '/developer/ui/auth': typeof AppDeveloperUiAuthRoute
  '/developer/ui/buttons': typeof AppDeveloperUiButtonsRoute
  '/developer/ui/dictionaries': typeof AppDeveloperUiDictionariesRoute
  '/developer/ui/entry-values': typeof AppDeveloperUiEntryValuesRoute
  '/developer/ui/input-switch': typeof AppDeveloperUiInputSwitchRoute
  '/developer/ui/inputs': typeof AppDeveloperUiInputsRoute
  '/diaries/$diaryId/forms': typeof AppDiariesDiaryIdFormsRoute
  '/diaries/$diaryId/progress': typeof AppDiariesDiaryIdProgressRoute
  '/diaries/$diaryId/setup': typeof AppDiariesDiaryIdSetupRouteWithChildren
  '/foot-watch/$diaryId/edit': typeof AppFootWatchDiaryIdEditRouteWithChildren
  '/foot-watch/new-diary/share': typeof AppFootWatchNewDiaryShareRoute
  '/invite/diary/complete': typeof AppInviteDiaryCompleteRoute
  '/invite/diary/organisation': typeof AppInviteDiaryOrganisationRoute
  '/invite/diary/patient': typeof AppInviteDiaryPatientRoute
  '/invite/diary/qr': typeof AppInviteDiaryQrRoute
  '/invite/diary/review': typeof AppInviteDiaryReviewRoute
  '/organisation/$organisationId/qr-code': typeof AppOrganisationOrganisationIdQrCodeRoute
  '/patients/$diaryId/edit': typeof AppPatientsDiaryIdEditRoute
  '/patients/bulk/contact': typeof AppPatientsBulkContactRoute
  '/patients/bulk/labels': typeof AppPatientsBulkLabelsRoute
  '/patients/bulk/message': typeof AppPatientsBulkMessageRoute
  '/patients/bulk/organisation': typeof AppPatientsBulkOrganisationRoute
  '/patients/bulk/reviewed': typeof AppPatientsBulkReviewedRoute
  '/profile/medical/diabetes': typeof AppProfileMedicalDiabetesRoute
  '/sales/leads/new': typeof AppSalesLeadsNewRoute
  '/studies/$studyId/edit': typeof AppStudiesStudyIdEditRoute
  '/team/invite/email': typeof AppTeamInviteEmailRoute
  '/team/invite/qr': typeof AppTeamInviteQrRoute
  '/templates/$templateId/consent': typeof AppTemplatesTemplateIdConsentRoute
  '/templates/$templateId/date': typeof AppTemplatesTemplateIdDateRoute
  '/templates/$templateId/hospital-number': typeof AppTemplatesTemplateIdHospitalNumberRoute
  '/templates/$templateId/labels': typeof AppTemplatesTemplateIdLabelsRoute
  '/templates/$templateId/name': typeof AppTemplatesTemplateIdNameRoute
  '/templates/$templateId/organisation': typeof AppTemplatesTemplateIdOrganisationRoute
  '/templates/$templateId/publish': typeof AppTemplatesTemplateIdPublishRoute
  '/templates/$templateId/screener': typeof AppTemplatesTemplateIdScreenerRoute
  '/templates/$templateId/trackers': typeof AppTemplatesTemplateIdTrackersRoute
  '/templates/diary/$newDiaryTemplateId': typeof AppTemplatesDiaryNewDiaryTemplateIdRoute
  '/templates/diary/$templateId': typeof AppTemplatesDiaryTemplateIdRoute
  '/users/admins/$userId': typeof AppUsersAdminsUserIdRoute
  '/users/clinicians/$userId': typeof AppUsersCliniciansUserIdRoute
  '/users/create-user/access': typeof AppUsersCreateUserAccessRoute
  '/users/create-user/billing': typeof AppUsersCreateUserBillingRoute
  '/users/create-user/details': typeof AppUsersCreateUserDetailsRoute
  '/users/create-user/impersonate': typeof AppUsersCreateUserImpersonateRoute
  '/users/create-user/organisations': typeof AppUsersCreateUserOrganisationsRoute
  '/users/create-user/templates': typeof AppUsersCreateUserTemplatesRoute
  '/users/managers/$userId': typeof AppUsersManagersUserIdRoute
  '/users/notifications/sms': typeof AppUsersNotificationsSmsRoute
  '/users/patients/$userId': typeof AppUsersPatientsUserIdRoute
  '/users/secretaries/$userId': typeof AppUsersSecretariesUserIdRoute
  '/login/verify': typeof AuthPublicLoginVerifyRoute
  '/signup/$plan': typeof AuthPublicSignupPlanRoute
  '/signup/trial': typeof AuthPublicSignupTrialRoute
  '/signup/verify-phone': typeof AuthPublicSignupVerifyPhoneRoute
  '/admin/access': typeof AppAdminAccessIndexRoute
  '/admin/audit': typeof AppAdminAuditIndexRoute
  '/admin/business': typeof AppAdminBusinessIndexRoute
  '/admin/clinicians': typeof AppAdminCliniciansIndexRoute
  '/admin/diaries': typeof AppAdminDiariesIndexRoute
  '/admin/organisation': typeof AppAdminOrganisationIndexRoute
  '/admin/sftp': typeof AppAdminSftpIndexRoute
  '/admin/user-activation': typeof AppAdminUserActivationIndexRoute
  '/builder/consents': typeof AppBuilderConsentsIndexRoute
  '/builder/dictionaries': typeof AppBuilderDictionariesIndexRoute
  '/builder/forms': typeof AppBuilderFormsIndexRoute
  '/builder/injection-contents': typeof AppBuilderInjectionContentsIndexRoute
  '/builder/injection-locations': typeof AppBuilderInjectionLocationsIndexRoute
  '/builder/labels': typeof AppBuilderLabelsIndexRoute
  '/builder/messages': typeof AppBuilderMessagesIndexRoute
  '/builder/options': typeof AppBuilderOptionsIndexRoute
  '/builder/schedules': typeof AppBuilderSchedulesIndexRoute
  '/builder/surgeries': typeof AppBuilderSurgeriesIndexRoute
  '/builder/templates': typeof AppBuilderTemplatesIndexRoute
  '/business/leads': typeof AppBusinessLeadsIndexRoute
  '/design/forms': typeof AppDesignFormsIndexRoute
  '/design/icons': typeof AppDesignIconsIndexRoute
  '/developer/sftp': typeof AppDeveloperSftpIndexRoute
  '/diaries/$diaryId': typeof AppDiariesDiaryIdIndexRoute
  '/organisation/$organisationId': typeof AppOrganisationOrganisationIdIndexRoute
  '/patients/$diaryId': typeof AppPatientsDiaryIdIndexRoute
  '/sales/leads': typeof AppSalesLeadsIndexRoute
  '/studies/$studyId': typeof AppStudiesStudyIdIndexRoute
  '/team/invite': typeof AppTeamInviteIndexRoute
  '/users/create-user': typeof AppUsersCreateUserIndexRoute
  '/users/notifications': typeof AppUsersNotificationsIndexRoute
  '/validate/$validationId': typeof AppValidateValidationIdIndexRoute
  '/login': typeof AuthPublicLoginIndexRoute
  '/signup': typeof AuthPublicSignupIndexRoute
  '/new-user/clinician': typeof AuthNewUserClinicianIndexRoute
  '/new-user/patient': typeof AuthNewUserPatientIndexRoute
  '/admin/business/leads/new': typeof AppAdminBusinessLeadsNewRoute
  '/admin/form/$formId/results': typeof AppAdminFormFormIdResultsRoute
  '/builder/forms/$formId/$tab': typeof AppBuilderFormsFormIdTabRoute
  '/builder/forms/$formId/metadata': typeof AppBuilderFormsFormIdMetadataRoute
  '/builder/schedules/forms/formId': typeof AppBuilderSchedulesFormsFormIdRoute
  '/business/leads/artifacts/$artifactId': typeof AppBusinessLeadsArtifactsArtifactIdRoute
  '/business/leads/artifacts/new': typeof AppBusinessLeadsArtifactsNewRoute
  '/business/leads/companies/$companyId': typeof AppBusinessLeadsCompaniesCompanyIdRoute
  '/business/leads/companies/new': typeof AppBusinessLeadsCompaniesNewRoute
  '/business/leads/templates/$templateId': typeof AppBusinessLeadsTemplatesTemplateIdRoute
  '/business/leads/templates/new': typeof AppBusinessLeadsTemplatesNewRoute
  '/business/leads/touches/$touchId': typeof AppBusinessLeadsTouchesTouchIdRoute
  '/design/features/worklist/automations': typeof AppDesignFeaturesWorklistAutomationsRoute
  '/design/forms/pages/$screen': typeof AppDesignFormsPagesScreenRoute
  '/diaries/$diaryId/home/edit': typeof AppDiariesDiaryIdHomeEditRoute
  '/diaries/$diaryId/home/forms': typeof AppDiariesDiaryIdHomeFormsRoute
  '/diaries/$diaryId/home/progress': typeof AppDiariesDiaryIdHomeProgressRoute
  '/diaries/$diaryId/home/results': typeof AppDiariesDiaryIdHomeResultsRoute
  '/diaries/$diaryId/home/to-do': typeof AppDiariesDiaryIdHomeToDoRoute
  '/diaries/$diaryId/setup/complete': typeof AppDiariesDiaryIdSetupCompleteRoute
  '/diaries/$diaryId/setup/hospital-number': typeof AppDiariesDiaryIdSetupHospitalNumberRoute
  '/diaries/$diaryId/setup/reference-date': typeof AppDiariesDiaryIdSetupReferenceDateRoute
  '/diaries/$diaryId/setup/side': typeof AppDiariesDiaryIdSetupSideRoute
  '/foot-watch/$diaryId/history': typeof AppFootWatchDiaryIdViewHistoryRoute
  '/foot-watch/$diaryId/new': typeof AppFootWatchDiaryIdViewNewRoute
  '/foot-watch/$diaryId/progress': typeof AppFootWatchDiaryIdViewProgressRoute
  '/foot-watch/$diaryId/edit/diary': typeof AppFootWatchDiaryIdEditDiaryRoute
  '/foot-watch/$diaryId/edit/name': typeof AppFootWatchDiaryIdEditNameRoute
  '/foot-watch/$diaryId/new/add-photos': typeof AppFootWatchDiaryIdNewAddPhotosRoute
  '/foot-watch/$diaryId/new/camera': typeof AppFootWatchDiaryIdNewCameraRoute
  '/foot-watch/$diaryId/new/instructions': typeof AppFootWatchDiaryIdNewInstructionsRouteWithChildren
  '/foot-watch/$diaryId/new/new-patient': typeof AppFootWatchDiaryIdNewNewPatientRoute
  '/foot-watch/$diaryId/new/select-patient': typeof AppFootWatchDiaryIdNewSelectPatientRoute
  '/foot-watch/$diaryId/new/start': typeof AppFootWatchDiaryIdNewStartRoute
  '/patients/$diaryId/action/$actionId': typeof AppPatientsDiaryIdActionActionIdRoute
  '/patients/$diaryId/update/add': typeof AppPatientsDiaryIdUpdateAddRoute
  '/patients/$diaryId/update/consent': typeof AppPatientsDiaryIdUpdateConsentRoute
  '/patients/$diaryId/update/existing-trackers': typeof AppPatientsDiaryIdUpdateExistingTrackersRoute
  '/patients/$diaryId/update/from-template': typeof AppPatientsDiaryIdUpdateFromTemplateRoute
  '/patients/$diaryId/update/review': typeof AppPatientsDiaryIdUpdateReviewRoute
  '/patients/$diaryId/update/template-existing-trackers': typeof AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute
  '/patients/$diaryId/update/templates': typeof AppPatientsDiaryIdUpdateTemplatesRoute
  '/patients/bulk/events/$eventType': typeof AppPatientsBulkEventsEventTypeRoute
  '/sales/leads/artifacts/$artifactId': typeof AppSalesLeadsArtifactsArtifactIdRoute
  '/sales/leads/artifacts/new': typeof AppSalesLeadsArtifactsNewRoute
  '/sales/leads/companies/$companyId': typeof AppSalesLeadsCompaniesCompanyIdRoute
  '/sales/leads/companies/new': typeof AppSalesLeadsCompaniesNewRoute
  '/sales/leads/templates/$templateId': typeof AppSalesLeadsTemplatesTemplateIdRoute
  '/sales/leads/templates/new': typeof AppSalesLeadsTemplatesNewRoute
  '/sales/leads/touches/$touchId': typeof AppSalesLeadsTouchesTouchIdRoute
  '/studies/$studyId/invite/qr': typeof AppStudiesStudyIdInviteQrRoute
  '/validate/change-trail/$entityType/$entityId': typeof AppValidateChangeTrailEntityTypeEntityIdRoute
  '/worklist/consent/$diaryId/$consentId': typeof AppWorklistConsentDiaryIdConsentIdRoute
  '/screen/$screenerId/$entryId/page/$pageIndex': typeof ScreenScreenerIdEntryIdPagePageIndexRoute
  '/admin/business/leads': typeof AppAdminBusinessLeadsIndexRoute
  '/admin/diaries/$diaryId': typeof AppAdminDiariesDiaryIdIndexRoute
  '/admin/entry/$entryId': typeof AppAdminEntryEntryIdIndexRoute
  '/builder/forms/$formId': typeof AppBuilderFormsFormIdIndexRoute
  '/business/leads/$leadId': typeof AppBusinessLeadsLeadIdIndexRoute
  '/business/leads/artifacts': typeof AppBusinessLeadsArtifactsIndexRoute
  '/business/leads/companies': typeof AppBusinessLeadsCompaniesIndexRoute
  '/business/leads/templates': typeof AppBusinessLeadsTemplatesIndexRoute
  '/business/leads/touches': typeof AppBusinessLeadsTouchesIndexRoute
  '/design/features/worklist': typeof AppDesignFeaturesWorklistIndexRoute
  '/design/forms/pages': typeof AppDesignFormsPagesIndexRoute
  '/diaries/$diaryId/home': typeof AppDiariesDiaryIdHomeIndexRoute
  '/patients/bulk/events': typeof AppPatientsBulkEventsIndexRoute
  '/sales/leads/$leadId': typeof AppSalesLeadsLeadIdIndexRoute
  '/sales/leads/artifacts': typeof AppSalesLeadsArtifactsIndexRoute
  '/sales/leads/companies': typeof AppSalesLeadsCompaniesIndexRoute
  '/sales/leads/templates': typeof AppSalesLeadsTemplatesIndexRoute
  '/sales/leads/touches': typeof AppSalesLeadsTouchesIndexRoute
  '/studies/$studyId/invite': typeof AppStudiesStudyIdInviteIndexRoute
  '/templates/$templateId/events': typeof AppTemplatesTemplateIdEventsIndexRoute
  '/forms/$formId/page/$pageIndex': typeof FormsFormIdPagePageIndexIndexRoute
  '/tracker/$trackerId/form/$formId': typeof TrackerTrackerIdFormFormIdIndexRoute
  '/admin/business/leads/artifacts/$artifactId': typeof AppAdminBusinessLeadsArtifactsArtifactIdRoute
  '/admin/business/leads/artifacts/new': typeof AppAdminBusinessLeadsArtifactsNewRoute
  '/admin/business/leads/companies/$companyId': typeof AppAdminBusinessLeadsCompaniesCompanyIdRoute
  '/admin/business/leads/companies/new': typeof AppAdminBusinessLeadsCompaniesNewRoute
  '/admin/business/leads/templates/$templateId': typeof AppAdminBusinessLeadsTemplatesTemplateIdRoute
  '/admin/business/leads/templates/new': typeof AppAdminBusinessLeadsTemplatesNewRoute
  '/admin/business/leads/touches/$touchId': typeof AppAdminBusinessLeadsTouchesTouchIdRoute
  '/foot-watch/$diaryId/new/upload/complete': typeof AppFootWatchDiaryIdNewUploadCompleteRoute
  '/foot-watch/$diaryId/new/upload/message': typeof AppFootWatchDiaryIdNewUploadMessageRoute
  '/foot-watch/$diaryId/new/upload/uploading': typeof AppFootWatchDiaryIdNewUploadUploadingRoute
  '/patients/$diaryId/consent/$consentId/complete': typeof AppPatientsDiaryIdConsentConsentIdCompleteRoute
  '/templates/$templateId/events/injection/details': typeof AppTemplatesTemplateIdEventsInjectionDetailsRoute
  '/templates/$templateId/events/shockwave/details': typeof AppTemplatesTemplateIdEventsShockwaveDetailsRoute
  '/templates/$templateId/events/surgery/details': typeof AppTemplatesTemplateIdEventsSurgeryDetailsRoute
  '/templates/diary/intervention/injection': typeof AppTemplatesDiaryFormInterventionInjectionRoute
  '/validate/$validationId/forms/$formId/results': typeof AppValidateValidationIdFormsFormIdResultsRoute
  '/admin/business/leads/$leadId': typeof AppAdminBusinessLeadsLeadIdIndexRoute
  '/admin/business/leads/artifacts': typeof AppAdminBusinessLeadsArtifactsIndexRoute
  '/admin/business/leads/companies': typeof AppAdminBusinessLeadsCompaniesIndexRoute
  '/admin/business/leads/templates': typeof AppAdminBusinessLeadsTemplatesIndexRoute
  '/admin/business/leads/touches': typeof AppAdminBusinessLeadsTouchesIndexRoute
  '/foot-watch/$diaryId/new/upload': typeof AppFootWatchDiaryIdNewUploadIndexRoute
  '/foot-watch/new-diary/$patientId/$diaryId': typeof AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute
  '/patients/$diaryId/consent/$consentId': typeof AppPatientsDiaryIdConsentConsentIdIndexRoute
  '/templates/$templateId/events/education': typeof AppTemplatesTemplateIdEventsEducationIndexRoute
  '/templates/$templateId/events/injection': typeof AppTemplatesTemplateIdEventsInjectionIndexRoute
  '/templates/$templateId/events/product': typeof AppTemplatesTemplateIdEventsProductIndexRoute
  '/templates/$templateId/events/shockwave': typeof AppTemplatesTemplateIdEventsShockwaveIndexRoute
  '/templates/$templateId/events/surgery': typeof AppTemplatesTemplateIdEventsSurgeryIndexRoute
  '/validate/$validationId/forms/$formId': typeof AppValidateValidationIdFormsFormIdIndexRoute
  '/preview/patient/$patientId/diary/$diaryId': typeof PreviewPatientPatientIdDiaryDiaryIdIndexRoute
  '/diaries/$diaryId/setup/consent/$consentId/complete': typeof AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute
  '/foot-watch/$diaryId/new/instructions/$angle/$side': typeof AppFootWatchDiaryIdNewInstructionsAngleSideRoute
  '/patients/$diaryId/update/$eventId/$trackerId/contact': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute
  '/patients/$diaryId/update/$eventId/$trackerId/date': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute
  '/patients/$diaryId/update/$eventId/$trackerId/message': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute
  '/patients/$diaryId/update/$eventId/$trackerId/questionnaire': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute
  '/templates/diary/$diaryId/events/$eventId/complete': typeof AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute
  '/templates/diary/$diaryId/events/$eventId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute
  '/templates/diary/$diaryId/trackers/$trackerId/date': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute
  '/templates/diary/$diaryId/trackers/$trackerId/details': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute
  '/validate/$validationId/forms/$formId/page/$pageIndex': typeof AppValidateValidationIdFormsFormIdPagePageIndexRoute
  '/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind': typeof AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute
  '/diaries/$diaryId/setup/consent/$consentId': typeof AppDiariesDiaryIdSetupConsentConsentIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId': typeof AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute
  '/templates/diary/$diaryId/trackers/$trackerId': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute
  '/preview/radiology-report/patient/$patientId/event/$eventId': typeof PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteWithChildren
  '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  '/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute
  '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute
  '/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex': typeof AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute
  '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId': typeof PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute
  '/tracker/$trackerId/form/$formId/entry/$entryId/page': typeof TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteWithChildren
  '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute
  '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute
  '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute
  '/templates/diary/$diaryId/events/$eventId/education/$educationId': typeof AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/injection/$injectionId': typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/product/$productId': typeof AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId': typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute
  '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId': typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute
  '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex': typeof TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute
  '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex': typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex': typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteWithChildren
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute
  '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/error': typeof ErrorRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/preview': typeof PreviewRouteWithChildren
  '/_app/users': typeof AppUsersRouteRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/analytics': typeof AppAnalyticsRouteWithChildren
  '/_app/builder': typeof AppBuilderRouteWithChildren
  '/_app/business': typeof AppBusinessRouteWithChildren
  '/_app/complete-profile': typeof AppCompleteProfileRoute
  '/_app/customers': typeof AppCustomersRouteWithChildren
  '/_app/design': typeof AppDesignRouteWithChildren
  '/_app/developer': typeof AppDeveloperRouteWithChildren
  '/_app/invite': typeof AppInviteRouteWithChildren
  '/_app/patients': typeof AppPatientsRouteWithChildren
  '/_app/profile': typeof AppProfileRouteWithChildren
  '/_app/role': typeof AppRoleRoute
  '/_app/sales': typeof AppSalesRouteWithChildren
  '/_app/statistics': typeof AppStatisticsRoute
  '/_app/studies': typeof AppStudiesRouteWithChildren
  '/_app/team': typeof AppTeamRouteWithChildren
  '/_app/templates': typeof AppTemplatesRouteWithChildren
  '/_app/worklist': typeof AppWorklistRouteWithChildren
  '/_auth/_public': typeof AuthPublicRouteWithChildren
  '/_auth/activate-account': typeof AuthActivateAccountRoute
  '/_auth/auth-error': typeof AuthAuthErrorRoute
  '/_auth/authentication-complete': typeof AuthAuthenticationCompleteRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/confirm-account': typeof AuthConfirmAccountRouteWithChildren
  '/_auth/delete-account': typeof AuthDeleteAccountRoute
  '/_auth/email-confirmed': typeof AuthEmailConfirmedRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRouteWithChildren
  '/_auth/magic': typeof AuthMagicRoute
  '/_auth/new-diary-invite': typeof AuthNewDiaryInviteRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/_auth/test': typeof AuthTestRoute
  '/_auth/try-demo': typeof AuthTryDemoRoute
  '/_auth/verification-complete': typeof AuthVerificationCompleteRoute
  '/_auth/verify': typeof AuthVerifyRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_auth/verify-payment': typeof AuthVerifyPaymentRoute
  '/clinicians/$clinicianId': typeof CliniciansClinicianIdRoute
  '/feedback/patient': typeof FeedbackPatientRoute
  '/forms/request': typeof FormsRequestRoute
  '/onboarding/clinician-number': typeof OnboardingClinicianNumberRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/date-of-birth': typeof OnboardingDateOfBirthRoute
  '/onboarding/email': typeof OnboardingEmailRoute
  '/onboarding/name': typeof OnboardingNameRoute
  '/onboarding/notifications': typeof OnboardingNotificationsRoute
  '/onboarding/phone': typeof OnboardingPhoneRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/preferences/$userId': typeof PreferencesUserIdRoute
  '/preview/consent': typeof PreviewConsentRouteWithChildren
  '/schedules/request': typeof SchedulesRequestRoute
  '/forms/': typeof FormsIndexRoute
  '/_app/admin/access': typeof AppAdminAccessRouteRouteWithChildren
  '/_app/admin/audit': typeof AppAdminAuditRouteRouteWithChildren
  '/_app/admin/organisation': typeof AppAdminOrganisationRouteRouteWithChildren
  '/_app/admin/sftp': typeof AppAdminSftpRouteRouteWithChildren
  '/_app/business/leads': typeof AppBusinessLeadsRouteRouteWithChildren
  '/_app/developer/sftp': typeof AppDeveloperSftpRouteRouteWithChildren
  '/_app/sales/leads': typeof AppSalesLeadsRouteRouteWithChildren
  '/_app/users/create-user': typeof AppUsersCreateUserRouteRouteWithChildren
  '/_app/users/notifications': typeof AppUsersNotificationsRouteRouteWithChildren
  '/_app/admin/ambassadors': typeof AppAdminAmbassadorsRoute
  '/_app/admin/entries': typeof AppAdminEntriesRoute
  '/_app/admin/entry-values': typeof AppAdminEntryValuesRoute
  '/_app/admin/events': typeof AppAdminEventsRoute
  '/_app/admin/health-check': typeof AppAdminHealthCheckRoute
  '/_app/admin/impersonate-user': typeof AppAdminImpersonateUserRoute
  '/_app/admin/label-access': typeof AppAdminLabelAccessRoute
  '/_app/admin/labels': typeof AppAdminLabelsRoute
  '/_app/admin/notification-preferences': typeof AppAdminNotificationPreferencesRoute
  '/_app/admin/reminder-send-volume': typeof AppAdminReminderSendVolumeRoute
  '/_app/admin/sms-deliverability': typeof AppAdminSmsDeliverabilityRoute
  '/_app/admin/studies': typeof AppAdminStudiesRoute
  '/_app/admin/templates': typeof AppAdminTemplatesRoute
  '/_app/admin/trackers': typeof AppAdminTrackersRoute
  '/_app/admin/user-billing': typeof AppAdminUserBillingRoute
  '/_app/admin/user-organisations': typeof AppAdminUserOrganisationsRoute
  '/_app/admin/view-diary-as-patient': typeof AppAdminViewDiaryAsPatientRoute
  '/_app/analytics/$diaryLabel': typeof AppAnalyticsDiaryLabelRoute
  '/_app/analytics/anika': typeof AppAnalyticsAnikaRoute
  '/_app/analytics/arthrosamid': typeof AppAnalyticsArthrosamidRoute
  '/_app/business/ambassadors': typeof AppBusinessAmbassadorsRoute
  '/_app/business/churn': typeof AppBusinessChurnRoute
  '/_app/clinician/diaries': typeof AppClinicianDiariesRoute
  '/_app/customers/ambassadors': typeof AppCustomersAmbassadorsRoute
  '/_app/customers/anonymous': typeof AppCustomersAnonymousRoute
  '/_app/customers/churn': typeof AppCustomersChurnRoute
  '/_app/customers/clinicians': typeof AppCustomersCliniciansRoute
  '/_app/customers/success': typeof AppCustomersSuccessRoute
  '/_app/developer/health-check': typeof AppDeveloperHealthCheckRoute
  '/_app/developer/messaging-schedule': typeof AppDeveloperMessagingScheduleRoute
  '/_app/developer/reminder-send-volume': typeof AppDeveloperReminderSendVolumeRoute
  '/_app/developer/sms-deliverability': typeof AppDeveloperSmsDeliverabilityRoute
  '/_app/diaries/$diaryId': typeof AppDiariesDiaryIdRouteWithChildren
  '/_app/fisher-watch/dashboard': typeof AppFisherWatchDashboardRoute
  '/_app/foot-watch/$diaryId': typeof AppFootWatchDiaryIdRouteWithChildren
  '/_app/headache-watch/dashboard': typeof AppHeadacheWatchDashboardRoute
  '/_app/help/clinician': typeof AppHelpClinicianRoute
  '/_app/help/patient': typeof AppHelpPatientRoute
  '/_app/invite/qr-code': typeof AppInviteQrCodeRoute
  '/_app/lead-gen/$': typeof AppLeadGenSplatRoute
  '/_app/new/$': typeof AppNewSplatRoute
  '/_app/patients/$diaryId': typeof AppPatientsDiaryIdRouteWithChildren
  '/_app/profile/add-imaging-center': typeof AppProfileAddImagingCenterRoute
  '/_app/profile/billing': typeof AppProfileBillingRoute
  '/_app/profile/change-password': typeof AppProfileChangePasswordRoute
  '/_app/profile/clinician-number': typeof AppProfileClinicianNumberRoute
  '/_app/profile/date-of-birth': typeof AppProfileDateOfBirthRoute
  '/_app/profile/delete-account': typeof AppProfileDeleteAccountRoute
  '/_app/profile/email': typeof AppProfileEmailRoute
  '/_app/profile/mfa': typeof AppProfileMfaRoute
  '/_app/profile/name': typeof AppProfileNameRoute
  '/_app/profile/nhs-number': typeof AppProfileNhsNumberRoute
  '/_app/profile/notifications': typeof AppProfileNotificationsRoute
  '/_app/profile/organisation': typeof AppProfileOrganisationRoute
  '/_app/profile/phone': typeof AppProfilePhoneRoute
  '/_app/schedules/$scheduleId': typeof AppSchedulesScheduleIdRoute
  '/_app/studies/$studyId': typeof AppStudiesStudyIdRouteWithChildren
  '/_app/team/invite': typeof AppTeamInviteRouteWithChildren
  '/_app/templates/$templateId': typeof AppTemplatesTemplateIdRouteWithChildren
  '/_app/templates/complete': typeof AppTemplatesCompleteRoute
  '/_app/templates/public': typeof AppTemplatesPublicRoute
  '/_app/templates/quickstart-page': typeof AppTemplatesQuickstartPageRoute
  '/_app/users/admins': typeof AppUsersAdminsRouteWithChildren
  '/_app/users/billing': typeof AppUsersBillingRoute
  '/_app/users/clinicians': typeof AppUsersCliniciansRouteWithChildren
  '/_app/users/managers': typeof AppUsersManagersRouteWithChildren
  '/_app/users/organisations': typeof AppUsersOrganisationsRoute
  '/_app/users/patients': typeof AppUsersPatientsRouteWithChildren
  '/_app/users/preferences': typeof AppUsersPreferencesRoute
  '/_app/users/secretaries': typeof AppUsersSecretariesRouteWithChildren
  '/_app/validate/$validationId': typeof AppValidateValidationIdRouteWithChildren
  '/_app/worklist/complete': typeof AppWorklistCompleteRoute
  '/_auth/_public/authenticate': typeof AuthPublicAuthenticateRoute
  '/_auth/_public/login': typeof AuthPublicLoginRouteWithChildren
  '/_auth/confirm-account/verify': typeof AuthConfirmAccountVerifyRoute
  '/_auth/forgot-password/verify': typeof AuthForgotPasswordVerifyRoute
  '/_auth/mfa/challenge': typeof AuthMfaChallengeRoute
  '/_auth/mfa/enroll': typeof AuthMfaEnrollRoute
  '/help/explainer/$explainerType': typeof HelpExplainerExplainerTypeRoute
  '/onboarding/clinician/name': typeof OnboardingClinicianNameRoute
  '/onboarding/clinician/organisation': typeof OnboardingClinicianOrganisationRoute
  '/onboarding/clinician/professional': typeof OnboardingClinicianProfessionalRoute
  '/preview/consent/$consentId': typeof PreviewConsentConsentIdRoute
  '/preview/invite/qr-code': typeof PreviewInviteQrCodeRoute
  '/screen/$screenerId/result': typeof ScreenScreenerIdResultRoute
  '/tracker/$trackerId/results': typeof TrackerTrackerIdResultsRoute
  '/tracker/$trackerId/success': typeof TrackerTrackerIdSuccessRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/analytics/': typeof AppAnalyticsIndexRoute
  '/_app/builder/': typeof AppBuilderIndexRoute
  '/_app/business/': typeof AppBusinessIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/design/': typeof AppDesignIndexRoute
  '/_app/developer/': typeof AppDeveloperIndexRoute
  '/_app/diaries/': typeof AppDiariesIndexRoute
  '/_app/invite/': typeof AppInviteIndexRoute
  '/_app/lead-gen/': typeof AppLeadGenIndexRoute
  '/_app/new/': typeof AppNewIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/sales/': typeof AppSalesIndexRoute
  '/_app/schedules/': typeof AppSchedulesIndexRoute
  '/_app/studies/': typeof AppStudiesIndexRoute
  '/_app/team/': typeof AppTeamIndexRoute
  '/_app/templates/': typeof AppTemplatesIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/validate/': typeof AppValidateIndexRoute
  '/_app/worklist/': typeof AppWorklistIndexRoute
  '/_auth/_public/': typeof AuthPublicIndexRoute
  '/_auth/confirm-account/': typeof AuthConfirmAccountIndexRoute
  '/_auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/_auth/new-user/': typeof AuthNewUserIndexRoute
  '/forms/$formId/': typeof FormsFormIdIndexRoute
  '/screen/$screenerId/': typeof ScreenScreenerIdIndexRoute
  '/_app/admin/business/leads': typeof AppAdminBusinessLeadsRouteRouteWithChildren
  '/_app/admin/access/$attribute': typeof AppAdminAccessAttributeRoute
  '/_app/admin/access/forms': typeof AppAdminAccessFormsRoute
  '/_app/admin/access/labels': typeof AppAdminAccessLabelsRoute
  '/_app/admin/access/roles': typeof AppAdminAccessRolesRoute
  '/_app/admin/access/schedules': typeof AppAdminAccessSchedulesRoute
  '/_app/admin/access/studies': typeof AppAdminAccessStudiesRoute
  '/_app/admin/access/tabs': typeof AppAdminAccessTabsRoute
  '/_app/admin/access/users': typeof AppAdminAccessUsersRoute
  '/_app/admin/audit/change-timeline': typeof AppAdminAuditChangeTimelineRoute
  '/_app/admin/audit/lock-diaries': typeof AppAdminAuditLockDiariesRoute
  '/_app/admin/audit/snapshot': typeof AppAdminAuditSnapshotRoute
  '/_app/admin/business/ambassadors': typeof AppAdminBusinessAmbassadorsRoute
  '/_app/admin/business/churn': typeof AppAdminBusinessChurnRoute
  '/_app/admin/clinicians/leaderboard': typeof AppAdminCliniciansLeaderboardRoute
  '/_app/admin/clinicians/photos': typeof AppAdminCliniciansPhotosRoute
  '/_app/admin/clinicians/statistics': typeof AppAdminCliniciansStatisticsRoute
  '/_app/admin/diaries/types': typeof AppAdminDiariesTypesRoute
  '/_app/admin/organisation/add': typeof AppAdminOrganisationAddRoute
  '/_app/admin/organisation/logos': typeof AppAdminOrganisationLogosRoute
  '/_app/admin/organisation/statistics': typeof AppAdminOrganisationStatisticsRoute
  '/_app/admin/sftp/dashboard': typeof AppAdminSftpDashboardRoute
  '/_app/admin/sftp/diaries': typeof AppAdminSftpDiariesRoute
  '/_app/admin/sftp/explorer': typeof AppAdminSftpExplorerRoute
  '/_app/admin/sftp/organisations': typeof AppAdminSftpOrganisationsRoute
  '/_app/admin/sftp/preview': typeof AppAdminSftpPreviewRoute
  '/_app/admin/sftp/upload': typeof AppAdminSftpUploadRoute
  '/_app/admin/user/$userId': typeof AppAdminUserUserIdRoute
  '/_app/builder/consents/$consentBodyId': typeof AppBuilderConsentsConsentBodyIdRoute
  '/_app/builder/dictionaries/$dictionaryId': typeof AppBuilderDictionariesDictionaryIdRoute
  '/_app/builder/forms/new': typeof AppBuilderFormsNewRoute
  '/_app/builder/schedules/$scheduleId': typeof AppBuilderSchedulesScheduleIdRoute
  '/_app/builder/schedules/new': typeof AppBuilderSchedulesNewRoute
  '/_app/business/leads/new': typeof AppBusinessLeadsNewRoute
  '/_app/design/components/animations': typeof AppDesignComponentsAnimationsRoute
  '/_app/design/components/auth': typeof AppDesignComponentsAuthRoute
  '/_app/design/components/buttons': typeof AppDesignComponentsButtonsRoute
  '/_app/design/components/dictionaries': typeof AppDesignComponentsDictionariesRoute
  '/_app/design/components/inputs': typeof AppDesignComponentsInputsRoute
  '/_app/design/components/search-fields': typeof AppDesignComponentsSearchFieldsRoute
  '/_app/design/components/select-dialogs': typeof AppDesignComponentsSelectDialogsRoute
  '/_app/design/features/generalised-analytics': typeof AppDesignFeaturesGeneralisedAnalyticsRoute
  '/_app/design/features/manager-study-clinician-invite-plan': typeof AppDesignFeaturesManagerStudyClinicianInvitePlanRoute
  '/_app/design/features/messaging-schedule': typeof AppDesignFeaturesMessagingScheduleRoute
  '/_app/design/features/otivio-frictionless-onboarding': typeof AppDesignFeaturesOtivioFrictionlessOnboardingRoute
  '/_app/design/features/reminder-sequences': typeof AppDesignFeaturesReminderSequencesRoute
  '/_app/design/forms/blocks': typeof AppDesignFormsBlocksRoute
  '/_app/design/forms/entry-values': typeof AppDesignFormsEntryValuesRoute
  '/_app/design/forms/inputs': typeof AppDesignFormsInputsRoute
  '/_app/design/forms/pages': typeof AppDesignFormsPagesRouteWithChildren
  '/_app/design/icons/animations': typeof AppDesignIconsAnimationsRoute
  '/_app/design/icons/faces': typeof AppDesignIconsFacesRoute
  '/_app/design/icons/states': typeof AppDesignIconsStatesRoute
  '/_app/developer/demos/generalised-analytics': typeof AppDeveloperDemosGeneralisedAnalyticsRoute
  '/_app/developer/demos/manager-study-clinician-invite-plan': typeof AppDeveloperDemosManagerStudyClinicianInvitePlanRoute
  '/_app/developer/demos/otivio-frictionless-onboarding': typeof AppDeveloperDemosOtivioFrictionlessOnboardingRoute
  '/_app/developer/sftp/dashboard': typeof AppDeveloperSftpDashboardRoute
  '/_app/developer/sftp/diaries': typeof AppDeveloperSftpDiariesRoute
  '/_app/developer/sftp/explorer': typeof AppDeveloperSftpExplorerRoute
  '/_app/developer/sftp/organisations': typeof AppDeveloperSftpOrganisationsRoute
  '/_app/developer/sftp/preview': typeof AppDeveloperSftpPreviewRoute
  '/_app/developer/sftp/upload': typeof AppDeveloperSftpUploadRoute
  '/_app/developer/ui/animations': typeof AppDeveloperUiAnimationsRoute
  '/_app/developer/ui/auth': typeof AppDeveloperUiAuthRoute
  '/_app/developer/ui/buttons': typeof AppDeveloperUiButtonsRoute
  '/_app/developer/ui/dictionaries': typeof AppDeveloperUiDictionariesRoute
  '/_app/developer/ui/entry-values': typeof AppDeveloperUiEntryValuesRoute
  '/_app/developer/ui/input-switch': typeof AppDeveloperUiInputSwitchRoute
  '/_app/developer/ui/inputs': typeof AppDeveloperUiInputsRoute
  '/_app/diaries/$diaryId/forms': typeof AppDiariesDiaryIdFormsRoute
  '/_app/diaries/$diaryId/home': typeof AppDiariesDiaryIdHomeRouteWithChildren
  '/_app/diaries/$diaryId/progress': typeof AppDiariesDiaryIdProgressRoute
  '/_app/diaries/$diaryId/setup': typeof AppDiariesDiaryIdSetupRouteWithChildren
  '/_app/foot-watch/$diaryId/_view': typeof AppFootWatchDiaryIdViewRouteWithChildren
  '/_app/foot-watch/$diaryId/edit': typeof AppFootWatchDiaryIdEditRouteWithChildren
  '/_app/foot-watch/new-diary/share': typeof AppFootWatchNewDiaryShareRoute
  '/_app/invite/diary/complete': typeof AppInviteDiaryCompleteRoute
  '/_app/invite/diary/organisation': typeof AppInviteDiaryOrganisationRoute
  '/_app/invite/diary/patient': typeof AppInviteDiaryPatientRoute
  '/_app/invite/diary/qr': typeof AppInviteDiaryQrRoute
  '/_app/invite/diary/review': typeof AppInviteDiaryReviewRoute
  '/_app/organisation/$organisationId/qr-code': typeof AppOrganisationOrganisationIdQrCodeRoute
  '/_app/patients/$diaryId/edit': typeof AppPatientsDiaryIdEditRoute
  '/_app/patients/bulk/contact': typeof AppPatientsBulkContactRoute
  '/_app/patients/bulk/events': typeof AppPatientsBulkEventsRouteWithChildren
  '/_app/patients/bulk/labels': typeof AppPatientsBulkLabelsRoute
  '/_app/patients/bulk/message': typeof AppPatientsBulkMessageRoute
  '/_app/patients/bulk/organisation': typeof AppPatientsBulkOrganisationRoute
  '/_app/patients/bulk/reviewed': typeof AppPatientsBulkReviewedRoute
  '/_app/profile/medical/diabetes': typeof AppProfileMedicalDiabetesRoute
  '/_app/sales/leads/new': typeof AppSalesLeadsNewRoute
  '/_app/studies/$studyId/edit': typeof AppStudiesStudyIdEditRoute
  '/_app/team/invite/email': typeof AppTeamInviteEmailRoute
  '/_app/team/invite/qr': typeof AppTeamInviteQrRoute
  '/_app/templates/$templateId/consent': typeof AppTemplatesTemplateIdConsentRoute
  '/_app/templates/$templateId/date': typeof AppTemplatesTemplateIdDateRoute
  '/_app/templates/$templateId/hospital-number': typeof AppTemplatesTemplateIdHospitalNumberRoute
  '/_app/templates/$templateId/labels': typeof AppTemplatesTemplateIdLabelsRoute
  '/_app/templates/$templateId/name': typeof AppTemplatesTemplateIdNameRoute
  '/_app/templates/$templateId/organisation': typeof AppTemplatesTemplateIdOrganisationRoute
  '/_app/templates/$templateId/publish': typeof AppTemplatesTemplateIdPublishRoute
  '/_app/templates/$templateId/screener': typeof AppTemplatesTemplateIdScreenerRoute
  '/_app/templates/$templateId/trackers': typeof AppTemplatesTemplateIdTrackersRoute
  '/_app/templates/diary/$newDiaryTemplateId': typeof AppTemplatesDiaryNewDiaryTemplateIdRoute
  '/_app/templates/diary/$templateId': typeof AppTemplatesDiaryTemplateIdRoute
  '/_app/users/admins/$userId': typeof AppUsersAdminsUserIdRoute
  '/_app/users/clinicians/$userId': typeof AppUsersCliniciansUserIdRoute
  '/_app/users/create-user/access': typeof AppUsersCreateUserAccessRoute
  '/_app/users/create-user/billing': typeof AppUsersCreateUserBillingRoute
  '/_app/users/create-user/details': typeof AppUsersCreateUserDetailsRoute
  '/_app/users/create-user/impersonate': typeof AppUsersCreateUserImpersonateRoute
  '/_app/users/create-user/organisations': typeof AppUsersCreateUserOrganisationsRoute
  '/_app/users/create-user/templates': typeof AppUsersCreateUserTemplatesRoute
  '/_app/users/managers/$userId': typeof AppUsersManagersUserIdRoute
  '/_app/users/notifications/sms': typeof AppUsersNotificationsSmsRoute
  '/_app/users/patients/$userId': typeof AppUsersPatientsUserIdRoute
  '/_app/users/secretaries/$userId': typeof AppUsersSecretariesUserIdRoute
  '/_auth/_public/login/verify': typeof AuthPublicLoginVerifyRoute
  '/_auth/_public/signup/$plan': typeof AuthPublicSignupPlanRoute
  '/_auth/_public/signup/trial': typeof AuthPublicSignupTrialRoute
  '/_auth/_public/signup/verify-phone': typeof AuthPublicSignupVerifyPhoneRoute
  '/_app/admin/access/': typeof AppAdminAccessIndexRoute
  '/_app/admin/audit/': typeof AppAdminAuditIndexRoute
  '/_app/admin/business/': typeof AppAdminBusinessIndexRoute
  '/_app/admin/clinicians/': typeof AppAdminCliniciansIndexRoute
  '/_app/admin/diaries/': typeof AppAdminDiariesIndexRoute
  '/_app/admin/organisation/': typeof AppAdminOrganisationIndexRoute
  '/_app/admin/sftp/': typeof AppAdminSftpIndexRoute
  '/_app/admin/user-activation/': typeof AppAdminUserActivationIndexRoute
  '/_app/builder/consents/': typeof AppBuilderConsentsIndexRoute
  '/_app/builder/dictionaries/': typeof AppBuilderDictionariesIndexRoute
  '/_app/builder/forms/': typeof AppBuilderFormsIndexRoute
  '/_app/builder/injection-contents/': typeof AppBuilderInjectionContentsIndexRoute
  '/_app/builder/injection-locations/': typeof AppBuilderInjectionLocationsIndexRoute
  '/_app/builder/labels/': typeof AppBuilderLabelsIndexRoute
  '/_app/builder/messages/': typeof AppBuilderMessagesIndexRoute
  '/_app/builder/options/': typeof AppBuilderOptionsIndexRoute
  '/_app/builder/schedules/': typeof AppBuilderSchedulesIndexRoute
  '/_app/builder/surgeries/': typeof AppBuilderSurgeriesIndexRoute
  '/_app/builder/templates/': typeof AppBuilderTemplatesIndexRoute
  '/_app/business/leads/': typeof AppBusinessLeadsIndexRoute
  '/_app/design/forms/': typeof AppDesignFormsIndexRoute
  '/_app/design/icons/': typeof AppDesignIconsIndexRoute
  '/_app/developer/sftp/': typeof AppDeveloperSftpIndexRoute
  '/_app/diaries/$diaryId/': typeof AppDiariesDiaryIdIndexRoute
  '/_app/organisation/$organisationId/': typeof AppOrganisationOrganisationIdIndexRoute
  '/_app/patients/$diaryId/': typeof AppPatientsDiaryIdIndexRoute
  '/_app/sales/leads/': typeof AppSalesLeadsIndexRoute
  '/_app/studies/$studyId/': typeof AppStudiesStudyIdIndexRoute
  '/_app/team/invite/': typeof AppTeamInviteIndexRoute
  '/_app/users/create-user/': typeof AppUsersCreateUserIndexRoute
  '/_app/users/notifications/': typeof AppUsersNotificationsIndexRoute
  '/_app/validate/$validationId/': typeof AppValidateValidationIdIndexRoute
  '/_auth/_public/login/': typeof AuthPublicLoginIndexRoute
  '/_auth/_public/signup/': typeof AuthPublicSignupIndexRoute
  '/_auth/new-user/clinician/': typeof AuthNewUserClinicianIndexRoute
  '/_auth/new-user/patient/': typeof AuthNewUserPatientIndexRoute
  '/_app/admin/business/leads/new': typeof AppAdminBusinessLeadsNewRoute
  '/_app/admin/form/$formId/results': typeof AppAdminFormFormIdResultsRoute
  '/_app/builder/forms/$formId/$tab': typeof AppBuilderFormsFormIdTabRoute
  '/_app/builder/forms/$formId/metadata': typeof AppBuilderFormsFormIdMetadataRoute
  '/_app/builder/schedules/forms/formId': typeof AppBuilderSchedulesFormsFormIdRoute
  '/_app/business/leads/artifacts/$artifactId': typeof AppBusinessLeadsArtifactsArtifactIdRoute
  '/_app/business/leads/artifacts/new': typeof AppBusinessLeadsArtifactsNewRoute
  '/_app/business/leads/companies/$companyId': typeof AppBusinessLeadsCompaniesCompanyIdRoute
  '/_app/business/leads/companies/new': typeof AppBusinessLeadsCompaniesNewRoute
  '/_app/business/leads/templates/$templateId': typeof AppBusinessLeadsTemplatesTemplateIdRoute
  '/_app/business/leads/templates/new': typeof AppBusinessLeadsTemplatesNewRoute
  '/_app/business/leads/touches/$touchId': typeof AppBusinessLeadsTouchesTouchIdRoute
  '/_app/design/features/worklist/automations': typeof AppDesignFeaturesWorklistAutomationsRoute
  '/_app/design/forms/pages/$screen': typeof AppDesignFormsPagesScreenRoute
  '/_app/diaries/$diaryId/home/edit': typeof AppDiariesDiaryIdHomeEditRoute
  '/_app/diaries/$diaryId/home/forms': typeof AppDiariesDiaryIdHomeFormsRoute
  '/_app/diaries/$diaryId/home/progress': typeof AppDiariesDiaryIdHomeProgressRoute
  '/_app/diaries/$diaryId/home/results': typeof AppDiariesDiaryIdHomeResultsRoute
  '/_app/diaries/$diaryId/home/to-do': typeof AppDiariesDiaryIdHomeToDoRoute
  '/_app/diaries/$diaryId/setup/complete': typeof AppDiariesDiaryIdSetupCompleteRoute
  '/_app/diaries/$diaryId/setup/hospital-number': typeof AppDiariesDiaryIdSetupHospitalNumberRoute
  '/_app/diaries/$diaryId/setup/reference-date': typeof AppDiariesDiaryIdSetupReferenceDateRoute
  '/_app/diaries/$diaryId/setup/side': typeof AppDiariesDiaryIdSetupSideRoute
  '/_app/foot-watch/$diaryId/_view/history': typeof AppFootWatchDiaryIdViewHistoryRoute
  '/_app/foot-watch/$diaryId/_view/new': typeof AppFootWatchDiaryIdViewNewRoute
  '/_app/foot-watch/$diaryId/_view/progress': typeof AppFootWatchDiaryIdViewProgressRoute
  '/_app/foot-watch/$diaryId/edit/diary': typeof AppFootWatchDiaryIdEditDiaryRoute
  '/_app/foot-watch/$diaryId/edit/name': typeof AppFootWatchDiaryIdEditNameRoute
  '/_app/foot-watch/$diaryId/new/add-photos': typeof AppFootWatchDiaryIdNewAddPhotosRoute
  '/_app/foot-watch/$diaryId/new/camera': typeof AppFootWatchDiaryIdNewCameraRoute
  '/_app/foot-watch/$diaryId/new/instructions': typeof AppFootWatchDiaryIdNewInstructionsRouteWithChildren
  '/_app/foot-watch/$diaryId/new/new-patient': typeof AppFootWatchDiaryIdNewNewPatientRoute
  '/_app/foot-watch/$diaryId/new/select-patient': typeof AppFootWatchDiaryIdNewSelectPatientRoute
  '/_app/foot-watch/$diaryId/new/start': typeof AppFootWatchDiaryIdNewStartRoute
  '/_app/foot-watch/$diaryId/new/upload': typeof AppFootWatchDiaryIdNewUploadRouteWithChildren
  '/_app/patients/$diaryId/action/$actionId': typeof AppPatientsDiaryIdActionActionIdRoute
  '/_app/patients/$diaryId/consent/$consentId': typeof AppPatientsDiaryIdConsentConsentIdRouteWithChildren
  '/_app/patients/$diaryId/update/add': typeof AppPatientsDiaryIdUpdateAddRoute
  '/_app/patients/$diaryId/update/consent': typeof AppPatientsDiaryIdUpdateConsentRoute
  '/_app/patients/$diaryId/update/existing-trackers': typeof AppPatientsDiaryIdUpdateExistingTrackersRoute
  '/_app/patients/$diaryId/update/from-template': typeof AppPatientsDiaryIdUpdateFromTemplateRoute
  '/_app/patients/$diaryId/update/review': typeof AppPatientsDiaryIdUpdateReviewRoute
  '/_app/patients/$diaryId/update/template-existing-trackers': typeof AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute
  '/_app/patients/$diaryId/update/templates': typeof AppPatientsDiaryIdUpdateTemplatesRoute
  '/_app/patients/bulk/events/$eventType': typeof AppPatientsBulkEventsEventTypeRoute
  '/_app/sales/leads/artifacts/$artifactId': typeof AppSalesLeadsArtifactsArtifactIdRoute
  '/_app/sales/leads/artifacts/new': typeof AppSalesLeadsArtifactsNewRoute
  '/_app/sales/leads/companies/$companyId': typeof AppSalesLeadsCompaniesCompanyIdRoute
  '/_app/sales/leads/companies/new': typeof AppSalesLeadsCompaniesNewRoute
  '/_app/sales/leads/templates/$templateId': typeof AppSalesLeadsTemplatesTemplateIdRoute
  '/_app/sales/leads/templates/new': typeof AppSalesLeadsTemplatesNewRoute
  '/_app/sales/leads/touches/$touchId': typeof AppSalesLeadsTouchesTouchIdRoute
  '/_app/studies/$studyId/invite/qr': typeof AppStudiesStudyIdInviteQrRoute
  '/_app/validate/change-trail/$entityType/$entityId': typeof AppValidateChangeTrailEntityTypeEntityIdRoute
  '/_app/worklist/consent/$diaryId/$consentId': typeof AppWorklistConsentDiaryIdConsentIdRoute
  '/screen/$screenerId/$entryId/page/$pageIndex': typeof ScreenScreenerIdEntryIdPagePageIndexRoute
  '/_app/admin/business/leads/': typeof AppAdminBusinessLeadsIndexRoute
  '/_app/admin/diaries/$diaryId/': typeof AppAdminDiariesDiaryIdIndexRoute
  '/_app/admin/entry/$entryId/': typeof AppAdminEntryEntryIdIndexRoute
  '/_app/builder/forms/$formId/': typeof AppBuilderFormsFormIdIndexRoute
  '/_app/business/leads/$leadId/': typeof AppBusinessLeadsLeadIdIndexRoute
  '/_app/business/leads/artifacts/': typeof AppBusinessLeadsArtifactsIndexRoute
  '/_app/business/leads/companies/': typeof AppBusinessLeadsCompaniesIndexRoute
  '/_app/business/leads/templates/': typeof AppBusinessLeadsTemplatesIndexRoute
  '/_app/business/leads/touches/': typeof AppBusinessLeadsTouchesIndexRoute
  '/_app/design/features/worklist/': typeof AppDesignFeaturesWorklistIndexRoute
  '/_app/design/forms/pages/': typeof AppDesignFormsPagesIndexRoute
  '/_app/diaries/$diaryId/home/': typeof AppDiariesDiaryIdHomeIndexRoute
  '/_app/patients/bulk/events/': typeof AppPatientsBulkEventsIndexRoute
  '/_app/sales/leads/$leadId/': typeof AppSalesLeadsLeadIdIndexRoute
  '/_app/sales/leads/artifacts/': typeof AppSalesLeadsArtifactsIndexRoute
  '/_app/sales/leads/companies/': typeof AppSalesLeadsCompaniesIndexRoute
  '/_app/sales/leads/templates/': typeof AppSalesLeadsTemplatesIndexRoute
  '/_app/sales/leads/touches/': typeof AppSalesLeadsTouchesIndexRoute
  '/_app/studies/$studyId/invite/': typeof AppStudiesStudyIdInviteIndexRoute
  '/_app/templates/$templateId/events/': typeof AppTemplatesTemplateIdEventsIndexRoute
  '/forms/$formId/page/$pageIndex/': typeof FormsFormIdPagePageIndexIndexRoute
  '/tracker/$trackerId/form/$formId/': typeof TrackerTrackerIdFormFormIdIndexRoute
  '/_app/admin/business/leads/artifacts/$artifactId': typeof AppAdminBusinessLeadsArtifactsArtifactIdRoute
  '/_app/admin/business/leads/artifacts/new': typeof AppAdminBusinessLeadsArtifactsNewRoute
  '/_app/admin/business/leads/companies/$companyId': typeof AppAdminBusinessLeadsCompaniesCompanyIdRoute
  '/_app/admin/business/leads/companies/new': typeof AppAdminBusinessLeadsCompaniesNewRoute
  '/_app/admin/business/leads/templates/$templateId': typeof AppAdminBusinessLeadsTemplatesTemplateIdRoute
  '/_app/admin/business/leads/templates/new': typeof AppAdminBusinessLeadsTemplatesNewRoute
  '/_app/admin/business/leads/touches/$touchId': typeof AppAdminBusinessLeadsTouchesTouchIdRoute
  '/_app/diaries/$diaryId/setup/consent/$consentId': typeof AppDiariesDiaryIdSetupConsentConsentIdRouteWithChildren
  '/_app/foot-watch/$diaryId/new/upload/complete': typeof AppFootWatchDiaryIdNewUploadCompleteRoute
  '/_app/foot-watch/$diaryId/new/upload/message': typeof AppFootWatchDiaryIdNewUploadMessageRoute
  '/_app/foot-watch/$diaryId/new/upload/uploading': typeof AppFootWatchDiaryIdNewUploadUploadingRoute
  '/_app/patients/$diaryId/consent/$consentId/complete': typeof AppPatientsDiaryIdConsentConsentIdCompleteRoute
  '/_app/templates/$templateId/events/injection/details': typeof AppTemplatesTemplateIdEventsInjectionDetailsRoute
  '/_app/templates/$templateId/events/shockwave/details': typeof AppTemplatesTemplateIdEventsShockwaveDetailsRoute
  '/_app/templates/$templateId/events/surgery/details': typeof AppTemplatesTemplateIdEventsSurgeryDetailsRoute
  '/_app/templates/diary/_form/intervention/injection': typeof AppTemplatesDiaryFormInterventionInjectionRoute
  '/_app/validate/$validationId/forms/$formId/results': typeof AppValidateValidationIdFormsFormIdResultsRoute
  '/_app/admin/business/leads/$leadId/': typeof AppAdminBusinessLeadsLeadIdIndexRoute
  '/_app/admin/business/leads/artifacts/': typeof AppAdminBusinessLeadsArtifactsIndexRoute
  '/_app/admin/business/leads/companies/': typeof AppAdminBusinessLeadsCompaniesIndexRoute
  '/_app/admin/business/leads/templates/': typeof AppAdminBusinessLeadsTemplatesIndexRoute
  '/_app/admin/business/leads/touches/': typeof AppAdminBusinessLeadsTouchesIndexRoute
  '/_app/foot-watch/$diaryId/new/upload/': typeof AppFootWatchDiaryIdNewUploadIndexRoute
  '/_app/foot-watch/new-diary/$patientId/$diaryId/': typeof AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute
  '/_app/patients/$diaryId/consent/$consentId/': typeof AppPatientsDiaryIdConsentConsentIdIndexRoute
  '/_app/templates/$templateId/events/education/': typeof AppTemplatesTemplateIdEventsEducationIndexRoute
  '/_app/templates/$templateId/events/injection/': typeof AppTemplatesTemplateIdEventsInjectionIndexRoute
  '/_app/templates/$templateId/events/product/': typeof AppTemplatesTemplateIdEventsProductIndexRoute
  '/_app/templates/$templateId/events/shockwave/': typeof AppTemplatesTemplateIdEventsShockwaveIndexRoute
  '/_app/templates/$templateId/events/surgery/': typeof AppTemplatesTemplateIdEventsSurgeryIndexRoute
  '/_app/validate/$validationId/forms/$formId/': typeof AppValidateValidationIdFormsFormIdIndexRoute
  '/preview/patient/$patientId/diary/$diaryId/': typeof PreviewPatientPatientIdDiaryDiaryIdIndexRoute
  '/_app/diaries/$diaryId/setup/consent/$consentId/complete': typeof AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute
  '/_app/foot-watch/$diaryId/new/instructions/$angle/$side': typeof AppFootWatchDiaryIdNewInstructionsAngleSideRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/contact': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/date': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/message': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/questionnaire': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute
  '/_app/templates/diary/$diaryId/events/$eventId/complete': typeof AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute
  '/_app/templates/diary/$diaryId/events/$eventId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute
  '/_app/templates/diary/$diaryId/trackers/$trackerId/date': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute
  '/_app/templates/diary/$diaryId/trackers/$trackerId/details': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute
  '/_app/validate/$validationId/forms/$formId/page/$pageIndex': typeof AppValidateValidationIdFormsFormIdPagePageIndexRoute
  '/_app/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind': typeof AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute
  '/_app/diaries/$diaryId/setup/consent/$consentId/': typeof AppDiariesDiaryIdSetupConsentConsentIdIndexRoute
  '/_app/templates/diary/$diaryId/events/$eventId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute
  '/_app/templates/diary/$diaryId/trackers/$trackerId/': typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute
  '/preview/radiology-report/patient/$patientId/event/$eventId/': typeof PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteWithChildren
  '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute
  '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery': typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute
  '/_app/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex': typeof AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute
  '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/': typeof PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute
  '/tracker/$trackerId/form/$formId/entry/$entryId/page/': typeof TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteWithChildren
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteWithChildren
  '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute
  '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute
  '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details': typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute
  '/_app/templates/diary/$diaryId/events/$eventId/education/$educationId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute
  '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute
  '/_app/templates/diary/$diaryId/events/$eventId/product/$productId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute
  '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute
  '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/': typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute
  '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/': typeof TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute
  '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/': typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/': typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/': typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteWithChildren
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteWithChildren
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute
  '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side': typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/onboarding'
    | '/preview'
    | '/users'
    | '/admin'
    | '/analytics'
    | '/builder'
    | '/business'
    | '/complete-profile'
    | '/customers'
    | '/design'
    | '/developer'
    | '/invite'
    | '/patients'
    | '/profile'
    | '/role'
    | '/sales'
    | '/statistics'
    | '/studies'
    | '/team'
    | '/templates'
    | '/worklist'
    | '/activate-account'
    | '/auth-error'
    | '/authentication-complete'
    | '/change-password'
    | '/confirm-account'
    | '/delete-account'
    | '/email-confirmed'
    | '/forgot-password'
    | '/magic'
    | '/new-diary-invite'
    | '/set-password'
    | '/test'
    | '/try-demo'
    | '/verification-complete'
    | '/verify'
    | '/verify-email'
    | '/verify-payment'
    | '/clinicians/$clinicianId'
    | '/feedback/patient'
    | '/forms/request'
    | '/onboarding/clinician-number'
    | '/onboarding/complete'
    | '/onboarding/date-of-birth'
    | '/onboarding/email'
    | '/onboarding/name'
    | '/onboarding/notifications'
    | '/onboarding/phone'
    | '/onboarding/welcome'
    | '/preferences/$userId'
    | '/preview/consent'
    | '/schedules/request'
    | '/forms/'
    | '/admin/access'
    | '/admin/audit'
    | '/admin/organisation'
    | '/admin/sftp'
    | '/business/leads'
    | '/developer/sftp'
    | '/sales/leads'
    | '/users/create-user'
    | '/users/notifications'
    | '/admin/ambassadors'
    | '/admin/entries'
    | '/admin/entry-values'
    | '/admin/events'
    | '/admin/health-check'
    | '/admin/impersonate-user'
    | '/admin/label-access'
    | '/admin/labels'
    | '/admin/notification-preferences'
    | '/admin/reminder-send-volume'
    | '/admin/sms-deliverability'
    | '/admin/studies'
    | '/admin/templates'
    | '/admin/trackers'
    | '/admin/user-billing'
    | '/admin/user-organisations'
    | '/admin/view-diary-as-patient'
    | '/analytics/$diaryLabel'
    | '/analytics/anika'
    | '/analytics/arthrosamid'
    | '/business/ambassadors'
    | '/business/churn'
    | '/clinician/diaries'
    | '/customers/ambassadors'
    | '/customers/anonymous'
    | '/customers/churn'
    | '/customers/clinicians'
    | '/customers/success'
    | '/developer/health-check'
    | '/developer/messaging-schedule'
    | '/developer/reminder-send-volume'
    | '/developer/sms-deliverability'
    | '/diaries/$diaryId'
    | '/fisher-watch/dashboard'
    | '/foot-watch/$diaryId'
    | '/headache-watch/dashboard'
    | '/help/clinician'
    | '/help/patient'
    | '/invite/qr-code'
    | '/lead-gen/$'
    | '/new/$'
    | '/patients/$diaryId'
    | '/profile/add-imaging-center'
    | '/profile/billing'
    | '/profile/change-password'
    | '/profile/clinician-number'
    | '/profile/date-of-birth'
    | '/profile/delete-account'
    | '/profile/email'
    | '/profile/mfa'
    | '/profile/name'
    | '/profile/nhs-number'
    | '/profile/notifications'
    | '/profile/organisation'
    | '/profile/phone'
    | '/schedules/$scheduleId'
    | '/studies/$studyId'
    | '/team/invite'
    | '/templates/$templateId'
    | '/templates/complete'
    | '/templates/public'
    | '/templates/quickstart-page'
    | '/users/admins'
    | '/users/billing'
    | '/users/clinicians'
    | '/users/managers'
    | '/users/organisations'
    | '/users/patients'
    | '/users/preferences'
    | '/users/secretaries'
    | '/validate/$validationId'
    | '/worklist/complete'
    | '/authenticate'
    | '/login'
    | '/confirm-account/verify'
    | '/forgot-password/verify'
    | '/mfa/challenge'
    | '/mfa/enroll'
    | '/help/explainer/$explainerType'
    | '/onboarding/clinician/name'
    | '/onboarding/clinician/organisation'
    | '/onboarding/clinician/professional'
    | '/preview/consent/$consentId'
    | '/preview/invite/qr-code'
    | '/screen/$screenerId/result'
    | '/tracker/$trackerId/results'
    | '/tracker/$trackerId/success'
    | '/admin/'
    | '/analytics/'
    | '/builder/'
    | '/business/'
    | '/customers/'
    | '/design/'
    | '/developer/'
    | '/diaries/'
    | '/invite/'
    | '/lead-gen/'
    | '/new/'
    | '/profile/'
    | '/sales/'
    | '/schedules/'
    | '/studies/'
    | '/team/'
    | '/templates/'
    | '/users/'
    | '/validate/'
    | '/worklist/'
    | '/confirm-account/'
    | '/forgot-password/'
    | '/new-user/'
    | '/forms/$formId/'
    | '/screen/$screenerId/'
    | '/admin/business/leads'
    | '/admin/access/$attribute'
    | '/admin/access/forms'
    | '/admin/access/labels'
    | '/admin/access/roles'
    | '/admin/access/schedules'
    | '/admin/access/studies'
    | '/admin/access/tabs'
    | '/admin/access/users'
    | '/admin/audit/change-timeline'
    | '/admin/audit/lock-diaries'
    | '/admin/audit/snapshot'
    | '/admin/business/ambassadors'
    | '/admin/business/churn'
    | '/admin/clinicians/leaderboard'
    | '/admin/clinicians/photos'
    | '/admin/clinicians/statistics'
    | '/admin/diaries/types'
    | '/admin/organisation/add'
    | '/admin/organisation/logos'
    | '/admin/organisation/statistics'
    | '/admin/sftp/dashboard'
    | '/admin/sftp/diaries'
    | '/admin/sftp/explorer'
    | '/admin/sftp/organisations'
    | '/admin/sftp/preview'
    | '/admin/sftp/upload'
    | '/admin/user/$userId'
    | '/builder/consents/$consentBodyId'
    | '/builder/dictionaries/$dictionaryId'
    | '/builder/forms/new'
    | '/builder/schedules/$scheduleId'
    | '/builder/schedules/new'
    | '/business/leads/new'
    | '/design/components/animations'
    | '/design/components/auth'
    | '/design/components/buttons'
    | '/design/components/dictionaries'
    | '/design/components/inputs'
    | '/design/components/search-fields'
    | '/design/components/select-dialogs'
    | '/design/features/generalised-analytics'
    | '/design/features/manager-study-clinician-invite-plan'
    | '/design/features/messaging-schedule'
    | '/design/features/otivio-frictionless-onboarding'
    | '/design/features/reminder-sequences'
    | '/design/forms/blocks'
    | '/design/forms/entry-values'
    | '/design/forms/inputs'
    | '/design/forms/pages'
    | '/design/icons/animations'
    | '/design/icons/faces'
    | '/design/icons/states'
    | '/developer/demos/generalised-analytics'
    | '/developer/demos/manager-study-clinician-invite-plan'
    | '/developer/demos/otivio-frictionless-onboarding'
    | '/developer/sftp/dashboard'
    | '/developer/sftp/diaries'
    | '/developer/sftp/explorer'
    | '/developer/sftp/organisations'
    | '/developer/sftp/preview'
    | '/developer/sftp/upload'
    | '/developer/ui/animations'
    | '/developer/ui/auth'
    | '/developer/ui/buttons'
    | '/developer/ui/dictionaries'
    | '/developer/ui/entry-values'
    | '/developer/ui/input-switch'
    | '/developer/ui/inputs'
    | '/diaries/$diaryId/forms'
    | '/diaries/$diaryId/home'
    | '/diaries/$diaryId/progress'
    | '/diaries/$diaryId/setup'
    | '/foot-watch/$diaryId/edit'
    | '/foot-watch/new-diary/share'
    | '/invite/diary/complete'
    | '/invite/diary/organisation'
    | '/invite/diary/patient'
    | '/invite/diary/qr'
    | '/invite/diary/review'
    | '/organisation/$organisationId/qr-code'
    | '/patients/$diaryId/edit'
    | '/patients/bulk/contact'
    | '/patients/bulk/events'
    | '/patients/bulk/labels'
    | '/patients/bulk/message'
    | '/patients/bulk/organisation'
    | '/patients/bulk/reviewed'
    | '/profile/medical/diabetes'
    | '/sales/leads/new'
    | '/studies/$studyId/edit'
    | '/team/invite/email'
    | '/team/invite/qr'
    | '/templates/$templateId/consent'
    | '/templates/$templateId/date'
    | '/templates/$templateId/hospital-number'
    | '/templates/$templateId/labels'
    | '/templates/$templateId/name'
    | '/templates/$templateId/organisation'
    | '/templates/$templateId/publish'
    | '/templates/$templateId/screener'
    | '/templates/$templateId/trackers'
    | '/templates/diary/$newDiaryTemplateId'
    | '/templates/diary/$templateId'
    | '/users/admins/$userId'
    | '/users/clinicians/$userId'
    | '/users/create-user/access'
    | '/users/create-user/billing'
    | '/users/create-user/details'
    | '/users/create-user/impersonate'
    | '/users/create-user/organisations'
    | '/users/create-user/templates'
    | '/users/managers/$userId'
    | '/users/notifications/sms'
    | '/users/patients/$userId'
    | '/users/secretaries/$userId'
    | '/login/verify'
    | '/signup/$plan'
    | '/signup/trial'
    | '/signup/verify-phone'
    | '/admin/access/'
    | '/admin/audit/'
    | '/admin/business/'
    | '/admin/clinicians/'
    | '/admin/diaries/'
    | '/admin/organisation/'
    | '/admin/sftp/'
    | '/admin/user-activation/'
    | '/builder/consents/'
    | '/builder/dictionaries/'
    | '/builder/forms/'
    | '/builder/injection-contents/'
    | '/builder/injection-locations/'
    | '/builder/labels/'
    | '/builder/messages/'
    | '/builder/options/'
    | '/builder/schedules/'
    | '/builder/surgeries/'
    | '/builder/templates/'
    | '/business/leads/'
    | '/design/forms/'
    | '/design/icons/'
    | '/developer/sftp/'
    | '/diaries/$diaryId/'
    | '/organisation/$organisationId/'
    | '/patients/$diaryId/'
    | '/sales/leads/'
    | '/studies/$studyId/'
    | '/team/invite/'
    | '/users/create-user/'
    | '/users/notifications/'
    | '/validate/$validationId/'
    | '/login/'
    | '/signup/'
    | '/new-user/clinician/'
    | '/new-user/patient/'
    | '/admin/business/leads/new'
    | '/admin/form/$formId/results'
    | '/builder/forms/$formId/$tab'
    | '/builder/forms/$formId/metadata'
    | '/builder/schedules/forms/formId'
    | '/business/leads/artifacts/$artifactId'
    | '/business/leads/artifacts/new'
    | '/business/leads/companies/$companyId'
    | '/business/leads/companies/new'
    | '/business/leads/templates/$templateId'
    | '/business/leads/templates/new'
    | '/business/leads/touches/$touchId'
    | '/design/features/worklist/automations'
    | '/design/forms/pages/$screen'
    | '/diaries/$diaryId/home/edit'
    | '/diaries/$diaryId/home/forms'
    | '/diaries/$diaryId/home/progress'
    | '/diaries/$diaryId/home/results'
    | '/diaries/$diaryId/home/to-do'
    | '/diaries/$diaryId/setup/complete'
    | '/diaries/$diaryId/setup/hospital-number'
    | '/diaries/$diaryId/setup/reference-date'
    | '/diaries/$diaryId/setup/side'
    | '/foot-watch/$diaryId/history'
    | '/foot-watch/$diaryId/new'
    | '/foot-watch/$diaryId/progress'
    | '/foot-watch/$diaryId/edit/diary'
    | '/foot-watch/$diaryId/edit/name'
    | '/foot-watch/$diaryId/new/add-photos'
    | '/foot-watch/$diaryId/new/camera'
    | '/foot-watch/$diaryId/new/instructions'
    | '/foot-watch/$diaryId/new/new-patient'
    | '/foot-watch/$diaryId/new/select-patient'
    | '/foot-watch/$diaryId/new/start'
    | '/foot-watch/$diaryId/new/upload'
    | '/patients/$diaryId/action/$actionId'
    | '/patients/$diaryId/consent/$consentId'
    | '/patients/$diaryId/update/add'
    | '/patients/$diaryId/update/consent'
    | '/patients/$diaryId/update/existing-trackers'
    | '/patients/$diaryId/update/from-template'
    | '/patients/$diaryId/update/review'
    | '/patients/$diaryId/update/template-existing-trackers'
    | '/patients/$diaryId/update/templates'
    | '/patients/bulk/events/$eventType'
    | '/sales/leads/artifacts/$artifactId'
    | '/sales/leads/artifacts/new'
    | '/sales/leads/companies/$companyId'
    | '/sales/leads/companies/new'
    | '/sales/leads/templates/$templateId'
    | '/sales/leads/templates/new'
    | '/sales/leads/touches/$touchId'
    | '/studies/$studyId/invite/qr'
    | '/validate/change-trail/$entityType/$entityId'
    | '/worklist/consent/$diaryId/$consentId'
    | '/screen/$screenerId/$entryId/page/$pageIndex'
    | '/admin/business/leads/'
    | '/admin/diaries/$diaryId/'
    | '/admin/entry/$entryId/'
    | '/builder/forms/$formId/'
    | '/business/leads/$leadId/'
    | '/business/leads/artifacts/'
    | '/business/leads/companies/'
    | '/business/leads/templates/'
    | '/business/leads/touches/'
    | '/design/features/worklist/'
    | '/design/forms/pages/'
    | '/diaries/$diaryId/home/'
    | '/patients/bulk/events/'
    | '/sales/leads/$leadId/'
    | '/sales/leads/artifacts/'
    | '/sales/leads/companies/'
    | '/sales/leads/templates/'
    | '/sales/leads/touches/'
    | '/studies/$studyId/invite/'
    | '/templates/$templateId/events/'
    | '/forms/$formId/page/$pageIndex/'
    | '/tracker/$trackerId/form/$formId/'
    | '/admin/business/leads/artifacts/$artifactId'
    | '/admin/business/leads/artifacts/new'
    | '/admin/business/leads/companies/$companyId'
    | '/admin/business/leads/companies/new'
    | '/admin/business/leads/templates/$templateId'
    | '/admin/business/leads/templates/new'
    | '/admin/business/leads/touches/$touchId'
    | '/diaries/$diaryId/setup/consent/$consentId'
    | '/foot-watch/$diaryId/new/upload/complete'
    | '/foot-watch/$diaryId/new/upload/message'
    | '/foot-watch/$diaryId/new/upload/uploading'
    | '/patients/$diaryId/consent/$consentId/complete'
    | '/templates/$templateId/events/injection/details'
    | '/templates/$templateId/events/shockwave/details'
    | '/templates/$templateId/events/surgery/details'
    | '/templates/diary/intervention/injection'
    | '/validate/$validationId/forms/$formId/results'
    | '/admin/business/leads/$leadId/'
    | '/admin/business/leads/artifacts/'
    | '/admin/business/leads/companies/'
    | '/admin/business/leads/templates/'
    | '/admin/business/leads/touches/'
    | '/foot-watch/$diaryId/new/upload/'
    | '/foot-watch/new-diary/$patientId/$diaryId/'
    | '/patients/$diaryId/consent/$consentId/'
    | '/templates/$templateId/events/education/'
    | '/templates/$templateId/events/injection/'
    | '/templates/$templateId/events/product/'
    | '/templates/$templateId/events/shockwave/'
    | '/templates/$templateId/events/surgery/'
    | '/validate/$validationId/forms/$formId/'
    | '/preview/patient/$patientId/diary/$diaryId/'
    | '/diaries/$diaryId/setup/consent/$consentId/complete'
    | '/foot-watch/$diaryId/new/instructions/$angle/$side'
    | '/patients/$diaryId/update/$eventId/$trackerId/contact'
    | '/patients/$diaryId/update/$eventId/$trackerId/date'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention'
    | '/patients/$diaryId/update/$eventId/$trackerId/message'
    | '/patients/$diaryId/update/$eventId/$trackerId/questionnaire'
    | '/templates/diary/$diaryId/events/$eventId/complete'
    | '/templates/diary/$diaryId/events/$eventId/details'
    | '/templates/diary/$diaryId/trackers/$trackerId/date'
    | '/templates/diary/$diaryId/trackers/$trackerId/details'
    | '/validate/$validationId/forms/$formId/page/$pageIndex'
    | '/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind'
    | '/diaries/$diaryId/setup/consent/$consentId/'
    | '/templates/diary/$diaryId/events/$eventId/'
    | '/templates/diary/$diaryId/trackers/$trackerId/'
    | '/preview/radiology-report/patient/$patientId/event/$eventId/'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId'
    | '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery'
    | '/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex'
    | '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/'
    | '/tracker/$trackerId/form/$formId/entry/$entryId/page/'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page'
    | '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details'
    | '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details'
    | '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details'
    | '/templates/diary/$diaryId/events/$eventId/education/$educationId/'
    | '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/'
    | '/templates/diary/$diaryId/events/$eventId/product/$productId/'
    | '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/'
    | '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/'
    | '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
    | '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
    | '/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/onboarding'
    | '/preview'
    | '/complete-profile'
    | '/patients'
    | '/role'
    | '/statistics'
    | '/activate-account'
    | '/auth-error'
    | '/authentication-complete'
    | '/change-password'
    | '/delete-account'
    | '/email-confirmed'
    | '/magic'
    | '/new-diary-invite'
    | '/set-password'
    | '/test'
    | '/try-demo'
    | '/verification-complete'
    | '/verify'
    | '/verify-email'
    | '/verify-payment'
    | '/clinicians/$clinicianId'
    | '/feedback/patient'
    | '/forms/request'
    | '/onboarding/clinician-number'
    | '/onboarding/complete'
    | '/onboarding/date-of-birth'
    | '/onboarding/email'
    | '/onboarding/name'
    | '/onboarding/notifications'
    | '/onboarding/phone'
    | '/onboarding/welcome'
    | '/preferences/$userId'
    | '/preview/consent'
    | '/schedules/request'
    | '/forms'
    | '/admin/ambassadors'
    | '/admin/entries'
    | '/admin/entry-values'
    | '/admin/events'
    | '/admin/health-check'
    | '/admin/impersonate-user'
    | '/admin/label-access'
    | '/admin/labels'
    | '/admin/notification-preferences'
    | '/admin/reminder-send-volume'
    | '/admin/sms-deliverability'
    | '/admin/studies'
    | '/admin/templates'
    | '/admin/trackers'
    | '/admin/user-billing'
    | '/admin/user-organisations'
    | '/admin/view-diary-as-patient'
    | '/analytics/$diaryLabel'
    | '/analytics/anika'
    | '/analytics/arthrosamid'
    | '/business/ambassadors'
    | '/business/churn'
    | '/clinician/diaries'
    | '/customers/ambassadors'
    | '/customers/anonymous'
    | '/customers/churn'
    | '/customers/clinicians'
    | '/customers/success'
    | '/developer/health-check'
    | '/developer/messaging-schedule'
    | '/developer/reminder-send-volume'
    | '/developer/sms-deliverability'
    | '/fisher-watch/dashboard'
    | '/foot-watch/$diaryId'
    | '/headache-watch/dashboard'
    | '/help/clinician'
    | '/help/patient'
    | '/invite/qr-code'
    | '/lead-gen/$'
    | '/new/$'
    | '/profile/add-imaging-center'
    | '/profile/billing'
    | '/profile/change-password'
    | '/profile/clinician-number'
    | '/profile/date-of-birth'
    | '/profile/delete-account'
    | '/profile/email'
    | '/profile/mfa'
    | '/profile/name'
    | '/profile/nhs-number'
    | '/profile/notifications'
    | '/profile/organisation'
    | '/profile/phone'
    | '/schedules/$scheduleId'
    | '/templates/$templateId'
    | '/templates/complete'
    | '/templates/public'
    | '/templates/quickstart-page'
    | '/users/admins'
    | '/users/billing'
    | '/users/clinicians'
    | '/users/managers'
    | '/users/organisations'
    | '/users/patients'
    | '/users/preferences'
    | '/users/secretaries'
    | '/worklist/complete'
    | '/authenticate'
    | '/confirm-account/verify'
    | '/forgot-password/verify'
    | '/mfa/challenge'
    | '/mfa/enroll'
    | '/help/explainer/$explainerType'
    | '/onboarding/clinician/name'
    | '/onboarding/clinician/organisation'
    | '/onboarding/clinician/professional'
    | '/preview/consent/$consentId'
    | '/preview/invite/qr-code'
    | '/screen/$screenerId/result'
    | '/tracker/$trackerId/results'
    | '/tracker/$trackerId/success'
    | '/admin'
    | '/analytics'
    | '/builder'
    | '/business'
    | '/customers'
    | '/design'
    | '/developer'
    | '/diaries'
    | '/invite'
    | '/lead-gen'
    | '/new'
    | '/profile'
    | '/sales'
    | '/schedules'
    | '/studies'
    | '/team'
    | '/templates'
    | '/users'
    | '/validate'
    | '/worklist'
    | '/confirm-account'
    | '/forgot-password'
    | '/new-user'
    | '/forms/$formId'
    | '/screen/$screenerId'
    | '/admin/access/$attribute'
    | '/admin/access/forms'
    | '/admin/access/labels'
    | '/admin/access/roles'
    | '/admin/access/schedules'
    | '/admin/access/studies'
    | '/admin/access/tabs'
    | '/admin/access/users'
    | '/admin/audit/change-timeline'
    | '/admin/audit/lock-diaries'
    | '/admin/audit/snapshot'
    | '/admin/business/ambassadors'
    | '/admin/business/churn'
    | '/admin/clinicians/leaderboard'
    | '/admin/clinicians/photos'
    | '/admin/clinicians/statistics'
    | '/admin/diaries/types'
    | '/admin/organisation/add'
    | '/admin/organisation/logos'
    | '/admin/organisation/statistics'
    | '/admin/sftp/dashboard'
    | '/admin/sftp/diaries'
    | '/admin/sftp/explorer'
    | '/admin/sftp/organisations'
    | '/admin/sftp/preview'
    | '/admin/sftp/upload'
    | '/admin/user/$userId'
    | '/builder/consents/$consentBodyId'
    | '/builder/dictionaries/$dictionaryId'
    | '/builder/forms/new'
    | '/builder/schedules/$scheduleId'
    | '/builder/schedules/new'
    | '/business/leads/new'
    | '/design/components/animations'
    | '/design/components/auth'
    | '/design/components/buttons'
    | '/design/components/dictionaries'
    | '/design/components/inputs'
    | '/design/components/search-fields'
    | '/design/components/select-dialogs'
    | '/design/features/generalised-analytics'
    | '/design/features/manager-study-clinician-invite-plan'
    | '/design/features/messaging-schedule'
    | '/design/features/otivio-frictionless-onboarding'
    | '/design/features/reminder-sequences'
    | '/design/forms/blocks'
    | '/design/forms/entry-values'
    | '/design/forms/inputs'
    | '/design/icons/animations'
    | '/design/icons/faces'
    | '/design/icons/states'
    | '/developer/demos/generalised-analytics'
    | '/developer/demos/manager-study-clinician-invite-plan'
    | '/developer/demos/otivio-frictionless-onboarding'
    | '/developer/sftp/dashboard'
    | '/developer/sftp/diaries'
    | '/developer/sftp/explorer'
    | '/developer/sftp/organisations'
    | '/developer/sftp/preview'
    | '/developer/sftp/upload'
    | '/developer/ui/animations'
    | '/developer/ui/auth'
    | '/developer/ui/buttons'
    | '/developer/ui/dictionaries'
    | '/developer/ui/entry-values'
    | '/developer/ui/input-switch'
    | '/developer/ui/inputs'
    | '/diaries/$diaryId/forms'
    | '/diaries/$diaryId/progress'
    | '/diaries/$diaryId/setup'
    | '/foot-watch/$diaryId/edit'
    | '/foot-watch/new-diary/share'
    | '/invite/diary/complete'
    | '/invite/diary/organisation'
    | '/invite/diary/patient'
    | '/invite/diary/qr'
    | '/invite/diary/review'
    | '/organisation/$organisationId/qr-code'
    | '/patients/$diaryId/edit'
    | '/patients/bulk/contact'
    | '/patients/bulk/labels'
    | '/patients/bulk/message'
    | '/patients/bulk/organisation'
    | '/patients/bulk/reviewed'
    | '/profile/medical/diabetes'
    | '/sales/leads/new'
    | '/studies/$studyId/edit'
    | '/team/invite/email'
    | '/team/invite/qr'
    | '/templates/$templateId/consent'
    | '/templates/$templateId/date'
    | '/templates/$templateId/hospital-number'
    | '/templates/$templateId/labels'
    | '/templates/$templateId/name'
    | '/templates/$templateId/organisation'
    | '/templates/$templateId/publish'
    | '/templates/$templateId/screener'
    | '/templates/$templateId/trackers'
    | '/templates/diary/$newDiaryTemplateId'
    | '/templates/diary/$templateId'
    | '/users/admins/$userId'
    | '/users/clinicians/$userId'
    | '/users/create-user/access'
    | '/users/create-user/billing'
    | '/users/create-user/details'
    | '/users/create-user/impersonate'
    | '/users/create-user/organisations'
    | '/users/create-user/templates'
    | '/users/managers/$userId'
    | '/users/notifications/sms'
    | '/users/patients/$userId'
    | '/users/secretaries/$userId'
    | '/login/verify'
    | '/signup/$plan'
    | '/signup/trial'
    | '/signup/verify-phone'
    | '/admin/access'
    | '/admin/audit'
    | '/admin/business'
    | '/admin/clinicians'
    | '/admin/diaries'
    | '/admin/organisation'
    | '/admin/sftp'
    | '/admin/user-activation'
    | '/builder/consents'
    | '/builder/dictionaries'
    | '/builder/forms'
    | '/builder/injection-contents'
    | '/builder/injection-locations'
    | '/builder/labels'
    | '/builder/messages'
    | '/builder/options'
    | '/builder/schedules'
    | '/builder/surgeries'
    | '/builder/templates'
    | '/business/leads'
    | '/design/forms'
    | '/design/icons'
    | '/developer/sftp'
    | '/diaries/$diaryId'
    | '/organisation/$organisationId'
    | '/patients/$diaryId'
    | '/sales/leads'
    | '/studies/$studyId'
    | '/team/invite'
    | '/users/create-user'
    | '/users/notifications'
    | '/validate/$validationId'
    | '/login'
    | '/signup'
    | '/new-user/clinician'
    | '/new-user/patient'
    | '/admin/business/leads/new'
    | '/admin/form/$formId/results'
    | '/builder/forms/$formId/$tab'
    | '/builder/forms/$formId/metadata'
    | '/builder/schedules/forms/formId'
    | '/business/leads/artifacts/$artifactId'
    | '/business/leads/artifacts/new'
    | '/business/leads/companies/$companyId'
    | '/business/leads/companies/new'
    | '/business/leads/templates/$templateId'
    | '/business/leads/templates/new'
    | '/business/leads/touches/$touchId'
    | '/design/features/worklist/automations'
    | '/design/forms/pages/$screen'
    | '/diaries/$diaryId/home/edit'
    | '/diaries/$diaryId/home/forms'
    | '/diaries/$diaryId/home/progress'
    | '/diaries/$diaryId/home/results'
    | '/diaries/$diaryId/home/to-do'
    | '/diaries/$diaryId/setup/complete'
    | '/diaries/$diaryId/setup/hospital-number'
    | '/diaries/$diaryId/setup/reference-date'
    | '/diaries/$diaryId/setup/side'
    | '/foot-watch/$diaryId/history'
    | '/foot-watch/$diaryId/new'
    | '/foot-watch/$diaryId/progress'
    | '/foot-watch/$diaryId/edit/diary'
    | '/foot-watch/$diaryId/edit/name'
    | '/foot-watch/$diaryId/new/add-photos'
    | '/foot-watch/$diaryId/new/camera'
    | '/foot-watch/$diaryId/new/instructions'
    | '/foot-watch/$diaryId/new/new-patient'
    | '/foot-watch/$diaryId/new/select-patient'
    | '/foot-watch/$diaryId/new/start'
    | '/patients/$diaryId/action/$actionId'
    | '/patients/$diaryId/update/add'
    | '/patients/$diaryId/update/consent'
    | '/patients/$diaryId/update/existing-trackers'
    | '/patients/$diaryId/update/from-template'
    | '/patients/$diaryId/update/review'
    | '/patients/$diaryId/update/template-existing-trackers'
    | '/patients/$diaryId/update/templates'
    | '/patients/bulk/events/$eventType'
    | '/sales/leads/artifacts/$artifactId'
    | '/sales/leads/artifacts/new'
    | '/sales/leads/companies/$companyId'
    | '/sales/leads/companies/new'
    | '/sales/leads/templates/$templateId'
    | '/sales/leads/templates/new'
    | '/sales/leads/touches/$touchId'
    | '/studies/$studyId/invite/qr'
    | '/validate/change-trail/$entityType/$entityId'
    | '/worklist/consent/$diaryId/$consentId'
    | '/screen/$screenerId/$entryId/page/$pageIndex'
    | '/admin/business/leads'
    | '/admin/diaries/$diaryId'
    | '/admin/entry/$entryId'
    | '/builder/forms/$formId'
    | '/business/leads/$leadId'
    | '/business/leads/artifacts'
    | '/business/leads/companies'
    | '/business/leads/templates'
    | '/business/leads/touches'
    | '/design/features/worklist'
    | '/design/forms/pages'
    | '/diaries/$diaryId/home'
    | '/patients/bulk/events'
    | '/sales/leads/$leadId'
    | '/sales/leads/artifacts'
    | '/sales/leads/companies'
    | '/sales/leads/templates'
    | '/sales/leads/touches'
    | '/studies/$studyId/invite'
    | '/templates/$templateId/events'
    | '/forms/$formId/page/$pageIndex'
    | '/tracker/$trackerId/form/$formId'
    | '/admin/business/leads/artifacts/$artifactId'
    | '/admin/business/leads/artifacts/new'
    | '/admin/business/leads/companies/$companyId'
    | '/admin/business/leads/companies/new'
    | '/admin/business/leads/templates/$templateId'
    | '/admin/business/leads/templates/new'
    | '/admin/business/leads/touches/$touchId'
    | '/foot-watch/$diaryId/new/upload/complete'
    | '/foot-watch/$diaryId/new/upload/message'
    | '/foot-watch/$diaryId/new/upload/uploading'
    | '/patients/$diaryId/consent/$consentId/complete'
    | '/templates/$templateId/events/injection/details'
    | '/templates/$templateId/events/shockwave/details'
    | '/templates/$templateId/events/surgery/details'
    | '/templates/diary/intervention/injection'
    | '/validate/$validationId/forms/$formId/results'
    | '/admin/business/leads/$leadId'
    | '/admin/business/leads/artifacts'
    | '/admin/business/leads/companies'
    | '/admin/business/leads/templates'
    | '/admin/business/leads/touches'
    | '/foot-watch/$diaryId/new/upload'
    | '/foot-watch/new-diary/$patientId/$diaryId'
    | '/patients/$diaryId/consent/$consentId'
    | '/templates/$templateId/events/education'
    | '/templates/$templateId/events/injection'
    | '/templates/$templateId/events/product'
    | '/templates/$templateId/events/shockwave'
    | '/templates/$templateId/events/surgery'
    | '/validate/$validationId/forms/$formId'
    | '/preview/patient/$patientId/diary/$diaryId'
    | '/diaries/$diaryId/setup/consent/$consentId/complete'
    | '/foot-watch/$diaryId/new/instructions/$angle/$side'
    | '/patients/$diaryId/update/$eventId/$trackerId/contact'
    | '/patients/$diaryId/update/$eventId/$trackerId/date'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention'
    | '/patients/$diaryId/update/$eventId/$trackerId/message'
    | '/patients/$diaryId/update/$eventId/$trackerId/questionnaire'
    | '/templates/diary/$diaryId/events/$eventId/complete'
    | '/templates/diary/$diaryId/events/$eventId/details'
    | '/templates/diary/$diaryId/trackers/$trackerId/date'
    | '/templates/diary/$diaryId/trackers/$trackerId/details'
    | '/validate/$validationId/forms/$formId/page/$pageIndex'
    | '/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind'
    | '/diaries/$diaryId/setup/consent/$consentId'
    | '/templates/diary/$diaryId/events/$eventId'
    | '/templates/diary/$diaryId/trackers/$trackerId'
    | '/preview/radiology-report/patient/$patientId/event/$eventId'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId'
    | '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave'
    | '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery'
    | '/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex'
    | '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId'
    | '/tracker/$trackerId/form/$formId/entry/$entryId/page'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page'
    | '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details'
    | '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details'
    | '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details'
    | '/templates/diary/$diaryId/events/$eventId/education/$educationId'
    | '/templates/diary/$diaryId/events/$eventId/injection/$injectionId'
    | '/templates/diary/$diaryId/events/$eventId/product/$productId'
    | '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId'
    | '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId'
    | '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
    | '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
    | '/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload'
    | '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/error'
    | '/onboarding'
    | '/preview'
    | '/_app/users'
    | '/_app/admin'
    | '/_app/analytics'
    | '/_app/builder'
    | '/_app/business'
    | '/_app/complete-profile'
    | '/_app/customers'
    | '/_app/design'
    | '/_app/developer'
    | '/_app/invite'
    | '/_app/patients'
    | '/_app/profile'
    | '/_app/role'
    | '/_app/sales'
    | '/_app/statistics'
    | '/_app/studies'
    | '/_app/team'
    | '/_app/templates'
    | '/_app/worklist'
    | '/_auth/_public'
    | '/_auth/activate-account'
    | '/_auth/auth-error'
    | '/_auth/authentication-complete'
    | '/_auth/change-password'
    | '/_auth/confirm-account'
    | '/_auth/delete-account'
    | '/_auth/email-confirmed'
    | '/_auth/forgot-password'
    | '/_auth/magic'
    | '/_auth/new-diary-invite'
    | '/_auth/set-password'
    | '/_auth/test'
    | '/_auth/try-demo'
    | '/_auth/verification-complete'
    | '/_auth/verify'
    | '/_auth/verify-email'
    | '/_auth/verify-payment'
    | '/clinicians/$clinicianId'
    | '/feedback/patient'
    | '/forms/request'
    | '/onboarding/clinician-number'
    | '/onboarding/complete'
    | '/onboarding/date-of-birth'
    | '/onboarding/email'
    | '/onboarding/name'
    | '/onboarding/notifications'
    | '/onboarding/phone'
    | '/onboarding/welcome'
    | '/preferences/$userId'
    | '/preview/consent'
    | '/schedules/request'
    | '/forms/'
    | '/_app/admin/access'
    | '/_app/admin/audit'
    | '/_app/admin/organisation'
    | '/_app/admin/sftp'
    | '/_app/business/leads'
    | '/_app/developer/sftp'
    | '/_app/sales/leads'
    | '/_app/users/create-user'
    | '/_app/users/notifications'
    | '/_app/admin/ambassadors'
    | '/_app/admin/entries'
    | '/_app/admin/entry-values'
    | '/_app/admin/events'
    | '/_app/admin/health-check'
    | '/_app/admin/impersonate-user'
    | '/_app/admin/label-access'
    | '/_app/admin/labels'
    | '/_app/admin/notification-preferences'
    | '/_app/admin/reminder-send-volume'
    | '/_app/admin/sms-deliverability'
    | '/_app/admin/studies'
    | '/_app/admin/templates'
    | '/_app/admin/trackers'
    | '/_app/admin/user-billing'
    | '/_app/admin/user-organisations'
    | '/_app/admin/view-diary-as-patient'
    | '/_app/analytics/$diaryLabel'
    | '/_app/analytics/anika'
    | '/_app/analytics/arthrosamid'
    | '/_app/business/ambassadors'
    | '/_app/business/churn'
    | '/_app/clinician/diaries'
    | '/_app/customers/ambassadors'
    | '/_app/customers/anonymous'
    | '/_app/customers/churn'
    | '/_app/customers/clinicians'
    | '/_app/customers/success'
    | '/_app/developer/health-check'
    | '/_app/developer/messaging-schedule'
    | '/_app/developer/reminder-send-volume'
    | '/_app/developer/sms-deliverability'
    | '/_app/diaries/$diaryId'
    | '/_app/fisher-watch/dashboard'
    | '/_app/foot-watch/$diaryId'
    | '/_app/headache-watch/dashboard'
    | '/_app/help/clinician'
    | '/_app/help/patient'
    | '/_app/invite/qr-code'
    | '/_app/lead-gen/$'
    | '/_app/new/$'
    | '/_app/patients/$diaryId'
    | '/_app/profile/add-imaging-center'
    | '/_app/profile/billing'
    | '/_app/profile/change-password'
    | '/_app/profile/clinician-number'
    | '/_app/profile/date-of-birth'
    | '/_app/profile/delete-account'
    | '/_app/profile/email'
    | '/_app/profile/mfa'
    | '/_app/profile/name'
    | '/_app/profile/nhs-number'
    | '/_app/profile/notifications'
    | '/_app/profile/organisation'
    | '/_app/profile/phone'
    | '/_app/schedules/$scheduleId'
    | '/_app/studies/$studyId'
    | '/_app/team/invite'
    | '/_app/templates/$templateId'
    | '/_app/templates/complete'
    | '/_app/templates/public'
    | '/_app/templates/quickstart-page'
    | '/_app/users/admins'
    | '/_app/users/billing'
    | '/_app/users/clinicians'
    | '/_app/users/managers'
    | '/_app/users/organisations'
    | '/_app/users/patients'
    | '/_app/users/preferences'
    | '/_app/users/secretaries'
    | '/_app/validate/$validationId'
    | '/_app/worklist/complete'
    | '/_auth/_public/authenticate'
    | '/_auth/_public/login'
    | '/_auth/confirm-account/verify'
    | '/_auth/forgot-password/verify'
    | '/_auth/mfa/challenge'
    | '/_auth/mfa/enroll'
    | '/help/explainer/$explainerType'
    | '/onboarding/clinician/name'
    | '/onboarding/clinician/organisation'
    | '/onboarding/clinician/professional'
    | '/preview/consent/$consentId'
    | '/preview/invite/qr-code'
    | '/screen/$screenerId/result'
    | '/tracker/$trackerId/results'
    | '/tracker/$trackerId/success'
    | '/_app/admin/'
    | '/_app/analytics/'
    | '/_app/builder/'
    | '/_app/business/'
    | '/_app/customers/'
    | '/_app/design/'
    | '/_app/developer/'
    | '/_app/diaries/'
    | '/_app/invite/'
    | '/_app/lead-gen/'
    | '/_app/new/'
    | '/_app/profile/'
    | '/_app/sales/'
    | '/_app/schedules/'
    | '/_app/studies/'
    | '/_app/team/'
    | '/_app/templates/'
    | '/_app/users/'
    | '/_app/validate/'
    | '/_app/worklist/'
    | '/_auth/_public/'
    | '/_auth/confirm-account/'
    | '/_auth/forgot-password/'
    | '/_auth/new-user/'
    | '/forms/$formId/'
    | '/screen/$screenerId/'
    | '/_app/admin/business/leads'
    | '/_app/admin/access/$attribute'
    | '/_app/admin/access/forms'
    | '/_app/admin/access/labels'
    | '/_app/admin/access/roles'
    | '/_app/admin/access/schedules'
    | '/_app/admin/access/studies'
    | '/_app/admin/access/tabs'
    | '/_app/admin/access/users'
    | '/_app/admin/audit/change-timeline'
    | '/_app/admin/audit/lock-diaries'
    | '/_app/admin/audit/snapshot'
    | '/_app/admin/business/ambassadors'
    | '/_app/admin/business/churn'
    | '/_app/admin/clinicians/leaderboard'
    | '/_app/admin/clinicians/photos'
    | '/_app/admin/clinicians/statistics'
    | '/_app/admin/diaries/types'
    | '/_app/admin/organisation/add'
    | '/_app/admin/organisation/logos'
    | '/_app/admin/organisation/statistics'
    | '/_app/admin/sftp/dashboard'
    | '/_app/admin/sftp/diaries'
    | '/_app/admin/sftp/explorer'
    | '/_app/admin/sftp/organisations'
    | '/_app/admin/sftp/preview'
    | '/_app/admin/sftp/upload'
    | '/_app/admin/user/$userId'
    | '/_app/builder/consents/$consentBodyId'
    | '/_app/builder/dictionaries/$dictionaryId'
    | '/_app/builder/forms/new'
    | '/_app/builder/schedules/$scheduleId'
    | '/_app/builder/schedules/new'
    | '/_app/business/leads/new'
    | '/_app/design/components/animations'
    | '/_app/design/components/auth'
    | '/_app/design/components/buttons'
    | '/_app/design/components/dictionaries'
    | '/_app/design/components/inputs'
    | '/_app/design/components/search-fields'
    | '/_app/design/components/select-dialogs'
    | '/_app/design/features/generalised-analytics'
    | '/_app/design/features/manager-study-clinician-invite-plan'
    | '/_app/design/features/messaging-schedule'
    | '/_app/design/features/otivio-frictionless-onboarding'
    | '/_app/design/features/reminder-sequences'
    | '/_app/design/forms/blocks'
    | '/_app/design/forms/entry-values'
    | '/_app/design/forms/inputs'
    | '/_app/design/forms/pages'
    | '/_app/design/icons/animations'
    | '/_app/design/icons/faces'
    | '/_app/design/icons/states'
    | '/_app/developer/demos/generalised-analytics'
    | '/_app/developer/demos/manager-study-clinician-invite-plan'
    | '/_app/developer/demos/otivio-frictionless-onboarding'
    | '/_app/developer/sftp/dashboard'
    | '/_app/developer/sftp/diaries'
    | '/_app/developer/sftp/explorer'
    | '/_app/developer/sftp/organisations'
    | '/_app/developer/sftp/preview'
    | '/_app/developer/sftp/upload'
    | '/_app/developer/ui/animations'
    | '/_app/developer/ui/auth'
    | '/_app/developer/ui/buttons'
    | '/_app/developer/ui/dictionaries'
    | '/_app/developer/ui/entry-values'
    | '/_app/developer/ui/input-switch'
    | '/_app/developer/ui/inputs'
    | '/_app/diaries/$diaryId/forms'
    | '/_app/diaries/$diaryId/home'
    | '/_app/diaries/$diaryId/progress'
    | '/_app/diaries/$diaryId/setup'
    | '/_app/foot-watch/$diaryId/_view'
    | '/_app/foot-watch/$diaryId/edit'
    | '/_app/foot-watch/new-diary/share'
    | '/_app/invite/diary/complete'
    | '/_app/invite/diary/organisation'
    | '/_app/invite/diary/patient'
    | '/_app/invite/diary/qr'
    | '/_app/invite/diary/review'
    | '/_app/organisation/$organisationId/qr-code'
    | '/_app/patients/$diaryId/edit'
    | '/_app/patients/bulk/contact'
    | '/_app/patients/bulk/events'
    | '/_app/patients/bulk/labels'
    | '/_app/patients/bulk/message'
    | '/_app/patients/bulk/organisation'
    | '/_app/patients/bulk/reviewed'
    | '/_app/profile/medical/diabetes'
    | '/_app/sales/leads/new'
    | '/_app/studies/$studyId/edit'
    | '/_app/team/invite/email'
    | '/_app/team/invite/qr'
    | '/_app/templates/$templateId/consent'
    | '/_app/templates/$templateId/date'
    | '/_app/templates/$templateId/hospital-number'
    | '/_app/templates/$templateId/labels'
    | '/_app/templates/$templateId/name'
    | '/_app/templates/$templateId/organisation'
    | '/_app/templates/$templateId/publish'
    | '/_app/templates/$templateId/screener'
    | '/_app/templates/$templateId/trackers'
    | '/_app/templates/diary/$newDiaryTemplateId'
    | '/_app/templates/diary/$templateId'
    | '/_app/users/admins/$userId'
    | '/_app/users/clinicians/$userId'
    | '/_app/users/create-user/access'
    | '/_app/users/create-user/billing'
    | '/_app/users/create-user/details'
    | '/_app/users/create-user/impersonate'
    | '/_app/users/create-user/organisations'
    | '/_app/users/create-user/templates'
    | '/_app/users/managers/$userId'
    | '/_app/users/notifications/sms'
    | '/_app/users/patients/$userId'
    | '/_app/users/secretaries/$userId'
    | '/_auth/_public/login/verify'
    | '/_auth/_public/signup/$plan'
    | '/_auth/_public/signup/trial'
    | '/_auth/_public/signup/verify-phone'
    | '/_app/admin/access/'
    | '/_app/admin/audit/'
    | '/_app/admin/business/'
    | '/_app/admin/clinicians/'
    | '/_app/admin/diaries/'
    | '/_app/admin/organisation/'
    | '/_app/admin/sftp/'
    | '/_app/admin/user-activation/'
    | '/_app/builder/consents/'
    | '/_app/builder/dictionaries/'
    | '/_app/builder/forms/'
    | '/_app/builder/injection-contents/'
    | '/_app/builder/injection-locations/'
    | '/_app/builder/labels/'
    | '/_app/builder/messages/'
    | '/_app/builder/options/'
    | '/_app/builder/schedules/'
    | '/_app/builder/surgeries/'
    | '/_app/builder/templates/'
    | '/_app/business/leads/'
    | '/_app/design/forms/'
    | '/_app/design/icons/'
    | '/_app/developer/sftp/'
    | '/_app/diaries/$diaryId/'
    | '/_app/organisation/$organisationId/'
    | '/_app/patients/$diaryId/'
    | '/_app/sales/leads/'
    | '/_app/studies/$studyId/'
    | '/_app/team/invite/'
    | '/_app/users/create-user/'
    | '/_app/users/notifications/'
    | '/_app/validate/$validationId/'
    | '/_auth/_public/login/'
    | '/_auth/_public/signup/'
    | '/_auth/new-user/clinician/'
    | '/_auth/new-user/patient/'
    | '/_app/admin/business/leads/new'
    | '/_app/admin/form/$formId/results'
    | '/_app/builder/forms/$formId/$tab'
    | '/_app/builder/forms/$formId/metadata'
    | '/_app/builder/schedules/forms/formId'
    | '/_app/business/leads/artifacts/$artifactId'
    | '/_app/business/leads/artifacts/new'
    | '/_app/business/leads/companies/$companyId'
    | '/_app/business/leads/companies/new'
    | '/_app/business/leads/templates/$templateId'
    | '/_app/business/leads/templates/new'
    | '/_app/business/leads/touches/$touchId'
    | '/_app/design/features/worklist/automations'
    | '/_app/design/forms/pages/$screen'
    | '/_app/diaries/$diaryId/home/edit'
    | '/_app/diaries/$diaryId/home/forms'
    | '/_app/diaries/$diaryId/home/progress'
    | '/_app/diaries/$diaryId/home/results'
    | '/_app/diaries/$diaryId/home/to-do'
    | '/_app/diaries/$diaryId/setup/complete'
    | '/_app/diaries/$diaryId/setup/hospital-number'
    | '/_app/diaries/$diaryId/setup/reference-date'
    | '/_app/diaries/$diaryId/setup/side'
    | '/_app/foot-watch/$diaryId/_view/history'
    | '/_app/foot-watch/$diaryId/_view/new'
    | '/_app/foot-watch/$diaryId/_view/progress'
    | '/_app/foot-watch/$diaryId/edit/diary'
    | '/_app/foot-watch/$diaryId/edit/name'
    | '/_app/foot-watch/$diaryId/new/add-photos'
    | '/_app/foot-watch/$diaryId/new/camera'
    | '/_app/foot-watch/$diaryId/new/instructions'
    | '/_app/foot-watch/$diaryId/new/new-patient'
    | '/_app/foot-watch/$diaryId/new/select-patient'
    | '/_app/foot-watch/$diaryId/new/start'
    | '/_app/foot-watch/$diaryId/new/upload'
    | '/_app/patients/$diaryId/action/$actionId'
    | '/_app/patients/$diaryId/consent/$consentId'
    | '/_app/patients/$diaryId/update/add'
    | '/_app/patients/$diaryId/update/consent'
    | '/_app/patients/$diaryId/update/existing-trackers'
    | '/_app/patients/$diaryId/update/from-template'
    | '/_app/patients/$diaryId/update/review'
    | '/_app/patients/$diaryId/update/template-existing-trackers'
    | '/_app/patients/$diaryId/update/templates'
    | '/_app/patients/bulk/events/$eventType'
    | '/_app/sales/leads/artifacts/$artifactId'
    | '/_app/sales/leads/artifacts/new'
    | '/_app/sales/leads/companies/$companyId'
    | '/_app/sales/leads/companies/new'
    | '/_app/sales/leads/templates/$templateId'
    | '/_app/sales/leads/templates/new'
    | '/_app/sales/leads/touches/$touchId'
    | '/_app/studies/$studyId/invite/qr'
    | '/_app/validate/change-trail/$entityType/$entityId'
    | '/_app/worklist/consent/$diaryId/$consentId'
    | '/screen/$screenerId/$entryId/page/$pageIndex'
    | '/_app/admin/business/leads/'
    | '/_app/admin/diaries/$diaryId/'
    | '/_app/admin/entry/$entryId/'
    | '/_app/builder/forms/$formId/'
    | '/_app/business/leads/$leadId/'
    | '/_app/business/leads/artifacts/'
    | '/_app/business/leads/companies/'
    | '/_app/business/leads/templates/'
    | '/_app/business/leads/touches/'
    | '/_app/design/features/worklist/'
    | '/_app/design/forms/pages/'
    | '/_app/diaries/$diaryId/home/'
    | '/_app/patients/bulk/events/'
    | '/_app/sales/leads/$leadId/'
    | '/_app/sales/leads/artifacts/'
    | '/_app/sales/leads/companies/'
    | '/_app/sales/leads/templates/'
    | '/_app/sales/leads/touches/'
    | '/_app/studies/$studyId/invite/'
    | '/_app/templates/$templateId/events/'
    | '/forms/$formId/page/$pageIndex/'
    | '/tracker/$trackerId/form/$formId/'
    | '/_app/admin/business/leads/artifacts/$artifactId'
    | '/_app/admin/business/leads/artifacts/new'
    | '/_app/admin/business/leads/companies/$companyId'
    | '/_app/admin/business/leads/companies/new'
    | '/_app/admin/business/leads/templates/$templateId'
    | '/_app/admin/business/leads/templates/new'
    | '/_app/admin/business/leads/touches/$touchId'
    | '/_app/diaries/$diaryId/setup/consent/$consentId'
    | '/_app/foot-watch/$diaryId/new/upload/complete'
    | '/_app/foot-watch/$diaryId/new/upload/message'
    | '/_app/foot-watch/$diaryId/new/upload/uploading'
    | '/_app/patients/$diaryId/consent/$consentId/complete'
    | '/_app/templates/$templateId/events/injection/details'
    | '/_app/templates/$templateId/events/shockwave/details'
    | '/_app/templates/$templateId/events/surgery/details'
    | '/_app/templates/diary/_form/intervention/injection'
    | '/_app/validate/$validationId/forms/$formId/results'
    | '/_app/admin/business/leads/$leadId/'
    | '/_app/admin/business/leads/artifacts/'
    | '/_app/admin/business/leads/companies/'
    | '/_app/admin/business/leads/templates/'
    | '/_app/admin/business/leads/touches/'
    | '/_app/foot-watch/$diaryId/new/upload/'
    | '/_app/foot-watch/new-diary/$patientId/$diaryId/'
    | '/_app/patients/$diaryId/consent/$consentId/'
    | '/_app/templates/$templateId/events/education/'
    | '/_app/templates/$templateId/events/injection/'
    | '/_app/templates/$templateId/events/product/'
    | '/_app/templates/$templateId/events/shockwave/'
    | '/_app/templates/$templateId/events/surgery/'
    | '/_app/validate/$validationId/forms/$formId/'
    | '/preview/patient/$patientId/diary/$diaryId/'
    | '/_app/diaries/$diaryId/setup/consent/$consentId/complete'
    | '/_app/foot-watch/$diaryId/new/instructions/$angle/$side'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/contact'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/date'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/message'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/questionnaire'
    | '/_app/templates/diary/$diaryId/events/$eventId/complete'
    | '/_app/templates/diary/$diaryId/events/$eventId/details'
    | '/_app/templates/diary/$diaryId/trackers/$trackerId/date'
    | '/_app/templates/diary/$diaryId/trackers/$trackerId/details'
    | '/_app/validate/$validationId/forms/$formId/page/$pageIndex'
    | '/_app/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind'
    | '/_app/diaries/$diaryId/setup/consent/$consentId/'
    | '/_app/templates/diary/$diaryId/events/$eventId/'
    | '/_app/templates/diary/$diaryId/trackers/$trackerId/'
    | '/preview/radiology-report/patient/$patientId/event/$eventId/'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId'
    | '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave'
    | '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery'
    | '/_app/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex'
    | '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/'
    | '/tracker/$trackerId/form/$formId/entry/$entryId/page/'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page'
    | '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details'
    | '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details'
    | '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details'
    | '/_app/templates/diary/$diaryId/events/$eventId/education/$educationId/'
    | '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/'
    | '/_app/templates/diary/$diaryId/events/$eventId/product/$productId/'
    | '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/'
    | '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/'
    | '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
    | '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
    | '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
    | '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/'
    | '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PreviewRoute: typeof PreviewRouteWithChildren
  CliniciansClinicianIdRoute: typeof CliniciansClinicianIdRoute
  FeedbackPatientRoute: typeof FeedbackPatientRoute
  FormsRequestRoute: typeof FormsRequestRoute
  PreferencesUserIdRoute: typeof PreferencesUserIdRoute
  SchedulesRequestRoute: typeof SchedulesRequestRoute
  FormsIndexRoute: typeof FormsIndexRoute
  HelpExplainerExplainerTypeRoute: typeof HelpExplainerExplainerTypeRoute
  ScreenScreenerIdResultRoute: typeof ScreenScreenerIdResultRoute
  TrackerTrackerIdResultsRoute: typeof TrackerTrackerIdResultsRoute
  TrackerTrackerIdSuccessRoute: typeof TrackerTrackerIdSuccessRoute
  FormsFormIdIndexRoute: typeof FormsFormIdIndexRoute
  ScreenScreenerIdIndexRoute: typeof ScreenScreenerIdIndexRoute
  ScreenScreenerIdEntryIdPagePageIndexRoute: typeof ScreenScreenerIdEntryIdPagePageIndexRoute
  FormsFormIdPagePageIndexIndexRoute: typeof FormsFormIdPagePageIndexIndexRoute
  TrackerTrackerIdFormFormIdIndexRoute: typeof TrackerTrackerIdFormFormIdIndexRoute
  TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute: typeof TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteWithChildren
  TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute: typeof TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/preview': {
      id: '/preview'
      path: '/preview'
      fullPath: '/preview'
      preLoaderRoute: typeof PreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/': {
      id: '/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof FormsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedules/request': {
      id: '/schedules/request'
      path: '/schedules/request'
      fullPath: '/schedules/request'
      preLoaderRoute: typeof SchedulesRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/consent': {
      id: '/preview/consent'
      path: '/consent'
      fullPath: '/preview/consent'
      preLoaderRoute: typeof PreviewConsentRouteImport
      parentRoute: typeof PreviewRoute
    }
    '/preferences/$userId': {
      id: '/preferences/$userId'
      path: '/preferences/$userId'
      fullPath: '/preferences/$userId'
      preLoaderRoute: typeof PreferencesUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/phone': {
      id: '/onboarding/phone'
      path: '/phone'
      fullPath: '/onboarding/phone'
      preLoaderRoute: typeof OnboardingPhoneRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/notifications': {
      id: '/onboarding/notifications'
      path: '/notifications'
      fullPath: '/onboarding/notifications'
      preLoaderRoute: typeof OnboardingNotificationsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/name': {
      id: '/onboarding/name'
      path: '/name'
      fullPath: '/onboarding/name'
      preLoaderRoute: typeof OnboardingNameRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/email': {
      id: '/onboarding/email'
      path: '/email'
      fullPath: '/onboarding/email'
      preLoaderRoute: typeof OnboardingEmailRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/date-of-birth': {
      id: '/onboarding/date-of-birth'
      path: '/date-of-birth'
      fullPath: '/onboarding/date-of-birth'
      preLoaderRoute: typeof OnboardingDateOfBirthRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/complete': {
      id: '/onboarding/complete'
      path: '/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof OnboardingCompleteRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/clinician-number': {
      id: '/onboarding/clinician-number'
      path: '/clinician-number'
      fullPath: '/onboarding/clinician-number'
      preLoaderRoute: typeof OnboardingClinicianNumberRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/forms/request': {
      id: '/forms/request'
      path: '/forms/request'
      fullPath: '/forms/request'
      preLoaderRoute: typeof FormsRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/patient': {
      id: '/feedback/patient'
      path: '/feedback/patient'
      fullPath: '/feedback/patient'
      preLoaderRoute: typeof FeedbackPatientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinicians/$clinicianId': {
      id: '/clinicians/$clinicianId'
      path: '/clinicians/$clinicianId'
      fullPath: '/clinicians/$clinicianId'
      preLoaderRoute: typeof CliniciansClinicianIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/verify-payment': {
      id: '/_auth/verify-payment'
      path: '/verify-payment'
      fullPath: '/verify-payment'
      preLoaderRoute: typeof AuthVerifyPaymentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify': {
      id: '/_auth/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verification-complete': {
      id: '/_auth/verification-complete'
      path: '/verification-complete'
      fullPath: '/verification-complete'
      preLoaderRoute: typeof AuthVerificationCompleteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/try-demo': {
      id: '/_auth/try-demo'
      path: '/try-demo'
      fullPath: '/try-demo'
      preLoaderRoute: typeof AuthTryDemoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/test': {
      id: '/_auth/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof AuthTestRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/new-diary-invite': {
      id: '/_auth/new-diary-invite'
      path: '/new-diary-invite'
      fullPath: '/new-diary-invite'
      preLoaderRoute: typeof AuthNewDiaryInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/magic': {
      id: '/_auth/magic'
      path: '/magic'
      fullPath: '/magic'
      preLoaderRoute: typeof AuthMagicRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/email-confirmed': {
      id: '/_auth/email-confirmed'
      path: '/email-confirmed'
      fullPath: '/email-confirmed'
      preLoaderRoute: typeof AuthEmailConfirmedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/delete-account': {
      id: '/_auth/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof AuthDeleteAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/confirm-account': {
      id: '/_auth/confirm-account'
      path: '/confirm-account'
      fullPath: '/confirm-account'
      preLoaderRoute: typeof AuthConfirmAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/authentication-complete': {
      id: '/_auth/authentication-complete'
      path: '/authentication-complete'
      fullPath: '/authentication-complete'
      preLoaderRoute: typeof AuthAuthenticationCompleteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth-error': {
      id: '/_auth/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof AuthAuthErrorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/activate-account': {
      id: '/_auth/activate-account'
      path: '/activate-account'
      fullPath: '/activate-account'
      preLoaderRoute: typeof AuthActivateAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_public': {
      id: '/_auth/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthPublicRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/worklist': {
      id: '/_app/worklist'
      path: '/worklist'
      fullPath: '/worklist'
      preLoaderRoute: typeof AppWorklistRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/studies': {
      id: '/_app/studies'
      path: '/studies'
      fullPath: '/studies'
      preLoaderRoute: typeof AppStudiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/statistics': {
      id: '/_app/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AppStatisticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales': {
      id: '/_app/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof AppSalesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/role': {
      id: '/_app/role'
      path: '/role'
      fullPath: '/role'
      preLoaderRoute: typeof AppRoleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/patients': {
      id: '/_app/patients'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof AppPatientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invite': {
      id: '/_app/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof AppInviteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer': {
      id: '/_app/developer'
      path: '/developer'
      fullPath: '/developer'
      preLoaderRoute: typeof AppDeveloperRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/design': {
      id: '/_app/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof AppDesignRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/complete-profile': {
      id: '/_app/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof AppCompleteProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business': {
      id: '/_app/business'
      path: '/business'
      fullPath: '/business'
      preLoaderRoute: typeof AppBusinessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/builder': {
      id: '/_app/builder'
      path: '/builder'
      fullPath: '/builder'
      preLoaderRoute: typeof AppBuilderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/screen/$screenerId/': {
      id: '/screen/$screenerId/'
      path: '/screen/$screenerId'
      fullPath: '/screen/$screenerId/'
      preLoaderRoute: typeof ScreenScreenerIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$formId/': {
      id: '/forms/$formId/'
      path: '/forms/$formId'
      fullPath: '/forms/$formId/'
      preLoaderRoute: typeof FormsFormIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/new-user/': {
      id: '/_auth/new-user/'
      path: '/new-user'
      fullPath: '/new-user/'
      preLoaderRoute: typeof AuthNewUserIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password/': {
      id: '/_auth/forgot-password/'
      path: '/'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthForgotPasswordRoute
    }
    '/_auth/confirm-account/': {
      id: '/_auth/confirm-account/'
      path: '/'
      fullPath: '/confirm-account/'
      preLoaderRoute: typeof AuthConfirmAccountIndexRouteImport
      parentRoute: typeof AuthConfirmAccountRoute
    }
    '/_auth/_public/': {
      id: '/_auth/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthPublicIndexRouteImport
      parentRoute: typeof AuthPublicRoute
    }
    '/_app/worklist/': {
      id: '/_app/worklist/'
      path: '/'
      fullPath: '/worklist/'
      preLoaderRoute: typeof AppWorklistIndexRouteImport
      parentRoute: typeof AppWorklistRoute
    }
    '/_app/validate/': {
      id: '/_app/validate/'
      path: '/validate'
      fullPath: '/validate/'
      preLoaderRoute: typeof AppValidateIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/templates/': {
      id: '/_app/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof AppTemplatesIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/team/': {
      id: '/_app/team/'
      path: '/'
      fullPath: '/team/'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof AppTeamRoute
    }
    '/_app/studies/': {
      id: '/_app/studies/'
      path: '/'
      fullPath: '/studies/'
      preLoaderRoute: typeof AppStudiesIndexRouteImport
      parentRoute: typeof AppStudiesRoute
    }
    '/_app/schedules/': {
      id: '/_app/schedules/'
      path: '/schedules'
      fullPath: '/schedules/'
      preLoaderRoute: typeof AppSchedulesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/': {
      id: '/_app/sales/'
      path: '/'
      fullPath: '/sales/'
      preLoaderRoute: typeof AppSalesIndexRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/new/': {
      id: '/_app/new/'
      path: '/new'
      fullPath: '/new/'
      preLoaderRoute: typeof AppNewIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lead-gen/': {
      id: '/_app/lead-gen/'
      path: '/lead-gen'
      fullPath: '/lead-gen/'
      preLoaderRoute: typeof AppLeadGenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invite/': {
      id: '/_app/invite/'
      path: '/'
      fullPath: '/invite/'
      preLoaderRoute: typeof AppInviteIndexRouteImport
      parentRoute: typeof AppInviteRoute
    }
    '/_app/diaries/': {
      id: '/_app/diaries/'
      path: '/diaries'
      fullPath: '/diaries/'
      preLoaderRoute: typeof AppDiariesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer/': {
      id: '/_app/developer/'
      path: '/'
      fullPath: '/developer/'
      preLoaderRoute: typeof AppDeveloperIndexRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/design/': {
      id: '/_app/design/'
      path: '/'
      fullPath: '/design/'
      preLoaderRoute: typeof AppDesignIndexRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppCustomersRoute
    }
    '/_app/business/': {
      id: '/_app/business/'
      path: '/'
      fullPath: '/business/'
      preLoaderRoute: typeof AppBusinessIndexRouteImport
      parentRoute: typeof AppBusinessRoute
    }
    '/_app/builder/': {
      id: '/_app/builder/'
      path: '/'
      fullPath: '/builder/'
      preLoaderRoute: typeof AppBuilderIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/analytics/': {
      id: '/_app/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AppAnalyticsIndexRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/tracker/$trackerId/success': {
      id: '/tracker/$trackerId/success'
      path: '/tracker/$trackerId/success'
      fullPath: '/tracker/$trackerId/success'
      preLoaderRoute: typeof TrackerTrackerIdSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracker/$trackerId/results': {
      id: '/tracker/$trackerId/results'
      path: '/tracker/$trackerId/results'
      fullPath: '/tracker/$trackerId/results'
      preLoaderRoute: typeof TrackerTrackerIdResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/screen/$screenerId/result': {
      id: '/screen/$screenerId/result'
      path: '/screen/$screenerId/result'
      fullPath: '/screen/$screenerId/result'
      preLoaderRoute: typeof ScreenScreenerIdResultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/invite/qr-code': {
      id: '/preview/invite/qr-code'
      path: '/invite/qr-code'
      fullPath: '/preview/invite/qr-code'
      preLoaderRoute: typeof PreviewInviteQrCodeRouteImport
      parentRoute: typeof PreviewRoute
    }
    '/preview/consent/$consentId': {
      id: '/preview/consent/$consentId'
      path: '/$consentId'
      fullPath: '/preview/consent/$consentId'
      preLoaderRoute: typeof PreviewConsentConsentIdRouteImport
      parentRoute: typeof PreviewConsentRoute
    }
    '/onboarding/clinician/professional': {
      id: '/onboarding/clinician/professional'
      path: '/clinician/professional'
      fullPath: '/onboarding/clinician/professional'
      preLoaderRoute: typeof OnboardingClinicianProfessionalRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/clinician/organisation': {
      id: '/onboarding/clinician/organisation'
      path: '/clinician/organisation'
      fullPath: '/onboarding/clinician/organisation'
      preLoaderRoute: typeof OnboardingClinicianOrganisationRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/clinician/name': {
      id: '/onboarding/clinician/name'
      path: '/clinician/name'
      fullPath: '/onboarding/clinician/name'
      preLoaderRoute: typeof OnboardingClinicianNameRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/help/explainer/$explainerType': {
      id: '/help/explainer/$explainerType'
      path: '/help/explainer/$explainerType'
      fullPath: '/help/explainer/$explainerType'
      preLoaderRoute: typeof HelpExplainerExplainerTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/mfa/enroll': {
      id: '/_auth/mfa/enroll'
      path: '/mfa/enroll'
      fullPath: '/mfa/enroll'
      preLoaderRoute: typeof AuthMfaEnrollRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/mfa/challenge': {
      id: '/_auth/mfa/challenge'
      path: '/mfa/challenge'
      fullPath: '/mfa/challenge'
      preLoaderRoute: typeof AuthMfaChallengeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password/verify': {
      id: '/_auth/forgot-password/verify'
      path: '/verify'
      fullPath: '/forgot-password/verify'
      preLoaderRoute: typeof AuthForgotPasswordVerifyRouteImport
      parentRoute: typeof AuthForgotPasswordRoute
    }
    '/_auth/confirm-account/verify': {
      id: '/_auth/confirm-account/verify'
      path: '/verify'
      fullPath: '/confirm-account/verify'
      preLoaderRoute: typeof AuthConfirmAccountVerifyRouteImport
      parentRoute: typeof AuthConfirmAccountRoute
    }
    '/_auth/_public/login': {
      id: '/_auth/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthPublicLoginRouteImport
      parentRoute: typeof AuthPublicRoute
    }
    '/_auth/_public/authenticate': {
      id: '/_auth/_public/authenticate'
      path: '/authenticate'
      fullPath: '/authenticate'
      preLoaderRoute: typeof AuthPublicAuthenticateRouteImport
      parentRoute: typeof AuthPublicRoute
    }
    '/_app/worklist/complete': {
      id: '/_app/worklist/complete'
      path: '/complete'
      fullPath: '/worklist/complete'
      preLoaderRoute: typeof AppWorklistCompleteRouteImport
      parentRoute: typeof AppWorklistRoute
    }
    '/_app/validate/$validationId': {
      id: '/_app/validate/$validationId'
      path: '/validate/$validationId'
      fullPath: '/validate/$validationId'
      preLoaderRoute: typeof AppValidateValidationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/secretaries': {
      id: '/_app/users/secretaries'
      path: '/secretaries'
      fullPath: '/users/secretaries'
      preLoaderRoute: typeof AppUsersSecretariesRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/preferences': {
      id: '/_app/users/preferences'
      path: '/preferences'
      fullPath: '/users/preferences'
      preLoaderRoute: typeof AppUsersPreferencesRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/patients': {
      id: '/_app/users/patients'
      path: '/patients'
      fullPath: '/users/patients'
      preLoaderRoute: typeof AppUsersPatientsRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/organisations': {
      id: '/_app/users/organisations'
      path: '/organisations'
      fullPath: '/users/organisations'
      preLoaderRoute: typeof AppUsersOrganisationsRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/managers': {
      id: '/_app/users/managers'
      path: '/managers'
      fullPath: '/users/managers'
      preLoaderRoute: typeof AppUsersManagersRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/clinicians': {
      id: '/_app/users/clinicians'
      path: '/clinicians'
      fullPath: '/users/clinicians'
      preLoaderRoute: typeof AppUsersCliniciansRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/billing': {
      id: '/_app/users/billing'
      path: '/billing'
      fullPath: '/users/billing'
      preLoaderRoute: typeof AppUsersBillingRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/admins': {
      id: '/_app/users/admins'
      path: '/admins'
      fullPath: '/users/admins'
      preLoaderRoute: typeof AppUsersAdminsRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/templates/quickstart-page': {
      id: '/_app/templates/quickstart-page'
      path: '/quickstart-page'
      fullPath: '/templates/quickstart-page'
      preLoaderRoute: typeof AppTemplatesQuickstartPageRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/public': {
      id: '/_app/templates/public'
      path: '/public'
      fullPath: '/templates/public'
      preLoaderRoute: typeof AppTemplatesPublicRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/complete': {
      id: '/_app/templates/complete'
      path: '/complete'
      fullPath: '/templates/complete'
      preLoaderRoute: typeof AppTemplatesCompleteRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/$templateId': {
      id: '/_app/templates/$templateId'
      path: '/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AppTemplatesTemplateIdRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/team/invite': {
      id: '/_app/team/invite'
      path: '/invite'
      fullPath: '/team/invite'
      preLoaderRoute: typeof AppTeamInviteRouteImport
      parentRoute: typeof AppTeamRoute
    }
    '/_app/studies/$studyId': {
      id: '/_app/studies/$studyId'
      path: '/$studyId'
      fullPath: '/studies/$studyId'
      preLoaderRoute: typeof AppStudiesStudyIdRouteImport
      parentRoute: typeof AppStudiesRoute
    }
    '/_app/schedules/$scheduleId': {
      id: '/_app/schedules/$scheduleId'
      path: '/schedules/$scheduleId'
      fullPath: '/schedules/$scheduleId'
      preLoaderRoute: typeof AppSchedulesScheduleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/phone': {
      id: '/_app/profile/phone'
      path: '/phone'
      fullPath: '/profile/phone'
      preLoaderRoute: typeof AppProfilePhoneRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/organisation': {
      id: '/_app/profile/organisation'
      path: '/organisation'
      fullPath: '/profile/organisation'
      preLoaderRoute: typeof AppProfileOrganisationRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/notifications': {
      id: '/_app/profile/notifications'
      path: '/notifications'
      fullPath: '/profile/notifications'
      preLoaderRoute: typeof AppProfileNotificationsRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/nhs-number': {
      id: '/_app/profile/nhs-number'
      path: '/nhs-number'
      fullPath: '/profile/nhs-number'
      preLoaderRoute: typeof AppProfileNhsNumberRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/name': {
      id: '/_app/profile/name'
      path: '/name'
      fullPath: '/profile/name'
      preLoaderRoute: typeof AppProfileNameRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/mfa': {
      id: '/_app/profile/mfa'
      path: '/mfa'
      fullPath: '/profile/mfa'
      preLoaderRoute: typeof AppProfileMfaRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/email': {
      id: '/_app/profile/email'
      path: '/email'
      fullPath: '/profile/email'
      preLoaderRoute: typeof AppProfileEmailRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/delete-account': {
      id: '/_app/profile/delete-account'
      path: '/delete-account'
      fullPath: '/profile/delete-account'
      preLoaderRoute: typeof AppProfileDeleteAccountRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/date-of-birth': {
      id: '/_app/profile/date-of-birth'
      path: '/date-of-birth'
      fullPath: '/profile/date-of-birth'
      preLoaderRoute: typeof AppProfileDateOfBirthRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/clinician-number': {
      id: '/_app/profile/clinician-number'
      path: '/clinician-number'
      fullPath: '/profile/clinician-number'
      preLoaderRoute: typeof AppProfileClinicianNumberRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/change-password': {
      id: '/_app/profile/change-password'
      path: '/change-password'
      fullPath: '/profile/change-password'
      preLoaderRoute: typeof AppProfileChangePasswordRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/billing': {
      id: '/_app/profile/billing'
      path: '/billing'
      fullPath: '/profile/billing'
      preLoaderRoute: typeof AppProfileBillingRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/profile/add-imaging-center': {
      id: '/_app/profile/add-imaging-center'
      path: '/add-imaging-center'
      fullPath: '/profile/add-imaging-center'
      preLoaderRoute: typeof AppProfileAddImagingCenterRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/patients/$diaryId': {
      id: '/_app/patients/$diaryId'
      path: '/$diaryId'
      fullPath: '/patients/$diaryId'
      preLoaderRoute: typeof AppPatientsDiaryIdRouteImport
      parentRoute: typeof AppPatientsRoute
    }
    '/_app/new/$': {
      id: '/_app/new/$'
      path: '/new/$'
      fullPath: '/new/$'
      preLoaderRoute: typeof AppNewSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lead-gen/$': {
      id: '/_app/lead-gen/$'
      path: '/lead-gen/$'
      fullPath: '/lead-gen/$'
      preLoaderRoute: typeof AppLeadGenSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invite/qr-code': {
      id: '/_app/invite/qr-code'
      path: '/qr-code'
      fullPath: '/invite/qr-code'
      preLoaderRoute: typeof AppInviteQrCodeRouteImport
      parentRoute: typeof AppInviteRoute
    }
    '/_app/help/patient': {
      id: '/_app/help/patient'
      path: '/help/patient'
      fullPath: '/help/patient'
      preLoaderRoute: typeof AppHelpPatientRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/clinician': {
      id: '/_app/help/clinician'
      path: '/help/clinician'
      fullPath: '/help/clinician'
      preLoaderRoute: typeof AppHelpClinicianRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/headache-watch/dashboard': {
      id: '/_app/headache-watch/dashboard'
      path: '/headache-watch/dashboard'
      fullPath: '/headache-watch/dashboard'
      preLoaderRoute: typeof AppHeadacheWatchDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foot-watch/$diaryId': {
      id: '/_app/foot-watch/$diaryId'
      path: '/foot-watch/$diaryId'
      fullPath: '/foot-watch/$diaryId'
      preLoaderRoute: typeof AppFootWatchDiaryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fisher-watch/dashboard': {
      id: '/_app/fisher-watch/dashboard'
      path: '/fisher-watch/dashboard'
      fullPath: '/fisher-watch/dashboard'
      preLoaderRoute: typeof AppFisherWatchDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/diaries/$diaryId': {
      id: '/_app/diaries/$diaryId'
      path: '/diaries/$diaryId'
      fullPath: '/diaries/$diaryId'
      preLoaderRoute: typeof AppDiariesDiaryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer/sms-deliverability': {
      id: '/_app/developer/sms-deliverability'
      path: '/sms-deliverability'
      fullPath: '/developer/sms-deliverability'
      preLoaderRoute: typeof AppDeveloperSmsDeliverabilityRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/reminder-send-volume': {
      id: '/_app/developer/reminder-send-volume'
      path: '/reminder-send-volume'
      fullPath: '/developer/reminder-send-volume'
      preLoaderRoute: typeof AppDeveloperReminderSendVolumeRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/messaging-schedule': {
      id: '/_app/developer/messaging-schedule'
      path: '/messaging-schedule'
      fullPath: '/developer/messaging-schedule'
      preLoaderRoute: typeof AppDeveloperMessagingScheduleRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/health-check': {
      id: '/_app/developer/health-check'
      path: '/health-check'
      fullPath: '/developer/health-check'
      preLoaderRoute: typeof AppDeveloperHealthCheckRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/customers/success': {
      id: '/_app/customers/success'
      path: '/success'
      fullPath: '/customers/success'
      preLoaderRoute: typeof AppCustomersSuccessRouteImport
      parentRoute: typeof AppCustomersRoute
    }
    '/_app/customers/clinicians': {
      id: '/_app/customers/clinicians'
      path: '/clinicians'
      fullPath: '/customers/clinicians'
      preLoaderRoute: typeof AppCustomersCliniciansRouteImport
      parentRoute: typeof AppCustomersRoute
    }
    '/_app/customers/churn': {
      id: '/_app/customers/churn'
      path: '/churn'
      fullPath: '/customers/churn'
      preLoaderRoute: typeof AppCustomersChurnRouteImport
      parentRoute: typeof AppCustomersRoute
    }
    '/_app/customers/anonymous': {
      id: '/_app/customers/anonymous'
      path: '/anonymous'
      fullPath: '/customers/anonymous'
      preLoaderRoute: typeof AppCustomersAnonymousRouteImport
      parentRoute: typeof AppCustomersRoute
    }
    '/_app/customers/ambassadors': {
      id: '/_app/customers/ambassadors'
      path: '/ambassadors'
      fullPath: '/customers/ambassadors'
      preLoaderRoute: typeof AppCustomersAmbassadorsRouteImport
      parentRoute: typeof AppCustomersRoute
    }
    '/_app/clinician/diaries': {
      id: '/_app/clinician/diaries'
      path: '/clinician/diaries'
      fullPath: '/clinician/diaries'
      preLoaderRoute: typeof AppClinicianDiariesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business/churn': {
      id: '/_app/business/churn'
      path: '/churn'
      fullPath: '/business/churn'
      preLoaderRoute: typeof AppBusinessChurnRouteImport
      parentRoute: typeof AppBusinessRoute
    }
    '/_app/business/ambassadors': {
      id: '/_app/business/ambassadors'
      path: '/ambassadors'
      fullPath: '/business/ambassadors'
      preLoaderRoute: typeof AppBusinessAmbassadorsRouteImport
      parentRoute: typeof AppBusinessRoute
    }
    '/_app/analytics/arthrosamid': {
      id: '/_app/analytics/arthrosamid'
      path: '/arthrosamid'
      fullPath: '/analytics/arthrosamid'
      preLoaderRoute: typeof AppAnalyticsArthrosamidRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/_app/analytics/anika': {
      id: '/_app/analytics/anika'
      path: '/anika'
      fullPath: '/analytics/anika'
      preLoaderRoute: typeof AppAnalyticsAnikaRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/_app/analytics/$diaryLabel': {
      id: '/_app/analytics/$diaryLabel'
      path: '/$diaryLabel'
      fullPath: '/analytics/$diaryLabel'
      preLoaderRoute: typeof AppAnalyticsDiaryLabelRouteImport
      parentRoute: typeof AppAnalyticsRoute
    }
    '/_app/admin/view-diary-as-patient': {
      id: '/_app/admin/view-diary-as-patient'
      path: '/view-diary-as-patient'
      fullPath: '/admin/view-diary-as-patient'
      preLoaderRoute: typeof AppAdminViewDiaryAsPatientRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/user-organisations': {
      id: '/_app/admin/user-organisations'
      path: '/user-organisations'
      fullPath: '/admin/user-organisations'
      preLoaderRoute: typeof AppAdminUserOrganisationsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/user-billing': {
      id: '/_app/admin/user-billing'
      path: '/user-billing'
      fullPath: '/admin/user-billing'
      preLoaderRoute: typeof AppAdminUserBillingRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/trackers': {
      id: '/_app/admin/trackers'
      path: '/trackers'
      fullPath: '/admin/trackers'
      preLoaderRoute: typeof AppAdminTrackersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/templates': {
      id: '/_app/admin/templates'
      path: '/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AppAdminTemplatesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/studies': {
      id: '/_app/admin/studies'
      path: '/studies'
      fullPath: '/admin/studies'
      preLoaderRoute: typeof AppAdminStudiesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/sms-deliverability': {
      id: '/_app/admin/sms-deliverability'
      path: '/sms-deliverability'
      fullPath: '/admin/sms-deliverability'
      preLoaderRoute: typeof AppAdminSmsDeliverabilityRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/reminder-send-volume': {
      id: '/_app/admin/reminder-send-volume'
      path: '/reminder-send-volume'
      fullPath: '/admin/reminder-send-volume'
      preLoaderRoute: typeof AppAdminReminderSendVolumeRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/notification-preferences': {
      id: '/_app/admin/notification-preferences'
      path: '/notification-preferences'
      fullPath: '/admin/notification-preferences'
      preLoaderRoute: typeof AppAdminNotificationPreferencesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/labels': {
      id: '/_app/admin/labels'
      path: '/labels'
      fullPath: '/admin/labels'
      preLoaderRoute: typeof AppAdminLabelsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/label-access': {
      id: '/_app/admin/label-access'
      path: '/label-access'
      fullPath: '/admin/label-access'
      preLoaderRoute: typeof AppAdminLabelAccessRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/impersonate-user': {
      id: '/_app/admin/impersonate-user'
      path: '/impersonate-user'
      fullPath: '/admin/impersonate-user'
      preLoaderRoute: typeof AppAdminImpersonateUserRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/health-check': {
      id: '/_app/admin/health-check'
      path: '/health-check'
      fullPath: '/admin/health-check'
      preLoaderRoute: typeof AppAdminHealthCheckRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/events': {
      id: '/_app/admin/events'
      path: '/events'
      fullPath: '/admin/events'
      preLoaderRoute: typeof AppAdminEventsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/entry-values': {
      id: '/_app/admin/entry-values'
      path: '/entry-values'
      fullPath: '/admin/entry-values'
      preLoaderRoute: typeof AppAdminEntryValuesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/entries': {
      id: '/_app/admin/entries'
      path: '/entries'
      fullPath: '/admin/entries'
      preLoaderRoute: typeof AppAdminEntriesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/ambassadors': {
      id: '/_app/admin/ambassadors'
      path: '/ambassadors'
      fullPath: '/admin/ambassadors'
      preLoaderRoute: typeof AppAdminAmbassadorsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/users/notifications': {
      id: '/_app/users/notifications'
      path: '/notifications'
      fullPath: '/users/notifications'
      preLoaderRoute: typeof AppUsersNotificationsRouteRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/create-user': {
      id: '/_app/users/create-user'
      path: '/create-user'
      fullPath: '/users/create-user'
      preLoaderRoute: typeof AppUsersCreateUserRouteRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/sales/leads': {
      id: '/_app/sales/leads'
      path: '/leads'
      fullPath: '/sales/leads'
      preLoaderRoute: typeof AppSalesLeadsRouteRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/developer/sftp': {
      id: '/_app/developer/sftp'
      path: '/sftp'
      fullPath: '/developer/sftp'
      preLoaderRoute: typeof AppDeveloperSftpRouteRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/business/leads': {
      id: '/_app/business/leads'
      path: '/leads'
      fullPath: '/business/leads'
      preLoaderRoute: typeof AppBusinessLeadsRouteRouteImport
      parentRoute: typeof AppBusinessRoute
    }
    '/_app/admin/sftp': {
      id: '/_app/admin/sftp'
      path: '/sftp'
      fullPath: '/admin/sftp'
      preLoaderRoute: typeof AppAdminSftpRouteRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/organisation': {
      id: '/_app/admin/organisation'
      path: '/organisation'
      fullPath: '/admin/organisation'
      preLoaderRoute: typeof AppAdminOrganisationRouteRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/access': {
      id: '/_app/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AppAdminAccessRouteRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_auth/new-user/patient/': {
      id: '/_auth/new-user/patient/'
      path: '/new-user/patient'
      fullPath: '/new-user/patient/'
      preLoaderRoute: typeof AuthNewUserPatientIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/new-user/clinician/': {
      id: '/_auth/new-user/clinician/'
      path: '/new-user/clinician'
      fullPath: '/new-user/clinician/'
      preLoaderRoute: typeof AuthNewUserClinicianIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_public/signup/': {
      id: '/_auth/_public/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof AuthPublicSignupIndexRouteImport
      parentRoute: typeof AuthPublicRoute
    }
    '/_auth/_public/login/': {
      id: '/_auth/_public/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthPublicLoginIndexRouteImport
      parentRoute: typeof AuthPublicLoginRoute
    }
    '/_app/validate/$validationId/': {
      id: '/_app/validate/$validationId/'
      path: '/'
      fullPath: '/validate/$validationId/'
      preLoaderRoute: typeof AppValidateValidationIdIndexRouteImport
      parentRoute: typeof AppValidateValidationIdRoute
    }
    '/_app/users/notifications/': {
      id: '/_app/users/notifications/'
      path: '/'
      fullPath: '/users/notifications/'
      preLoaderRoute: typeof AppUsersNotificationsIndexRouteImport
      parentRoute: typeof AppUsersNotificationsRouteRoute
    }
    '/_app/users/create-user/': {
      id: '/_app/users/create-user/'
      path: '/'
      fullPath: '/users/create-user/'
      preLoaderRoute: typeof AppUsersCreateUserIndexRouteImport
      parentRoute: typeof AppUsersCreateUserRouteRoute
    }
    '/_app/team/invite/': {
      id: '/_app/team/invite/'
      path: '/'
      fullPath: '/team/invite/'
      preLoaderRoute: typeof AppTeamInviteIndexRouteImport
      parentRoute: typeof AppTeamInviteRoute
    }
    '/_app/studies/$studyId/': {
      id: '/_app/studies/$studyId/'
      path: '/'
      fullPath: '/studies/$studyId/'
      preLoaderRoute: typeof AppStudiesStudyIdIndexRouteImport
      parentRoute: typeof AppStudiesStudyIdRoute
    }
    '/_app/sales/leads/': {
      id: '/_app/sales/leads/'
      path: '/'
      fullPath: '/sales/leads/'
      preLoaderRoute: typeof AppSalesLeadsIndexRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/patients/$diaryId/': {
      id: '/_app/patients/$diaryId/'
      path: '/'
      fullPath: '/patients/$diaryId/'
      preLoaderRoute: typeof AppPatientsDiaryIdIndexRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/organisation/$organisationId/': {
      id: '/_app/organisation/$organisationId/'
      path: '/organisation/$organisationId'
      fullPath: '/organisation/$organisationId/'
      preLoaderRoute: typeof AppOrganisationOrganisationIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/diaries/$diaryId/': {
      id: '/_app/diaries/$diaryId/'
      path: '/'
      fullPath: '/diaries/$diaryId/'
      preLoaderRoute: typeof AppDiariesDiaryIdIndexRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/_app/developer/sftp/': {
      id: '/_app/developer/sftp/'
      path: '/'
      fullPath: '/developer/sftp/'
      preLoaderRoute: typeof AppDeveloperSftpIndexRouteImport
      parentRoute: typeof AppDeveloperSftpRouteRoute
    }
    '/_app/design/icons/': {
      id: '/_app/design/icons/'
      path: '/icons'
      fullPath: '/design/icons/'
      preLoaderRoute: typeof AppDesignIconsIndexRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/forms/': {
      id: '/_app/design/forms/'
      path: '/forms'
      fullPath: '/design/forms/'
      preLoaderRoute: typeof AppDesignFormsIndexRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/business/leads/': {
      id: '/_app/business/leads/'
      path: '/'
      fullPath: '/business/leads/'
      preLoaderRoute: typeof AppBusinessLeadsIndexRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/builder/templates/': {
      id: '/_app/builder/templates/'
      path: '/templates'
      fullPath: '/builder/templates/'
      preLoaderRoute: typeof AppBuilderTemplatesIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/surgeries/': {
      id: '/_app/builder/surgeries/'
      path: '/surgeries'
      fullPath: '/builder/surgeries/'
      preLoaderRoute: typeof AppBuilderSurgeriesIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/schedules/': {
      id: '/_app/builder/schedules/'
      path: '/schedules'
      fullPath: '/builder/schedules/'
      preLoaderRoute: typeof AppBuilderSchedulesIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/options/': {
      id: '/_app/builder/options/'
      path: '/options'
      fullPath: '/builder/options/'
      preLoaderRoute: typeof AppBuilderOptionsIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/messages/': {
      id: '/_app/builder/messages/'
      path: '/messages'
      fullPath: '/builder/messages/'
      preLoaderRoute: typeof AppBuilderMessagesIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/labels/': {
      id: '/_app/builder/labels/'
      path: '/labels'
      fullPath: '/builder/labels/'
      preLoaderRoute: typeof AppBuilderLabelsIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/injection-locations/': {
      id: '/_app/builder/injection-locations/'
      path: '/injection-locations'
      fullPath: '/builder/injection-locations/'
      preLoaderRoute: typeof AppBuilderInjectionLocationsIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/injection-contents/': {
      id: '/_app/builder/injection-contents/'
      path: '/injection-contents'
      fullPath: '/builder/injection-contents/'
      preLoaderRoute: typeof AppBuilderInjectionContentsIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/forms/': {
      id: '/_app/builder/forms/'
      path: '/forms'
      fullPath: '/builder/forms/'
      preLoaderRoute: typeof AppBuilderFormsIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/dictionaries/': {
      id: '/_app/builder/dictionaries/'
      path: '/dictionaries'
      fullPath: '/builder/dictionaries/'
      preLoaderRoute: typeof AppBuilderDictionariesIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/consents/': {
      id: '/_app/builder/consents/'
      path: '/consents'
      fullPath: '/builder/consents/'
      preLoaderRoute: typeof AppBuilderConsentsIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/admin/user-activation/': {
      id: '/_app/admin/user-activation/'
      path: '/user-activation'
      fullPath: '/admin/user-activation/'
      preLoaderRoute: typeof AppAdminUserActivationIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/sftp/': {
      id: '/_app/admin/sftp/'
      path: '/'
      fullPath: '/admin/sftp/'
      preLoaderRoute: typeof AppAdminSftpIndexRouteImport
      parentRoute: typeof AppAdminSftpRouteRoute
    }
    '/_app/admin/organisation/': {
      id: '/_app/admin/organisation/'
      path: '/'
      fullPath: '/admin/organisation/'
      preLoaderRoute: typeof AppAdminOrganisationIndexRouteImport
      parentRoute: typeof AppAdminOrganisationRouteRoute
    }
    '/_app/admin/diaries/': {
      id: '/_app/admin/diaries/'
      path: '/diaries'
      fullPath: '/admin/diaries/'
      preLoaderRoute: typeof AppAdminDiariesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/clinicians/': {
      id: '/_app/admin/clinicians/'
      path: '/clinicians'
      fullPath: '/admin/clinicians/'
      preLoaderRoute: typeof AppAdminCliniciansIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/business/': {
      id: '/_app/admin/business/'
      path: '/business'
      fullPath: '/admin/business/'
      preLoaderRoute: typeof AppAdminBusinessIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit/': {
      id: '/_app/admin/audit/'
      path: '/'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AppAdminAuditIndexRouteImport
      parentRoute: typeof AppAdminAuditRouteRoute
    }
    '/_app/admin/access/': {
      id: '/_app/admin/access/'
      path: '/'
      fullPath: '/admin/access/'
      preLoaderRoute: typeof AppAdminAccessIndexRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_auth/_public/signup/verify-phone': {
      id: '/_auth/_public/signup/verify-phone'
      path: '/signup/verify-phone'
      fullPath: '/signup/verify-phone'
      preLoaderRoute: typeof AuthPublicSignupVerifyPhoneRouteImport
      parentRoute: typeof AuthPublicRoute
    }
    '/_auth/_public/signup/trial': {
      id: '/_auth/_public/signup/trial'
      path: '/signup/trial'
      fullPath: '/signup/trial'
      preLoaderRoute: typeof AuthPublicSignupTrialRouteImport
      parentRoute: typeof AuthPublicRoute
    }
    '/_auth/_public/signup/$plan': {
      id: '/_auth/_public/signup/$plan'
      path: '/signup/$plan'
      fullPath: '/signup/$plan'
      preLoaderRoute: typeof AuthPublicSignupPlanRouteImport
      parentRoute: typeof AuthPublicRoute
    }
    '/_auth/_public/login/verify': {
      id: '/_auth/_public/login/verify'
      path: '/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof AuthPublicLoginVerifyRouteImport
      parentRoute: typeof AuthPublicLoginRoute
    }
    '/_app/users/secretaries/$userId': {
      id: '/_app/users/secretaries/$userId'
      path: '/$userId'
      fullPath: '/users/secretaries/$userId'
      preLoaderRoute: typeof AppUsersSecretariesUserIdRouteImport
      parentRoute: typeof AppUsersSecretariesRoute
    }
    '/_app/users/patients/$userId': {
      id: '/_app/users/patients/$userId'
      path: '/$userId'
      fullPath: '/users/patients/$userId'
      preLoaderRoute: typeof AppUsersPatientsUserIdRouteImport
      parentRoute: typeof AppUsersPatientsRoute
    }
    '/_app/users/notifications/sms': {
      id: '/_app/users/notifications/sms'
      path: '/sms'
      fullPath: '/users/notifications/sms'
      preLoaderRoute: typeof AppUsersNotificationsSmsRouteImport
      parentRoute: typeof AppUsersNotificationsRouteRoute
    }
    '/_app/users/managers/$userId': {
      id: '/_app/users/managers/$userId'
      path: '/$userId'
      fullPath: '/users/managers/$userId'
      preLoaderRoute: typeof AppUsersManagersUserIdRouteImport
      parentRoute: typeof AppUsersManagersRoute
    }
    '/_app/users/create-user/templates': {
      id: '/_app/users/create-user/templates'
      path: '/templates'
      fullPath: '/users/create-user/templates'
      preLoaderRoute: typeof AppUsersCreateUserTemplatesRouteImport
      parentRoute: typeof AppUsersCreateUserRouteRoute
    }
    '/_app/users/create-user/organisations': {
      id: '/_app/users/create-user/organisations'
      path: '/organisations'
      fullPath: '/users/create-user/organisations'
      preLoaderRoute: typeof AppUsersCreateUserOrganisationsRouteImport
      parentRoute: typeof AppUsersCreateUserRouteRoute
    }
    '/_app/users/create-user/impersonate': {
      id: '/_app/users/create-user/impersonate'
      path: '/impersonate'
      fullPath: '/users/create-user/impersonate'
      preLoaderRoute: typeof AppUsersCreateUserImpersonateRouteImport
      parentRoute: typeof AppUsersCreateUserRouteRoute
    }
    '/_app/users/create-user/details': {
      id: '/_app/users/create-user/details'
      path: '/details'
      fullPath: '/users/create-user/details'
      preLoaderRoute: typeof AppUsersCreateUserDetailsRouteImport
      parentRoute: typeof AppUsersCreateUserRouteRoute
    }
    '/_app/users/create-user/billing': {
      id: '/_app/users/create-user/billing'
      path: '/billing'
      fullPath: '/users/create-user/billing'
      preLoaderRoute: typeof AppUsersCreateUserBillingRouteImport
      parentRoute: typeof AppUsersCreateUserRouteRoute
    }
    '/_app/users/create-user/access': {
      id: '/_app/users/create-user/access'
      path: '/access'
      fullPath: '/users/create-user/access'
      preLoaderRoute: typeof AppUsersCreateUserAccessRouteImport
      parentRoute: typeof AppUsersCreateUserRouteRoute
    }
    '/_app/users/clinicians/$userId': {
      id: '/_app/users/clinicians/$userId'
      path: '/$userId'
      fullPath: '/users/clinicians/$userId'
      preLoaderRoute: typeof AppUsersCliniciansUserIdRouteImport
      parentRoute: typeof AppUsersCliniciansRoute
    }
    '/_app/users/admins/$userId': {
      id: '/_app/users/admins/$userId'
      path: '/$userId'
      fullPath: '/users/admins/$userId'
      preLoaderRoute: typeof AppUsersAdminsUserIdRouteImport
      parentRoute: typeof AppUsersAdminsRoute
    }
    '/_app/templates/diary/$templateId': {
      id: '/_app/templates/diary/$templateId'
      path: '/diary/$templateId'
      fullPath: '/templates/diary/$templateId'
      preLoaderRoute: typeof AppTemplatesDiaryTemplateIdRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$newDiaryTemplateId': {
      id: '/_app/templates/diary/$newDiaryTemplateId'
      path: '/diary/$newDiaryTemplateId'
      fullPath: '/templates/diary/$newDiaryTemplateId'
      preLoaderRoute: typeof AppTemplatesDiaryNewDiaryTemplateIdRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/$templateId/trackers': {
      id: '/_app/templates/$templateId/trackers'
      path: '/trackers'
      fullPath: '/templates/$templateId/trackers'
      preLoaderRoute: typeof AppTemplatesTemplateIdTrackersRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/screener': {
      id: '/_app/templates/$templateId/screener'
      path: '/screener'
      fullPath: '/templates/$templateId/screener'
      preLoaderRoute: typeof AppTemplatesTemplateIdScreenerRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/publish': {
      id: '/_app/templates/$templateId/publish'
      path: '/publish'
      fullPath: '/templates/$templateId/publish'
      preLoaderRoute: typeof AppTemplatesTemplateIdPublishRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/organisation': {
      id: '/_app/templates/$templateId/organisation'
      path: '/organisation'
      fullPath: '/templates/$templateId/organisation'
      preLoaderRoute: typeof AppTemplatesTemplateIdOrganisationRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/name': {
      id: '/_app/templates/$templateId/name'
      path: '/name'
      fullPath: '/templates/$templateId/name'
      preLoaderRoute: typeof AppTemplatesTemplateIdNameRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/labels': {
      id: '/_app/templates/$templateId/labels'
      path: '/labels'
      fullPath: '/templates/$templateId/labels'
      preLoaderRoute: typeof AppTemplatesTemplateIdLabelsRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/hospital-number': {
      id: '/_app/templates/$templateId/hospital-number'
      path: '/hospital-number'
      fullPath: '/templates/$templateId/hospital-number'
      preLoaderRoute: typeof AppTemplatesTemplateIdHospitalNumberRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/date': {
      id: '/_app/templates/$templateId/date'
      path: '/date'
      fullPath: '/templates/$templateId/date'
      preLoaderRoute: typeof AppTemplatesTemplateIdDateRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/consent': {
      id: '/_app/templates/$templateId/consent'
      path: '/consent'
      fullPath: '/templates/$templateId/consent'
      preLoaderRoute: typeof AppTemplatesTemplateIdConsentRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/team/invite/qr': {
      id: '/_app/team/invite/qr'
      path: '/qr'
      fullPath: '/team/invite/qr'
      preLoaderRoute: typeof AppTeamInviteQrRouteImport
      parentRoute: typeof AppTeamInviteRoute
    }
    '/_app/team/invite/email': {
      id: '/_app/team/invite/email'
      path: '/email'
      fullPath: '/team/invite/email'
      preLoaderRoute: typeof AppTeamInviteEmailRouteImport
      parentRoute: typeof AppTeamInviteRoute
    }
    '/_app/studies/$studyId/edit': {
      id: '/_app/studies/$studyId/edit'
      path: '/edit'
      fullPath: '/studies/$studyId/edit'
      preLoaderRoute: typeof AppStudiesStudyIdEditRouteImport
      parentRoute: typeof AppStudiesStudyIdRoute
    }
    '/_app/sales/leads/new': {
      id: '/_app/sales/leads/new'
      path: '/new'
      fullPath: '/sales/leads/new'
      preLoaderRoute: typeof AppSalesLeadsNewRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/profile/medical/diabetes': {
      id: '/_app/profile/medical/diabetes'
      path: '/medical/diabetes'
      fullPath: '/profile/medical/diabetes'
      preLoaderRoute: typeof AppProfileMedicalDiabetesRouteImport
      parentRoute: typeof AppProfileRoute
    }
    '/_app/patients/bulk/reviewed': {
      id: '/_app/patients/bulk/reviewed'
      path: '/bulk/reviewed'
      fullPath: '/patients/bulk/reviewed'
      preLoaderRoute: typeof AppPatientsBulkReviewedRouteImport
      parentRoute: typeof AppPatientsRoute
    }
    '/_app/patients/bulk/organisation': {
      id: '/_app/patients/bulk/organisation'
      path: '/bulk/organisation'
      fullPath: '/patients/bulk/organisation'
      preLoaderRoute: typeof AppPatientsBulkOrganisationRouteImport
      parentRoute: typeof AppPatientsRoute
    }
    '/_app/patients/bulk/message': {
      id: '/_app/patients/bulk/message'
      path: '/bulk/message'
      fullPath: '/patients/bulk/message'
      preLoaderRoute: typeof AppPatientsBulkMessageRouteImport
      parentRoute: typeof AppPatientsRoute
    }
    '/_app/patients/bulk/labels': {
      id: '/_app/patients/bulk/labels'
      path: '/bulk/labels'
      fullPath: '/patients/bulk/labels'
      preLoaderRoute: typeof AppPatientsBulkLabelsRouteImport
      parentRoute: typeof AppPatientsRoute
    }
    '/_app/patients/bulk/events': {
      id: '/_app/patients/bulk/events'
      path: '/bulk/events'
      fullPath: '/patients/bulk/events'
      preLoaderRoute: typeof AppPatientsBulkEventsRouteImport
      parentRoute: typeof AppPatientsRoute
    }
    '/_app/patients/bulk/contact': {
      id: '/_app/patients/bulk/contact'
      path: '/bulk/contact'
      fullPath: '/patients/bulk/contact'
      preLoaderRoute: typeof AppPatientsBulkContactRouteImport
      parentRoute: typeof AppPatientsRoute
    }
    '/_app/patients/$diaryId/edit': {
      id: '/_app/patients/$diaryId/edit'
      path: '/edit'
      fullPath: '/patients/$diaryId/edit'
      preLoaderRoute: typeof AppPatientsDiaryIdEditRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/organisation/$organisationId/qr-code': {
      id: '/_app/organisation/$organisationId/qr-code'
      path: '/organisation/$organisationId/qr-code'
      fullPath: '/organisation/$organisationId/qr-code'
      preLoaderRoute: typeof AppOrganisationOrganisationIdQrCodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invite/diary/review': {
      id: '/_app/invite/diary/review'
      path: '/diary/review'
      fullPath: '/invite/diary/review'
      preLoaderRoute: typeof AppInviteDiaryReviewRouteImport
      parentRoute: typeof AppInviteRoute
    }
    '/_app/invite/diary/qr': {
      id: '/_app/invite/diary/qr'
      path: '/diary/qr'
      fullPath: '/invite/diary/qr'
      preLoaderRoute: typeof AppInviteDiaryQrRouteImport
      parentRoute: typeof AppInviteRoute
    }
    '/_app/invite/diary/patient': {
      id: '/_app/invite/diary/patient'
      path: '/diary/patient'
      fullPath: '/invite/diary/patient'
      preLoaderRoute: typeof AppInviteDiaryPatientRouteImport
      parentRoute: typeof AppInviteRoute
    }
    '/_app/invite/diary/organisation': {
      id: '/_app/invite/diary/organisation'
      path: '/diary/organisation'
      fullPath: '/invite/diary/organisation'
      preLoaderRoute: typeof AppInviteDiaryOrganisationRouteImport
      parentRoute: typeof AppInviteRoute
    }
    '/_app/invite/diary/complete': {
      id: '/_app/invite/diary/complete'
      path: '/diary/complete'
      fullPath: '/invite/diary/complete'
      preLoaderRoute: typeof AppInviteDiaryCompleteRouteImport
      parentRoute: typeof AppInviteRoute
    }
    '/_app/foot-watch/new-diary/share': {
      id: '/_app/foot-watch/new-diary/share'
      path: '/foot-watch/new-diary/share'
      fullPath: '/foot-watch/new-diary/share'
      preLoaderRoute: typeof AppFootWatchNewDiaryShareRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foot-watch/$diaryId/edit': {
      id: '/_app/foot-watch/$diaryId/edit'
      path: '/edit'
      fullPath: '/foot-watch/$diaryId/edit'
      preLoaderRoute: typeof AppFootWatchDiaryIdEditRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/_view': {
      id: '/_app/foot-watch/$diaryId/_view'
      path: ''
      fullPath: '/foot-watch/$diaryId'
      preLoaderRoute: typeof AppFootWatchDiaryIdViewRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/diaries/$diaryId/setup': {
      id: '/_app/diaries/$diaryId/setup'
      path: '/setup'
      fullPath: '/diaries/$diaryId/setup'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/_app/diaries/$diaryId/progress': {
      id: '/_app/diaries/$diaryId/progress'
      path: '/progress'
      fullPath: '/diaries/$diaryId/progress'
      preLoaderRoute: typeof AppDiariesDiaryIdProgressRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/_app/diaries/$diaryId/home': {
      id: '/_app/diaries/$diaryId/home'
      path: '/home'
      fullPath: '/diaries/$diaryId/home'
      preLoaderRoute: typeof AppDiariesDiaryIdHomeRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/_app/diaries/$diaryId/forms': {
      id: '/_app/diaries/$diaryId/forms'
      path: '/forms'
      fullPath: '/diaries/$diaryId/forms'
      preLoaderRoute: typeof AppDiariesDiaryIdFormsRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/_app/developer/ui/inputs': {
      id: '/_app/developer/ui/inputs'
      path: '/ui/inputs'
      fullPath: '/developer/ui/inputs'
      preLoaderRoute: typeof AppDeveloperUiInputsRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/ui/input-switch': {
      id: '/_app/developer/ui/input-switch'
      path: '/ui/input-switch'
      fullPath: '/developer/ui/input-switch'
      preLoaderRoute: typeof AppDeveloperUiInputSwitchRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/ui/entry-values': {
      id: '/_app/developer/ui/entry-values'
      path: '/ui/entry-values'
      fullPath: '/developer/ui/entry-values'
      preLoaderRoute: typeof AppDeveloperUiEntryValuesRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/ui/dictionaries': {
      id: '/_app/developer/ui/dictionaries'
      path: '/ui/dictionaries'
      fullPath: '/developer/ui/dictionaries'
      preLoaderRoute: typeof AppDeveloperUiDictionariesRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/ui/buttons': {
      id: '/_app/developer/ui/buttons'
      path: '/ui/buttons'
      fullPath: '/developer/ui/buttons'
      preLoaderRoute: typeof AppDeveloperUiButtonsRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/ui/auth': {
      id: '/_app/developer/ui/auth'
      path: '/ui/auth'
      fullPath: '/developer/ui/auth'
      preLoaderRoute: typeof AppDeveloperUiAuthRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/ui/animations': {
      id: '/_app/developer/ui/animations'
      path: '/ui/animations'
      fullPath: '/developer/ui/animations'
      preLoaderRoute: typeof AppDeveloperUiAnimationsRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/sftp/upload': {
      id: '/_app/developer/sftp/upload'
      path: '/upload'
      fullPath: '/developer/sftp/upload'
      preLoaderRoute: typeof AppDeveloperSftpUploadRouteImport
      parentRoute: typeof AppDeveloperSftpRouteRoute
    }
    '/_app/developer/sftp/preview': {
      id: '/_app/developer/sftp/preview'
      path: '/preview'
      fullPath: '/developer/sftp/preview'
      preLoaderRoute: typeof AppDeveloperSftpPreviewRouteImport
      parentRoute: typeof AppDeveloperSftpRouteRoute
    }
    '/_app/developer/sftp/organisations': {
      id: '/_app/developer/sftp/organisations'
      path: '/organisations'
      fullPath: '/developer/sftp/organisations'
      preLoaderRoute: typeof AppDeveloperSftpOrganisationsRouteImport
      parentRoute: typeof AppDeveloperSftpRouteRoute
    }
    '/_app/developer/sftp/explorer': {
      id: '/_app/developer/sftp/explorer'
      path: '/explorer'
      fullPath: '/developer/sftp/explorer'
      preLoaderRoute: typeof AppDeveloperSftpExplorerRouteImport
      parentRoute: typeof AppDeveloperSftpRouteRoute
    }
    '/_app/developer/sftp/diaries': {
      id: '/_app/developer/sftp/diaries'
      path: '/diaries'
      fullPath: '/developer/sftp/diaries'
      preLoaderRoute: typeof AppDeveloperSftpDiariesRouteImport
      parentRoute: typeof AppDeveloperSftpRouteRoute
    }
    '/_app/developer/sftp/dashboard': {
      id: '/_app/developer/sftp/dashboard'
      path: '/dashboard'
      fullPath: '/developer/sftp/dashboard'
      preLoaderRoute: typeof AppDeveloperSftpDashboardRouteImport
      parentRoute: typeof AppDeveloperSftpRouteRoute
    }
    '/_app/developer/demos/otivio-frictionless-onboarding': {
      id: '/_app/developer/demos/otivio-frictionless-onboarding'
      path: '/demos/otivio-frictionless-onboarding'
      fullPath: '/developer/demos/otivio-frictionless-onboarding'
      preLoaderRoute: typeof AppDeveloperDemosOtivioFrictionlessOnboardingRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/demos/manager-study-clinician-invite-plan': {
      id: '/_app/developer/demos/manager-study-clinician-invite-plan'
      path: '/demos/manager-study-clinician-invite-plan'
      fullPath: '/developer/demos/manager-study-clinician-invite-plan'
      preLoaderRoute: typeof AppDeveloperDemosManagerStudyClinicianInvitePlanRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/developer/demos/generalised-analytics': {
      id: '/_app/developer/demos/generalised-analytics'
      path: '/demos/generalised-analytics'
      fullPath: '/developer/demos/generalised-analytics'
      preLoaderRoute: typeof AppDeveloperDemosGeneralisedAnalyticsRouteImport
      parentRoute: typeof AppDeveloperRoute
    }
    '/_app/design/icons/states': {
      id: '/_app/design/icons/states'
      path: '/icons/states'
      fullPath: '/design/icons/states'
      preLoaderRoute: typeof AppDesignIconsStatesRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/icons/faces': {
      id: '/_app/design/icons/faces'
      path: '/icons/faces'
      fullPath: '/design/icons/faces'
      preLoaderRoute: typeof AppDesignIconsFacesRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/icons/animations': {
      id: '/_app/design/icons/animations'
      path: '/icons/animations'
      fullPath: '/design/icons/animations'
      preLoaderRoute: typeof AppDesignIconsAnimationsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/forms/pages': {
      id: '/_app/design/forms/pages'
      path: '/forms/pages'
      fullPath: '/design/forms/pages'
      preLoaderRoute: typeof AppDesignFormsPagesRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/forms/inputs': {
      id: '/_app/design/forms/inputs'
      path: '/forms/inputs'
      fullPath: '/design/forms/inputs'
      preLoaderRoute: typeof AppDesignFormsInputsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/forms/entry-values': {
      id: '/_app/design/forms/entry-values'
      path: '/forms/entry-values'
      fullPath: '/design/forms/entry-values'
      preLoaderRoute: typeof AppDesignFormsEntryValuesRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/forms/blocks': {
      id: '/_app/design/forms/blocks'
      path: '/forms/blocks'
      fullPath: '/design/forms/blocks'
      preLoaderRoute: typeof AppDesignFormsBlocksRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/features/reminder-sequences': {
      id: '/_app/design/features/reminder-sequences'
      path: '/features/reminder-sequences'
      fullPath: '/design/features/reminder-sequences'
      preLoaderRoute: typeof AppDesignFeaturesReminderSequencesRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/features/otivio-frictionless-onboarding': {
      id: '/_app/design/features/otivio-frictionless-onboarding'
      path: '/features/otivio-frictionless-onboarding'
      fullPath: '/design/features/otivio-frictionless-onboarding'
      preLoaderRoute: typeof AppDesignFeaturesOtivioFrictionlessOnboardingRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/features/messaging-schedule': {
      id: '/_app/design/features/messaging-schedule'
      path: '/features/messaging-schedule'
      fullPath: '/design/features/messaging-schedule'
      preLoaderRoute: typeof AppDesignFeaturesMessagingScheduleRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/features/manager-study-clinician-invite-plan': {
      id: '/_app/design/features/manager-study-clinician-invite-plan'
      path: '/features/manager-study-clinician-invite-plan'
      fullPath: '/design/features/manager-study-clinician-invite-plan'
      preLoaderRoute: typeof AppDesignFeaturesManagerStudyClinicianInvitePlanRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/features/generalised-analytics': {
      id: '/_app/design/features/generalised-analytics'
      path: '/features/generalised-analytics'
      fullPath: '/design/features/generalised-analytics'
      preLoaderRoute: typeof AppDesignFeaturesGeneralisedAnalyticsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/components/select-dialogs': {
      id: '/_app/design/components/select-dialogs'
      path: '/components/select-dialogs'
      fullPath: '/design/components/select-dialogs'
      preLoaderRoute: typeof AppDesignComponentsSelectDialogsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/components/search-fields': {
      id: '/_app/design/components/search-fields'
      path: '/components/search-fields'
      fullPath: '/design/components/search-fields'
      preLoaderRoute: typeof AppDesignComponentsSearchFieldsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/components/inputs': {
      id: '/_app/design/components/inputs'
      path: '/components/inputs'
      fullPath: '/design/components/inputs'
      preLoaderRoute: typeof AppDesignComponentsInputsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/components/dictionaries': {
      id: '/_app/design/components/dictionaries'
      path: '/components/dictionaries'
      fullPath: '/design/components/dictionaries'
      preLoaderRoute: typeof AppDesignComponentsDictionariesRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/components/buttons': {
      id: '/_app/design/components/buttons'
      path: '/components/buttons'
      fullPath: '/design/components/buttons'
      preLoaderRoute: typeof AppDesignComponentsButtonsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/components/auth': {
      id: '/_app/design/components/auth'
      path: '/components/auth'
      fullPath: '/design/components/auth'
      preLoaderRoute: typeof AppDesignComponentsAuthRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/design/components/animations': {
      id: '/_app/design/components/animations'
      path: '/components/animations'
      fullPath: '/design/components/animations'
      preLoaderRoute: typeof AppDesignComponentsAnimationsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/business/leads/new': {
      id: '/_app/business/leads/new'
      path: '/new'
      fullPath: '/business/leads/new'
      preLoaderRoute: typeof AppBusinessLeadsNewRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/builder/schedules/new': {
      id: '/_app/builder/schedules/new'
      path: '/schedules/new'
      fullPath: '/builder/schedules/new'
      preLoaderRoute: typeof AppBuilderSchedulesNewRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/schedules/$scheduleId': {
      id: '/_app/builder/schedules/$scheduleId'
      path: '/schedules/$scheduleId'
      fullPath: '/builder/schedules/$scheduleId'
      preLoaderRoute: typeof AppBuilderSchedulesScheduleIdRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/forms/new': {
      id: '/_app/builder/forms/new'
      path: '/forms/new'
      fullPath: '/builder/forms/new'
      preLoaderRoute: typeof AppBuilderFormsNewRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/dictionaries/$dictionaryId': {
      id: '/_app/builder/dictionaries/$dictionaryId'
      path: '/dictionaries/$dictionaryId'
      fullPath: '/builder/dictionaries/$dictionaryId'
      preLoaderRoute: typeof AppBuilderDictionariesDictionaryIdRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/consents/$consentBodyId': {
      id: '/_app/builder/consents/$consentBodyId'
      path: '/consents/$consentBodyId'
      fullPath: '/builder/consents/$consentBodyId'
      preLoaderRoute: typeof AppBuilderConsentsConsentBodyIdRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/admin/user/$userId': {
      id: '/_app/admin/user/$userId'
      path: '/user/$userId'
      fullPath: '/admin/user/$userId'
      preLoaderRoute: typeof AppAdminUserUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/sftp/upload': {
      id: '/_app/admin/sftp/upload'
      path: '/upload'
      fullPath: '/admin/sftp/upload'
      preLoaderRoute: typeof AppAdminSftpUploadRouteImport
      parentRoute: typeof AppAdminSftpRouteRoute
    }
    '/_app/admin/sftp/preview': {
      id: '/_app/admin/sftp/preview'
      path: '/preview'
      fullPath: '/admin/sftp/preview'
      preLoaderRoute: typeof AppAdminSftpPreviewRouteImport
      parentRoute: typeof AppAdminSftpRouteRoute
    }
    '/_app/admin/sftp/organisations': {
      id: '/_app/admin/sftp/organisations'
      path: '/organisations'
      fullPath: '/admin/sftp/organisations'
      preLoaderRoute: typeof AppAdminSftpOrganisationsRouteImport
      parentRoute: typeof AppAdminSftpRouteRoute
    }
    '/_app/admin/sftp/explorer': {
      id: '/_app/admin/sftp/explorer'
      path: '/explorer'
      fullPath: '/admin/sftp/explorer'
      preLoaderRoute: typeof AppAdminSftpExplorerRouteImport
      parentRoute: typeof AppAdminSftpRouteRoute
    }
    '/_app/admin/sftp/diaries': {
      id: '/_app/admin/sftp/diaries'
      path: '/diaries'
      fullPath: '/admin/sftp/diaries'
      preLoaderRoute: typeof AppAdminSftpDiariesRouteImport
      parentRoute: typeof AppAdminSftpRouteRoute
    }
    '/_app/admin/sftp/dashboard': {
      id: '/_app/admin/sftp/dashboard'
      path: '/dashboard'
      fullPath: '/admin/sftp/dashboard'
      preLoaderRoute: typeof AppAdminSftpDashboardRouteImport
      parentRoute: typeof AppAdminSftpRouteRoute
    }
    '/_app/admin/organisation/statistics': {
      id: '/_app/admin/organisation/statistics'
      path: '/statistics'
      fullPath: '/admin/organisation/statistics'
      preLoaderRoute: typeof AppAdminOrganisationStatisticsRouteImport
      parentRoute: typeof AppAdminOrganisationRouteRoute
    }
    '/_app/admin/organisation/logos': {
      id: '/_app/admin/organisation/logos'
      path: '/logos'
      fullPath: '/admin/organisation/logos'
      preLoaderRoute: typeof AppAdminOrganisationLogosRouteImport
      parentRoute: typeof AppAdminOrganisationRouteRoute
    }
    '/_app/admin/organisation/add': {
      id: '/_app/admin/organisation/add'
      path: '/add'
      fullPath: '/admin/organisation/add'
      preLoaderRoute: typeof AppAdminOrganisationAddRouteImport
      parentRoute: typeof AppAdminOrganisationRouteRoute
    }
    '/_app/admin/diaries/types': {
      id: '/_app/admin/diaries/types'
      path: '/diaries/types'
      fullPath: '/admin/diaries/types'
      preLoaderRoute: typeof AppAdminDiariesTypesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/clinicians/statistics': {
      id: '/_app/admin/clinicians/statistics'
      path: '/clinicians/statistics'
      fullPath: '/admin/clinicians/statistics'
      preLoaderRoute: typeof AppAdminCliniciansStatisticsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/clinicians/photos': {
      id: '/_app/admin/clinicians/photos'
      path: '/clinicians/photos'
      fullPath: '/admin/clinicians/photos'
      preLoaderRoute: typeof AppAdminCliniciansPhotosRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/clinicians/leaderboard': {
      id: '/_app/admin/clinicians/leaderboard'
      path: '/clinicians/leaderboard'
      fullPath: '/admin/clinicians/leaderboard'
      preLoaderRoute: typeof AppAdminCliniciansLeaderboardRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/business/churn': {
      id: '/_app/admin/business/churn'
      path: '/business/churn'
      fullPath: '/admin/business/churn'
      preLoaderRoute: typeof AppAdminBusinessChurnRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/business/ambassadors': {
      id: '/_app/admin/business/ambassadors'
      path: '/business/ambassadors'
      fullPath: '/admin/business/ambassadors'
      preLoaderRoute: typeof AppAdminBusinessAmbassadorsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit/snapshot': {
      id: '/_app/admin/audit/snapshot'
      path: '/snapshot'
      fullPath: '/admin/audit/snapshot'
      preLoaderRoute: typeof AppAdminAuditSnapshotRouteImport
      parentRoute: typeof AppAdminAuditRouteRoute
    }
    '/_app/admin/audit/lock-diaries': {
      id: '/_app/admin/audit/lock-diaries'
      path: '/lock-diaries'
      fullPath: '/admin/audit/lock-diaries'
      preLoaderRoute: typeof AppAdminAuditLockDiariesRouteImport
      parentRoute: typeof AppAdminAuditRouteRoute
    }
    '/_app/admin/audit/change-timeline': {
      id: '/_app/admin/audit/change-timeline'
      path: '/change-timeline'
      fullPath: '/admin/audit/change-timeline'
      preLoaderRoute: typeof AppAdminAuditChangeTimelineRouteImport
      parentRoute: typeof AppAdminAuditRouteRoute
    }
    '/_app/admin/access/users': {
      id: '/_app/admin/access/users'
      path: '/users'
      fullPath: '/admin/access/users'
      preLoaderRoute: typeof AppAdminAccessUsersRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/access/tabs': {
      id: '/_app/admin/access/tabs'
      path: '/tabs'
      fullPath: '/admin/access/tabs'
      preLoaderRoute: typeof AppAdminAccessTabsRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/access/studies': {
      id: '/_app/admin/access/studies'
      path: '/studies'
      fullPath: '/admin/access/studies'
      preLoaderRoute: typeof AppAdminAccessStudiesRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/access/schedules': {
      id: '/_app/admin/access/schedules'
      path: '/schedules'
      fullPath: '/admin/access/schedules'
      preLoaderRoute: typeof AppAdminAccessSchedulesRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/access/roles': {
      id: '/_app/admin/access/roles'
      path: '/roles'
      fullPath: '/admin/access/roles'
      preLoaderRoute: typeof AppAdminAccessRolesRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/access/labels': {
      id: '/_app/admin/access/labels'
      path: '/labels'
      fullPath: '/admin/access/labels'
      preLoaderRoute: typeof AppAdminAccessLabelsRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/access/forms': {
      id: '/_app/admin/access/forms'
      path: '/forms'
      fullPath: '/admin/access/forms'
      preLoaderRoute: typeof AppAdminAccessFormsRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/access/$attribute': {
      id: '/_app/admin/access/$attribute'
      path: '/$attribute'
      fullPath: '/admin/access/$attribute'
      preLoaderRoute: typeof AppAdminAccessAttributeRouteImport
      parentRoute: typeof AppAdminAccessRouteRoute
    }
    '/_app/admin/business/leads': {
      id: '/_app/admin/business/leads'
      path: '/business/leads'
      fullPath: '/admin/business/leads'
      preLoaderRoute: typeof AppAdminBusinessLeadsRouteRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/tracker/$trackerId/form/$formId/': {
      id: '/tracker/$trackerId/form/$formId/'
      path: '/tracker/$trackerId/form/$formId'
      fullPath: '/tracker/$trackerId/form/$formId/'
      preLoaderRoute: typeof TrackerTrackerIdFormFormIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$formId/page/$pageIndex/': {
      id: '/forms/$formId/page/$pageIndex/'
      path: '/forms/$formId/page/$pageIndex'
      fullPath: '/forms/$formId/page/$pageIndex/'
      preLoaderRoute: typeof FormsFormIdPagePageIndexIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/templates/$templateId/events/': {
      id: '/_app/templates/$templateId/events/'
      path: '/events'
      fullPath: '/templates/$templateId/events/'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsIndexRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/studies/$studyId/invite/': {
      id: '/_app/studies/$studyId/invite/'
      path: '/invite'
      fullPath: '/studies/$studyId/invite/'
      preLoaderRoute: typeof AppStudiesStudyIdInviteIndexRouteImport
      parentRoute: typeof AppStudiesStudyIdRoute
    }
    '/_app/sales/leads/touches/': {
      id: '/_app/sales/leads/touches/'
      path: '/touches'
      fullPath: '/sales/leads/touches/'
      preLoaderRoute: typeof AppSalesLeadsTouchesIndexRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/templates/': {
      id: '/_app/sales/leads/templates/'
      path: '/templates'
      fullPath: '/sales/leads/templates/'
      preLoaderRoute: typeof AppSalesLeadsTemplatesIndexRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/companies/': {
      id: '/_app/sales/leads/companies/'
      path: '/companies'
      fullPath: '/sales/leads/companies/'
      preLoaderRoute: typeof AppSalesLeadsCompaniesIndexRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/artifacts/': {
      id: '/_app/sales/leads/artifacts/'
      path: '/artifacts'
      fullPath: '/sales/leads/artifacts/'
      preLoaderRoute: typeof AppSalesLeadsArtifactsIndexRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/$leadId/': {
      id: '/_app/sales/leads/$leadId/'
      path: '/$leadId'
      fullPath: '/sales/leads/$leadId/'
      preLoaderRoute: typeof AppSalesLeadsLeadIdIndexRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/patients/bulk/events/': {
      id: '/_app/patients/bulk/events/'
      path: '/'
      fullPath: '/patients/bulk/events/'
      preLoaderRoute: typeof AppPatientsBulkEventsIndexRouteImport
      parentRoute: typeof AppPatientsBulkEventsRoute
    }
    '/_app/diaries/$diaryId/home/': {
      id: '/_app/diaries/$diaryId/home/'
      path: '/'
      fullPath: '/diaries/$diaryId/home/'
      preLoaderRoute: typeof AppDiariesDiaryIdHomeIndexRouteImport
      parentRoute: typeof AppDiariesDiaryIdHomeRoute
    }
    '/_app/design/forms/pages/': {
      id: '/_app/design/forms/pages/'
      path: '/'
      fullPath: '/design/forms/pages/'
      preLoaderRoute: typeof AppDesignFormsPagesIndexRouteImport
      parentRoute: typeof AppDesignFormsPagesRoute
    }
    '/_app/design/features/worklist/': {
      id: '/_app/design/features/worklist/'
      path: '/features/worklist'
      fullPath: '/design/features/worklist/'
      preLoaderRoute: typeof AppDesignFeaturesWorklistIndexRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/business/leads/touches/': {
      id: '/_app/business/leads/touches/'
      path: '/touches'
      fullPath: '/business/leads/touches/'
      preLoaderRoute: typeof AppBusinessLeadsTouchesIndexRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/templates/': {
      id: '/_app/business/leads/templates/'
      path: '/templates'
      fullPath: '/business/leads/templates/'
      preLoaderRoute: typeof AppBusinessLeadsTemplatesIndexRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/companies/': {
      id: '/_app/business/leads/companies/'
      path: '/companies'
      fullPath: '/business/leads/companies/'
      preLoaderRoute: typeof AppBusinessLeadsCompaniesIndexRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/artifacts/': {
      id: '/_app/business/leads/artifacts/'
      path: '/artifacts'
      fullPath: '/business/leads/artifacts/'
      preLoaderRoute: typeof AppBusinessLeadsArtifactsIndexRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/$leadId/': {
      id: '/_app/business/leads/$leadId/'
      path: '/$leadId'
      fullPath: '/business/leads/$leadId/'
      preLoaderRoute: typeof AppBusinessLeadsLeadIdIndexRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/builder/forms/$formId/': {
      id: '/_app/builder/forms/$formId/'
      path: '/forms/$formId'
      fullPath: '/builder/forms/$formId/'
      preLoaderRoute: typeof AppBuilderFormsFormIdIndexRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/admin/entry/$entryId/': {
      id: '/_app/admin/entry/$entryId/'
      path: '/entry/$entryId'
      fullPath: '/admin/entry/$entryId/'
      preLoaderRoute: typeof AppAdminEntryEntryIdIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/diaries/$diaryId/': {
      id: '/_app/admin/diaries/$diaryId/'
      path: '/diaries/$diaryId'
      fullPath: '/admin/diaries/$diaryId/'
      preLoaderRoute: typeof AppAdminDiariesDiaryIdIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/business/leads/': {
      id: '/_app/admin/business/leads/'
      path: '/'
      fullPath: '/admin/business/leads/'
      preLoaderRoute: typeof AppAdminBusinessLeadsIndexRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/screen/$screenerId/$entryId/page/$pageIndex': {
      id: '/screen/$screenerId/$entryId/page/$pageIndex'
      path: '/screen/$screenerId/$entryId/page/$pageIndex'
      fullPath: '/screen/$screenerId/$entryId/page/$pageIndex'
      preLoaderRoute: typeof ScreenScreenerIdEntryIdPagePageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/worklist/consent/$diaryId/$consentId': {
      id: '/_app/worklist/consent/$diaryId/$consentId'
      path: '/consent/$diaryId/$consentId'
      fullPath: '/worklist/consent/$diaryId/$consentId'
      preLoaderRoute: typeof AppWorklistConsentDiaryIdConsentIdRouteImport
      parentRoute: typeof AppWorklistRoute
    }
    '/_app/validate/change-trail/$entityType/$entityId': {
      id: '/_app/validate/change-trail/$entityType/$entityId'
      path: '/validate/change-trail/$entityType/$entityId'
      fullPath: '/validate/change-trail/$entityType/$entityId'
      preLoaderRoute: typeof AppValidateChangeTrailEntityTypeEntityIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/studies/$studyId/invite/qr': {
      id: '/_app/studies/$studyId/invite/qr'
      path: '/invite/qr'
      fullPath: '/studies/$studyId/invite/qr'
      preLoaderRoute: typeof AppStudiesStudyIdInviteQrRouteImport
      parentRoute: typeof AppStudiesStudyIdRoute
    }
    '/_app/sales/leads/touches/$touchId': {
      id: '/_app/sales/leads/touches/$touchId'
      path: '/touches/$touchId'
      fullPath: '/sales/leads/touches/$touchId'
      preLoaderRoute: typeof AppSalesLeadsTouchesTouchIdRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/templates/new': {
      id: '/_app/sales/leads/templates/new'
      path: '/templates/new'
      fullPath: '/sales/leads/templates/new'
      preLoaderRoute: typeof AppSalesLeadsTemplatesNewRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/templates/$templateId': {
      id: '/_app/sales/leads/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/sales/leads/templates/$templateId'
      preLoaderRoute: typeof AppSalesLeadsTemplatesTemplateIdRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/companies/new': {
      id: '/_app/sales/leads/companies/new'
      path: '/companies/new'
      fullPath: '/sales/leads/companies/new'
      preLoaderRoute: typeof AppSalesLeadsCompaniesNewRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/companies/$companyId': {
      id: '/_app/sales/leads/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/sales/leads/companies/$companyId'
      preLoaderRoute: typeof AppSalesLeadsCompaniesCompanyIdRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/artifacts/new': {
      id: '/_app/sales/leads/artifacts/new'
      path: '/artifacts/new'
      fullPath: '/sales/leads/artifacts/new'
      preLoaderRoute: typeof AppSalesLeadsArtifactsNewRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/leads/artifacts/$artifactId': {
      id: '/_app/sales/leads/artifacts/$artifactId'
      path: '/artifacts/$artifactId'
      fullPath: '/sales/leads/artifacts/$artifactId'
      preLoaderRoute: typeof AppSalesLeadsArtifactsArtifactIdRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/patients/bulk/events/$eventType': {
      id: '/_app/patients/bulk/events/$eventType'
      path: '/$eventType'
      fullPath: '/patients/bulk/events/$eventType'
      preLoaderRoute: typeof AppPatientsBulkEventsEventTypeRouteImport
      parentRoute: typeof AppPatientsBulkEventsRoute
    }
    '/_app/patients/$diaryId/update/templates': {
      id: '/_app/patients/$diaryId/update/templates'
      path: '/update/templates'
      fullPath: '/patients/$diaryId/update/templates'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateTemplatesRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/template-existing-trackers': {
      id: '/_app/patients/$diaryId/update/template-existing-trackers'
      path: '/update/template-existing-trackers'
      fullPath: '/patients/$diaryId/update/template-existing-trackers'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateTemplateExistingTrackersRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/review': {
      id: '/_app/patients/$diaryId/update/review'
      path: '/update/review'
      fullPath: '/patients/$diaryId/update/review'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateReviewRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/from-template': {
      id: '/_app/patients/$diaryId/update/from-template'
      path: '/update/from-template'
      fullPath: '/patients/$diaryId/update/from-template'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateFromTemplateRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/existing-trackers': {
      id: '/_app/patients/$diaryId/update/existing-trackers'
      path: '/update/existing-trackers'
      fullPath: '/patients/$diaryId/update/existing-trackers'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateExistingTrackersRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/consent': {
      id: '/_app/patients/$diaryId/update/consent'
      path: '/update/consent'
      fullPath: '/patients/$diaryId/update/consent'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateConsentRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/add': {
      id: '/_app/patients/$diaryId/update/add'
      path: '/update/add'
      fullPath: '/patients/$diaryId/update/add'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateAddRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/consent/$consentId': {
      id: '/_app/patients/$diaryId/consent/$consentId'
      path: '/consent/$consentId'
      fullPath: '/patients/$diaryId/consent/$consentId'
      preLoaderRoute: typeof AppPatientsDiaryIdConsentConsentIdRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/action/$actionId': {
      id: '/_app/patients/$diaryId/action/$actionId'
      path: '/action/$actionId'
      fullPath: '/patients/$diaryId/action/$actionId'
      preLoaderRoute: typeof AppPatientsDiaryIdActionActionIdRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/upload': {
      id: '/_app/foot-watch/$diaryId/new/upload'
      path: '/new/upload'
      fullPath: '/foot-watch/$diaryId/new/upload'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/start': {
      id: '/_app/foot-watch/$diaryId/new/start'
      path: '/new/start'
      fullPath: '/foot-watch/$diaryId/new/start'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewStartRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/select-patient': {
      id: '/_app/foot-watch/$diaryId/new/select-patient'
      path: '/new/select-patient'
      fullPath: '/foot-watch/$diaryId/new/select-patient'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewSelectPatientRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/new-patient': {
      id: '/_app/foot-watch/$diaryId/new/new-patient'
      path: '/new/new-patient'
      fullPath: '/foot-watch/$diaryId/new/new-patient'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewNewPatientRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/instructions': {
      id: '/_app/foot-watch/$diaryId/new/instructions'
      path: '/new/instructions'
      fullPath: '/foot-watch/$diaryId/new/instructions'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewInstructionsRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/camera': {
      id: '/_app/foot-watch/$diaryId/new/camera'
      path: '/new/camera'
      fullPath: '/foot-watch/$diaryId/new/camera'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewCameraRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/add-photos': {
      id: '/_app/foot-watch/$diaryId/new/add-photos'
      path: '/new/add-photos'
      fullPath: '/foot-watch/$diaryId/new/add-photos'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewAddPhotosRouteImport
      parentRoute: typeof AppFootWatchDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/edit/name': {
      id: '/_app/foot-watch/$diaryId/edit/name'
      path: '/name'
      fullPath: '/foot-watch/$diaryId/edit/name'
      preLoaderRoute: typeof AppFootWatchDiaryIdEditNameRouteImport
      parentRoute: typeof AppFootWatchDiaryIdEditRoute
    }
    '/_app/foot-watch/$diaryId/edit/diary': {
      id: '/_app/foot-watch/$diaryId/edit/diary'
      path: '/diary'
      fullPath: '/foot-watch/$diaryId/edit/diary'
      preLoaderRoute: typeof AppFootWatchDiaryIdEditDiaryRouteImport
      parentRoute: typeof AppFootWatchDiaryIdEditRoute
    }
    '/_app/foot-watch/$diaryId/_view/progress': {
      id: '/_app/foot-watch/$diaryId/_view/progress'
      path: '/progress'
      fullPath: '/foot-watch/$diaryId/progress'
      preLoaderRoute: typeof AppFootWatchDiaryIdViewProgressRouteImport
      parentRoute: typeof AppFootWatchDiaryIdViewRoute
    }
    '/_app/foot-watch/$diaryId/_view/new': {
      id: '/_app/foot-watch/$diaryId/_view/new'
      path: '/new'
      fullPath: '/foot-watch/$diaryId/new'
      preLoaderRoute: typeof AppFootWatchDiaryIdViewNewRouteImport
      parentRoute: typeof AppFootWatchDiaryIdViewRoute
    }
    '/_app/foot-watch/$diaryId/_view/history': {
      id: '/_app/foot-watch/$diaryId/_view/history'
      path: '/history'
      fullPath: '/foot-watch/$diaryId/history'
      preLoaderRoute: typeof AppFootWatchDiaryIdViewHistoryRouteImport
      parentRoute: typeof AppFootWatchDiaryIdViewRoute
    }
    '/_app/diaries/$diaryId/setup/side': {
      id: '/_app/diaries/$diaryId/setup/side'
      path: '/side'
      fullPath: '/diaries/$diaryId/setup/side'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupSideRouteImport
      parentRoute: typeof AppDiariesDiaryIdSetupRoute
    }
    '/_app/diaries/$diaryId/setup/reference-date': {
      id: '/_app/diaries/$diaryId/setup/reference-date'
      path: '/reference-date'
      fullPath: '/diaries/$diaryId/setup/reference-date'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupReferenceDateRouteImport
      parentRoute: typeof AppDiariesDiaryIdSetupRoute
    }
    '/_app/diaries/$diaryId/setup/hospital-number': {
      id: '/_app/diaries/$diaryId/setup/hospital-number'
      path: '/hospital-number'
      fullPath: '/diaries/$diaryId/setup/hospital-number'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupHospitalNumberRouteImport
      parentRoute: typeof AppDiariesDiaryIdSetupRoute
    }
    '/_app/diaries/$diaryId/setup/complete': {
      id: '/_app/diaries/$diaryId/setup/complete'
      path: '/complete'
      fullPath: '/diaries/$diaryId/setup/complete'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupCompleteRouteImport
      parentRoute: typeof AppDiariesDiaryIdSetupRoute
    }
    '/_app/diaries/$diaryId/home/to-do': {
      id: '/_app/diaries/$diaryId/home/to-do'
      path: '/to-do'
      fullPath: '/diaries/$diaryId/home/to-do'
      preLoaderRoute: typeof AppDiariesDiaryIdHomeToDoRouteImport
      parentRoute: typeof AppDiariesDiaryIdHomeRoute
    }
    '/_app/diaries/$diaryId/home/results': {
      id: '/_app/diaries/$diaryId/home/results'
      path: '/results'
      fullPath: '/diaries/$diaryId/home/results'
      preLoaderRoute: typeof AppDiariesDiaryIdHomeResultsRouteImport
      parentRoute: typeof AppDiariesDiaryIdHomeRoute
    }
    '/_app/diaries/$diaryId/home/progress': {
      id: '/_app/diaries/$diaryId/home/progress'
      path: '/progress'
      fullPath: '/diaries/$diaryId/home/progress'
      preLoaderRoute: typeof AppDiariesDiaryIdHomeProgressRouteImport
      parentRoute: typeof AppDiariesDiaryIdHomeRoute
    }
    '/_app/diaries/$diaryId/home/forms': {
      id: '/_app/diaries/$diaryId/home/forms'
      path: '/forms'
      fullPath: '/diaries/$diaryId/home/forms'
      preLoaderRoute: typeof AppDiariesDiaryIdHomeFormsRouteImport
      parentRoute: typeof AppDiariesDiaryIdHomeRoute
    }
    '/_app/diaries/$diaryId/home/edit': {
      id: '/_app/diaries/$diaryId/home/edit'
      path: '/edit'
      fullPath: '/diaries/$diaryId/home/edit'
      preLoaderRoute: typeof AppDiariesDiaryIdHomeEditRouteImport
      parentRoute: typeof AppDiariesDiaryIdHomeRoute
    }
    '/_app/design/forms/pages/$screen': {
      id: '/_app/design/forms/pages/$screen'
      path: '/$screen'
      fullPath: '/design/forms/pages/$screen'
      preLoaderRoute: typeof AppDesignFormsPagesScreenRouteImport
      parentRoute: typeof AppDesignFormsPagesRoute
    }
    '/_app/design/features/worklist/automations': {
      id: '/_app/design/features/worklist/automations'
      path: '/features/worklist/automations'
      fullPath: '/design/features/worklist/automations'
      preLoaderRoute: typeof AppDesignFeaturesWorklistAutomationsRouteImport
      parentRoute: typeof AppDesignRoute
    }
    '/_app/business/leads/touches/$touchId': {
      id: '/_app/business/leads/touches/$touchId'
      path: '/touches/$touchId'
      fullPath: '/business/leads/touches/$touchId'
      preLoaderRoute: typeof AppBusinessLeadsTouchesTouchIdRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/templates/new': {
      id: '/_app/business/leads/templates/new'
      path: '/templates/new'
      fullPath: '/business/leads/templates/new'
      preLoaderRoute: typeof AppBusinessLeadsTemplatesNewRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/templates/$templateId': {
      id: '/_app/business/leads/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/business/leads/templates/$templateId'
      preLoaderRoute: typeof AppBusinessLeadsTemplatesTemplateIdRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/companies/new': {
      id: '/_app/business/leads/companies/new'
      path: '/companies/new'
      fullPath: '/business/leads/companies/new'
      preLoaderRoute: typeof AppBusinessLeadsCompaniesNewRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/companies/$companyId': {
      id: '/_app/business/leads/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/business/leads/companies/$companyId'
      preLoaderRoute: typeof AppBusinessLeadsCompaniesCompanyIdRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/artifacts/new': {
      id: '/_app/business/leads/artifacts/new'
      path: '/artifacts/new'
      fullPath: '/business/leads/artifacts/new'
      preLoaderRoute: typeof AppBusinessLeadsArtifactsNewRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/business/leads/artifacts/$artifactId': {
      id: '/_app/business/leads/artifacts/$artifactId'
      path: '/artifacts/$artifactId'
      fullPath: '/business/leads/artifacts/$artifactId'
      preLoaderRoute: typeof AppBusinessLeadsArtifactsArtifactIdRouteImport
      parentRoute: typeof AppBusinessLeadsRouteRoute
    }
    '/_app/builder/schedules/forms/formId': {
      id: '/_app/builder/schedules/forms/formId'
      path: '/schedules/forms/formId'
      fullPath: '/builder/schedules/forms/formId'
      preLoaderRoute: typeof AppBuilderSchedulesFormsFormIdRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/forms/$formId/metadata': {
      id: '/_app/builder/forms/$formId/metadata'
      path: '/forms/$formId/metadata'
      fullPath: '/builder/forms/$formId/metadata'
      preLoaderRoute: typeof AppBuilderFormsFormIdMetadataRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/builder/forms/$formId/$tab': {
      id: '/_app/builder/forms/$formId/$tab'
      path: '/forms/$formId/$tab'
      fullPath: '/builder/forms/$formId/$tab'
      preLoaderRoute: typeof AppBuilderFormsFormIdTabRouteImport
      parentRoute: typeof AppBuilderRoute
    }
    '/_app/admin/form/$formId/results': {
      id: '/_app/admin/form/$formId/results'
      path: '/form/$formId/results'
      fullPath: '/admin/form/$formId/results'
      preLoaderRoute: typeof AppAdminFormFormIdResultsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/business/leads/new': {
      id: '/_app/admin/business/leads/new'
      path: '/new'
      fullPath: '/admin/business/leads/new'
      preLoaderRoute: typeof AppAdminBusinessLeadsNewRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/preview/patient/$patientId/diary/$diaryId/': {
      id: '/preview/patient/$patientId/diary/$diaryId/'
      path: '/patient/$patientId/diary/$diaryId'
      fullPath: '/preview/patient/$patientId/diary/$diaryId/'
      preLoaderRoute: typeof PreviewPatientPatientIdDiaryDiaryIdIndexRouteImport
      parentRoute: typeof PreviewRoute
    }
    '/_app/validate/$validationId/forms/$formId/': {
      id: '/_app/validate/$validationId/forms/$formId/'
      path: '/forms/$formId'
      fullPath: '/validate/$validationId/forms/$formId/'
      preLoaderRoute: typeof AppValidateValidationIdFormsFormIdIndexRouteImport
      parentRoute: typeof AppValidateValidationIdRoute
    }
    '/_app/templates/$templateId/events/surgery/': {
      id: '/_app/templates/$templateId/events/surgery/'
      path: '/events/surgery'
      fullPath: '/templates/$templateId/events/surgery/'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsSurgeryIndexRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/events/shockwave/': {
      id: '/_app/templates/$templateId/events/shockwave/'
      path: '/events/shockwave'
      fullPath: '/templates/$templateId/events/shockwave/'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsShockwaveIndexRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/events/product/': {
      id: '/_app/templates/$templateId/events/product/'
      path: '/events/product'
      fullPath: '/templates/$templateId/events/product/'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsProductIndexRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/events/injection/': {
      id: '/_app/templates/$templateId/events/injection/'
      path: '/events/injection'
      fullPath: '/templates/$templateId/events/injection/'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsInjectionIndexRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/events/education/': {
      id: '/_app/templates/$templateId/events/education/'
      path: '/events/education'
      fullPath: '/templates/$templateId/events/education/'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsEducationIndexRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/patients/$diaryId/consent/$consentId/': {
      id: '/_app/patients/$diaryId/consent/$consentId/'
      path: '/'
      fullPath: '/patients/$diaryId/consent/$consentId/'
      preLoaderRoute: typeof AppPatientsDiaryIdConsentConsentIdIndexRouteImport
      parentRoute: typeof AppPatientsDiaryIdConsentConsentIdRoute
    }
    '/_app/foot-watch/new-diary/$patientId/$diaryId/': {
      id: '/_app/foot-watch/new-diary/$patientId/$diaryId/'
      path: '/foot-watch/new-diary/$patientId/$diaryId'
      fullPath: '/foot-watch/new-diary/$patientId/$diaryId/'
      preLoaderRoute: typeof AppFootWatchNewDiaryPatientIdDiaryIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/foot-watch/$diaryId/new/upload/': {
      id: '/_app/foot-watch/$diaryId/new/upload/'
      path: '/'
      fullPath: '/foot-watch/$diaryId/new/upload/'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadIndexRouteImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadRoute
    }
    '/_app/admin/business/leads/touches/': {
      id: '/_app/admin/business/leads/touches/'
      path: '/touches'
      fullPath: '/admin/business/leads/touches/'
      preLoaderRoute: typeof AppAdminBusinessLeadsTouchesIndexRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/templates/': {
      id: '/_app/admin/business/leads/templates/'
      path: '/templates'
      fullPath: '/admin/business/leads/templates/'
      preLoaderRoute: typeof AppAdminBusinessLeadsTemplatesIndexRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/companies/': {
      id: '/_app/admin/business/leads/companies/'
      path: '/companies'
      fullPath: '/admin/business/leads/companies/'
      preLoaderRoute: typeof AppAdminBusinessLeadsCompaniesIndexRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/artifacts/': {
      id: '/_app/admin/business/leads/artifacts/'
      path: '/artifacts'
      fullPath: '/admin/business/leads/artifacts/'
      preLoaderRoute: typeof AppAdminBusinessLeadsArtifactsIndexRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/$leadId/': {
      id: '/_app/admin/business/leads/$leadId/'
      path: '/$leadId'
      fullPath: '/admin/business/leads/$leadId/'
      preLoaderRoute: typeof AppAdminBusinessLeadsLeadIdIndexRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/validate/$validationId/forms/$formId/results': {
      id: '/_app/validate/$validationId/forms/$formId/results'
      path: '/forms/$formId/results'
      fullPath: '/validate/$validationId/forms/$formId/results'
      preLoaderRoute: typeof AppValidateValidationIdFormsFormIdResultsRouteImport
      parentRoute: typeof AppValidateValidationIdRoute
    }
    '/_app/templates/diary/_form/intervention/injection': {
      id: '/_app/templates/diary/_form/intervention/injection'
      path: '/diary/intervention/injection'
      fullPath: '/templates/diary/intervention/injection'
      preLoaderRoute: typeof AppTemplatesDiaryFormInterventionInjectionRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/$templateId/events/surgery/details': {
      id: '/_app/templates/$templateId/events/surgery/details'
      path: '/events/surgery/details'
      fullPath: '/templates/$templateId/events/surgery/details'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsSurgeryDetailsRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/events/shockwave/details': {
      id: '/_app/templates/$templateId/events/shockwave/details'
      path: '/events/shockwave/details'
      fullPath: '/templates/$templateId/events/shockwave/details'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsShockwaveDetailsRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/templates/$templateId/events/injection/details': {
      id: '/_app/templates/$templateId/events/injection/details'
      path: '/events/injection/details'
      fullPath: '/templates/$templateId/events/injection/details'
      preLoaderRoute: typeof AppTemplatesTemplateIdEventsInjectionDetailsRouteImport
      parentRoute: typeof AppTemplatesTemplateIdRoute
    }
    '/_app/patients/$diaryId/consent/$consentId/complete': {
      id: '/_app/patients/$diaryId/consent/$consentId/complete'
      path: '/complete'
      fullPath: '/patients/$diaryId/consent/$consentId/complete'
      preLoaderRoute: typeof AppPatientsDiaryIdConsentConsentIdCompleteRouteImport
      parentRoute: typeof AppPatientsDiaryIdConsentConsentIdRoute
    }
    '/_app/foot-watch/$diaryId/new/upload/uploading': {
      id: '/_app/foot-watch/$diaryId/new/upload/uploading'
      path: '/uploading'
      fullPath: '/foot-watch/$diaryId/new/upload/uploading'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadUploadingRouteImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadRoute
    }
    '/_app/foot-watch/$diaryId/new/upload/message': {
      id: '/_app/foot-watch/$diaryId/new/upload/message'
      path: '/message'
      fullPath: '/foot-watch/$diaryId/new/upload/message'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadMessageRouteImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadRoute
    }
    '/_app/foot-watch/$diaryId/new/upload/complete': {
      id: '/_app/foot-watch/$diaryId/new/upload/complete'
      path: '/complete'
      fullPath: '/foot-watch/$diaryId/new/upload/complete'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadCompleteRouteImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadRoute
    }
    '/_app/diaries/$diaryId/setup/consent/$consentId': {
      id: '/_app/diaries/$diaryId/setup/consent/$consentId'
      path: '/consent/$consentId'
      fullPath: '/diaries/$diaryId/setup/consent/$consentId'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdRouteImport
      parentRoute: typeof AppDiariesDiaryIdSetupRoute
    }
    '/_app/admin/business/leads/touches/$touchId': {
      id: '/_app/admin/business/leads/touches/$touchId'
      path: '/touches/$touchId'
      fullPath: '/admin/business/leads/touches/$touchId'
      preLoaderRoute: typeof AppAdminBusinessLeadsTouchesTouchIdRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/templates/new': {
      id: '/_app/admin/business/leads/templates/new'
      path: '/templates/new'
      fullPath: '/admin/business/leads/templates/new'
      preLoaderRoute: typeof AppAdminBusinessLeadsTemplatesNewRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/templates/$templateId': {
      id: '/_app/admin/business/leads/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/admin/business/leads/templates/$templateId'
      preLoaderRoute: typeof AppAdminBusinessLeadsTemplatesTemplateIdRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/companies/new': {
      id: '/_app/admin/business/leads/companies/new'
      path: '/companies/new'
      fullPath: '/admin/business/leads/companies/new'
      preLoaderRoute: typeof AppAdminBusinessLeadsCompaniesNewRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/companies/$companyId': {
      id: '/_app/admin/business/leads/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/admin/business/leads/companies/$companyId'
      preLoaderRoute: typeof AppAdminBusinessLeadsCompaniesCompanyIdRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/artifacts/new': {
      id: '/_app/admin/business/leads/artifacts/new'
      path: '/artifacts/new'
      fullPath: '/admin/business/leads/artifacts/new'
      preLoaderRoute: typeof AppAdminBusinessLeadsArtifactsNewRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/_app/admin/business/leads/artifacts/$artifactId': {
      id: '/_app/admin/business/leads/artifacts/$artifactId'
      path: '/artifacts/$artifactId'
      fullPath: '/admin/business/leads/artifacts/$artifactId'
      preLoaderRoute: typeof AppAdminBusinessLeadsArtifactsArtifactIdRouteImport
      parentRoute: typeof AppAdminBusinessLeadsRouteRoute
    }
    '/preview/radiology-report/patient/$patientId/event/$eventId/': {
      id: '/preview/radiology-report/patient/$patientId/event/$eventId/'
      path: '/radiology-report/patient/$patientId/event/$eventId'
      fullPath: '/preview/radiology-report/patient/$patientId/event/$eventId/'
      preLoaderRoute: typeof PreviewRadiologyReportPatientPatientIdEventEventIdIndexRouteImport
      parentRoute: typeof PreviewRoute
    }
    '/_app/templates/diary/$diaryId/trackers/$trackerId/': {
      id: '/_app/templates/diary/$diaryId/trackers/$trackerId/'
      path: '/diary/$diaryId/trackers/$trackerId'
      fullPath: '/templates/diary/$diaryId/trackers/$trackerId/'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/'
      path: '/diary/$diaryId/events/$eventId'
      fullPath: '/templates/diary/$diaryId/events/$eventId/'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/diaries/$diaryId/setup/consent/$consentId/': {
      id: '/_app/diaries/$diaryId/setup/consent/$consentId/'
      path: '/'
      fullPath: '/diaries/$diaryId/setup/consent/$consentId/'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdIndexRouteImport
      parentRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdRoute
    }
    '/_app/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind': {
      id: '/_app/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind'
      path: '/details/$diaryId/$eventId/$trackerId/$procedureKind'
      fullPath: '/worklist/details/$diaryId/$eventId/$trackerId/$procedureKind'
      preLoaderRoute: typeof AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRouteImport
      parentRoute: typeof AppWorklistRoute
    }
    '/_app/validate/$validationId/forms/$formId/page/$pageIndex': {
      id: '/_app/validate/$validationId/forms/$formId/page/$pageIndex'
      path: '/forms/$formId/page/$pageIndex'
      fullPath: '/validate/$validationId/forms/$formId/page/$pageIndex'
      preLoaderRoute: typeof AppValidateValidationIdFormsFormIdPagePageIndexRouteImport
      parentRoute: typeof AppValidateValidationIdRoute
    }
    '/_app/templates/diary/$diaryId/trackers/$trackerId/details': {
      id: '/_app/templates/diary/$diaryId/trackers/$trackerId/details'
      path: '/diary/$diaryId/trackers/$trackerId/details'
      fullPath: '/templates/diary/$diaryId/trackers/$trackerId/details'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/trackers/$trackerId/date': {
      id: '/_app/templates/diary/$diaryId/trackers/$trackerId/date'
      path: '/diary/$diaryId/trackers/$trackerId/date'
      fullPath: '/templates/diary/$diaryId/trackers/$trackerId/date'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/details': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/details'
      path: '/diary/$diaryId/events/$eventId/details'
      fullPath: '/templates/diary/$diaryId/events/$eventId/details'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdDetailsRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/complete': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/complete'
      path: '/diary/$diaryId/events/$eventId/complete'
      fullPath: '/templates/diary/$diaryId/events/$eventId/complete'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdCompleteRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/questionnaire': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/questionnaire'
      path: '/update/$eventId/$trackerId/questionnaire'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/questionnaire'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/message': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/message'
      path: '/update/$eventId/$trackerId/message'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/message'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention'
      path: '/update/$eventId/$trackerId/intervention'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/intervention'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/date': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/date'
      path: '/update/$eventId/$trackerId/date'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/date'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdDateRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/contact': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/contact'
      path: '/update/$eventId/$trackerId/contact'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/contact'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdContactRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/foot-watch/$diaryId/new/instructions/$angle/$side': {
      id: '/_app/foot-watch/$diaryId/new/instructions/$angle/$side'
      path: '/$angle/$side'
      fullPath: '/foot-watch/$diaryId/new/instructions/$angle/$side'
      preLoaderRoute: typeof AppFootWatchDiaryIdNewInstructionsAngleSideRouteImport
      parentRoute: typeof AppFootWatchDiaryIdNewInstructionsRoute
    }
    '/_app/diaries/$diaryId/setup/consent/$consentId/complete': {
      id: '/_app/diaries/$diaryId/setup/consent/$consentId/complete'
      path: '/complete'
      fullPath: '/diaries/$diaryId/setup/consent/$consentId/complete'
      preLoaderRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdCompleteRouteImport
      parentRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdRoute
    }
    '/tracker/$trackerId/form/$formId/entry/$entryId/page/': {
      id: '/tracker/$trackerId/form/$formId/entry/$entryId/page/'
      path: '/tracker/$trackerId/form/$formId/entry/$entryId/page'
      fullPath: '/tracker/$trackerId/form/$formId/entry/$entryId/page/'
      preLoaderRoute: typeof TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/': {
      id: '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/'
      path: '/patient/$patientId/diary/$diaryId/tracker/$trackerId'
      fullPath: '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/'
      preLoaderRoute: typeof PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRouteImport
      parentRoute: typeof PreviewRoute
    }
    '/_app/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex': {
      id: '/_app/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex'
      path: '/form/$diaryId/$trackerId/$entryId/page/$pageIndex'
      fullPath: '/worklist/form/$diaryId/$trackerId/$entryId/page/$pageIndex'
      preLoaderRoute: typeof AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRouteImport
      parentRoute: typeof AppWorklistRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery'
      path: '/update/$eventId/$trackerId/intervention-details/surgery'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/surgery'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave'
      path: '/update/$eventId/$trackerId/intervention-details/shockwave'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/shockwave'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product'
      path: '/update/$eventId/$trackerId/intervention-details/product'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/product'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection'
      path: '/update/$eventId/$trackerId/intervention-details/injection'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/injection'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education': {
      id: '/_app/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education'
      path: '/update/$eventId/$trackerId/intervention-details/education'
      fullPath: '/patients/$diaryId/update/$eventId/$trackerId/intervention-details/education'
      preLoaderRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete': {
      id: '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete'
      path: '/tracker/$trackerId/entry/$entryId/complete'
      fullPath: '/patients/$diaryId/tracker/$trackerId/entry/$entryId/complete'
      preLoaderRoute: typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete': {
      id: '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete'
      path: '/tracker/$trackerId/entry/$entryId/complete'
      fullPath: '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/complete'
      preLoaderRoute: typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId'
      path: '/new/tracker/$trackerId/entry/$entryId'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/': {
      id: '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/'
      path: '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex'
      fullPath: '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/'
      preLoaderRoute: typeof TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/'
      path: '/diary/$diaryId/events/$eventId/surgery/$surgeryId'
      fullPath: '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/'
      path: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId'
      fullPath: '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/product/$productId/': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/product/$productId/'
      path: '/diary/$diaryId/events/$eventId/product/$productId'
      fullPath: '/templates/diary/$diaryId/events/$eventId/product/$productId/'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/'
      path: '/diary/$diaryId/events/$eventId/injection/$injectionId'
      fullPath: '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/education/$educationId/': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/education/$educationId/'
      path: '/diary/$diaryId/events/$eventId/education/$educationId'
      fullPath: '/templates/diary/$diaryId/events/$eventId/education/$educationId/'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details'
      path: '/diary/$diaryId/events/$eventId/surgery/$surgeryId/details'
      fullPath: '/templates/diary/$diaryId/events/$eventId/surgery/$surgeryId/details'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details'
      path: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details'
      fullPath: '/templates/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details': {
      id: '/_app/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details'
      path: '/diary/$diaryId/events/$eventId/injection/$injectionId/details'
      fullPath: '/templates/diary/$diaryId/events/$eventId/injection/$injectionId/details'
      preLoaderRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRouteImport
      parentRoute: typeof AppTemplatesRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page'
      path: '/page'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete'
      path: '/complete'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute
    }
    '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete': {
      id: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete'
      path: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete'
      fullPath: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete'
      preLoaderRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/': {
      id: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/'
      path: '/'
      fullPath: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/'
      preLoaderRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRouteImport
      parentRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute
    }
    '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/': {
      id: '/_app/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
      path: '/tracker/$trackerId/entry/$entryId/page/$pageIndex'
      fullPath: '/patients/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
      preLoaderRoute: typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport
      parentRoute: typeof AppPatientsDiaryIdRoute
    }
    '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/': {
      id: '/_app/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
      path: '/tracker/$trackerId/entry/$entryId/page/$pageIndex'
      fullPath: '/diaries/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
      preLoaderRoute: typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport
      parentRoute: typeof AppDiariesDiaryIdRoute
    }
    '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex': {
      id: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
      path: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
      fullPath: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/page/$pageIndex'
      preLoaderRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews': {
      id: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews'
      path: '/reviews'
      fullPath: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/reviews'
      preLoaderRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRouteImport
      parentRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute
    }
    '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results': {
      id: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results'
      path: '/results'
      fullPath: '/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete/results'
      preLoaderRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRouteImport
      parentRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
      path: '/$pageIndex'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload'
      path: '/$pageIndex/foot-photos/upload'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start'
      path: '/$pageIndex/foot-photos/start'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient'
      path: '/$pageIndex/foot-photos/select-patient'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient'
      path: '/$pageIndex/foot-photos/new-patient'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions'
      path: '/$pageIndex/foot-photos/instructions'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera'
      path: '/$pageIndex/foot-photos/camera'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos'
      path: '/$pageIndex/foot-photos/add-photos'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/'
      path: '/'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading'
      path: '/uploading'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message'
      path: '/message'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete'
      path: '/complete'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side': {
      id: '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side'
      path: '/$angle/$side'
      fullPath: '/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side'
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRouteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute
    }
  }
}

interface AppUsersCreateUserRouteRouteChildren {
  AppUsersCreateUserAccessRoute: typeof AppUsersCreateUserAccessRoute
  AppUsersCreateUserBillingRoute: typeof AppUsersCreateUserBillingRoute
  AppUsersCreateUserDetailsRoute: typeof AppUsersCreateUserDetailsRoute
  AppUsersCreateUserImpersonateRoute: typeof AppUsersCreateUserImpersonateRoute
  AppUsersCreateUserOrganisationsRoute: typeof AppUsersCreateUserOrganisationsRoute
  AppUsersCreateUserTemplatesRoute: typeof AppUsersCreateUserTemplatesRoute
  AppUsersCreateUserIndexRoute: typeof AppUsersCreateUserIndexRoute
}

const AppUsersCreateUserRouteRouteChildren: AppUsersCreateUserRouteRouteChildren =
  {
    AppUsersCreateUserAccessRoute: AppUsersCreateUserAccessRoute,
    AppUsersCreateUserBillingRoute: AppUsersCreateUserBillingRoute,
    AppUsersCreateUserDetailsRoute: AppUsersCreateUserDetailsRoute,
    AppUsersCreateUserImpersonateRoute: AppUsersCreateUserImpersonateRoute,
    AppUsersCreateUserOrganisationsRoute: AppUsersCreateUserOrganisationsRoute,
    AppUsersCreateUserTemplatesRoute: AppUsersCreateUserTemplatesRoute,
    AppUsersCreateUserIndexRoute: AppUsersCreateUserIndexRoute,
  }

const AppUsersCreateUserRouteRouteWithChildren =
  AppUsersCreateUserRouteRoute._addFileChildren(
    AppUsersCreateUserRouteRouteChildren,
  )

interface AppUsersNotificationsRouteRouteChildren {
  AppUsersNotificationsSmsRoute: typeof AppUsersNotificationsSmsRoute
  AppUsersNotificationsIndexRoute: typeof AppUsersNotificationsIndexRoute
}

const AppUsersNotificationsRouteRouteChildren: AppUsersNotificationsRouteRouteChildren =
  {
    AppUsersNotificationsSmsRoute: AppUsersNotificationsSmsRoute,
    AppUsersNotificationsIndexRoute: AppUsersNotificationsIndexRoute,
  }

const AppUsersNotificationsRouteRouteWithChildren =
  AppUsersNotificationsRouteRoute._addFileChildren(
    AppUsersNotificationsRouteRouteChildren,
  )

interface AppUsersAdminsRouteChildren {
  AppUsersAdminsUserIdRoute: typeof AppUsersAdminsUserIdRoute
}

const AppUsersAdminsRouteChildren: AppUsersAdminsRouteChildren = {
  AppUsersAdminsUserIdRoute: AppUsersAdminsUserIdRoute,
}

const AppUsersAdminsRouteWithChildren = AppUsersAdminsRoute._addFileChildren(
  AppUsersAdminsRouteChildren,
)

interface AppUsersCliniciansRouteChildren {
  AppUsersCliniciansUserIdRoute: typeof AppUsersCliniciansUserIdRoute
}

const AppUsersCliniciansRouteChildren: AppUsersCliniciansRouteChildren = {
  AppUsersCliniciansUserIdRoute: AppUsersCliniciansUserIdRoute,
}

const AppUsersCliniciansRouteWithChildren =
  AppUsersCliniciansRoute._addFileChildren(AppUsersCliniciansRouteChildren)

interface AppUsersManagersRouteChildren {
  AppUsersManagersUserIdRoute: typeof AppUsersManagersUserIdRoute
}

const AppUsersManagersRouteChildren: AppUsersManagersRouteChildren = {
  AppUsersManagersUserIdRoute: AppUsersManagersUserIdRoute,
}

const AppUsersManagersRouteWithChildren =
  AppUsersManagersRoute._addFileChildren(AppUsersManagersRouteChildren)

interface AppUsersPatientsRouteChildren {
  AppUsersPatientsUserIdRoute: typeof AppUsersPatientsUserIdRoute
}

const AppUsersPatientsRouteChildren: AppUsersPatientsRouteChildren = {
  AppUsersPatientsUserIdRoute: AppUsersPatientsUserIdRoute,
}

const AppUsersPatientsRouteWithChildren =
  AppUsersPatientsRoute._addFileChildren(AppUsersPatientsRouteChildren)

interface AppUsersSecretariesRouteChildren {
  AppUsersSecretariesUserIdRoute: typeof AppUsersSecretariesUserIdRoute
}

const AppUsersSecretariesRouteChildren: AppUsersSecretariesRouteChildren = {
  AppUsersSecretariesUserIdRoute: AppUsersSecretariesUserIdRoute,
}

const AppUsersSecretariesRouteWithChildren =
  AppUsersSecretariesRoute._addFileChildren(AppUsersSecretariesRouteChildren)

interface AppUsersRouteRouteChildren {
  AppUsersCreateUserRouteRoute: typeof AppUsersCreateUserRouteRouteWithChildren
  AppUsersNotificationsRouteRoute: typeof AppUsersNotificationsRouteRouteWithChildren
  AppUsersAdminsRoute: typeof AppUsersAdminsRouteWithChildren
  AppUsersBillingRoute: typeof AppUsersBillingRoute
  AppUsersCliniciansRoute: typeof AppUsersCliniciansRouteWithChildren
  AppUsersManagersRoute: typeof AppUsersManagersRouteWithChildren
  AppUsersOrganisationsRoute: typeof AppUsersOrganisationsRoute
  AppUsersPatientsRoute: typeof AppUsersPatientsRouteWithChildren
  AppUsersPreferencesRoute: typeof AppUsersPreferencesRoute
  AppUsersSecretariesRoute: typeof AppUsersSecretariesRouteWithChildren
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppUsersRouteRouteChildren: AppUsersRouteRouteChildren = {
  AppUsersCreateUserRouteRoute: AppUsersCreateUserRouteRouteWithChildren,
  AppUsersNotificationsRouteRoute: AppUsersNotificationsRouteRouteWithChildren,
  AppUsersAdminsRoute: AppUsersAdminsRouteWithChildren,
  AppUsersBillingRoute: AppUsersBillingRoute,
  AppUsersCliniciansRoute: AppUsersCliniciansRouteWithChildren,
  AppUsersManagersRoute: AppUsersManagersRouteWithChildren,
  AppUsersOrganisationsRoute: AppUsersOrganisationsRoute,
  AppUsersPatientsRoute: AppUsersPatientsRouteWithChildren,
  AppUsersPreferencesRoute: AppUsersPreferencesRoute,
  AppUsersSecretariesRoute: AppUsersSecretariesRouteWithChildren,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppUsersRouteRouteWithChildren = AppUsersRouteRoute._addFileChildren(
  AppUsersRouteRouteChildren,
)

interface AppAdminAccessRouteRouteChildren {
  AppAdminAccessAttributeRoute: typeof AppAdminAccessAttributeRoute
  AppAdminAccessFormsRoute: typeof AppAdminAccessFormsRoute
  AppAdminAccessLabelsRoute: typeof AppAdminAccessLabelsRoute
  AppAdminAccessRolesRoute: typeof AppAdminAccessRolesRoute
  AppAdminAccessSchedulesRoute: typeof AppAdminAccessSchedulesRoute
  AppAdminAccessStudiesRoute: typeof AppAdminAccessStudiesRoute
  AppAdminAccessTabsRoute: typeof AppAdminAccessTabsRoute
  AppAdminAccessUsersRoute: typeof AppAdminAccessUsersRoute
  AppAdminAccessIndexRoute: typeof AppAdminAccessIndexRoute
}

const AppAdminAccessRouteRouteChildren: AppAdminAccessRouteRouteChildren = {
  AppAdminAccessAttributeRoute: AppAdminAccessAttributeRoute,
  AppAdminAccessFormsRoute: AppAdminAccessFormsRoute,
  AppAdminAccessLabelsRoute: AppAdminAccessLabelsRoute,
  AppAdminAccessRolesRoute: AppAdminAccessRolesRoute,
  AppAdminAccessSchedulesRoute: AppAdminAccessSchedulesRoute,
  AppAdminAccessStudiesRoute: AppAdminAccessStudiesRoute,
  AppAdminAccessTabsRoute: AppAdminAccessTabsRoute,
  AppAdminAccessUsersRoute: AppAdminAccessUsersRoute,
  AppAdminAccessIndexRoute: AppAdminAccessIndexRoute,
}

const AppAdminAccessRouteRouteWithChildren =
  AppAdminAccessRouteRoute._addFileChildren(AppAdminAccessRouteRouteChildren)

interface AppAdminAuditRouteRouteChildren {
  AppAdminAuditChangeTimelineRoute: typeof AppAdminAuditChangeTimelineRoute
  AppAdminAuditLockDiariesRoute: typeof AppAdminAuditLockDiariesRoute
  AppAdminAuditSnapshotRoute: typeof AppAdminAuditSnapshotRoute
  AppAdminAuditIndexRoute: typeof AppAdminAuditIndexRoute
}

const AppAdminAuditRouteRouteChildren: AppAdminAuditRouteRouteChildren = {
  AppAdminAuditChangeTimelineRoute: AppAdminAuditChangeTimelineRoute,
  AppAdminAuditLockDiariesRoute: AppAdminAuditLockDiariesRoute,
  AppAdminAuditSnapshotRoute: AppAdminAuditSnapshotRoute,
  AppAdminAuditIndexRoute: AppAdminAuditIndexRoute,
}

const AppAdminAuditRouteRouteWithChildren =
  AppAdminAuditRouteRoute._addFileChildren(AppAdminAuditRouteRouteChildren)

interface AppAdminOrganisationRouteRouteChildren {
  AppAdminOrganisationAddRoute: typeof AppAdminOrganisationAddRoute
  AppAdminOrganisationLogosRoute: typeof AppAdminOrganisationLogosRoute
  AppAdminOrganisationStatisticsRoute: typeof AppAdminOrganisationStatisticsRoute
  AppAdminOrganisationIndexRoute: typeof AppAdminOrganisationIndexRoute
}

const AppAdminOrganisationRouteRouteChildren: AppAdminOrganisationRouteRouteChildren =
  {
    AppAdminOrganisationAddRoute: AppAdminOrganisationAddRoute,
    AppAdminOrganisationLogosRoute: AppAdminOrganisationLogosRoute,
    AppAdminOrganisationStatisticsRoute: AppAdminOrganisationStatisticsRoute,
    AppAdminOrganisationIndexRoute: AppAdminOrganisationIndexRoute,
  }

const AppAdminOrganisationRouteRouteWithChildren =
  AppAdminOrganisationRouteRoute._addFileChildren(
    AppAdminOrganisationRouteRouteChildren,
  )

interface AppAdminSftpRouteRouteChildren {
  AppAdminSftpDashboardRoute: typeof AppAdminSftpDashboardRoute
  AppAdminSftpDiariesRoute: typeof AppAdminSftpDiariesRoute
  AppAdminSftpExplorerRoute: typeof AppAdminSftpExplorerRoute
  AppAdminSftpOrganisationsRoute: typeof AppAdminSftpOrganisationsRoute
  AppAdminSftpPreviewRoute: typeof AppAdminSftpPreviewRoute
  AppAdminSftpUploadRoute: typeof AppAdminSftpUploadRoute
  AppAdminSftpIndexRoute: typeof AppAdminSftpIndexRoute
}

const AppAdminSftpRouteRouteChildren: AppAdminSftpRouteRouteChildren = {
  AppAdminSftpDashboardRoute: AppAdminSftpDashboardRoute,
  AppAdminSftpDiariesRoute: AppAdminSftpDiariesRoute,
  AppAdminSftpExplorerRoute: AppAdminSftpExplorerRoute,
  AppAdminSftpOrganisationsRoute: AppAdminSftpOrganisationsRoute,
  AppAdminSftpPreviewRoute: AppAdminSftpPreviewRoute,
  AppAdminSftpUploadRoute: AppAdminSftpUploadRoute,
  AppAdminSftpIndexRoute: AppAdminSftpIndexRoute,
}

const AppAdminSftpRouteRouteWithChildren =
  AppAdminSftpRouteRoute._addFileChildren(AppAdminSftpRouteRouteChildren)

interface AppAdminBusinessLeadsRouteRouteChildren {
  AppAdminBusinessLeadsNewRoute: typeof AppAdminBusinessLeadsNewRoute
  AppAdminBusinessLeadsIndexRoute: typeof AppAdminBusinessLeadsIndexRoute
  AppAdminBusinessLeadsArtifactsArtifactIdRoute: typeof AppAdminBusinessLeadsArtifactsArtifactIdRoute
  AppAdminBusinessLeadsArtifactsNewRoute: typeof AppAdminBusinessLeadsArtifactsNewRoute
  AppAdminBusinessLeadsCompaniesCompanyIdRoute: typeof AppAdminBusinessLeadsCompaniesCompanyIdRoute
  AppAdminBusinessLeadsCompaniesNewRoute: typeof AppAdminBusinessLeadsCompaniesNewRoute
  AppAdminBusinessLeadsTemplatesTemplateIdRoute: typeof AppAdminBusinessLeadsTemplatesTemplateIdRoute
  AppAdminBusinessLeadsTemplatesNewRoute: typeof AppAdminBusinessLeadsTemplatesNewRoute
  AppAdminBusinessLeadsTouchesTouchIdRoute: typeof AppAdminBusinessLeadsTouchesTouchIdRoute
  AppAdminBusinessLeadsLeadIdIndexRoute: typeof AppAdminBusinessLeadsLeadIdIndexRoute
  AppAdminBusinessLeadsArtifactsIndexRoute: typeof AppAdminBusinessLeadsArtifactsIndexRoute
  AppAdminBusinessLeadsCompaniesIndexRoute: typeof AppAdminBusinessLeadsCompaniesIndexRoute
  AppAdminBusinessLeadsTemplatesIndexRoute: typeof AppAdminBusinessLeadsTemplatesIndexRoute
  AppAdminBusinessLeadsTouchesIndexRoute: typeof AppAdminBusinessLeadsTouchesIndexRoute
}

const AppAdminBusinessLeadsRouteRouteChildren: AppAdminBusinessLeadsRouteRouteChildren =
  {
    AppAdminBusinessLeadsNewRoute: AppAdminBusinessLeadsNewRoute,
    AppAdminBusinessLeadsIndexRoute: AppAdminBusinessLeadsIndexRoute,
    AppAdminBusinessLeadsArtifactsArtifactIdRoute:
      AppAdminBusinessLeadsArtifactsArtifactIdRoute,
    AppAdminBusinessLeadsArtifactsNewRoute:
      AppAdminBusinessLeadsArtifactsNewRoute,
    AppAdminBusinessLeadsCompaniesCompanyIdRoute:
      AppAdminBusinessLeadsCompaniesCompanyIdRoute,
    AppAdminBusinessLeadsCompaniesNewRoute:
      AppAdminBusinessLeadsCompaniesNewRoute,
    AppAdminBusinessLeadsTemplatesTemplateIdRoute:
      AppAdminBusinessLeadsTemplatesTemplateIdRoute,
    AppAdminBusinessLeadsTemplatesNewRoute:
      AppAdminBusinessLeadsTemplatesNewRoute,
    AppAdminBusinessLeadsTouchesTouchIdRoute:
      AppAdminBusinessLeadsTouchesTouchIdRoute,
    AppAdminBusinessLeadsLeadIdIndexRoute:
      AppAdminBusinessLeadsLeadIdIndexRoute,
    AppAdminBusinessLeadsArtifactsIndexRoute:
      AppAdminBusinessLeadsArtifactsIndexRoute,
    AppAdminBusinessLeadsCompaniesIndexRoute:
      AppAdminBusinessLeadsCompaniesIndexRoute,
    AppAdminBusinessLeadsTemplatesIndexRoute:
      AppAdminBusinessLeadsTemplatesIndexRoute,
    AppAdminBusinessLeadsTouchesIndexRoute:
      AppAdminBusinessLeadsTouchesIndexRoute,
  }

const AppAdminBusinessLeadsRouteRouteWithChildren =
  AppAdminBusinessLeadsRouteRoute._addFileChildren(
    AppAdminBusinessLeadsRouteRouteChildren,
  )

interface AppAdminRouteChildren {
  AppAdminAccessRouteRoute: typeof AppAdminAccessRouteRouteWithChildren
  AppAdminAuditRouteRoute: typeof AppAdminAuditRouteRouteWithChildren
  AppAdminOrganisationRouteRoute: typeof AppAdminOrganisationRouteRouteWithChildren
  AppAdminSftpRouteRoute: typeof AppAdminSftpRouteRouteWithChildren
  AppAdminAmbassadorsRoute: typeof AppAdminAmbassadorsRoute
  AppAdminEntriesRoute: typeof AppAdminEntriesRoute
  AppAdminEntryValuesRoute: typeof AppAdminEntryValuesRoute
  AppAdminEventsRoute: typeof AppAdminEventsRoute
  AppAdminHealthCheckRoute: typeof AppAdminHealthCheckRoute
  AppAdminImpersonateUserRoute: typeof AppAdminImpersonateUserRoute
  AppAdminLabelAccessRoute: typeof AppAdminLabelAccessRoute
  AppAdminLabelsRoute: typeof AppAdminLabelsRoute
  AppAdminNotificationPreferencesRoute: typeof AppAdminNotificationPreferencesRoute
  AppAdminReminderSendVolumeRoute: typeof AppAdminReminderSendVolumeRoute
  AppAdminSmsDeliverabilityRoute: typeof AppAdminSmsDeliverabilityRoute
  AppAdminStudiesRoute: typeof AppAdminStudiesRoute
  AppAdminTemplatesRoute: typeof AppAdminTemplatesRoute
  AppAdminTrackersRoute: typeof AppAdminTrackersRoute
  AppAdminUserBillingRoute: typeof AppAdminUserBillingRoute
  AppAdminUserOrganisationsRoute: typeof AppAdminUserOrganisationsRoute
  AppAdminViewDiaryAsPatientRoute: typeof AppAdminViewDiaryAsPatientRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminBusinessLeadsRouteRoute: typeof AppAdminBusinessLeadsRouteRouteWithChildren
  AppAdminBusinessAmbassadorsRoute: typeof AppAdminBusinessAmbassadorsRoute
  AppAdminBusinessChurnRoute: typeof AppAdminBusinessChurnRoute
  AppAdminCliniciansLeaderboardRoute: typeof AppAdminCliniciansLeaderboardRoute
  AppAdminCliniciansPhotosRoute: typeof AppAdminCliniciansPhotosRoute
  AppAdminCliniciansStatisticsRoute: typeof AppAdminCliniciansStatisticsRoute
  AppAdminDiariesTypesRoute: typeof AppAdminDiariesTypesRoute
  AppAdminUserUserIdRoute: typeof AppAdminUserUserIdRoute
  AppAdminBusinessIndexRoute: typeof AppAdminBusinessIndexRoute
  AppAdminCliniciansIndexRoute: typeof AppAdminCliniciansIndexRoute
  AppAdminDiariesIndexRoute: typeof AppAdminDiariesIndexRoute
  AppAdminUserActivationIndexRoute: typeof AppAdminUserActivationIndexRoute
  AppAdminFormFormIdResultsRoute: typeof AppAdminFormFormIdResultsRoute
  AppAdminDiariesDiaryIdIndexRoute: typeof AppAdminDiariesDiaryIdIndexRoute
  AppAdminEntryEntryIdIndexRoute: typeof AppAdminEntryEntryIdIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAccessRouteRoute: AppAdminAccessRouteRouteWithChildren,
  AppAdminAuditRouteRoute: AppAdminAuditRouteRouteWithChildren,
  AppAdminOrganisationRouteRoute: AppAdminOrganisationRouteRouteWithChildren,
  AppAdminSftpRouteRoute: AppAdminSftpRouteRouteWithChildren,
  AppAdminAmbassadorsRoute: AppAdminAmbassadorsRoute,
  AppAdminEntriesRoute: AppAdminEntriesRoute,
  AppAdminEntryValuesRoute: AppAdminEntryValuesRoute,
  AppAdminEventsRoute: AppAdminEventsRoute,
  AppAdminHealthCheckRoute: AppAdminHealthCheckRoute,
  AppAdminImpersonateUserRoute: AppAdminImpersonateUserRoute,
  AppAdminLabelAccessRoute: AppAdminLabelAccessRoute,
  AppAdminLabelsRoute: AppAdminLabelsRoute,
  AppAdminNotificationPreferencesRoute: AppAdminNotificationPreferencesRoute,
  AppAdminReminderSendVolumeRoute: AppAdminReminderSendVolumeRoute,
  AppAdminSmsDeliverabilityRoute: AppAdminSmsDeliverabilityRoute,
  AppAdminStudiesRoute: AppAdminStudiesRoute,
  AppAdminTemplatesRoute: AppAdminTemplatesRoute,
  AppAdminTrackersRoute: AppAdminTrackersRoute,
  AppAdminUserBillingRoute: AppAdminUserBillingRoute,
  AppAdminUserOrganisationsRoute: AppAdminUserOrganisationsRoute,
  AppAdminViewDiaryAsPatientRoute: AppAdminViewDiaryAsPatientRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminBusinessLeadsRouteRoute: AppAdminBusinessLeadsRouteRouteWithChildren,
  AppAdminBusinessAmbassadorsRoute: AppAdminBusinessAmbassadorsRoute,
  AppAdminBusinessChurnRoute: AppAdminBusinessChurnRoute,
  AppAdminCliniciansLeaderboardRoute: AppAdminCliniciansLeaderboardRoute,
  AppAdminCliniciansPhotosRoute: AppAdminCliniciansPhotosRoute,
  AppAdminCliniciansStatisticsRoute: AppAdminCliniciansStatisticsRoute,
  AppAdminDiariesTypesRoute: AppAdminDiariesTypesRoute,
  AppAdminUserUserIdRoute: AppAdminUserUserIdRoute,
  AppAdminBusinessIndexRoute: AppAdminBusinessIndexRoute,
  AppAdminCliniciansIndexRoute: AppAdminCliniciansIndexRoute,
  AppAdminDiariesIndexRoute: AppAdminDiariesIndexRoute,
  AppAdminUserActivationIndexRoute: AppAdminUserActivationIndexRoute,
  AppAdminFormFormIdResultsRoute: AppAdminFormFormIdResultsRoute,
  AppAdminDiariesDiaryIdIndexRoute: AppAdminDiariesDiaryIdIndexRoute,
  AppAdminEntryEntryIdIndexRoute: AppAdminEntryEntryIdIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppAnalyticsRouteChildren {
  AppAnalyticsDiaryLabelRoute: typeof AppAnalyticsDiaryLabelRoute
  AppAnalyticsAnikaRoute: typeof AppAnalyticsAnikaRoute
  AppAnalyticsArthrosamidRoute: typeof AppAnalyticsArthrosamidRoute
  AppAnalyticsIndexRoute: typeof AppAnalyticsIndexRoute
}

const AppAnalyticsRouteChildren: AppAnalyticsRouteChildren = {
  AppAnalyticsDiaryLabelRoute: AppAnalyticsDiaryLabelRoute,
  AppAnalyticsAnikaRoute: AppAnalyticsAnikaRoute,
  AppAnalyticsArthrosamidRoute: AppAnalyticsArthrosamidRoute,
  AppAnalyticsIndexRoute: AppAnalyticsIndexRoute,
}

const AppAnalyticsRouteWithChildren = AppAnalyticsRoute._addFileChildren(
  AppAnalyticsRouteChildren,
)

interface AppBuilderRouteChildren {
  AppBuilderIndexRoute: typeof AppBuilderIndexRoute
  AppBuilderConsentsConsentBodyIdRoute: typeof AppBuilderConsentsConsentBodyIdRoute
  AppBuilderDictionariesDictionaryIdRoute: typeof AppBuilderDictionariesDictionaryIdRoute
  AppBuilderFormsNewRoute: typeof AppBuilderFormsNewRoute
  AppBuilderSchedulesScheduleIdRoute: typeof AppBuilderSchedulesScheduleIdRoute
  AppBuilderSchedulesNewRoute: typeof AppBuilderSchedulesNewRoute
  AppBuilderConsentsIndexRoute: typeof AppBuilderConsentsIndexRoute
  AppBuilderDictionariesIndexRoute: typeof AppBuilderDictionariesIndexRoute
  AppBuilderFormsIndexRoute: typeof AppBuilderFormsIndexRoute
  AppBuilderInjectionContentsIndexRoute: typeof AppBuilderInjectionContentsIndexRoute
  AppBuilderInjectionLocationsIndexRoute: typeof AppBuilderInjectionLocationsIndexRoute
  AppBuilderLabelsIndexRoute: typeof AppBuilderLabelsIndexRoute
  AppBuilderMessagesIndexRoute: typeof AppBuilderMessagesIndexRoute
  AppBuilderOptionsIndexRoute: typeof AppBuilderOptionsIndexRoute
  AppBuilderSchedulesIndexRoute: typeof AppBuilderSchedulesIndexRoute
  AppBuilderSurgeriesIndexRoute: typeof AppBuilderSurgeriesIndexRoute
  AppBuilderTemplatesIndexRoute: typeof AppBuilderTemplatesIndexRoute
  AppBuilderFormsFormIdTabRoute: typeof AppBuilderFormsFormIdTabRoute
  AppBuilderFormsFormIdMetadataRoute: typeof AppBuilderFormsFormIdMetadataRoute
  AppBuilderSchedulesFormsFormIdRoute: typeof AppBuilderSchedulesFormsFormIdRoute
  AppBuilderFormsFormIdIndexRoute: typeof AppBuilderFormsFormIdIndexRoute
}

const AppBuilderRouteChildren: AppBuilderRouteChildren = {
  AppBuilderIndexRoute: AppBuilderIndexRoute,
  AppBuilderConsentsConsentBodyIdRoute: AppBuilderConsentsConsentBodyIdRoute,
  AppBuilderDictionariesDictionaryIdRoute:
    AppBuilderDictionariesDictionaryIdRoute,
  AppBuilderFormsNewRoute: AppBuilderFormsNewRoute,
  AppBuilderSchedulesScheduleIdRoute: AppBuilderSchedulesScheduleIdRoute,
  AppBuilderSchedulesNewRoute: AppBuilderSchedulesNewRoute,
  AppBuilderConsentsIndexRoute: AppBuilderConsentsIndexRoute,
  AppBuilderDictionariesIndexRoute: AppBuilderDictionariesIndexRoute,
  AppBuilderFormsIndexRoute: AppBuilderFormsIndexRoute,
  AppBuilderInjectionContentsIndexRoute: AppBuilderInjectionContentsIndexRoute,
  AppBuilderInjectionLocationsIndexRoute:
    AppBuilderInjectionLocationsIndexRoute,
  AppBuilderLabelsIndexRoute: AppBuilderLabelsIndexRoute,
  AppBuilderMessagesIndexRoute: AppBuilderMessagesIndexRoute,
  AppBuilderOptionsIndexRoute: AppBuilderOptionsIndexRoute,
  AppBuilderSchedulesIndexRoute: AppBuilderSchedulesIndexRoute,
  AppBuilderSurgeriesIndexRoute: AppBuilderSurgeriesIndexRoute,
  AppBuilderTemplatesIndexRoute: AppBuilderTemplatesIndexRoute,
  AppBuilderFormsFormIdTabRoute: AppBuilderFormsFormIdTabRoute,
  AppBuilderFormsFormIdMetadataRoute: AppBuilderFormsFormIdMetadataRoute,
  AppBuilderSchedulesFormsFormIdRoute: AppBuilderSchedulesFormsFormIdRoute,
  AppBuilderFormsFormIdIndexRoute: AppBuilderFormsFormIdIndexRoute,
}

const AppBuilderRouteWithChildren = AppBuilderRoute._addFileChildren(
  AppBuilderRouteChildren,
)

interface AppBusinessLeadsRouteRouteChildren {
  AppBusinessLeadsNewRoute: typeof AppBusinessLeadsNewRoute
  AppBusinessLeadsIndexRoute: typeof AppBusinessLeadsIndexRoute
  AppBusinessLeadsArtifactsArtifactIdRoute: typeof AppBusinessLeadsArtifactsArtifactIdRoute
  AppBusinessLeadsArtifactsNewRoute: typeof AppBusinessLeadsArtifactsNewRoute
  AppBusinessLeadsCompaniesCompanyIdRoute: typeof AppBusinessLeadsCompaniesCompanyIdRoute
  AppBusinessLeadsCompaniesNewRoute: typeof AppBusinessLeadsCompaniesNewRoute
  AppBusinessLeadsTemplatesTemplateIdRoute: typeof AppBusinessLeadsTemplatesTemplateIdRoute
  AppBusinessLeadsTemplatesNewRoute: typeof AppBusinessLeadsTemplatesNewRoute
  AppBusinessLeadsTouchesTouchIdRoute: typeof AppBusinessLeadsTouchesTouchIdRoute
  AppBusinessLeadsLeadIdIndexRoute: typeof AppBusinessLeadsLeadIdIndexRoute
  AppBusinessLeadsArtifactsIndexRoute: typeof AppBusinessLeadsArtifactsIndexRoute
  AppBusinessLeadsCompaniesIndexRoute: typeof AppBusinessLeadsCompaniesIndexRoute
  AppBusinessLeadsTemplatesIndexRoute: typeof AppBusinessLeadsTemplatesIndexRoute
  AppBusinessLeadsTouchesIndexRoute: typeof AppBusinessLeadsTouchesIndexRoute
}

const AppBusinessLeadsRouteRouteChildren: AppBusinessLeadsRouteRouteChildren = {
  AppBusinessLeadsNewRoute: AppBusinessLeadsNewRoute,
  AppBusinessLeadsIndexRoute: AppBusinessLeadsIndexRoute,
  AppBusinessLeadsArtifactsArtifactIdRoute:
    AppBusinessLeadsArtifactsArtifactIdRoute,
  AppBusinessLeadsArtifactsNewRoute: AppBusinessLeadsArtifactsNewRoute,
  AppBusinessLeadsCompaniesCompanyIdRoute:
    AppBusinessLeadsCompaniesCompanyIdRoute,
  AppBusinessLeadsCompaniesNewRoute: AppBusinessLeadsCompaniesNewRoute,
  AppBusinessLeadsTemplatesTemplateIdRoute:
    AppBusinessLeadsTemplatesTemplateIdRoute,
  AppBusinessLeadsTemplatesNewRoute: AppBusinessLeadsTemplatesNewRoute,
  AppBusinessLeadsTouchesTouchIdRoute: AppBusinessLeadsTouchesTouchIdRoute,
  AppBusinessLeadsLeadIdIndexRoute: AppBusinessLeadsLeadIdIndexRoute,
  AppBusinessLeadsArtifactsIndexRoute: AppBusinessLeadsArtifactsIndexRoute,
  AppBusinessLeadsCompaniesIndexRoute: AppBusinessLeadsCompaniesIndexRoute,
  AppBusinessLeadsTemplatesIndexRoute: AppBusinessLeadsTemplatesIndexRoute,
  AppBusinessLeadsTouchesIndexRoute: AppBusinessLeadsTouchesIndexRoute,
}

const AppBusinessLeadsRouteRouteWithChildren =
  AppBusinessLeadsRouteRoute._addFileChildren(
    AppBusinessLeadsRouteRouteChildren,
  )

interface AppBusinessRouteChildren {
  AppBusinessLeadsRouteRoute: typeof AppBusinessLeadsRouteRouteWithChildren
  AppBusinessAmbassadorsRoute: typeof AppBusinessAmbassadorsRoute
  AppBusinessChurnRoute: typeof AppBusinessChurnRoute
  AppBusinessIndexRoute: typeof AppBusinessIndexRoute
}

const AppBusinessRouteChildren: AppBusinessRouteChildren = {
  AppBusinessLeadsRouteRoute: AppBusinessLeadsRouteRouteWithChildren,
  AppBusinessAmbassadorsRoute: AppBusinessAmbassadorsRoute,
  AppBusinessChurnRoute: AppBusinessChurnRoute,
  AppBusinessIndexRoute: AppBusinessIndexRoute,
}

const AppBusinessRouteWithChildren = AppBusinessRoute._addFileChildren(
  AppBusinessRouteChildren,
)

interface AppCustomersRouteChildren {
  AppCustomersAmbassadorsRoute: typeof AppCustomersAmbassadorsRoute
  AppCustomersAnonymousRoute: typeof AppCustomersAnonymousRoute
  AppCustomersChurnRoute: typeof AppCustomersChurnRoute
  AppCustomersCliniciansRoute: typeof AppCustomersCliniciansRoute
  AppCustomersSuccessRoute: typeof AppCustomersSuccessRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
}

const AppCustomersRouteChildren: AppCustomersRouteChildren = {
  AppCustomersAmbassadorsRoute: AppCustomersAmbassadorsRoute,
  AppCustomersAnonymousRoute: AppCustomersAnonymousRoute,
  AppCustomersChurnRoute: AppCustomersChurnRoute,
  AppCustomersCliniciansRoute: AppCustomersCliniciansRoute,
  AppCustomersSuccessRoute: AppCustomersSuccessRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
}

const AppCustomersRouteWithChildren = AppCustomersRoute._addFileChildren(
  AppCustomersRouteChildren,
)

interface AppDesignFormsPagesRouteChildren {
  AppDesignFormsPagesScreenRoute: typeof AppDesignFormsPagesScreenRoute
  AppDesignFormsPagesIndexRoute: typeof AppDesignFormsPagesIndexRoute
}

const AppDesignFormsPagesRouteChildren: AppDesignFormsPagesRouteChildren = {
  AppDesignFormsPagesScreenRoute: AppDesignFormsPagesScreenRoute,
  AppDesignFormsPagesIndexRoute: AppDesignFormsPagesIndexRoute,
}

const AppDesignFormsPagesRouteWithChildren =
  AppDesignFormsPagesRoute._addFileChildren(AppDesignFormsPagesRouteChildren)

interface AppDesignRouteChildren {
  AppDesignIndexRoute: typeof AppDesignIndexRoute
  AppDesignComponentsAnimationsRoute: typeof AppDesignComponentsAnimationsRoute
  AppDesignComponentsAuthRoute: typeof AppDesignComponentsAuthRoute
  AppDesignComponentsButtonsRoute: typeof AppDesignComponentsButtonsRoute
  AppDesignComponentsDictionariesRoute: typeof AppDesignComponentsDictionariesRoute
  AppDesignComponentsInputsRoute: typeof AppDesignComponentsInputsRoute
  AppDesignComponentsSearchFieldsRoute: typeof AppDesignComponentsSearchFieldsRoute
  AppDesignComponentsSelectDialogsRoute: typeof AppDesignComponentsSelectDialogsRoute
  AppDesignFeaturesGeneralisedAnalyticsRoute: typeof AppDesignFeaturesGeneralisedAnalyticsRoute
  AppDesignFeaturesManagerStudyClinicianInvitePlanRoute: typeof AppDesignFeaturesManagerStudyClinicianInvitePlanRoute
  AppDesignFeaturesMessagingScheduleRoute: typeof AppDesignFeaturesMessagingScheduleRoute
  AppDesignFeaturesOtivioFrictionlessOnboardingRoute: typeof AppDesignFeaturesOtivioFrictionlessOnboardingRoute
  AppDesignFeaturesReminderSequencesRoute: typeof AppDesignFeaturesReminderSequencesRoute
  AppDesignFormsBlocksRoute: typeof AppDesignFormsBlocksRoute
  AppDesignFormsEntryValuesRoute: typeof AppDesignFormsEntryValuesRoute
  AppDesignFormsInputsRoute: typeof AppDesignFormsInputsRoute
  AppDesignFormsPagesRoute: typeof AppDesignFormsPagesRouteWithChildren
  AppDesignIconsAnimationsRoute: typeof AppDesignIconsAnimationsRoute
  AppDesignIconsFacesRoute: typeof AppDesignIconsFacesRoute
  AppDesignIconsStatesRoute: typeof AppDesignIconsStatesRoute
  AppDesignFormsIndexRoute: typeof AppDesignFormsIndexRoute
  AppDesignIconsIndexRoute: typeof AppDesignIconsIndexRoute
  AppDesignFeaturesWorklistAutomationsRoute: typeof AppDesignFeaturesWorklistAutomationsRoute
  AppDesignFeaturesWorklistIndexRoute: typeof AppDesignFeaturesWorklistIndexRoute
}

const AppDesignRouteChildren: AppDesignRouteChildren = {
  AppDesignIndexRoute: AppDesignIndexRoute,
  AppDesignComponentsAnimationsRoute: AppDesignComponentsAnimationsRoute,
  AppDesignComponentsAuthRoute: AppDesignComponentsAuthRoute,
  AppDesignComponentsButtonsRoute: AppDesignComponentsButtonsRoute,
  AppDesignComponentsDictionariesRoute: AppDesignComponentsDictionariesRoute,
  AppDesignComponentsInputsRoute: AppDesignComponentsInputsRoute,
  AppDesignComponentsSearchFieldsRoute: AppDesignComponentsSearchFieldsRoute,
  AppDesignComponentsSelectDialogsRoute: AppDesignComponentsSelectDialogsRoute,
  AppDesignFeaturesGeneralisedAnalyticsRoute:
    AppDesignFeaturesGeneralisedAnalyticsRoute,
  AppDesignFeaturesManagerStudyClinicianInvitePlanRoute:
    AppDesignFeaturesManagerStudyClinicianInvitePlanRoute,
  AppDesignFeaturesMessagingScheduleRoute:
    AppDesignFeaturesMessagingScheduleRoute,
  AppDesignFeaturesOtivioFrictionlessOnboardingRoute:
    AppDesignFeaturesOtivioFrictionlessOnboardingRoute,
  AppDesignFeaturesReminderSequencesRoute:
    AppDesignFeaturesReminderSequencesRoute,
  AppDesignFormsBlocksRoute: AppDesignFormsBlocksRoute,
  AppDesignFormsEntryValuesRoute: AppDesignFormsEntryValuesRoute,
  AppDesignFormsInputsRoute: AppDesignFormsInputsRoute,
  AppDesignFormsPagesRoute: AppDesignFormsPagesRouteWithChildren,
  AppDesignIconsAnimationsRoute: AppDesignIconsAnimationsRoute,
  AppDesignIconsFacesRoute: AppDesignIconsFacesRoute,
  AppDesignIconsStatesRoute: AppDesignIconsStatesRoute,
  AppDesignFormsIndexRoute: AppDesignFormsIndexRoute,
  AppDesignIconsIndexRoute: AppDesignIconsIndexRoute,
  AppDesignFeaturesWorklistAutomationsRoute:
    AppDesignFeaturesWorklistAutomationsRoute,
  AppDesignFeaturesWorklistIndexRoute: AppDesignFeaturesWorklistIndexRoute,
}

const AppDesignRouteWithChildren = AppDesignRoute._addFileChildren(
  AppDesignRouteChildren,
)

interface AppDeveloperSftpRouteRouteChildren {
  AppDeveloperSftpDashboardRoute: typeof AppDeveloperSftpDashboardRoute
  AppDeveloperSftpDiariesRoute: typeof AppDeveloperSftpDiariesRoute
  AppDeveloperSftpExplorerRoute: typeof AppDeveloperSftpExplorerRoute
  AppDeveloperSftpOrganisationsRoute: typeof AppDeveloperSftpOrganisationsRoute
  AppDeveloperSftpPreviewRoute: typeof AppDeveloperSftpPreviewRoute
  AppDeveloperSftpUploadRoute: typeof AppDeveloperSftpUploadRoute
  AppDeveloperSftpIndexRoute: typeof AppDeveloperSftpIndexRoute
}

const AppDeveloperSftpRouteRouteChildren: AppDeveloperSftpRouteRouteChildren = {
  AppDeveloperSftpDashboardRoute: AppDeveloperSftpDashboardRoute,
  AppDeveloperSftpDiariesRoute: AppDeveloperSftpDiariesRoute,
  AppDeveloperSftpExplorerRoute: AppDeveloperSftpExplorerRoute,
  AppDeveloperSftpOrganisationsRoute: AppDeveloperSftpOrganisationsRoute,
  AppDeveloperSftpPreviewRoute: AppDeveloperSftpPreviewRoute,
  AppDeveloperSftpUploadRoute: AppDeveloperSftpUploadRoute,
  AppDeveloperSftpIndexRoute: AppDeveloperSftpIndexRoute,
}

const AppDeveloperSftpRouteRouteWithChildren =
  AppDeveloperSftpRouteRoute._addFileChildren(
    AppDeveloperSftpRouteRouteChildren,
  )

interface AppDeveloperRouteChildren {
  AppDeveloperSftpRouteRoute: typeof AppDeveloperSftpRouteRouteWithChildren
  AppDeveloperHealthCheckRoute: typeof AppDeveloperHealthCheckRoute
  AppDeveloperMessagingScheduleRoute: typeof AppDeveloperMessagingScheduleRoute
  AppDeveloperReminderSendVolumeRoute: typeof AppDeveloperReminderSendVolumeRoute
  AppDeveloperSmsDeliverabilityRoute: typeof AppDeveloperSmsDeliverabilityRoute
  AppDeveloperIndexRoute: typeof AppDeveloperIndexRoute
  AppDeveloperDemosGeneralisedAnalyticsRoute: typeof AppDeveloperDemosGeneralisedAnalyticsRoute
  AppDeveloperDemosManagerStudyClinicianInvitePlanRoute: typeof AppDeveloperDemosManagerStudyClinicianInvitePlanRoute
  AppDeveloperDemosOtivioFrictionlessOnboardingRoute: typeof AppDeveloperDemosOtivioFrictionlessOnboardingRoute
  AppDeveloperUiAnimationsRoute: typeof AppDeveloperUiAnimationsRoute
  AppDeveloperUiAuthRoute: typeof AppDeveloperUiAuthRoute
  AppDeveloperUiButtonsRoute: typeof AppDeveloperUiButtonsRoute
  AppDeveloperUiDictionariesRoute: typeof AppDeveloperUiDictionariesRoute
  AppDeveloperUiEntryValuesRoute: typeof AppDeveloperUiEntryValuesRoute
  AppDeveloperUiInputSwitchRoute: typeof AppDeveloperUiInputSwitchRoute
  AppDeveloperUiInputsRoute: typeof AppDeveloperUiInputsRoute
}

const AppDeveloperRouteChildren: AppDeveloperRouteChildren = {
  AppDeveloperSftpRouteRoute: AppDeveloperSftpRouteRouteWithChildren,
  AppDeveloperHealthCheckRoute: AppDeveloperHealthCheckRoute,
  AppDeveloperMessagingScheduleRoute: AppDeveloperMessagingScheduleRoute,
  AppDeveloperReminderSendVolumeRoute: AppDeveloperReminderSendVolumeRoute,
  AppDeveloperSmsDeliverabilityRoute: AppDeveloperSmsDeliverabilityRoute,
  AppDeveloperIndexRoute: AppDeveloperIndexRoute,
  AppDeveloperDemosGeneralisedAnalyticsRoute:
    AppDeveloperDemosGeneralisedAnalyticsRoute,
  AppDeveloperDemosManagerStudyClinicianInvitePlanRoute:
    AppDeveloperDemosManagerStudyClinicianInvitePlanRoute,
  AppDeveloperDemosOtivioFrictionlessOnboardingRoute:
    AppDeveloperDemosOtivioFrictionlessOnboardingRoute,
  AppDeveloperUiAnimationsRoute: AppDeveloperUiAnimationsRoute,
  AppDeveloperUiAuthRoute: AppDeveloperUiAuthRoute,
  AppDeveloperUiButtonsRoute: AppDeveloperUiButtonsRoute,
  AppDeveloperUiDictionariesRoute: AppDeveloperUiDictionariesRoute,
  AppDeveloperUiEntryValuesRoute: AppDeveloperUiEntryValuesRoute,
  AppDeveloperUiInputSwitchRoute: AppDeveloperUiInputSwitchRoute,
  AppDeveloperUiInputsRoute: AppDeveloperUiInputsRoute,
}

const AppDeveloperRouteWithChildren = AppDeveloperRoute._addFileChildren(
  AppDeveloperRouteChildren,
)

interface AppInviteRouteChildren {
  AppInviteQrCodeRoute: typeof AppInviteQrCodeRoute
  AppInviteIndexRoute: typeof AppInviteIndexRoute
  AppInviteDiaryCompleteRoute: typeof AppInviteDiaryCompleteRoute
  AppInviteDiaryOrganisationRoute: typeof AppInviteDiaryOrganisationRoute
  AppInviteDiaryPatientRoute: typeof AppInviteDiaryPatientRoute
  AppInviteDiaryQrRoute: typeof AppInviteDiaryQrRoute
  AppInviteDiaryReviewRoute: typeof AppInviteDiaryReviewRoute
}

const AppInviteRouteChildren: AppInviteRouteChildren = {
  AppInviteQrCodeRoute: AppInviteQrCodeRoute,
  AppInviteIndexRoute: AppInviteIndexRoute,
  AppInviteDiaryCompleteRoute: AppInviteDiaryCompleteRoute,
  AppInviteDiaryOrganisationRoute: AppInviteDiaryOrganisationRoute,
  AppInviteDiaryPatientRoute: AppInviteDiaryPatientRoute,
  AppInviteDiaryQrRoute: AppInviteDiaryQrRoute,
  AppInviteDiaryReviewRoute: AppInviteDiaryReviewRoute,
}

const AppInviteRouteWithChildren = AppInviteRoute._addFileChildren(
  AppInviteRouteChildren,
)

interface AppPatientsDiaryIdConsentConsentIdRouteChildren {
  AppPatientsDiaryIdConsentConsentIdCompleteRoute: typeof AppPatientsDiaryIdConsentConsentIdCompleteRoute
  AppPatientsDiaryIdConsentConsentIdIndexRoute: typeof AppPatientsDiaryIdConsentConsentIdIndexRoute
}

const AppPatientsDiaryIdConsentConsentIdRouteChildren: AppPatientsDiaryIdConsentConsentIdRouteChildren =
  {
    AppPatientsDiaryIdConsentConsentIdCompleteRoute:
      AppPatientsDiaryIdConsentConsentIdCompleteRoute,
    AppPatientsDiaryIdConsentConsentIdIndexRoute:
      AppPatientsDiaryIdConsentConsentIdIndexRoute,
  }

const AppPatientsDiaryIdConsentConsentIdRouteWithChildren =
  AppPatientsDiaryIdConsentConsentIdRoute._addFileChildren(
    AppPatientsDiaryIdConsentConsentIdRouteChildren,
  )

interface AppPatientsDiaryIdRouteChildren {
  AppPatientsDiaryIdEditRoute: typeof AppPatientsDiaryIdEditRoute
  AppPatientsDiaryIdIndexRoute: typeof AppPatientsDiaryIdIndexRoute
  AppPatientsDiaryIdActionActionIdRoute: typeof AppPatientsDiaryIdActionActionIdRoute
  AppPatientsDiaryIdConsentConsentIdRoute: typeof AppPatientsDiaryIdConsentConsentIdRouteWithChildren
  AppPatientsDiaryIdUpdateAddRoute: typeof AppPatientsDiaryIdUpdateAddRoute
  AppPatientsDiaryIdUpdateConsentRoute: typeof AppPatientsDiaryIdUpdateConsentRoute
  AppPatientsDiaryIdUpdateExistingTrackersRoute: typeof AppPatientsDiaryIdUpdateExistingTrackersRoute
  AppPatientsDiaryIdUpdateFromTemplateRoute: typeof AppPatientsDiaryIdUpdateFromTemplateRoute
  AppPatientsDiaryIdUpdateReviewRoute: typeof AppPatientsDiaryIdUpdateReviewRoute
  AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute: typeof AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute
  AppPatientsDiaryIdUpdateTemplatesRoute: typeof AppPatientsDiaryIdUpdateTemplatesRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute
  AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute: typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute: typeof AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute
  AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute: typeof AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
}

const AppPatientsDiaryIdRouteChildren: AppPatientsDiaryIdRouteChildren = {
  AppPatientsDiaryIdEditRoute: AppPatientsDiaryIdEditRoute,
  AppPatientsDiaryIdIndexRoute: AppPatientsDiaryIdIndexRoute,
  AppPatientsDiaryIdActionActionIdRoute: AppPatientsDiaryIdActionActionIdRoute,
  AppPatientsDiaryIdConsentConsentIdRoute:
    AppPatientsDiaryIdConsentConsentIdRouteWithChildren,
  AppPatientsDiaryIdUpdateAddRoute: AppPatientsDiaryIdUpdateAddRoute,
  AppPatientsDiaryIdUpdateConsentRoute: AppPatientsDiaryIdUpdateConsentRoute,
  AppPatientsDiaryIdUpdateExistingTrackersRoute:
    AppPatientsDiaryIdUpdateExistingTrackersRoute,
  AppPatientsDiaryIdUpdateFromTemplateRoute:
    AppPatientsDiaryIdUpdateFromTemplateRoute,
  AppPatientsDiaryIdUpdateReviewRoute: AppPatientsDiaryIdUpdateReviewRoute,
  AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute:
    AppPatientsDiaryIdUpdateTemplateExistingTrackersRoute,
  AppPatientsDiaryIdUpdateTemplatesRoute:
    AppPatientsDiaryIdUpdateTemplatesRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdContactRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdDateRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdMessageRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdQuestionnaireRoute,
  AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute:
    AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsEducationRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsInjectionRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsProductRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsShockwaveRoute,
  AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute:
    AppPatientsDiaryIdUpdateEventIdTrackerIdInterventionDetailsSurgeryRoute,
  AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute:
    AppPatientsDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute,
}

const AppPatientsDiaryIdRouteWithChildren =
  AppPatientsDiaryIdRoute._addFileChildren(AppPatientsDiaryIdRouteChildren)

interface AppPatientsBulkEventsRouteChildren {
  AppPatientsBulkEventsEventTypeRoute: typeof AppPatientsBulkEventsEventTypeRoute
  AppPatientsBulkEventsIndexRoute: typeof AppPatientsBulkEventsIndexRoute
}

const AppPatientsBulkEventsRouteChildren: AppPatientsBulkEventsRouteChildren = {
  AppPatientsBulkEventsEventTypeRoute: AppPatientsBulkEventsEventTypeRoute,
  AppPatientsBulkEventsIndexRoute: AppPatientsBulkEventsIndexRoute,
}

const AppPatientsBulkEventsRouteWithChildren =
  AppPatientsBulkEventsRoute._addFileChildren(
    AppPatientsBulkEventsRouteChildren,
  )

interface AppPatientsRouteChildren {
  AppPatientsDiaryIdRoute: typeof AppPatientsDiaryIdRouteWithChildren
  AppPatientsBulkContactRoute: typeof AppPatientsBulkContactRoute
  AppPatientsBulkEventsRoute: typeof AppPatientsBulkEventsRouteWithChildren
  AppPatientsBulkLabelsRoute: typeof AppPatientsBulkLabelsRoute
  AppPatientsBulkMessageRoute: typeof AppPatientsBulkMessageRoute
  AppPatientsBulkOrganisationRoute: typeof AppPatientsBulkOrganisationRoute
  AppPatientsBulkReviewedRoute: typeof AppPatientsBulkReviewedRoute
}

const AppPatientsRouteChildren: AppPatientsRouteChildren = {
  AppPatientsDiaryIdRoute: AppPatientsDiaryIdRouteWithChildren,
  AppPatientsBulkContactRoute: AppPatientsBulkContactRoute,
  AppPatientsBulkEventsRoute: AppPatientsBulkEventsRouteWithChildren,
  AppPatientsBulkLabelsRoute: AppPatientsBulkLabelsRoute,
  AppPatientsBulkMessageRoute: AppPatientsBulkMessageRoute,
  AppPatientsBulkOrganisationRoute: AppPatientsBulkOrganisationRoute,
  AppPatientsBulkReviewedRoute: AppPatientsBulkReviewedRoute,
}

const AppPatientsRouteWithChildren = AppPatientsRoute._addFileChildren(
  AppPatientsRouteChildren,
)

interface AppProfileRouteChildren {
  AppProfileAddImagingCenterRoute: typeof AppProfileAddImagingCenterRoute
  AppProfileBillingRoute: typeof AppProfileBillingRoute
  AppProfileChangePasswordRoute: typeof AppProfileChangePasswordRoute
  AppProfileClinicianNumberRoute: typeof AppProfileClinicianNumberRoute
  AppProfileDateOfBirthRoute: typeof AppProfileDateOfBirthRoute
  AppProfileDeleteAccountRoute: typeof AppProfileDeleteAccountRoute
  AppProfileEmailRoute: typeof AppProfileEmailRoute
  AppProfileMfaRoute: typeof AppProfileMfaRoute
  AppProfileNameRoute: typeof AppProfileNameRoute
  AppProfileNhsNumberRoute: typeof AppProfileNhsNumberRoute
  AppProfileNotificationsRoute: typeof AppProfileNotificationsRoute
  AppProfileOrganisationRoute: typeof AppProfileOrganisationRoute
  AppProfilePhoneRoute: typeof AppProfilePhoneRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppProfileMedicalDiabetesRoute: typeof AppProfileMedicalDiabetesRoute
}

const AppProfileRouteChildren: AppProfileRouteChildren = {
  AppProfileAddImagingCenterRoute: AppProfileAddImagingCenterRoute,
  AppProfileBillingRoute: AppProfileBillingRoute,
  AppProfileChangePasswordRoute: AppProfileChangePasswordRoute,
  AppProfileClinicianNumberRoute: AppProfileClinicianNumberRoute,
  AppProfileDateOfBirthRoute: AppProfileDateOfBirthRoute,
  AppProfileDeleteAccountRoute: AppProfileDeleteAccountRoute,
  AppProfileEmailRoute: AppProfileEmailRoute,
  AppProfileMfaRoute: AppProfileMfaRoute,
  AppProfileNameRoute: AppProfileNameRoute,
  AppProfileNhsNumberRoute: AppProfileNhsNumberRoute,
  AppProfileNotificationsRoute: AppProfileNotificationsRoute,
  AppProfileOrganisationRoute: AppProfileOrganisationRoute,
  AppProfilePhoneRoute: AppProfilePhoneRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppProfileMedicalDiabetesRoute: AppProfileMedicalDiabetesRoute,
}

const AppProfileRouteWithChildren = AppProfileRoute._addFileChildren(
  AppProfileRouteChildren,
)

interface AppSalesLeadsRouteRouteChildren {
  AppSalesLeadsNewRoute: typeof AppSalesLeadsNewRoute
  AppSalesLeadsIndexRoute: typeof AppSalesLeadsIndexRoute
  AppSalesLeadsArtifactsArtifactIdRoute: typeof AppSalesLeadsArtifactsArtifactIdRoute
  AppSalesLeadsArtifactsNewRoute: typeof AppSalesLeadsArtifactsNewRoute
  AppSalesLeadsCompaniesCompanyIdRoute: typeof AppSalesLeadsCompaniesCompanyIdRoute
  AppSalesLeadsCompaniesNewRoute: typeof AppSalesLeadsCompaniesNewRoute
  AppSalesLeadsTemplatesTemplateIdRoute: typeof AppSalesLeadsTemplatesTemplateIdRoute
  AppSalesLeadsTemplatesNewRoute: typeof AppSalesLeadsTemplatesNewRoute
  AppSalesLeadsTouchesTouchIdRoute: typeof AppSalesLeadsTouchesTouchIdRoute
  AppSalesLeadsLeadIdIndexRoute: typeof AppSalesLeadsLeadIdIndexRoute
  AppSalesLeadsArtifactsIndexRoute: typeof AppSalesLeadsArtifactsIndexRoute
  AppSalesLeadsCompaniesIndexRoute: typeof AppSalesLeadsCompaniesIndexRoute
  AppSalesLeadsTemplatesIndexRoute: typeof AppSalesLeadsTemplatesIndexRoute
  AppSalesLeadsTouchesIndexRoute: typeof AppSalesLeadsTouchesIndexRoute
}

const AppSalesLeadsRouteRouteChildren: AppSalesLeadsRouteRouteChildren = {
  AppSalesLeadsNewRoute: AppSalesLeadsNewRoute,
  AppSalesLeadsIndexRoute: AppSalesLeadsIndexRoute,
  AppSalesLeadsArtifactsArtifactIdRoute: AppSalesLeadsArtifactsArtifactIdRoute,
  AppSalesLeadsArtifactsNewRoute: AppSalesLeadsArtifactsNewRoute,
  AppSalesLeadsCompaniesCompanyIdRoute: AppSalesLeadsCompaniesCompanyIdRoute,
  AppSalesLeadsCompaniesNewRoute: AppSalesLeadsCompaniesNewRoute,
  AppSalesLeadsTemplatesTemplateIdRoute: AppSalesLeadsTemplatesTemplateIdRoute,
  AppSalesLeadsTemplatesNewRoute: AppSalesLeadsTemplatesNewRoute,
  AppSalesLeadsTouchesTouchIdRoute: AppSalesLeadsTouchesTouchIdRoute,
  AppSalesLeadsLeadIdIndexRoute: AppSalesLeadsLeadIdIndexRoute,
  AppSalesLeadsArtifactsIndexRoute: AppSalesLeadsArtifactsIndexRoute,
  AppSalesLeadsCompaniesIndexRoute: AppSalesLeadsCompaniesIndexRoute,
  AppSalesLeadsTemplatesIndexRoute: AppSalesLeadsTemplatesIndexRoute,
  AppSalesLeadsTouchesIndexRoute: AppSalesLeadsTouchesIndexRoute,
}

const AppSalesLeadsRouteRouteWithChildren =
  AppSalesLeadsRouteRoute._addFileChildren(AppSalesLeadsRouteRouteChildren)

interface AppSalesRouteChildren {
  AppSalesLeadsRouteRoute: typeof AppSalesLeadsRouteRouteWithChildren
  AppSalesIndexRoute: typeof AppSalesIndexRoute
}

const AppSalesRouteChildren: AppSalesRouteChildren = {
  AppSalesLeadsRouteRoute: AppSalesLeadsRouteRouteWithChildren,
  AppSalesIndexRoute: AppSalesIndexRoute,
}

const AppSalesRouteWithChildren = AppSalesRoute._addFileChildren(
  AppSalesRouteChildren,
)

interface AppStudiesStudyIdRouteChildren {
  AppStudiesStudyIdEditRoute: typeof AppStudiesStudyIdEditRoute
  AppStudiesStudyIdIndexRoute: typeof AppStudiesStudyIdIndexRoute
  AppStudiesStudyIdInviteQrRoute: typeof AppStudiesStudyIdInviteQrRoute
  AppStudiesStudyIdInviteIndexRoute: typeof AppStudiesStudyIdInviteIndexRoute
}

const AppStudiesStudyIdRouteChildren: AppStudiesStudyIdRouteChildren = {
  AppStudiesStudyIdEditRoute: AppStudiesStudyIdEditRoute,
  AppStudiesStudyIdIndexRoute: AppStudiesStudyIdIndexRoute,
  AppStudiesStudyIdInviteQrRoute: AppStudiesStudyIdInviteQrRoute,
  AppStudiesStudyIdInviteIndexRoute: AppStudiesStudyIdInviteIndexRoute,
}

const AppStudiesStudyIdRouteWithChildren =
  AppStudiesStudyIdRoute._addFileChildren(AppStudiesStudyIdRouteChildren)

interface AppStudiesRouteChildren {
  AppStudiesStudyIdRoute: typeof AppStudiesStudyIdRouteWithChildren
  AppStudiesIndexRoute: typeof AppStudiesIndexRoute
}

const AppStudiesRouteChildren: AppStudiesRouteChildren = {
  AppStudiesStudyIdRoute: AppStudiesStudyIdRouteWithChildren,
  AppStudiesIndexRoute: AppStudiesIndexRoute,
}

const AppStudiesRouteWithChildren = AppStudiesRoute._addFileChildren(
  AppStudiesRouteChildren,
)

interface AppTeamInviteRouteChildren {
  AppTeamInviteEmailRoute: typeof AppTeamInviteEmailRoute
  AppTeamInviteQrRoute: typeof AppTeamInviteQrRoute
  AppTeamInviteIndexRoute: typeof AppTeamInviteIndexRoute
}

const AppTeamInviteRouteChildren: AppTeamInviteRouteChildren = {
  AppTeamInviteEmailRoute: AppTeamInviteEmailRoute,
  AppTeamInviteQrRoute: AppTeamInviteQrRoute,
  AppTeamInviteIndexRoute: AppTeamInviteIndexRoute,
}

const AppTeamInviteRouteWithChildren = AppTeamInviteRoute._addFileChildren(
  AppTeamInviteRouteChildren,
)

interface AppTeamRouteChildren {
  AppTeamInviteRoute: typeof AppTeamInviteRouteWithChildren
  AppTeamIndexRoute: typeof AppTeamIndexRoute
}

const AppTeamRouteChildren: AppTeamRouteChildren = {
  AppTeamInviteRoute: AppTeamInviteRouteWithChildren,
  AppTeamIndexRoute: AppTeamIndexRoute,
}

const AppTeamRouteWithChildren =
  AppTeamRoute._addFileChildren(AppTeamRouteChildren)

interface AppTemplatesTemplateIdRouteChildren {
  AppTemplatesTemplateIdConsentRoute: typeof AppTemplatesTemplateIdConsentRoute
  AppTemplatesTemplateIdDateRoute: typeof AppTemplatesTemplateIdDateRoute
  AppTemplatesTemplateIdHospitalNumberRoute: typeof AppTemplatesTemplateIdHospitalNumberRoute
  AppTemplatesTemplateIdLabelsRoute: typeof AppTemplatesTemplateIdLabelsRoute
  AppTemplatesTemplateIdNameRoute: typeof AppTemplatesTemplateIdNameRoute
  AppTemplatesTemplateIdOrganisationRoute: typeof AppTemplatesTemplateIdOrganisationRoute
  AppTemplatesTemplateIdPublishRoute: typeof AppTemplatesTemplateIdPublishRoute
  AppTemplatesTemplateIdScreenerRoute: typeof AppTemplatesTemplateIdScreenerRoute
  AppTemplatesTemplateIdTrackersRoute: typeof AppTemplatesTemplateIdTrackersRoute
  AppTemplatesTemplateIdEventsIndexRoute: typeof AppTemplatesTemplateIdEventsIndexRoute
  AppTemplatesTemplateIdEventsInjectionDetailsRoute: typeof AppTemplatesTemplateIdEventsInjectionDetailsRoute
  AppTemplatesTemplateIdEventsShockwaveDetailsRoute: typeof AppTemplatesTemplateIdEventsShockwaveDetailsRoute
  AppTemplatesTemplateIdEventsSurgeryDetailsRoute: typeof AppTemplatesTemplateIdEventsSurgeryDetailsRoute
  AppTemplatesTemplateIdEventsEducationIndexRoute: typeof AppTemplatesTemplateIdEventsEducationIndexRoute
  AppTemplatesTemplateIdEventsInjectionIndexRoute: typeof AppTemplatesTemplateIdEventsInjectionIndexRoute
  AppTemplatesTemplateIdEventsProductIndexRoute: typeof AppTemplatesTemplateIdEventsProductIndexRoute
  AppTemplatesTemplateIdEventsShockwaveIndexRoute: typeof AppTemplatesTemplateIdEventsShockwaveIndexRoute
  AppTemplatesTemplateIdEventsSurgeryIndexRoute: typeof AppTemplatesTemplateIdEventsSurgeryIndexRoute
}

const AppTemplatesTemplateIdRouteChildren: AppTemplatesTemplateIdRouteChildren =
  {
    AppTemplatesTemplateIdConsentRoute: AppTemplatesTemplateIdConsentRoute,
    AppTemplatesTemplateIdDateRoute: AppTemplatesTemplateIdDateRoute,
    AppTemplatesTemplateIdHospitalNumberRoute:
      AppTemplatesTemplateIdHospitalNumberRoute,
    AppTemplatesTemplateIdLabelsRoute: AppTemplatesTemplateIdLabelsRoute,
    AppTemplatesTemplateIdNameRoute: AppTemplatesTemplateIdNameRoute,
    AppTemplatesTemplateIdOrganisationRoute:
      AppTemplatesTemplateIdOrganisationRoute,
    AppTemplatesTemplateIdPublishRoute: AppTemplatesTemplateIdPublishRoute,
    AppTemplatesTemplateIdScreenerRoute: AppTemplatesTemplateIdScreenerRoute,
    AppTemplatesTemplateIdTrackersRoute: AppTemplatesTemplateIdTrackersRoute,
    AppTemplatesTemplateIdEventsIndexRoute:
      AppTemplatesTemplateIdEventsIndexRoute,
    AppTemplatesTemplateIdEventsInjectionDetailsRoute:
      AppTemplatesTemplateIdEventsInjectionDetailsRoute,
    AppTemplatesTemplateIdEventsShockwaveDetailsRoute:
      AppTemplatesTemplateIdEventsShockwaveDetailsRoute,
    AppTemplatesTemplateIdEventsSurgeryDetailsRoute:
      AppTemplatesTemplateIdEventsSurgeryDetailsRoute,
    AppTemplatesTemplateIdEventsEducationIndexRoute:
      AppTemplatesTemplateIdEventsEducationIndexRoute,
    AppTemplatesTemplateIdEventsInjectionIndexRoute:
      AppTemplatesTemplateIdEventsInjectionIndexRoute,
    AppTemplatesTemplateIdEventsProductIndexRoute:
      AppTemplatesTemplateIdEventsProductIndexRoute,
    AppTemplatesTemplateIdEventsShockwaveIndexRoute:
      AppTemplatesTemplateIdEventsShockwaveIndexRoute,
    AppTemplatesTemplateIdEventsSurgeryIndexRoute:
      AppTemplatesTemplateIdEventsSurgeryIndexRoute,
  }

const AppTemplatesTemplateIdRouteWithChildren =
  AppTemplatesTemplateIdRoute._addFileChildren(
    AppTemplatesTemplateIdRouteChildren,
  )

interface AppTemplatesRouteChildren {
  AppTemplatesTemplateIdRoute: typeof AppTemplatesTemplateIdRouteWithChildren
  AppTemplatesCompleteRoute: typeof AppTemplatesCompleteRoute
  AppTemplatesPublicRoute: typeof AppTemplatesPublicRoute
  AppTemplatesQuickstartPageRoute: typeof AppTemplatesQuickstartPageRoute
  AppTemplatesIndexRoute: typeof AppTemplatesIndexRoute
  AppTemplatesDiaryNewDiaryTemplateIdRoute: typeof AppTemplatesDiaryNewDiaryTemplateIdRoute
  AppTemplatesDiaryTemplateIdRoute: typeof AppTemplatesDiaryTemplateIdRoute
  AppTemplatesDiaryFormInterventionInjectionRoute: typeof AppTemplatesDiaryFormInterventionInjectionRoute
  AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute
  AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute
  AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute: typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute
  AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute: typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute
  AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute
  AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute: typeof AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute
  AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute
  AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute
  AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute
  AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute
  AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute
  AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute
  AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute
  AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute: typeof AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute
}

const AppTemplatesRouteChildren: AppTemplatesRouteChildren = {
  AppTemplatesTemplateIdRoute: AppTemplatesTemplateIdRouteWithChildren,
  AppTemplatesCompleteRoute: AppTemplatesCompleteRoute,
  AppTemplatesPublicRoute: AppTemplatesPublicRoute,
  AppTemplatesQuickstartPageRoute: AppTemplatesQuickstartPageRoute,
  AppTemplatesIndexRoute: AppTemplatesIndexRoute,
  AppTemplatesDiaryNewDiaryTemplateIdRoute:
    AppTemplatesDiaryNewDiaryTemplateIdRoute,
  AppTemplatesDiaryTemplateIdRoute: AppTemplatesDiaryTemplateIdRoute,
  AppTemplatesDiaryFormInterventionInjectionRoute:
    AppTemplatesDiaryFormInterventionInjectionRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdCompleteRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdDetailsRoute,
  AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute:
    AppTemplatesDiaryDiaryIdTrackersTrackerIdDateRoute,
  AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute:
    AppTemplatesDiaryDiaryIdTrackersTrackerIdDetailsRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdIndexRoute,
  AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute:
    AppTemplatesDiaryDiaryIdTrackersTrackerIdIndexRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdProductProductIdIndexRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute,
  AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute:
    AppTemplatesDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute,
}

const AppTemplatesRouteWithChildren = AppTemplatesRoute._addFileChildren(
  AppTemplatesRouteChildren,
)

interface AppWorklistRouteChildren {
  AppWorklistCompleteRoute: typeof AppWorklistCompleteRoute
  AppWorklistIndexRoute: typeof AppWorklistIndexRoute
  AppWorklistConsentDiaryIdConsentIdRoute: typeof AppWorklistConsentDiaryIdConsentIdRoute
  AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute: typeof AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute
  AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute: typeof AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute
}

const AppWorklistRouteChildren: AppWorklistRouteChildren = {
  AppWorklistCompleteRoute: AppWorklistCompleteRoute,
  AppWorklistIndexRoute: AppWorklistIndexRoute,
  AppWorklistConsentDiaryIdConsentIdRoute:
    AppWorklistConsentDiaryIdConsentIdRoute,
  AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute:
    AppWorklistDetailsDiaryIdEventIdTrackerIdProcedureKindRoute,
  AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute:
    AppWorklistFormDiaryIdTrackerIdEntryIdPagePageIndexRoute,
}

const AppWorklistRouteWithChildren = AppWorklistRoute._addFileChildren(
  AppWorklistRouteChildren,
)

interface AppDiariesDiaryIdHomeRouteChildren {
  AppDiariesDiaryIdHomeEditRoute: typeof AppDiariesDiaryIdHomeEditRoute
  AppDiariesDiaryIdHomeFormsRoute: typeof AppDiariesDiaryIdHomeFormsRoute
  AppDiariesDiaryIdHomeProgressRoute: typeof AppDiariesDiaryIdHomeProgressRoute
  AppDiariesDiaryIdHomeResultsRoute: typeof AppDiariesDiaryIdHomeResultsRoute
  AppDiariesDiaryIdHomeToDoRoute: typeof AppDiariesDiaryIdHomeToDoRoute
  AppDiariesDiaryIdHomeIndexRoute: typeof AppDiariesDiaryIdHomeIndexRoute
}

const AppDiariesDiaryIdHomeRouteChildren: AppDiariesDiaryIdHomeRouteChildren = {
  AppDiariesDiaryIdHomeEditRoute: AppDiariesDiaryIdHomeEditRoute,
  AppDiariesDiaryIdHomeFormsRoute: AppDiariesDiaryIdHomeFormsRoute,
  AppDiariesDiaryIdHomeProgressRoute: AppDiariesDiaryIdHomeProgressRoute,
  AppDiariesDiaryIdHomeResultsRoute: AppDiariesDiaryIdHomeResultsRoute,
  AppDiariesDiaryIdHomeToDoRoute: AppDiariesDiaryIdHomeToDoRoute,
  AppDiariesDiaryIdHomeIndexRoute: AppDiariesDiaryIdHomeIndexRoute,
}

const AppDiariesDiaryIdHomeRouteWithChildren =
  AppDiariesDiaryIdHomeRoute._addFileChildren(
    AppDiariesDiaryIdHomeRouteChildren,
  )

interface AppDiariesDiaryIdSetupConsentConsentIdRouteChildren {
  AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute
  AppDiariesDiaryIdSetupConsentConsentIdIndexRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdIndexRoute
}

const AppDiariesDiaryIdSetupConsentConsentIdRouteChildren: AppDiariesDiaryIdSetupConsentConsentIdRouteChildren =
  {
    AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute:
      AppDiariesDiaryIdSetupConsentConsentIdCompleteRoute,
    AppDiariesDiaryIdSetupConsentConsentIdIndexRoute:
      AppDiariesDiaryIdSetupConsentConsentIdIndexRoute,
  }

const AppDiariesDiaryIdSetupConsentConsentIdRouteWithChildren =
  AppDiariesDiaryIdSetupConsentConsentIdRoute._addFileChildren(
    AppDiariesDiaryIdSetupConsentConsentIdRouteChildren,
  )

interface AppDiariesDiaryIdSetupRouteChildren {
  AppDiariesDiaryIdSetupCompleteRoute: typeof AppDiariesDiaryIdSetupCompleteRoute
  AppDiariesDiaryIdSetupHospitalNumberRoute: typeof AppDiariesDiaryIdSetupHospitalNumberRoute
  AppDiariesDiaryIdSetupReferenceDateRoute: typeof AppDiariesDiaryIdSetupReferenceDateRoute
  AppDiariesDiaryIdSetupSideRoute: typeof AppDiariesDiaryIdSetupSideRoute
  AppDiariesDiaryIdSetupConsentConsentIdRoute: typeof AppDiariesDiaryIdSetupConsentConsentIdRouteWithChildren
}

const AppDiariesDiaryIdSetupRouteChildren: AppDiariesDiaryIdSetupRouteChildren =
  {
    AppDiariesDiaryIdSetupCompleteRoute: AppDiariesDiaryIdSetupCompleteRoute,
    AppDiariesDiaryIdSetupHospitalNumberRoute:
      AppDiariesDiaryIdSetupHospitalNumberRoute,
    AppDiariesDiaryIdSetupReferenceDateRoute:
      AppDiariesDiaryIdSetupReferenceDateRoute,
    AppDiariesDiaryIdSetupSideRoute: AppDiariesDiaryIdSetupSideRoute,
    AppDiariesDiaryIdSetupConsentConsentIdRoute:
      AppDiariesDiaryIdSetupConsentConsentIdRouteWithChildren,
  }

const AppDiariesDiaryIdSetupRouteWithChildren =
  AppDiariesDiaryIdSetupRoute._addFileChildren(
    AppDiariesDiaryIdSetupRouteChildren,
  )

interface AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteChildren {
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute
}

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteChildren: AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteChildren =
  {
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute,
  }

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteWithChildren =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute._addFileChildren(
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteChildren,
  )

interface AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteChildren {
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute
}

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteChildren: AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteChildren =
  {
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute,
  }

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteWithChildren =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute._addFileChildren(
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteChildren,
  )

interface AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteChildren {
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteWithChildren
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteWithChildren
}

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteChildren: AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteChildren =
  {
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRouteWithChildren,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRouteWithChildren,
  }

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteWithChildren =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute._addFileChildren(
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteChildren,
  )

interface AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteChildren {
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteWithChildren
}

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteChildren: AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteChildren =
  {
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute,
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute:
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRouteWithChildren,
  }

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteWithChildren =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute._addFileChildren(
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteChildren,
  )

interface AppDiariesDiaryIdRouteChildren {
  AppDiariesDiaryIdFormsRoute: typeof AppDiariesDiaryIdFormsRoute
  AppDiariesDiaryIdHomeRoute: typeof AppDiariesDiaryIdHomeRouteWithChildren
  AppDiariesDiaryIdProgressRoute: typeof AppDiariesDiaryIdProgressRoute
  AppDiariesDiaryIdSetupRoute: typeof AppDiariesDiaryIdSetupRouteWithChildren
  AppDiariesDiaryIdIndexRoute: typeof AppDiariesDiaryIdIndexRoute
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteWithChildren
  AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute: typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute
  AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute: typeof AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute
}

const AppDiariesDiaryIdRouteChildren: AppDiariesDiaryIdRouteChildren = {
  AppDiariesDiaryIdFormsRoute: AppDiariesDiaryIdFormsRoute,
  AppDiariesDiaryIdHomeRoute: AppDiariesDiaryIdHomeRouteWithChildren,
  AppDiariesDiaryIdProgressRoute: AppDiariesDiaryIdProgressRoute,
  AppDiariesDiaryIdSetupRoute: AppDiariesDiaryIdSetupRouteWithChildren,
  AppDiariesDiaryIdIndexRoute: AppDiariesDiaryIdIndexRoute,
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRoute:
    AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdRouteWithChildren,
  AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute:
    AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdCompleteRoute,
  AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute:
    AppDiariesDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute,
}

const AppDiariesDiaryIdRouteWithChildren =
  AppDiariesDiaryIdRoute._addFileChildren(AppDiariesDiaryIdRouteChildren)

interface AppFootWatchDiaryIdViewRouteChildren {
  AppFootWatchDiaryIdViewHistoryRoute: typeof AppFootWatchDiaryIdViewHistoryRoute
  AppFootWatchDiaryIdViewNewRoute: typeof AppFootWatchDiaryIdViewNewRoute
  AppFootWatchDiaryIdViewProgressRoute: typeof AppFootWatchDiaryIdViewProgressRoute
}

const AppFootWatchDiaryIdViewRouteChildren: AppFootWatchDiaryIdViewRouteChildren =
  {
    AppFootWatchDiaryIdViewHistoryRoute: AppFootWatchDiaryIdViewHistoryRoute,
    AppFootWatchDiaryIdViewNewRoute: AppFootWatchDiaryIdViewNewRoute,
    AppFootWatchDiaryIdViewProgressRoute: AppFootWatchDiaryIdViewProgressRoute,
  }

const AppFootWatchDiaryIdViewRouteWithChildren =
  AppFootWatchDiaryIdViewRoute._addFileChildren(
    AppFootWatchDiaryIdViewRouteChildren,
  )

interface AppFootWatchDiaryIdEditRouteChildren {
  AppFootWatchDiaryIdEditDiaryRoute: typeof AppFootWatchDiaryIdEditDiaryRoute
  AppFootWatchDiaryIdEditNameRoute: typeof AppFootWatchDiaryIdEditNameRoute
}

const AppFootWatchDiaryIdEditRouteChildren: AppFootWatchDiaryIdEditRouteChildren =
  {
    AppFootWatchDiaryIdEditDiaryRoute: AppFootWatchDiaryIdEditDiaryRoute,
    AppFootWatchDiaryIdEditNameRoute: AppFootWatchDiaryIdEditNameRoute,
  }

const AppFootWatchDiaryIdEditRouteWithChildren =
  AppFootWatchDiaryIdEditRoute._addFileChildren(
    AppFootWatchDiaryIdEditRouteChildren,
  )

interface AppFootWatchDiaryIdNewInstructionsRouteChildren {
  AppFootWatchDiaryIdNewInstructionsAngleSideRoute: typeof AppFootWatchDiaryIdNewInstructionsAngleSideRoute
}

const AppFootWatchDiaryIdNewInstructionsRouteChildren: AppFootWatchDiaryIdNewInstructionsRouteChildren =
  {
    AppFootWatchDiaryIdNewInstructionsAngleSideRoute:
      AppFootWatchDiaryIdNewInstructionsAngleSideRoute,
  }

const AppFootWatchDiaryIdNewInstructionsRouteWithChildren =
  AppFootWatchDiaryIdNewInstructionsRoute._addFileChildren(
    AppFootWatchDiaryIdNewInstructionsRouteChildren,
  )

interface AppFootWatchDiaryIdNewUploadRouteChildren {
  AppFootWatchDiaryIdNewUploadCompleteRoute: typeof AppFootWatchDiaryIdNewUploadCompleteRoute
  AppFootWatchDiaryIdNewUploadMessageRoute: typeof AppFootWatchDiaryIdNewUploadMessageRoute
  AppFootWatchDiaryIdNewUploadUploadingRoute: typeof AppFootWatchDiaryIdNewUploadUploadingRoute
  AppFootWatchDiaryIdNewUploadIndexRoute: typeof AppFootWatchDiaryIdNewUploadIndexRoute
}

const AppFootWatchDiaryIdNewUploadRouteChildren: AppFootWatchDiaryIdNewUploadRouteChildren =
  {
    AppFootWatchDiaryIdNewUploadCompleteRoute:
      AppFootWatchDiaryIdNewUploadCompleteRoute,
    AppFootWatchDiaryIdNewUploadMessageRoute:
      AppFootWatchDiaryIdNewUploadMessageRoute,
    AppFootWatchDiaryIdNewUploadUploadingRoute:
      AppFootWatchDiaryIdNewUploadUploadingRoute,
    AppFootWatchDiaryIdNewUploadIndexRoute:
      AppFootWatchDiaryIdNewUploadIndexRoute,
  }

const AppFootWatchDiaryIdNewUploadRouteWithChildren =
  AppFootWatchDiaryIdNewUploadRoute._addFileChildren(
    AppFootWatchDiaryIdNewUploadRouteChildren,
  )

interface AppFootWatchDiaryIdRouteChildren {
  AppFootWatchDiaryIdViewRoute: typeof AppFootWatchDiaryIdViewRouteWithChildren
  AppFootWatchDiaryIdEditRoute: typeof AppFootWatchDiaryIdEditRouteWithChildren
  AppFootWatchDiaryIdNewAddPhotosRoute: typeof AppFootWatchDiaryIdNewAddPhotosRoute
  AppFootWatchDiaryIdNewCameraRoute: typeof AppFootWatchDiaryIdNewCameraRoute
  AppFootWatchDiaryIdNewInstructionsRoute: typeof AppFootWatchDiaryIdNewInstructionsRouteWithChildren
  AppFootWatchDiaryIdNewNewPatientRoute: typeof AppFootWatchDiaryIdNewNewPatientRoute
  AppFootWatchDiaryIdNewSelectPatientRoute: typeof AppFootWatchDiaryIdNewSelectPatientRoute
  AppFootWatchDiaryIdNewStartRoute: typeof AppFootWatchDiaryIdNewStartRoute
  AppFootWatchDiaryIdNewUploadRoute: typeof AppFootWatchDiaryIdNewUploadRouteWithChildren
}

const AppFootWatchDiaryIdRouteChildren: AppFootWatchDiaryIdRouteChildren = {
  AppFootWatchDiaryIdViewRoute: AppFootWatchDiaryIdViewRouteWithChildren,
  AppFootWatchDiaryIdEditRoute: AppFootWatchDiaryIdEditRouteWithChildren,
  AppFootWatchDiaryIdNewAddPhotosRoute: AppFootWatchDiaryIdNewAddPhotosRoute,
  AppFootWatchDiaryIdNewCameraRoute: AppFootWatchDiaryIdNewCameraRoute,
  AppFootWatchDiaryIdNewInstructionsRoute:
    AppFootWatchDiaryIdNewInstructionsRouteWithChildren,
  AppFootWatchDiaryIdNewNewPatientRoute: AppFootWatchDiaryIdNewNewPatientRoute,
  AppFootWatchDiaryIdNewSelectPatientRoute:
    AppFootWatchDiaryIdNewSelectPatientRoute,
  AppFootWatchDiaryIdNewStartRoute: AppFootWatchDiaryIdNewStartRoute,
  AppFootWatchDiaryIdNewUploadRoute:
    AppFootWatchDiaryIdNewUploadRouteWithChildren,
}

const AppFootWatchDiaryIdRouteWithChildren =
  AppFootWatchDiaryIdRoute._addFileChildren(AppFootWatchDiaryIdRouteChildren)

interface AppValidateValidationIdRouteChildren {
  AppValidateValidationIdIndexRoute: typeof AppValidateValidationIdIndexRoute
  AppValidateValidationIdFormsFormIdResultsRoute: typeof AppValidateValidationIdFormsFormIdResultsRoute
  AppValidateValidationIdFormsFormIdIndexRoute: typeof AppValidateValidationIdFormsFormIdIndexRoute
  AppValidateValidationIdFormsFormIdPagePageIndexRoute: typeof AppValidateValidationIdFormsFormIdPagePageIndexRoute
}

const AppValidateValidationIdRouteChildren: AppValidateValidationIdRouteChildren =
  {
    AppValidateValidationIdIndexRoute: AppValidateValidationIdIndexRoute,
    AppValidateValidationIdFormsFormIdResultsRoute:
      AppValidateValidationIdFormsFormIdResultsRoute,
    AppValidateValidationIdFormsFormIdIndexRoute:
      AppValidateValidationIdFormsFormIdIndexRoute,
    AppValidateValidationIdFormsFormIdPagePageIndexRoute:
      AppValidateValidationIdFormsFormIdPagePageIndexRoute,
  }

const AppValidateValidationIdRouteWithChildren =
  AppValidateValidationIdRoute._addFileChildren(
    AppValidateValidationIdRouteChildren,
  )

interface AppRouteChildren {
  AppUsersRouteRoute: typeof AppUsersRouteRouteWithChildren
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppAnalyticsRoute: typeof AppAnalyticsRouteWithChildren
  AppBuilderRoute: typeof AppBuilderRouteWithChildren
  AppBusinessRoute: typeof AppBusinessRouteWithChildren
  AppCompleteProfileRoute: typeof AppCompleteProfileRoute
  AppCustomersRoute: typeof AppCustomersRouteWithChildren
  AppDesignRoute: typeof AppDesignRouteWithChildren
  AppDeveloperRoute: typeof AppDeveloperRouteWithChildren
  AppInviteRoute: typeof AppInviteRouteWithChildren
  AppPatientsRoute: typeof AppPatientsRouteWithChildren
  AppProfileRoute: typeof AppProfileRouteWithChildren
  AppRoleRoute: typeof AppRoleRoute
  AppSalesRoute: typeof AppSalesRouteWithChildren
  AppStatisticsRoute: typeof AppStatisticsRoute
  AppStudiesRoute: typeof AppStudiesRouteWithChildren
  AppTeamRoute: typeof AppTeamRouteWithChildren
  AppTemplatesRoute: typeof AppTemplatesRouteWithChildren
  AppWorklistRoute: typeof AppWorklistRouteWithChildren
  AppClinicianDiariesRoute: typeof AppClinicianDiariesRoute
  AppDiariesDiaryIdRoute: typeof AppDiariesDiaryIdRouteWithChildren
  AppFisherWatchDashboardRoute: typeof AppFisherWatchDashboardRoute
  AppFootWatchDiaryIdRoute: typeof AppFootWatchDiaryIdRouteWithChildren
  AppHeadacheWatchDashboardRoute: typeof AppHeadacheWatchDashboardRoute
  AppHelpClinicianRoute: typeof AppHelpClinicianRoute
  AppHelpPatientRoute: typeof AppHelpPatientRoute
  AppLeadGenSplatRoute: typeof AppLeadGenSplatRoute
  AppNewSplatRoute: typeof AppNewSplatRoute
  AppSchedulesScheduleIdRoute: typeof AppSchedulesScheduleIdRoute
  AppValidateValidationIdRoute: typeof AppValidateValidationIdRouteWithChildren
  AppDiariesIndexRoute: typeof AppDiariesIndexRoute
  AppLeadGenIndexRoute: typeof AppLeadGenIndexRoute
  AppNewIndexRoute: typeof AppNewIndexRoute
  AppSchedulesIndexRoute: typeof AppSchedulesIndexRoute
  AppValidateIndexRoute: typeof AppValidateIndexRoute
  AppFootWatchNewDiaryShareRoute: typeof AppFootWatchNewDiaryShareRoute
  AppOrganisationOrganisationIdQrCodeRoute: typeof AppOrganisationOrganisationIdQrCodeRoute
  AppOrganisationOrganisationIdIndexRoute: typeof AppOrganisationOrganisationIdIndexRoute
  AppValidateChangeTrailEntityTypeEntityIdRoute: typeof AppValidateChangeTrailEntityTypeEntityIdRoute
  AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute: typeof AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppUsersRouteRoute: AppUsersRouteRouteWithChildren,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppAnalyticsRoute: AppAnalyticsRouteWithChildren,
  AppBuilderRoute: AppBuilderRouteWithChildren,
  AppBusinessRoute: AppBusinessRouteWithChildren,
  AppCompleteProfileRoute: AppCompleteProfileRoute,
  AppCustomersRoute: AppCustomersRouteWithChildren,
  AppDesignRoute: AppDesignRouteWithChildren,
  AppDeveloperRoute: AppDeveloperRouteWithChildren,
  AppInviteRoute: AppInviteRouteWithChildren,
  AppPatientsRoute: AppPatientsRouteWithChildren,
  AppProfileRoute: AppProfileRouteWithChildren,
  AppRoleRoute: AppRoleRoute,
  AppSalesRoute: AppSalesRouteWithChildren,
  AppStatisticsRoute: AppStatisticsRoute,
  AppStudiesRoute: AppStudiesRouteWithChildren,
  AppTeamRoute: AppTeamRouteWithChildren,
  AppTemplatesRoute: AppTemplatesRouteWithChildren,
  AppWorklistRoute: AppWorklistRouteWithChildren,
  AppClinicianDiariesRoute: AppClinicianDiariesRoute,
  AppDiariesDiaryIdRoute: AppDiariesDiaryIdRouteWithChildren,
  AppFisherWatchDashboardRoute: AppFisherWatchDashboardRoute,
  AppFootWatchDiaryIdRoute: AppFootWatchDiaryIdRouteWithChildren,
  AppHeadacheWatchDashboardRoute: AppHeadacheWatchDashboardRoute,
  AppHelpClinicianRoute: AppHelpClinicianRoute,
  AppHelpPatientRoute: AppHelpPatientRoute,
  AppLeadGenSplatRoute: AppLeadGenSplatRoute,
  AppNewSplatRoute: AppNewSplatRoute,
  AppSchedulesScheduleIdRoute: AppSchedulesScheduleIdRoute,
  AppValidateValidationIdRoute: AppValidateValidationIdRouteWithChildren,
  AppDiariesIndexRoute: AppDiariesIndexRoute,
  AppLeadGenIndexRoute: AppLeadGenIndexRoute,
  AppNewIndexRoute: AppNewIndexRoute,
  AppSchedulesIndexRoute: AppSchedulesIndexRoute,
  AppValidateIndexRoute: AppValidateIndexRoute,
  AppFootWatchNewDiaryShareRoute: AppFootWatchNewDiaryShareRoute,
  AppOrganisationOrganisationIdQrCodeRoute:
    AppOrganisationOrganisationIdQrCodeRoute,
  AppOrganisationOrganisationIdIndexRoute:
    AppOrganisationOrganisationIdIndexRoute,
  AppValidateChangeTrailEntityTypeEntityIdRoute:
    AppValidateChangeTrailEntityTypeEntityIdRoute,
  AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute:
    AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthPublicLoginRouteChildren {
  AuthPublicLoginVerifyRoute: typeof AuthPublicLoginVerifyRoute
  AuthPublicLoginIndexRoute: typeof AuthPublicLoginIndexRoute
}

const AuthPublicLoginRouteChildren: AuthPublicLoginRouteChildren = {
  AuthPublicLoginVerifyRoute: AuthPublicLoginVerifyRoute,
  AuthPublicLoginIndexRoute: AuthPublicLoginIndexRoute,
}

const AuthPublicLoginRouteWithChildren = AuthPublicLoginRoute._addFileChildren(
  AuthPublicLoginRouteChildren,
)

interface AuthPublicRouteChildren {
  AuthPublicAuthenticateRoute: typeof AuthPublicAuthenticateRoute
  AuthPublicLoginRoute: typeof AuthPublicLoginRouteWithChildren
  AuthPublicIndexRoute: typeof AuthPublicIndexRoute
  AuthPublicSignupPlanRoute: typeof AuthPublicSignupPlanRoute
  AuthPublicSignupTrialRoute: typeof AuthPublicSignupTrialRoute
  AuthPublicSignupVerifyPhoneRoute: typeof AuthPublicSignupVerifyPhoneRoute
  AuthPublicSignupIndexRoute: typeof AuthPublicSignupIndexRoute
}

const AuthPublicRouteChildren: AuthPublicRouteChildren = {
  AuthPublicAuthenticateRoute: AuthPublicAuthenticateRoute,
  AuthPublicLoginRoute: AuthPublicLoginRouteWithChildren,
  AuthPublicIndexRoute: AuthPublicIndexRoute,
  AuthPublicSignupPlanRoute: AuthPublicSignupPlanRoute,
  AuthPublicSignupTrialRoute: AuthPublicSignupTrialRoute,
  AuthPublicSignupVerifyPhoneRoute: AuthPublicSignupVerifyPhoneRoute,
  AuthPublicSignupIndexRoute: AuthPublicSignupIndexRoute,
}

const AuthPublicRouteWithChildren = AuthPublicRoute._addFileChildren(
  AuthPublicRouteChildren,
)

interface AuthConfirmAccountRouteChildren {
  AuthConfirmAccountVerifyRoute: typeof AuthConfirmAccountVerifyRoute
  AuthConfirmAccountIndexRoute: typeof AuthConfirmAccountIndexRoute
}

const AuthConfirmAccountRouteChildren: AuthConfirmAccountRouteChildren = {
  AuthConfirmAccountVerifyRoute: AuthConfirmAccountVerifyRoute,
  AuthConfirmAccountIndexRoute: AuthConfirmAccountIndexRoute,
}

const AuthConfirmAccountRouteWithChildren =
  AuthConfirmAccountRoute._addFileChildren(AuthConfirmAccountRouteChildren)

interface AuthForgotPasswordRouteChildren {
  AuthForgotPasswordVerifyRoute: typeof AuthForgotPasswordVerifyRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
}

const AuthForgotPasswordRouteChildren: AuthForgotPasswordRouteChildren = {
  AuthForgotPasswordVerifyRoute: AuthForgotPasswordVerifyRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
}

const AuthForgotPasswordRouteWithChildren =
  AuthForgotPasswordRoute._addFileChildren(AuthForgotPasswordRouteChildren)

interface AuthRouteChildren {
  AuthPublicRoute: typeof AuthPublicRouteWithChildren
  AuthActivateAccountRoute: typeof AuthActivateAccountRoute
  AuthAuthErrorRoute: typeof AuthAuthErrorRoute
  AuthAuthenticationCompleteRoute: typeof AuthAuthenticationCompleteRoute
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthConfirmAccountRoute: typeof AuthConfirmAccountRouteWithChildren
  AuthDeleteAccountRoute: typeof AuthDeleteAccountRoute
  AuthEmailConfirmedRoute: typeof AuthEmailConfirmedRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRouteWithChildren
  AuthMagicRoute: typeof AuthMagicRoute
  AuthNewDiaryInviteRoute: typeof AuthNewDiaryInviteRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
  AuthTestRoute: typeof AuthTestRoute
  AuthTryDemoRoute: typeof AuthTryDemoRoute
  AuthVerificationCompleteRoute: typeof AuthVerificationCompleteRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthVerifyPaymentRoute: typeof AuthVerifyPaymentRoute
  AuthMfaChallengeRoute: typeof AuthMfaChallengeRoute
  AuthMfaEnrollRoute: typeof AuthMfaEnrollRoute
  AuthNewUserIndexRoute: typeof AuthNewUserIndexRoute
  AuthNewUserClinicianIndexRoute: typeof AuthNewUserClinicianIndexRoute
  AuthNewUserPatientIndexRoute: typeof AuthNewUserPatientIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthPublicRoute: AuthPublicRouteWithChildren,
  AuthActivateAccountRoute: AuthActivateAccountRoute,
  AuthAuthErrorRoute: AuthAuthErrorRoute,
  AuthAuthenticationCompleteRoute: AuthAuthenticationCompleteRoute,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthConfirmAccountRoute: AuthConfirmAccountRouteWithChildren,
  AuthDeleteAccountRoute: AuthDeleteAccountRoute,
  AuthEmailConfirmedRoute: AuthEmailConfirmedRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRouteWithChildren,
  AuthMagicRoute: AuthMagicRoute,
  AuthNewDiaryInviteRoute: AuthNewDiaryInviteRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
  AuthTestRoute: AuthTestRoute,
  AuthTryDemoRoute: AuthTryDemoRoute,
  AuthVerificationCompleteRoute: AuthVerificationCompleteRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthVerifyPaymentRoute: AuthVerifyPaymentRoute,
  AuthMfaChallengeRoute: AuthMfaChallengeRoute,
  AuthMfaEnrollRoute: AuthMfaEnrollRoute,
  AuthNewUserIndexRoute: AuthNewUserIndexRoute,
  AuthNewUserClinicianIndexRoute: AuthNewUserClinicianIndexRoute,
  AuthNewUserPatientIndexRoute: AuthNewUserPatientIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface OnboardingRouteChildren {
  OnboardingClinicianNumberRoute: typeof OnboardingClinicianNumberRoute
  OnboardingCompleteRoute: typeof OnboardingCompleteRoute
  OnboardingDateOfBirthRoute: typeof OnboardingDateOfBirthRoute
  OnboardingEmailRoute: typeof OnboardingEmailRoute
  OnboardingNameRoute: typeof OnboardingNameRoute
  OnboardingNotificationsRoute: typeof OnboardingNotificationsRoute
  OnboardingPhoneRoute: typeof OnboardingPhoneRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
  OnboardingClinicianNameRoute: typeof OnboardingClinicianNameRoute
  OnboardingClinicianOrganisationRoute: typeof OnboardingClinicianOrganisationRoute
  OnboardingClinicianProfessionalRoute: typeof OnboardingClinicianProfessionalRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingClinicianNumberRoute: OnboardingClinicianNumberRoute,
  OnboardingCompleteRoute: OnboardingCompleteRoute,
  OnboardingDateOfBirthRoute: OnboardingDateOfBirthRoute,
  OnboardingEmailRoute: OnboardingEmailRoute,
  OnboardingNameRoute: OnboardingNameRoute,
  OnboardingNotificationsRoute: OnboardingNotificationsRoute,
  OnboardingPhoneRoute: OnboardingPhoneRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
  OnboardingClinicianNameRoute: OnboardingClinicianNameRoute,
  OnboardingClinicianOrganisationRoute: OnboardingClinicianOrganisationRoute,
  OnboardingClinicianProfessionalRoute: OnboardingClinicianProfessionalRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface PreviewConsentRouteChildren {
  PreviewConsentConsentIdRoute: typeof PreviewConsentConsentIdRoute
}

const PreviewConsentRouteChildren: PreviewConsentRouteChildren = {
  PreviewConsentConsentIdRoute: PreviewConsentConsentIdRoute,
}

const PreviewConsentRouteWithChildren = PreviewConsentRoute._addFileChildren(
  PreviewConsentRouteChildren,
)

interface PreviewRouteChildren {
  PreviewConsentRoute: typeof PreviewConsentRouteWithChildren
  PreviewInviteQrCodeRoute: typeof PreviewInviteQrCodeRoute
  PreviewPatientPatientIdDiaryDiaryIdIndexRoute: typeof PreviewPatientPatientIdDiaryDiaryIdIndexRoute
  PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute: typeof PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute
  PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute: typeof PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute
}

const PreviewRouteChildren: PreviewRouteChildren = {
  PreviewConsentRoute: PreviewConsentRouteWithChildren,
  PreviewInviteQrCodeRoute: PreviewInviteQrCodeRoute,
  PreviewPatientPatientIdDiaryDiaryIdIndexRoute:
    PreviewPatientPatientIdDiaryDiaryIdIndexRoute,
  PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute:
    PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute,
  PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute:
    PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute,
}

const PreviewRouteWithChildren =
  PreviewRoute._addFileChildren(PreviewRouteChildren)

interface FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteChildren {
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute: typeof FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute
}

const FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteChildren: FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteChildren =
  {
    FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute:
      FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteResultsRoute,
    FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute:
      FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteReviewsRoute,
    FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute:
      FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteIndexRoute,
  }

const FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteWithChildren =
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute._addFileChildren(
    FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ErrorRoute: ErrorRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  PreviewRoute: PreviewRouteWithChildren,
  CliniciansClinicianIdRoute: CliniciansClinicianIdRoute,
  FeedbackPatientRoute: FeedbackPatientRoute,
  FormsRequestRoute: FormsRequestRoute,
  PreferencesUserIdRoute: PreferencesUserIdRoute,
  SchedulesRequestRoute: SchedulesRequestRoute,
  FormsIndexRoute: FormsIndexRoute,
  HelpExplainerExplainerTypeRoute: HelpExplainerExplainerTypeRoute,
  ScreenScreenerIdResultRoute: ScreenScreenerIdResultRoute,
  TrackerTrackerIdResultsRoute: TrackerTrackerIdResultsRoute,
  TrackerTrackerIdSuccessRoute: TrackerTrackerIdSuccessRoute,
  FormsFormIdIndexRoute: FormsFormIdIndexRoute,
  ScreenScreenerIdIndexRoute: ScreenScreenerIdIndexRoute,
  ScreenScreenerIdEntryIdPagePageIndexRoute:
    ScreenScreenerIdEntryIdPagePageIndexRoute,
  FormsFormIdPagePageIndexIndexRoute: FormsFormIdPagePageIndexIndexRoute,
  TrackerTrackerIdFormFormIdIndexRoute: TrackerTrackerIdFormFormIdIndexRoute,
  TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute:
    TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute,
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRoute:
    FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdCompleteRouteRouteWithChildren,
  TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute:
    TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute,
  FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute:
    FormsFormIdDiaryDiaryIdTrackerTrackerIdEntryEntryIdPagePageIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
